(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("lodash"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "lodash", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["VisualEngine"] = factory(require("react"), require("lodash"), require("react-dom"));
	else
		root["VisualEngine"] = factory(root["React"], root["_"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(3);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _index2.default;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils = __webpack_require__(4);
	var vu_logger_1 = __webpack_require__(6);
	var lodash_1 = __webpack_require__(7);
	var React = __webpack_require__(5);
	var ReactDOM = __webpack_require__(8);
	var context_1 = __webpack_require__(9);
	var core_1 = __webpack_require__(13);
	var node_1 = __webpack_require__(39);
	var prop_1 = __webpack_require__(46);
	var props_1 = __webpack_require__(42);
	var base_1 = __webpack_require__(125);
	var scroller_1 = __webpack_require__(77);
	var location_1 = __webpack_require__(38);
	var ui_1 = __webpack_require__(131);
	var Field = __webpack_require__(269);
	var placeholders_1 = __webpack_require__(15);
	/**
	 * Boot built-ins modules
	 */
	__webpack_require__(293);
	__webpack_require__(305);
	var engineExports = {
	    /**
	     * Compatible with old APIs
	     * @deprecated
	     */
	    Popup: __webpack_require__(282),
	    /**
	     * VE.context
	     *
	     * 默认未初始化，需要等待 init 之后
	     * @memberof VisualEngine
	     */
	    context: new context_1.default(),
	    /**
	     * VE.init
	     *
	     * Initialized the whole VisualEngine UI
	     */
	    init: lodash_1.once(function (container, contextConfigs) {
	        if (!container) {
	            container = document.createElement('div');
	            document.body.appendChild(container);
	        }
	        container.id = 'engine';
	        ReactDOM.render(React.createElement(ui_1.default, null), container);
	    }),
	    /**
	     * VE.modules.xxx
	     *
	     * VE BuildIn Modules
	     */
	    modules: __assign(__assign({}, base_1.default), { Node: node_1.Node,
	        Props: props_1.Props,
	        Prop: prop_1.default,
	        Scroller: scroller_1.default,
	        Insertion: location_1.Insertion }),
	    /**
	     * VE.ui.xxx
	     *
	     * Core UI Components
	     */
	    ui: {
	        Field: Field,
	        Icon: __webpack_require__(133),
	        Icons: __webpack_require__(133),
	        Popup: __webpack_require__(282),
	        FaultComponent: placeholders_1.FaultComponent,
	        HiddenComponent: placeholders_1.HiddenComponent,
	        UnknownComponent: placeholders_1.UnknownComponent,
	        InsertionGhost: placeholders_1.InsertionGhost,
	    },
	    /**
	     * VisualEngine Logger Tool
	     */
	    lg: vu_logger_1.default,
	    logger: vu_logger_1.default,
	    /**
	     * VE Utils
	     */
	    utils: utils,
	};
	module.exports = __assign(__assign({}, engineExports), core_1.default);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GeneratorCache = {};
	var disableUniqueIdDuplicateChecker = false;
	
	var UniqueIdGenerator = function () {
	  function UniqueIdGenerator(namespace) {
	    _classCallCheck(this, UniqueIdGenerator);
	
	    this.base = Date.now();
	    this.guidStack = [];
	    this.namespace = namespace;
	    this.enableUniqueChecker = true;
	  }
	
	  UniqueIdGenerator.prototype.enableChecker = function enableChecker() {
	    this.enableUniqueChecker = true;
	  };
	
	  UniqueIdGenerator.prototype.disableChecker = function disableChecker() {
	    this.enableUniqueChecker = false;
	  };
	
	  UniqueIdGenerator.prototype.generate = function generate(id, prefix) {
	    if (!this.enableUniqueChecker || disableUniqueIdDuplicateChecker) {
	      if (id) return id;
	    }
	    if (id && this.guidStack.indexOf(id) < 0) {
	      this.guidStack.push(id);
	      return id;
	    }
	    return this.generate(prefix + '_' + (this.base++).toString(36).toLowerCase(), prefix);
	  };
	
	  return UniqueIdGenerator;
	}();
	
	function getGenerator(namespace) {
	  if (!GeneratorCache.hasOwnProperty(namespace)) {
	    GeneratorCache[namespace] = new UniqueIdGenerator(namespace);
	  }
	  return GeneratorCache[namespace];
	}
	
	function uniqueId(value) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
	  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
	
	  return getGenerator(namespace).generate(value, prefix);
	}
	
	function sid() {
	  return uniqueId(null, 'serial', 'serial');
	}
	
	/**
	 * 清除全部的 uuid 缓存
	 * 一般是在页面销毁或者重绘 / 重构的时候调用
	 */
	function clearUuidCache() {
	  GeneratorCache = {};
	}
	
	function enableUniqueIdChecker(namespace) {
	  if (namespace && GeneratorCache[namespace]) {
	    GeneratorCache[namespace].enableChecker();
	  } else {
	    disableUniqueIdDuplicateChecker = false;
	  }
	}
	
	function disableUniqueIdChecker(namespace) {
	  if (namespace && GeneratorCache[namespace]) {
	    GeneratorCache[namespace].disableChecker();
	  } else {
	    disableUniqueIdDuplicateChecker = true;
	  }
	}
	
	function getSid(obj) {
	  return obj && obj.__sid__;
	}
	
	function addSid(obj, id) {
	  if (!obj) return obj;
	  id = id || getSid(obj) || sid();
	  try {
	    obj.__sid__ = id;
	  } catch (e) {
	    // eslint-disable-line
	  }
	  return obj;
	}
	
	function valueHeater(val, withSid) {
	  var t = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	  if (!val || t === 'string' || t === 'number') {
	    return val;
	  }
	  if (Array.isArray(val)) {
	    return val.map(function (item) {
	      return valueHeater(item, true);
	    });
	  }
	  if (t === 'object') {
	    var ret = {};
	    for (var k in val) {
	      if (val.hasOwnProperty(k)) {
	        ret[k] = valueHeater(val[k]);
	      }
	    }
	    if (withSid) {
	      addSid(ret);
	    }
	    return ret;
	  }
	  if (typeof val.toString === 'function') {
	    return val.toString();
	  }
	  return null;
	}
	
	function valueCooler(obj) {
	  if (obj == null) {
	    return obj;
	  }
	  if (Array.isArray(obj)) {
	    return obj.map(function (item) {
	      return valueCooler(item);
	    });
	  }
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	    var ret = {};
	    for (var k in obj) {
	      if (obj.hasOwnProperty(k) && k !== '__sid__') {
	        ret[k] = valueCooler(obj[k]);
	      }
	    }
	    return ret;
	  }
	  return obj;
	}
	
	function i18nTransform(obj, locale) {
	  if (!obj) return obj;
	  if (Array.isArray(obj)) {
	    return obj.map(function (item) {
	      return i18nTransform(item, locale);
	    });
	  }
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	    if (obj.type === 'i18n') {
	      if (locale !== 'zh_CN' && locale !== 'zh_TW' && !obj[locale]) {
	        locale = 'en_US';
	      }
	      return obj[locale];
	    }
	    var out = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        out[key] = i18nTransform(obj[key], locale);
	      }
	    }
	    return out;
	  }
	  return obj;
	}
	
	function cloneDeep(val) {
	  if (!val) {
	    return val;
	  }
	
	  if (Array.isArray(val)) {
	    return val.map(function (item) {
	      return cloneDeep(item);
	    });
	  }
	
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    var ret = {};
	    Object.keys(val).forEach(function (key) {
	      ret[key] = cloneDeep(val[key]);
	    });
	    return ret;
	  }
	
	  return val;
	}
	
	function encodeData(data) {
	  if (Array.isArray(data)) {
	    return '[' + data.map(function (v) {
	      return encodeData(v);
	    }).join(',') + ']';
	  }
	
	  if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	    if (data == null) {
	      return 'null';
	    }
	    var ret = Object.keys(data).sort().map(function (key) {
	      return JSON.stringify(key) + ':' + encodeData(data[key]);
	    });
	    return '{' + ret.join(',') + '}';
	  }
	
	  return JSON.stringify(data);
	}
	
	function isDataEqual(data1, data2) {
	  return encodeData(data1) === encodeData(data2);
	}
	
	function getHotterFromSetter(setter) {
	  return setter && (setter.Hotter || setter.type && setter.type.Hotter) || []; // eslint-disable-line
	}
	
	function getTransducerFromSetter(setter) {
	  return setter && (setter.transducer || setter.Transducer || setter.type && (setter.type.transducer || setter.type.Transducer)) || null; // eslint-disable-line
	}
	
	function getInitialFromSetter(setter) {
	  return setter && (setter.initial || setter.Initial || setter.type && (setter.type.initial || setter.type.Initial)) || null; // eslint-disable-line
	}
	
	function combineTransducer(transducer, arr, context) {
	  if (!transducer && Array.isArray(arr)) {
	    var _arr = _slicedToArray(arr, 2),
	        toHot = _arr[0],
	        toNative = _arr[1];
	
	    transducer = { toHot: toHot, toNative: toNative };
	  }
	
	  return {
	    toHot: (transducer && transducer.toHot || function (x) {
	      return x;
	    }).bind(context), // eslint-disable-line
	    toNative: (transducer && transducer.toNative || function (x) {
	      return x;
	    }).bind(context) // eslint-disable-line
	  };
	}
	
	function defaultInitial(value, defaultValue) {
	  return value == null ? defaultValue : value;
	}
	
	function combineInitial(context, config) {
	  var configInitial = config.initial || config.initialValue;
	  var setterInitial = getInitialFromSetter(config.setter);
	
	  if (typeof configInitial !== 'function') {
	    configInitial = defaultInitial;
	  }
	
	  configInitial = configInitial.bind(context);
	
	  if (setterInitial) {
	    setterInitial = setterInitial.bind(context);
	    return function (value, defaultValue) {
	      return setterInitial(configInitial(value, defaultValue), defaultValue);
	    };
	  }
	
	  return configInitial;
	}
	
	var Transducer = function () {
	  function Transducer(context, config) {
	    _classCallCheck(this, Transducer);
	
	    this.setterTransducer = combineTransducer(getTransducerFromSetter(config.setter), getHotterFromSetter(config.setter), context);
	
	    this.configTransducer = combineTransducer(config.transducer, config.transform, context);
	
	    this.context = context;
	  }
	
	  Transducer.prototype.toHot = function toHot(data) {
	    data = this.configTransducer.toHot(data);
	    return this.setterTransducer.toHot(data);
	  };
	
	  Transducer.prototype.toNative = function toNative(data) {
	    data = this.setterTransducer.toNative(data);
	    return this.configTransducer.toNative(data);
	  };
	
	  return Transducer;
	}();
	
	function testType(obj) {
	  var t = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
	  if (t === 'function' && obj.prototype && (obj.prototype.isReactComponent || obj.prototype instanceof _react.Component)) {
	    return 'ReactClass';
	  } else if (t === 'object' && (0, _react.isValidElement)(obj)) {
	    return 'ReactElement';
	  }
	  return t;
	}
	
	var debugEnabled = null;
	
	function isDebug() {
	  if (debugEnabled !== null) return debugEnabled;
	  debugEnabled = location.search.indexOf('__ve_debug=1') >= 0;
	  return debugEnabled;
	}
	
	exports.default = {
	  sid: sid,
	  addSid: addSid,
	  getSid: getSid,
	  valueHeater: valueHeater,
	  valueCooler: valueCooler,
	  uniqueId: uniqueId,
	  clearUuidCache: clearUuidCache,
	  enableUniqueIdChecker: enableUniqueIdChecker,
	  disableUniqueIdChecker: disableUniqueIdChecker,
	  i18nTransform: i18nTransform,
	  cloneDeep: cloneDeep,
	  testType: testType,
	  encodeData: encodeData,
	  isDataEqual: isDataEqual,
	  isDebug: isDebug,
	  combineInitial: combineInitial,
	  Transducer: Transducer
	};
	module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var log = __webpack_require__(1);
	;
	var LOG_ENV = {
	    dev: 'TRACE',
	    test: 'WARN',
	    production: 'ERROR'
	};
	var LOG_LEVEL = ['trace', 'error', 'info', 'debug', 'warn'];
	var DEFAULT_DOC_ADDRESS = 'https://lark.alipay.com/vision/error';
	var loggerInstance;
	var LoggerManager = /** @class */function () {
	    function LoggerManager(configs) {
	        this.logMessageMap = {};
	        this.lang = 'zh_CN';
	        this.configs = configs || {};
	        this.logger = log;
	    }
	    LoggerManager.prototype.setLang = function (lang) {
	        this.lang = lang;
	    };
	    LoggerManager.prototype.getLang = function () {
	        return this.lang;
	    };
	    LoggerManager.prototype.setEnv = function (env) {
	        this.logEnv = env;
	        this.logger.setLevel(LOG_ENV[env]);
	    };
	    LoggerManager.prototype.getEnv = function () {
	        return this.logEnv;
	    };
	    LoggerManager.prototype.setLogLevel = function (level) {
	        this.logger.setLevel(level);
	    };
	    LoggerManager.prototype.getLogLevel = function () {
	        return this.logger.getLevel();
	    };
	    LoggerManager.prototype.setLogMap = function (errorMap) {
	        this.logMessageMap = _extends(this.logMessageMap, errorMap);
	    };
	    LoggerManager.prototype.getLogMap = function () {
	        return this.logMessageMap;
	    };
	    LoggerManager.prototype.log = function (logTypeName) {
	        var logRecord = this.logMessageMap[logTypeName];
	        if (logRecord && logRecord.type) {
	            if (LOG_LEVEL.indexOf(logRecord.type) < 0) {
	                logRecord.type = 'info';
	            }
	            var docUrl = logRecord.doc || this.configs.defaultErrorDocUrl || DEFAULT_DOC_ADDRESS;
	            this.logger[logRecord.type].call(null, (logRecord.title || logRecord.type.toUpperCase()) + ": " + logRecord[this.lang] + " see %o", docUrl);
	        } else {
	            this.logger.info('Unknown Log Type: 未知 Log 类型');
	        }
	    };
	    LoggerManager.prototype.trace = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        loggerInstance.logger.trace.apply(null, args);
	    };
	    LoggerManager.prototype.debug = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        loggerInstance.logger.debug.apply(null, args);
	    };
	    LoggerManager.prototype.info = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        loggerInstance.logger.info.apply(null, args);
	    };
	    LoggerManager.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        loggerInstance.logger.warn.apply(null, args);
	    };
	    LoggerManager.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        loggerInstance.logger.error.apply(null, args);
	    };
	    return LoggerManager;
	}();
	exports.LoggerManager = LoggerManager;
	loggerInstance = new LoggerManager();
	exports.default = loggerInstance;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	* loglevel - https://github.com/pimterry/loglevel
	*
	* Copyright (c) 2013 Tim Perry
	* Licensed under the MIT license.
	*/
	(function (root, definition) {
	    "use strict";
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
					__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
					(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
					__WEBPACK_AMD_DEFINE_FACTORY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(this, function () {
	    "use strict";
	
	    // Slightly dubious tricks to cut down minimized file size
	    var noop = function() {};
	    var undefinedType = "undefined";
	
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	
	    // Cross-browser bind equivalent that works at least back to IE6
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	
	    // Build the best logging method possible for this env
	    // Wherever possible we want to bind, not wrap, to preserve stack traces
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	
	        if (typeof console === undefinedType) {
	            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	
	    // These private functions always need `this` to be set properly
	
	    function replaceLoggingMethods(level, loggerName) {
	        /*jshint validthis:true */
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	
	        // Define log.log as an alias for log.debug
	        this.log = this.debug;
	    }
	
	    // In old IE versions, the console isn't present until you first open it.
	    // We build realMethod() replacements here that regenerate logging methods
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	
	    // By default, we use closely bound real methods wherever possible, and
	    // otherwise we wait for a console to appear, and then try again.
	    function defaultMethodFactory(methodName, level, loggerName) {
	        /*jshint validthis:true */
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      var storageKey = "loglevel";
	      if (name) {
	        storageKey += ":" + name;
	      }
	
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	
	          if (typeof window === undefinedType) return;
	
	          // Use localStorage if available
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	
	          // Use session cookie as fallback
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	
	      function getPersistedLevel() {
	          var storedLevel;
	
	          if (typeof window === undefinedType) return;
	
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	
	          // Fallback to cookies if local storage gives us nothing
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	
	          // If the stored level is not valid, treat it as if nothing was stored.
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	
	          return storedLevel;
	      }
	
	      /*
	       *
	       * Public logger API - see https://github.com/pimterry/loglevel for details
	       *
	       */
	
	      self.name = name;
	
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	
	      self.methodFactory = factory || defaultMethodFactory;
	
	      self.getLevel = function () {
	          return currentLevel;
	      };
	
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {  // defaults to true
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	
	      self.setDefaultLevel = function (level) {
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	
	      // Initialize with the right level
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	
	    /*
	     *
	     * Top-level API
	     *
	     */
	
	    var defaultLogger = new Logger();
	
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if (typeof name !== "string" || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	
	    // Grab the current global log variable in case of overwrite
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	
	        return defaultLogger;
	    };
	
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	
	    return defaultLogger;
	}));
	

	/***/ })
	/******/ ]);


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var env_1 = __webpack_require__(10);
	var contextInstance = null;
	var VisualEngineContext = /** @class */ (function () {
	    function VisualEngineContext() {
	        this.managerMap = {};
	        this.moduleMap = {};
	        this.pluginsMap = {};
	        // singleton
	        if (!contextInstance) {
	            contextInstance = this;
	        }
	        else {
	            return contextInstance;
	        }
	    }
	    VisualEngineContext.prototype.use = function (pluginName, plugin) {
	        this.pluginsMap[pluginName || 'unknown'] = plugin;
	    };
	    VisualEngineContext.prototype.getPlugin = function (name) {
	        if (this.pluginsMap[name]) {
	            return this.pluginsMap[name];
	        }
	        else if (this.moduleMap[name]) {
	            return this.moduleMap[name];
	        }
	        return this.getManager(name);
	    };
	    VisualEngineContext.prototype.registerManager = function (name, manager) {
	        if (name && typeof name === 'object') {
	            this.managerMap = lodash_1.assign(this.managerMap, name);
	        }
	        else {
	            this.managerMap[name] = manager;
	        }
	        return this;
	    };
	    VisualEngineContext.prototype.registerModule = function (name, module) {
	        if (typeof name === 'object') {
	            this.moduleMap = Object.assign({}, this.moduleMap, name);
	        }
	        else {
	            this.moduleMap[name] = module;
	        }
	        return this;
	    };
	    VisualEngineContext.prototype.getManager = function (name) {
	        return this.managerMap[name];
	    };
	    VisualEngineContext.prototype.getModule = function (name) {
	        return this.moduleMap[name];
	    };
	    VisualEngineContext.prototype.getDesignerLocale = function () {
	        return env_1.default.getLocale();
	    };
	    /**
	     * Builtin APIs
	     */
	    /**
	     * support dynamic setter replacement
	     */
	    VisualEngineContext.prototype.registerDynamicSetterProvider = function (setterProvider) {
	        if (!setterProvider) {
	            console.error('ERROR: ', 'please set provider function.');
	            return;
	        }
	        this.use('ve.plugin.setterProvider', setterProvider);
	    };
	    /**
	     * support add treePane on the setting pane
	     * @param treePane see @ali/ve-tree-pane
	     * @param treeCore see @ali/ve-tree-pane
	     */
	    VisualEngineContext.prototype.registerTreePane = function (TreePane, TreeCore) {
	        if (TreePane && TreeCore) {
	            this.registerModule('TreePane', TreePane);
	            this.registerModule('TreeCore', TreeCore);
	        }
	    };
	    // TODO: export global event map
	    VisualEngineContext.prototype.getGlobalEventMap = function () {
	    };
	    return VisualEngineContext;
	}());
	exports.default = VisualEngineContext;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var const_1 = __webpack_require__(12);
	var Env = /** @class */ (function () {
	    function Env() {
	        this.emitter = new EventEmitter();
	        this.emitter.setMaxListeners(0);
	        this.envs = {};
	        this.featureMap = {};
	    }
	    Env.prototype.get = function (name) {
	        return this.getEnv(name);
	    };
	    Env.prototype.getEnv = function (name) {
	        return this.envs[name];
	    };
	    Env.prototype.set = function (name, value) {
	        return this.setEnv(name, value);
	    };
	    Env.prototype.setEnv = function (name, value) {
	        var orig = this.envs[name];
	        if (JSON.stringify(orig) === JSON.stringify(value)) {
	            return;
	        }
	        this.envs[name] = value;
	        this.emitter.emit('envchange', this.envs, name, value);
	    };
	    Env.prototype.setEnvMap = function (envs) {
	        this.envs = Object.assign(this.envs, envs);
	        this.emitter.emit('envchange', this.envs);
	    };
	    Env.prototype.getLocale = function () {
	        return this.getEnv('locale') || 'zh_CN';
	    };
	    Env.prototype.setLocale = function (locale) {
	        this.setEnv('locale', locale);
	    };
	    Env.prototype.setExpertMode = function (flag) {
	        this.setEnv('expertMode', !!flag);
	    };
	    Env.prototype.isExpertMode = function () {
	        return !!this.getEnv('expertMode');
	    };
	    Env.prototype.getSupportFeatures = function () {
	        return Object.assign({}, this.featureMap);
	    };
	    Env.prototype.setSupportFeatures = function (features) {
	        this.featureMap = Object.assign({}, this.featureMap, features);
	    };
	    Env.prototype.supports = function (name) {
	        if (name === void 0) { name = 'supports'; }
	        return !!this.featureMap[name];
	    };
	    Env.prototype.onEnvChange = function (func) {
	        var _this = this;
	        this.emitter.on('envchange', func);
	        return function () {
	            _this.emitter.removeListener('envchange', func);
	        };
	    };
	    Env.prototype.getAliSchemaVersion = function () {
	        return const_1.ALI_SCHEMA_VERSION;
	    };
	    return Env;
	}());
	exports.default = new Env();


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Storage the const variables
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Global
	 */
	exports.VERSION = '5.0.0';
	/**
	 * schema version defined in alibaba
	 */
	exports.ALI_SCHEMA_VERSION = '1.0.0';
	exports.VE_EVENTS = {
	    /**
	     * node props to be dynamically replaced
	     * @event props the new props object been replaced
	     */
	    VE_NODE_CREATED: 've.node.created',
	    VE_NODE_DESTROY: 've.node.destroyed',
	    VE_NODE_PROPS_REPLACE: 've.node.props.replaced',
	    // copy / clone node
	    VE_OVERLAY_ACTION_CLONE_NODE: 've.overlay.cloneElement',
	    // remove / delete node
	    VE_OVERLAY_ACTION_REMOVE_NODE: 've.overlay.removeElement',
	    // one page successfully mount on the DOM
	    VE_PAGE_PAGE_READY: 've.page.pageReady',
	};
	exports.VE_HOOKS = {
	    // a decorator function
	    VE_NODE_PROPS_DECORATOR: 've.leaf.props.decorator',
	    // a remove callback function
	    VE_NODE_REMOVE_HELPER: 've.outline.actions.removeHelper',
	    /**
	     * provide customization field
	     */
	    VE_SETTING_FIELD_PROVIDER: 've.settingField.provider',
	    /**
	     * VariableSetter for variable mode of a specified prop
	     */
	    VE_SETTING_FIELD_VARIABLE_SETTER: 've.settingField.variableSetter',
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var const_1 = __webpack_require__(12);
	var bundle_1 = __webpack_require__(14);
	var prototype_1 = __webpack_require__(37);
	var bus_1 = __webpack_require__(36);
	var dragengine_1 = __webpack_require__(21);
	var env_1 = __webpack_require__(10);
	var exchange_1 = __webpack_require__(20);
	var flags_1 = __webpack_require__(23);
	var location_1 = __webpack_require__(38);
	var panes_1 = __webpack_require__(51);
	var project_1 = __webpack_require__(60);
	var symbols_1 = __webpack_require__(122);
	var trunk_1 = __webpack_require__(31);
	var viewport_1 = __webpack_require__(41);
	var Hotkey = __webpack_require__(123);
	var vnode_1 = __webpack_require__(124);
	var pages_1 = __webpack_require__(61);
	var node_1 = __webpack_require__(39);
	var I18nUtil = __webpack_require__(47);
	/* tslint:disable: no-console */
	console.log("%cVisualEngine %cv" + const_1.VERSION, 'color:#000;font-weight:bold;', 'color:green;font-weight:bold;');
	// 全局属性配置
	exports.default = {
	    /**
	     * 不允许在下面添加核心类和对象了
	     * 推荐通过 Engine.Context 来处理
	     *
	     * @deprecated
	     */
	    /* 包抽象 */
	    Bundle: bundle_1.default,
	    /* pub/sub 集线器 */
	    Bus: new bus_1.default(),
	    /* 拖拽引擎 */
	    DragEngine: dragengine_1.default,
	    /* 环境变量 */
	    Env: env_1.default,
	    /* 状态交换 */
	    Exchange: exchange_1.default,
	    /* 状态 Flags */
	    Flags: flags_1.default,
	    /* 快捷键 */
	    Hotkey: Hotkey,
	    /* 多语言文案 */
	    I18nUtil: I18nUtil,
	    /* 页面管理 */
	    Pages: pages_1.default,
	    /* 面板管理 */
	    Panes: panes_1.default,
	    /* 应用管理 */
	    Project: project_1.default,
	    /* 包原型 */
	    Prototype: prototype_1.default,
	    /* 组件仓库 */
	    Trunk: new trunk_1.default(),
	    /* 版本号 */
	    Version: const_1.VERSION,
	    /* 事件 */
	    EVENTS: const_1.VE_EVENTS,
	    /* 修饰方法 */
	    HOOKS: const_1.VE_HOOKS,
	    /* 视图管理 */
	    Viewport: viewport_1.default,
	    /* 位置解析 */
	    Location: location_1.default,
	    /* Symbol 管理类 */
	    Symbols: symbols_1.default,
	    /* 节点类 */
	    Node: node_1.Node,
	    VirtualRenderingNode: vnode_1.VirtualRenderingNode,
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var lodash_1 = __webpack_require__(7);
	var placeholders_1 = __webpack_require__(15);
	var trunk_1 = __webpack_require__(31);
	var prototype_1 = __webpack_require__(37);
	function basename(name) {
	    return name ? (/[^\/]+$/.exec(name) || [''])[0] : '';
	}
	function getCamelName(name) {
	    var words = basename(name).replace(/^((vc)-)?(.+)/, '$3').split('-');
	    return words.reduce(function (s, word) { return s + word[0].toUpperCase() + word.substring(1); }, '');
	}
	var Bundle = /** @class */ (function () {
	    function Bundle(componentPrototypes, views, nameSpace) {
	        var _this = this;
	        /**
	         * if all components are packed in a single package
	         * the compositeBundle property shall be true
	         */
	        this.compositeBundle = false;
	        this.viewMap = {};
	        this.viewList = [];
	        this.nameSpace = nameSpace || '';
	        this.registry = {};
	        this.registryById = {};
	        this.prototypeList = [];
	        this.trunk = new trunk_1.default();
	        if (Array.isArray(views)) {
	            this.recursivelyRegisterViews(views);
	        }
	        componentPrototypes.forEach(function (item) {
	            var prototype = item.module;
	            if (prototype instanceof prototype_1.default) {
	                _this.revisePrototype(item, prototype);
	                var matchedView = _this.viewMap[item.componentName || prototype.getComponentName()] || null;
	                if (!prototype.getView() && matchedView) {
	                    prototype.setView(matchedView);
	                }
	                _this.registerPrototype(prototype);
	            }
	            else if (Array.isArray(prototype)) {
	                _this.recursivelyRegisterPrototypes(prototype, item);
	            }
	        });
	        this.prototypeList.forEach(function (p, idx) {
	            if (!p.getView()) {
	                p.setView(placeholders_1.UnknownComponent);
	            }
	        });
	        // invoke prototype mocker while the prototype does not exist
	        Object.keys(this.viewMap).forEach(function (viewName) {
	            if (!lodash_1.find(_this.prototypeList, function (proto) { return proto.getComponentName() === viewName; })) {
	                var mockedPrototype = _this.trunk.mockComponentPrototype(_this.viewMap[viewName]);
	                if (mockedPrototype) {
	                    _this.registry[viewName] = mockedPrototype;
	                    _this.registryById[mockedPrototype.getId()] = mockedPrototype;
	                    _this.prototypeList.push(mockedPrototype);
	                }
	            }
	        });
	    }
	    Bundle.prototype.addComponentBundle = function (bundles) {
	        /**
	         * Normal Component bundle: [ Prototype, PrototypeView ]
	         * Component without Prototype.js: [ View ]
	         */
	        if (bundles.length >= 2) {
	            var prototype = bundles[0];
	            var prototypeView = bundles[1];
	            prototype.setView(prototypeView);
	            this.registerPrototype(prototype);
	        }
	        else if (bundles.length === 1) {
	            // Mock a Prototype for DIY Component load from async build
	            var proto = this.trunk.mockComponentPrototype(bundles[0]);
	            if (!proto) {
	                return;
	            }
	            if (!proto.getView()) {
	                proto.setView(bundles[0]);
	            }
	            this.registerPrototype(proto);
	        }
	    };
	    Bundle.prototype.removeComponentBundle = function (componentName) {
	        var cIndex = lodash_1.findIndex(this.prototypeList, function (proto) { return proto.getComponentName() === componentName; });
	        var id = this.prototypeList[cIndex].getId();
	        delete this.registryById[id];
	        delete this.registry[componentName];
	        this.prototypeList.splice(cIndex, 1);
	    };
	    Bundle.prototype.getNamespace = function () {
	        return this.nameSpace;
	    };
	    Bundle.prototype.getList = function () {
	        return this.prototypeList;
	    };
	    Bundle.prototype.get = function (componentName) {
	        return this.registry[componentName];
	    };
	    Bundle.prototype.getById = function (id) {
	        return this.registryById[id];
	    };
	    Bundle.prototype.isCompositeBundle = function () {
	        return this.isCompositeBundle;
	    };
	    Bundle.prototype.replacePrototype = function (componentName, cp) {
	        var view = this.get(componentName).getView();
	        this.removeComponentBundle(componentName);
	        this.registry[cp.getComponentName()] = cp;
	        this.registryById[cp.getId()] = cp;
	        this.prototypeList.push(cp);
	        cp.setView(view);
	    };
	    Bundle.prototype.recursivelyRegisterPrototypes = function (list, cp) {
	        var _this = this;
	        var propList = list;
	        propList.forEach(function (proto, index) {
	            if (Array.isArray(proto)) {
	                _this.recursivelyRegisterPrototypes(proto, cp);
	                return;
	            }
	            if (proto instanceof prototype_1.default) {
	                if (!proto.getView() && _this.viewMap[proto.getComponentName()]) {
	                    proto.setView(_this.viewMap[proto.getComponentName()]);
	                }
	                if (index === 0 && cp.componentName) {
	                    proto.setComponentName(cp.componentName);
	                }
	                _this.registerPrototype(proto);
	            }
	        });
	    };
	    Bundle.prototype.recursivelyRegisterViews = function (list, viewName) {
	        var _this = this;
	        list.forEach(function (item) {
	            if (Array.isArray(item.module)) {
	                return _this.recursivelyRegisterViews(item.module, item.name);
	            }
	            else if (Array.isArray(item)) {
	                _this.compositeBundle = true;
	                return _this.recursivelyRegisterViews(item, viewName);
	            }
	            var viewDetail;
	            if (item.module && typeof item.module === 'function') {
	                viewDetail = item.module;
	            }
	            else {
	                viewDetail = item;
	            }
	            if (!viewDetail.displayName) {
	                vu_logger_1.default.log('ERROR_NO_PROTOTYPE_VIEW');
	                vu_logger_1.default.error('WARNING: the package without displayName is', item);
	                viewDetail.displayName = lodash_1.upperFirst(
	                // mock componentName from packageName
	                lodash_1.camelCase((viewName || item.name).split('-').slice(1).join('-')));
	            }
	            _this.viewMap[viewDetail.displayName] = viewDetail;
	            _this.viewList.push(viewDetail);
	        });
	    };
	    Bundle.prototype.revisePrototype = function (item, prototype) {
	        var name = item.name || item.componentName;
	        if (item.category) {
	            prototype.setCategory(item.category);
	        }
	        if (item.name && !prototype.getPackageName()) {
	            prototype.setPackageName(item.name);
	        }
	        if (item.componentName) {
	            prototype.setComponentName(item.componentName);
	        }
	        if (!prototype.getComponentName()) {
	            prototype.setComponentName(getCamelName(name));
	        }
	    };
	    Bundle.prototype.registerPrototype = function (prototype) {
	        if (this.registry[prototype.getComponentName()]) {
	            vu_logger_1.default.warn('WARN: override prototype', prototype, prototype.getComponentName());
	            var idx = lodash_1.findIndex(this.prototypeList, function (proto) {
	                return prototype.getComponentName() === proto.getComponentName();
	            });
	            this.prototypeList[idx] = prototype;
	            delete this.registryById[prototype.getId()];
	        }
	        else {
	            this.prototypeList.push(prototype);
	        }
	        this.registry[prototype.getComponentName()] = prototype;
	        this.registryById[prototype.getId()] = prototype;
	    };
	    Bundle.createPrototype = prototype_1.default.create;
	    Bundle.addGlobalPropsReducer = prototype_1.default.addGlobalPropsReducer;
	    Bundle.addGlobalPropsConfigure = prototype_1.default.addGlobalPropsConfigure;
	    Bundle.addGlobalExtraActions = prototype_1.default.addGlobalExtraActions;
	    Bundle.addGlobalNodeCanDragConfig = prototype_1.default.addGlobalNodeCanDragConfig;
	    Bundle.removeGlobalPropsConfigure = prototype_1.default.removeGlobalPropsConfigure;
	    Bundle.overridePropsConfigure = prototype_1.default.overridePropsConfigure;
	    Bundle.create = function createBundle(components, views, nameSpace) {
	        return new Bundle(components, views, nameSpace);
	    };
	    return Bundle;
	}());
	exports.default = Bundle;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var React = __webpack_require__(5);
	var overlay_1 = __webpack_require__(16);
	__webpack_require__(27);
	var UnknownComponent = /** @class */ (function (_super) {
	    __extends(UnknownComponent, _super);
	    function UnknownComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    UnknownComponent.prototype.render = function () {
	        vu_logger_1.default.log('ERROR_NO_COMPONENT_VIEW');
	        vu_logger_1.default.error('Error component information:', this.props);
	        return React.createElement("div", { className: 'engine-unknow-component' },
	            "\u7EC4\u4EF6 ",
	            this.props._componentName,
	            " \u65E0\u89C6\u56FE\uFF0C\u8BF7\u6253\u5F00\u63A7\u5236\u53F0\u6392\u67E5");
	    };
	    return UnknownComponent;
	}(React.Component));
	exports.UnknownComponent = UnknownComponent;
	var FaultComponent = /** @class */ (function (_super) {
	    __extends(FaultComponent, _super);
	    function FaultComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FaultComponent.prototype.render = function () {
	        return (React.createElement("div", { className: 'engine-fault-component' },
	            "\u7EC4\u4EF6 ",
	            this.props._componentName,
	            " \u6E32\u67D3\u9519\u8BEF\uFF0C\u8BF7\u6253\u5F00\u63A7\u5236\u53F0\u6392\u67E5"));
	    };
	    return FaultComponent;
	}(React.Component));
	exports.FaultComponent = FaultComponent;
	var HiddenComponent = /** @class */ (function (_super) {
	    __extends(HiddenComponent, _super);
	    function HiddenComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HiddenComponent.prototype.render = function () {
	        return React.createElement("div", { className: 'engine-hidden-component' }, "\u5728\u672C\u9875\u9762\u4E0D\u663E\u793A");
	    };
	    return HiddenComponent;
	}(React.Component));
	exports.HiddenComponent = HiddenComponent;
	var InsertionGhost = /** @class */ (function (_super) {
	    __extends(InsertionGhost, _super);
	    function InsertionGhost() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InsertionGhost.prototype.componentDidMount = function () {
	        var elem = this.ghost;
	        overlay_1.default.getInsertionGhost().mount(elem);
	        this.willDetach = function () {
	            overlay_1.default.getInsertionGhost().unmount(elem);
	        };
	    };
	    InsertionGhost.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    InsertionGhost.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", { className: 'engine-insertion-ghost', ref: function (ref) { _this.ghost = ref; } }));
	    };
	    return InsertionGhost;
	}(React.Component));
	exports.InsertionGhost = InsertionGhost;
	exports.default = { FaultComponent: FaultComponent, HiddenComponent: HiddenComponent, UnknownComponent: UnknownComponent, InsertionGhost: InsertionGhost };


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hoveringcapture_1 = __webpack_require__(17);
	var insertionghost_1 = __webpack_require__(18);
	var outlinesync_1 = __webpack_require__(19);
	var watcher_1 = __webpack_require__(26);
	var Overlay = /** @class */ (function () {
	    function Overlay() {
	    }
	    Overlay.prototype.touch = function (delay) {
	        watcher_1.default.touch(delay);
	    };
	    Overlay.prototype.getHoveringLine = function () {
	        if (!this.hoveringLine) {
	            this.hoveringLine = new outlinesync_1.default('Hovering');
	        }
	        return this.hoveringLine;
	    };
	    Overlay.prototype.getDroppingLine = function () {
	        if (!this.droppingLine) {
	            this.droppingLine = new outlinesync_1.default('Dropping');
	        }
	        return this.droppingLine;
	    };
	    Overlay.prototype.getSelectedLine = function () {
	        if (!this.selectedLine) {
	            this.selectedLine = new outlinesync_1.default('Selected');
	        }
	        return this.selectedLine;
	    };
	    Overlay.prototype.getInPlaceEditingPoint = function () {
	        if (!this.inPlaceEditingPoint) {
	            this.inPlaceEditingPoint = new outlinesync_1.default('InPlaceEditing');
	        }
	        return this.inPlaceEditingPoint;
	    };
	    Overlay.prototype.getInsertionGhost = function () {
	        if (!this.insertionGhost) {
	            this.insertionGhost = new insertionghost_1.default();
	        }
	        return this.insertionGhost;
	    };
	    Overlay.prototype.getHoveringCapture = function () {
	        if (!this.hoveringCapture) {
	            this.hoveringCapture = new hoveringcapture_1.default();
	        }
	        return this.hoveringCapture;
	    };
	    return Overlay;
	}());
	exports.default = new Overlay();


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HoveringCapture = /** @class */ (function () {
	    function HoveringCapture() {
	    }
	    HoveringCapture.prototype.capture = function (e, onLeave) {
	        var _this = this;
	        this.release();
	        var box = this.boundary;
	        if (!box) {
	            return false;
	        }
	        var elem = e.relatedTarget
	            || document.elementFromPoint(e.clientX, e.clientY);
	        if (!elem || !box.contains(elem)) {
	            return false;
	        }
	        var leave = function (evt) {
	            onLeave(evt);
	            _this.release();
	        };
	        this.willDetach = function () {
	            box.removeEventListener('mouseleave', leave, false);
	            _this.willDetach = null;
	        };
	        box.addEventListener('mouseleave', leave, false);
	        return true;
	    };
	    HoveringCapture.prototype.release = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    HoveringCapture.prototype.setBoundary = function (boundary) {
	        this.release();
	        this.boundary = boundary;
	    };
	    return HoveringCapture;
	}());
	exports.default = HoveringCapture;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var InsertionSync = /** @class */ (function () {
	    function InsertionSync() {
	        this.emitter = new EventEmitter();
	    }
	    InsertionSync.prototype.mount = function (ghost) {
	        if (ghost === this.ghost) {
	            return;
	        }
	        this.ghost = ghost;
	        this.emitter.emit('sync', this.ghost);
	    };
	    InsertionSync.prototype.getGhost = function () {
	        return this.ghost;
	    };
	    InsertionSync.prototype.unmount = function (ghost) {
	        if (this.ghost === ghost) {
	            this.ghost = null;
	            this.emitter.emit('sync', null);
	        }
	    };
	    InsertionSync.prototype.onSync = function (func) {
	        var _this = this;
	        this.emitter.on('sync', func);
	        return function () {
	            _this.emitter.removeListener('sync', func);
	        };
	    };
	    return InsertionSync;
	}());
	exports.default = InsertionSync;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(11);
	var lodash_1 = __webpack_require__(7);
	var exchange_1 = __webpack_require__(20);
	var domobserver_1 = __webpack_require__(25);
	var watcher_1 = __webpack_require__(26);
	var OutlineSync = /** @class */ (function () {
	    function OutlineSync(name) {
	        var _this = this;
	        this.emitter = new events_1.EventEmitter();
	        lodash_1.get(exchange_1.default, "on" + name + "Change").bind(exchange_1.default)(function (node) {
	            if (node) {
	                _this.observe(node);
	            }
	            else {
	                _this.stop();
	            }
	            _this.emitter.emit('sync');
	        });
	        var currentNode = lodash_1.get(exchange_1.default, "get" + name).bind(exchange_1.default)();
	        if (currentNode) {
	            this.observe(currentNode);
	        }
	    }
	    OutlineSync.prototype.observe = function (node) {
	        var _this = this;
	        if (node === this.currentNode) {
	            return;
	        }
	        var sync = function () { return _this.emitter.emit('sync'); };
	        if (!this.domObserver) {
	            this.domObserver = new domobserver_1.default(sync);
	        }
	        this.domObserver.observe(node);
	        if (this.mountOff) {
	            this.mountOff();
	            this.mountOff = null;
	        }
	        this.mountOff = node.onMountChange(function () {
	            _this.domObserver.observe(node);
	            sync();
	        });
	        if (!this.watchOff) {
	            this.watchOff = watcher_1.default.addSync(sync);
	        }
	        this.currentNode = node;
	    };
	    OutlineSync.prototype.stop = function () {
	        this.currentNode = null;
	        if (this.domObserver) {
	            this.domObserver.stop();
	        }
	        if (this.mountOff) {
	            this.mountOff();
	            this.mountOff = null;
	        }
	        if (this.watchOff) {
	            this.watchOff();
	            this.watchOff = null;
	        }
	    };
	    OutlineSync.prototype.hasOutline = function () {
	        return this.currentNode && this.currentNode.isMount();
	    };
	    OutlineSync.prototype.getCurrentNode = function () {
	        return this.currentNode;
	    };
	    OutlineSync.prototype.onSync = function (func) {
	        var _this = this;
	        this.emitter.on('sync', func);
	        return function () {
	            _this.emitter.removeListener('sync', func);
	        };
	    };
	    return OutlineSync;
	}());
	exports.default = OutlineSync;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var dragengine_1 = __webpack_require__(21);
	var Exchange = /** @class */ (function () {
	    function Exchange() {
	        var _this = this;
	        this.emitter = new EventEmitter();
	        this.draggingNode = null;
	        this.droppingNode = null;
	        this.selectedNode = null;
	        this.hoveringNode = null;
	        this.lockingNode = null;
	        this.inPlaceEditingNode = null;
	        dragengine_1.default.onDragstart(function (e, dragment) {
	            _this.select(null);
	            _this.hover(null);
	            if (dragment.isNode) {
	                _this.dragging(dragment);
	            }
	        });
	        dragengine_1.default.onDrag(function (e, dragment, location) {
	            if (location) {
	                _this.dropping(location.getContainer(), location.getInsertion());
	            }
	            else {
	                _this.dropping(null);
	            }
	        });
	        dragengine_1.default.onDragend(function (dragment, location, copy) {
	            _this.dragging(null);
	            _this.dropping(null);
	            if (dragment.isMetadata) {
	                return;
	            }
	            if (location) {
	                if (copy && dragment.toData) {
	                    dragment = dragment.toData();
	                }
	                var node = location.getContainer()
	                    .insert(dragment, location.getInsertion());
	                if (node) {
	                    _this.select(node);
	                }
	            }
	        });
	    }
	    Exchange.prototype.purge = function (node) {
	        if (node) {
	            if (this.draggingNode === node) {
	                this.dragging(null);
	            }
	            else if (this.droppingNode === node) {
	                this.dropping(null);
	            }
	            else if (this.selectedNode === node) {
	                this.select(null);
	            }
	            else if (this.hoveringNode === node) {
	                this.hover(null);
	            }
	        }
	        else {
	            this.dragging(null);
	            this.dropping(null);
	            this.select(null);
	            this.hover(null);
	            this.lock(null);
	        }
	    };
	    Exchange.prototype.hover = function (node) {
	        while (node && !node.canHovering()) {
	            node = node.getParent();
	        }
	        if (node === this.draggingNode || node === this.droppingNode) {
	            node = null;
	        }
	        if (this.hoveringNode === node) {
	            return;
	        }
	        if (this.hoveringNode) {
	            this.hoveringNode.setStatus('hovering', false);
	        }
	        if (node) {
	            node.setStatus('hovering', true);
	        }
	        this.hoveringNode = node;
	        this.emitter.emit('hoveringchange', this.hoveringNode);
	    };
	    Exchange.prototype.getHovering = function () {
	        return this.hoveringNode;
	    };
	    Exchange.prototype.select = function (node) {
	        while (node && !node.canSelecting()) {
	            node = node.getParent();
	        }
	        if (node) {
	            this.emitter.emit('intoview', node);
	        }
	        if (this.lockingNode && this.lockingNode !== node) {
	            this.lock(null);
	        }
	        if (this.selectedNode === node) {
	            return;
	        }
	        if (this.selectedNode) {
	            this.selectedNode.setStatus('selected', false);
	        }
	        if (node) {
	            this.hoveringNode = node;
	            node.setStatus('selected', true);
	            node.setStatus('hovering', true);
	        }
	        this.selectedNode = node;
	        this.emitter.emit('selectedchange', this.selectedNode);
	    };
	    Exchange.prototype.getSelected = function () {
	        return this.selectedNode;
	    };
	    Exchange.prototype.dropping = function (node, insertion) {
	        if (node) {
	            this.emitter.emit('intoview', node, insertion);
	        }
	        if (this.droppingNode && this.droppingNode !== node) {
	            this.droppingNode.setStatus('dropping', false);
	        }
	        if (node) {
	            this.select(null);
	            this.hover(null);
	            node.setStatus('dropping', insertion);
	        }
	        this.droppingNode = node;
	        this.emitter.emit('droppingchange', this.droppingNode);
	    };
	    Exchange.prototype.getDropping = function () {
	        return this.droppingNode;
	    };
	    Exchange.prototype.dragging = function (node) {
	        if (this.draggingNode === node) {
	            return;
	        }
	        if (this.draggingNode) {
	            this.draggingNode.setStatus('dragging', false);
	        }
	        if (node) {
	            this.dropping(null);
	            this.select(null);
	            this.hover(null);
	            node.setStatus('dragging', true);
	        }
	        this.draggingNode = node;
	        this.emitter.emit('draggingchange', this.draggingNode);
	    };
	    Exchange.prototype.lock = function (node) {
	        this.setNodeStatus(node, 'locking');
	    };
	    Exchange.prototype.inPlaceEdit = function (node) {
	        this.setNodeStatus(node, 'inPlaceEditing');
	    };
	    Exchange.prototype.getInPlaceEditing = function () {
	        return this.inPlaceEditingNode;
	    };
	    Exchange.prototype.getLocking = function () {
	        return this.lockingNode;
	    };
	    Exchange.prototype.onInPlaceEditingChange = function (func) {
	        var _this = this;
	        this.emitter.on('inPlaceEditingchange', func);
	        return function () {
	            _this.emitter.removeListener('inPlaceEditingchange', func);
	        };
	    };
	    Exchange.prototype.onHoveringChange = function (func) {
	        var _this = this;
	        this.emitter.on('hoveringchange', func);
	        return function () {
	            _this.emitter.removeListener('hoveringchange', func);
	        };
	    };
	    Exchange.prototype.onSelectedChange = function (func) {
	        var _this = this;
	        this.emitter.on('selectedchange', func);
	        return function () {
	            _this.emitter.removeListener('selectedchange', func);
	        };
	    };
	    Exchange.prototype.onDroppingChange = function (func) {
	        var _this = this;
	        this.emitter.on('droppingchange', func);
	        return function () {
	            _this.emitter.removeListener('droppingchange', func);
	        };
	    };
	    Exchange.prototype.onDraggingChange = function (func) {
	        var _this = this;
	        this.emitter.on('draggingchange', func);
	        return function () {
	            _this.emitter.removeListener('draggingchange', func);
	        };
	    };
	    Exchange.prototype.onLockingChange = function (func) {
	        var _this = this;
	        this.emitter.on('lockingchange', func);
	        return function () {
	            _this.emitter.removeListener('lockingchange', func);
	        };
	    };
	    Exchange.prototype.onIntoView = function (func) {
	        var _this = this;
	        this.emitter.on('intoview', func);
	        return function () {
	            _this.emitter.removeListener('intoview', func);
	        };
	    };
	    Exchange.prototype.setNodeStatus = function (node, status) {
	        var nodeHolder = (status === 'locking' ? 'lockingNode' : 'inPlaceEditingNode');
	        if (this[nodeHolder] === node) {
	            return;
	        }
	        if (this[nodeHolder]) {
	            this[nodeHolder].setStatus(status, false);
	            this[nodeHolder] = null;
	        }
	        if (node) {
	            this.select(node);
	            node.setStatus(status, true);
	        }
	        this[nodeHolder] = node;
	        this.emitter.emit(status + "change", this[nodeHolder]);
	    };
	    return Exchange;
	}());
	exports.default = new Exchange();


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var cursor_1 = __webpack_require__(22);
	var flags_1 = __webpack_require__(23);
	var SHAKE_DISTANCE = 4;
	/**
	 * 抖动检测，只有当鼠标移动位移距离超过定值的时候才算抖动
	 *
	 * @param {any} e1 MouseEvent
	 * @param {any} e2 MouseEvent
	 * @returns Boolean
	 */
	function hasShake(e1, e2, distance) {
	    if (distance === void 0) { distance = SHAKE_DISTANCE; }
	    return (Math.pow((e1.clientY - e2.clientY), 2) + Math.pow((e1.clientX - e2.clientX), 2))
	        > distance;
	}
	var DragEngine = /** @class */ (function () {
	    function DragEngine() {
	        var _this = this;
	        this.sensors = [];
	        this.emitter = new EventEmitter();
	        var prevent = function (e) {
	            if (!_this.boosted) {
	                return null;
	            }
	            e.preventDefault();
	            e.stopPropagation();
	            return false;
	        };
	        document.addEventListener('selectstart', prevent, true);
	        document.addEventListener('dragstart', prevent, true);
	    }
	    DragEngine.prototype.setUseHandler = function (flag) {
	        this.useHandler = flag;
	    };
	    DragEngine.prototype.isUseHandler = function () {
	        return this.useHandler;
	    };
	    /**
	     * drag from
	     * @param shell
	     * @param boost (e: MouseEvent) => VE.Node
	     */
	    DragEngine.prototype.from = function (shell, boost) {
	        var _this = this;
	        var mousedown = function (e) {
	            _this.boosted = false;
	            // ESC or RightClick
	            if (e.which === 3 || e.button === 2) {
	                return;
	            }
	            // Get a new node to be dragged
	            var node = boost(e);
	            if (!node) {
	                return;
	            }
	            _this.boost(node, e);
	        };
	        shell.addEventListener('mousedown', mousedown);
	        return function () {
	            shell.removeEventListener('mousedown', mousedown);
	        };
	    };
	    DragEngine.prototype.boost = function (dragment, boostEvent) {
	        var _this = this;
	        this.lastLocation = null;
	        this.lastSensor = null;
	        this.isNewBie = !dragment.isNode;
	        this.isMoving = false;
	        this.boosted = true;
	        var checkesc = function (e) {
	            if (e.keyCode === 27) {
	                _this.lastLocation = null;
	                over(); // eslint-disable-line
	            }
	        };
	        var checkcopy = function (e) {
	            if ((e.altKey || e.ctrlKey) && !_this.isNewBie) {
	                cursor_1.default.setCopy(true);
	            }
	            else {
	                cursor_1.default.setCopy(false);
	            }
	        };
	        var drag = function (e) {
	            checkcopy(e);
	            // sensor 为拖动元素的可放置区域（敏感区）
	            var sensor = _this.chooseSensor(e);
	            if (sensor) {
	                _this.lastLocation = sensor.orient(dragment, e);
	            }
	            else {
	                _this.lastLocation = null;
	            }
	            _this.emitter.emit('drag', e, dragment, _this.lastLocation);
	        };
	        var dragstart = function () {
	            if (!_this.isNewBie) {
	                _this.chooseSensor(boostEvent);
	            }
	            cursor_1.default.setMove(true);
	            // ESC cancel drag
	            document.addEventListener('keydown', checkesc, false);
	            flags_1.default.setDragMode(true);
	            _this.emitter.emit('dragstart', boostEvent, dragment);
	        };
	        var move = function (e) {
	            if (_this.isMoving) {
	                drag(e);
	                return;
	            }
	            if (hasShake(e, boostEvent)) {
	                _this.isMoving = true;
	                boostEvent.shaked = true;
	                dragstart();
	                drag(e);
	            }
	        };
	        var over = function () {
	            if (_this.lastSensor) {
	                _this.lastSensor.deactive();
	            }
	            _this.lastSensor = null;
	            _this.isNewBie = false;
	            _this.boosted = false;
	            var exception;
	            if (_this.isMoving) {
	                try {
	                    _this.emitter.emit('dragend', dragment, _this.lastLocation, cursor_1.default.isCopy());
	                }
	                catch (ex) {
	                    exception = ex;
	                }
	            }
	            _this.isMoving = false;
	            _this.lastLocation = null;
	            document.removeEventListener('mousemove', move, true);
	            document.removeEventListener('mouseup', over, true);
	            document.removeEventListener('keydown', checkesc, false);
	            document.removeEventListener('keydown', checkcopy, false);
	            document.removeEventListener('keyup', checkcopy, false);
	            flags_1.default.setDragMode(false);
	            cursor_1.default.release();
	            if (exception) {
	                throw exception;
	            }
	        };
	        document.addEventListener('mousemove', move, true);
	        document.addEventListener('mouseup', over, true);
	        document.addEventListener('keydown', checkcopy, false);
	        document.addEventListener('keyup', checkcopy, false);
	    };
	    DragEngine.prototype.inDragging = function () {
	        return this.isMoving;
	    };
	    DragEngine.prototype.addSensor = function (sensor) {
	        this.sensors.push(sensor);
	    };
	    DragEngine.prototype.removeSensor = function (sensor) {
	        var i = this.sensors.indexOf(sensor);
	        if (i > -1) {
	            this.sensors.splice(i, 1);
	        }
	    };
	    DragEngine.prototype.chooseSensor = function (e) {
	        var useSensor;
	        if (this.isNewBie && !this.lastLocation) {
	            useSensor = this.sensors.find(function (sensor) { return sensor.isEnabled() && sensor.isEnter(e); });
	        }
	        else {
	            useSensor = this.sensors.find(function (sensor) { return sensor.isEnabled() && sensor.isInRange(e); })
	                || this.lastSensor;
	        }
	        if (useSensor !== this.lastSensor) {
	            if (this.lastSensor) {
	                this.lastSensor.deactive();
	            }
	            this.lastSensor = useSensor;
	        }
	        return useSensor;
	    };
	    DragEngine.prototype.onDragstart = function (func) {
	        var _this = this;
	        this.emitter.on('dragstart', func);
	        return function () {
	            _this.emitter.removeListener('dragstart', func);
	        };
	    };
	    DragEngine.prototype.onDrag = function (func) {
	        var _this = this;
	        this.emitter.on('drag', func);
	        return function () {
	            _this.emitter.removeListener('drag', func);
	        };
	    };
	    DragEngine.prototype.onDragend = function (func) {
	        var _this = this;
	        this.emitter.on('dragend', func);
	        return function () {
	            _this.emitter.removeListener('dragend', func);
	        };
	    };
	    return DragEngine;
	}());
	exports.default = new DragEngine();


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Cursor = /** @class */ (function () {
	    function Cursor() {
	        this.state = [];
	        this.state = [];
	    }
	    Cursor.prototype.addState = function (state) {
	        if (this.state.indexOf(state) === -1) {
	            this.state.push(state);
	            document.documentElement.classList.add("engine-cursor-" + state);
	        }
	    };
	    Cursor.prototype.hasState = function (state) {
	        return this.state.indexOf(state) > -1;
	    };
	    Cursor.prototype.removeState = function (state) {
	        var i = this.state.indexOf(state);
	        if (i > -1) {
	            this.state.splice(i, 1);
	            document.documentElement.classList.remove("engine-cursor-" + state);
	        }
	    };
	    Cursor.prototype.clearState = function () {
	        var i = this.state.length;
	        while (i-- > 0) {
	            this.removeState(this.state[i]);
	        }
	    };
	    Cursor.prototype.setMove = function (flag) {
	        if (flag) {
	            this.addState('move');
	        }
	        else {
	            this.removeState('move');
	        }
	    };
	    Cursor.prototype.setCopy = function (flag) {
	        if (flag) {
	            this.addState('copy');
	        }
	        else {
	            this.removeState('copy');
	        }
	    };
	    Cursor.prototype.isCopy = function () {
	        return this.hasState('copy');
	    };
	    Cursor.prototype.release = function () {
	        this.clearState();
	    };
	    return Cursor;
	}());
	exports.default = new Cursor();


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var domReady = __webpack_require__(24);
	var EventEmitter = __webpack_require__(11);
	var Shells = ['iphone6'];
	var Flags = /** @class */ (function () {
	    function Flags() {
	        var _this = this;
	        this.emitter = new EventEmitter();
	        this.flags = ['design-mode'];
	        domReady(function () {
	            _this.ready = true;
	            _this.applyFlags();
	        });
	    }
	    Flags.prototype.setDragMode = function (flag) {
	        if (flag) {
	            this.add('drag-mode');
	        }
	        else {
	            this.remove('drag-mode');
	        }
	    };
	    Flags.prototype.setPreviewMode = function (flag) {
	        if (flag) {
	            this.add('preview-mode');
	            this.remove('design-mode');
	        }
	        else {
	            this.add('design-mode');
	            this.remove('preview-mode');
	        }
	    };
	    Flags.prototype.setWithShell = function (shell) {
	        if (shell === this.lastShell) {
	            return;
	        }
	        if (this.lastShell) {
	            this.remove("with-" + this.lastShell + "shell");
	        }
	        if (shell) {
	            if (Shells.indexOf(shell) < 0) {
	                shell = Shells[0];
	            }
	            this.add("with-" + shell + "shell");
	            this.lastShell = shell;
	        }
	    };
	    Flags.prototype.setSimulator = function (device) {
	        if (this.lastSimulatorDevice) {
	            this.remove("simulator-" + this.lastSimulatorDevice);
	        }
	        if (device !== '' && device !== 'pc') {
	            this.add("simulator-" + device);
	        }
	        this.lastSimulatorDevice = device;
	    };
	    Flags.prototype.setHideSlate = function (flag) {
	        if (flag) {
	            this.add('hide-slate');
	        }
	        else {
	            this.remove('hide-slate');
	        }
	    };
	    Flags.prototype.getFlags = function () {
	        return this.flags;
	    };
	    Flags.prototype.applyFlags = function (modifiedFlag) {
	        var _this = this;
	        if (!this.ready) {
	            return;
	        }
	        var doe = document.documentElement;
	        if (this.lastFlags) {
	            this.lastFlags.filter(function (flag) { return _this.flags.indexOf(flag) < 0; }).forEach(function (flag) {
	                doe.classList.remove("engine-" + flag);
	            });
	        }
	        this.flags.forEach(function (flag) {
	            doe.classList.add("engine-" + flag);
	        });
	        this.lastFlags = this.flags.slice(0);
	        this.emitter.emit('flagschange', this.flags, modifiedFlag);
	    };
	    Flags.prototype.has = function (flag) {
	        return this.flags.indexOf(flag) > -1;
	    };
	    Flags.prototype.add = function (flag) {
	        if (!this.has(flag)) {
	            this.flags.push(flag);
	            this.applyFlags(flag);
	        }
	    };
	    Flags.prototype.remove = function (flag) {
	        var i = this.flags.indexOf(flag);
	        if (i > -1) {
	            this.flags.splice(i, 1);
	            this.applyFlags(flag);
	        }
	    };
	    Flags.prototype.onFlagsChange = function (func) {
	        var _this = this;
	        this.emitter.on('flagschange', func);
	        return function () {
	            _this.emitter.removeListener('flagschange', func);
	        };
	    };
	    return Flags;
	}());
	exports.default = new Flags();


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var SUPPORT_MUTATION_OBSERVER = !!lodash_1.get(window, 'MutationObserver', null);
	var DOMObserver = /** @class */ (function () {
	    function DOMObserver(sync) {
	        this.observer = SUPPORT_MUTATION_OBSERVER
	            ? new MutationObserver(sync) : null;
	    }
	    DOMObserver.prototype.observe = function (node) {
	        if (!this.observer) {
	            return;
	        }
	        if (!node) {
	            this.stop();
	            return;
	        }
	        var nativeNode = node.getDOMNode();
	        if (nativeNode === this.lastNativeNode) {
	            return;
	        }
	        if (nativeNode) {
	            this.observer.observe(nativeNode, {
	                attributes: true,
	                characterData: true,
	                childList: true,
	                subtree: true,
	            });
	            this.lastNativeNode = nativeNode;
	        }
	        else {
	            this.stop();
	        }
	    };
	    DOMObserver.prototype.stop = function () {
	        if (!this.observer) {
	            return;
	        }
	        this.observer.disconnect();
	        this.lastNativeNode = null;
	    };
	    return DOMObserver;
	}());
	exports.default = DOMObserver;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Watcher = /** @class */ (function () {
	    function Watcher() {
	        var _this = this;
	        this.synces = [];
	        window.onresize = function () {
	            _this.touch();
	        };
	    }
	    Watcher.prototype.touch = function (delay) {
	        var _this = this;
	        var applyTouch = function () {
	            if (_this.synces.length < 1) {
	                return;
	            }
	            _this.synces.forEach(function (item) { return item(); });
	        };
	        applyTouch();
	        if (delay) {
	            if (typeof delay === 'number') {
	                setTimeout(applyTouch, delay);
	            }
	            else {
	                requestAnimationFrame(applyTouch);
	            }
	        }
	    };
	    Watcher.prototype.addSync = function (sync) {
	        var _this = this;
	        if (this.synces.indexOf(sync) > -1) {
	            return null;
	        }
	        this.synces.push(sync);
	        return function () {
	            _this.removeSync(sync);
	        };
	    };
	    Watcher.prototype.removeSync = function (sync) {
	        var i = this.synces.indexOf(sync);
	        if (i > -1) {
	            this.synces.splice(i, 1);
	        }
	    };
	    return Watcher;
	}());
	exports.default = new Watcher();


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(28);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-insertion-ghost{height:0}.engine-dragging{filter:blur(2px) brightness(.6)}.engine-unknow-component{background:var(--color-function-information-light,#66a8d4)}.engine-fault-component,.engine-unknow-component{padding:15px;color:var(--color-text-reverse,hsla(0,0%,100%,.8));font-size:18px;text-align:center}.engine-fault-component{background:var(--color-function-error-dark,#ae1e0d)}.engine-hidden-component{background:var(--color-function-information,#2e76a6);padding:5px;color:var(--color-text-reverse,hsla(0,0%,100%,.8));font-size:16px;text-align:center;font-style:italic}", ""]);
	
	// exports


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var EventEmitter = __webpack_require__(11);
	var lodash_1 = __webpack_require__(7);
	var util_1 = __webpack_require__(32);
	var bus_1 = __webpack_require__(36);
	var singletonTrunk = null;
	var Trunk = /** @class */ (function () {
	    function Trunk() {
	        this.trunk = [];
	        this.bus = new bus_1.default();
	        this.emitter = new EventEmitter();
	        this.componentBundleLoader = null;
	        if (!singletonTrunk) {
	            singletonTrunk = this;
	        }
	        return singletonTrunk;
	    }
	    Trunk.prototype.isReady = function () {
	        return this.getList().length > 0;
	    };
	    Trunk.prototype.addBundle = function (bundle, bundleOptions) {
	        var _this = this;
	        if (bundleOptions === void 0) { bundleOptions = {}; }
	        if (bundleOptions.before) {
	            bundleOptions.before.call(this, bundle).then(function (processedBundle) {
	                _this.trunk.push(processedBundle);
	                _this.emitter.emit('trunkchange');
	            });
	        }
	        else {
	            this.trunk.push(bundle);
	            this.emitter.emit('trunkchange');
	        }
	        if (bundleOptions.after) {
	            bundleOptions.after.call(this, bundle);
	        }
	    };
	    /**
	     * 注册组件信息加载器
	     * @param loader
	     */
	    Trunk.prototype.registerComponentBundleLoader = function (loader) {
	        this.componentBundleLoader = loader;
	    };
	    Trunk.prototype.registerComponentPrototypeMocker = function (mocker) {
	        this.componentPrototypeMocker = mocker;
	    };
	    /**
	     * ["componentName", {componentName, title, icon, category, defaultProps, ..}]
	     *
	     * @param {Array} list
	     */
	    Trunk.prototype.setList = function (list) {
	        this.list = this.parseList(list);
	        this.emitter.emit('trunkchange');
	    };
	    Trunk.prototype.addList = function (list) {
	        this.list = (this.getList()).concat(this.parseList(list));
	        this.emitter.emit('trunkchange');
	    };
	    Trunk.prototype.getBundle = function (nameSpace) {
	        if (!nameSpace) {
	            return this.trunk[0];
	        }
	        return lodash_1.find(this.trunk, function (b) { return b.getNamespace() === nameSpace; });
	    };
	    Trunk.prototype.getList = function () {
	        return this.list || this.trunk.reduceRight(function (prev, cur) { return prev.concat(cur.getList()); }, []);
	    };
	    Trunk.prototype.getRecents = function (limit) {
	        return this.getList().filter(function (prototype) { return prototype.getCategory(); }).slice(0, limit);
	    };
	    /**
	     * 列出所有组件列表
	     *
	     * @returns {Array}
	     */
	    Trunk.prototype.listByCategory = function () {
	        var categories = [];
	        var categoryMap = {};
	        var categoryItems = [];
	        var defaultCategory = {
	            items: categoryItems,
	            name: '*',
	        };
	        categories.push(defaultCategory);
	        categoryMap['*'] = defaultCategory;
	        this.getList().forEach(function (prototype) {
	            var cat = prototype.getCategory();
	            if (!cat) {
	                return;
	            }
	            if (!categoryMap.hasOwnProperty(cat)) {
	                var categoryMapItems = [];
	                categoryMap[cat] = {
	                    items: categoryMapItems,
	                    name: cat,
	                };
	                categories.push(categoryMap[cat]);
	            }
	            categoryMap[cat].items.push(prototype);
	        });
	        return categories;
	    };
	    Trunk.prototype.getAllCategories = function () {
	        return this.listByCategory().map(function (group) {
	            if (group.name === '*') {
	                return '未分类';
	            }
	            return group.name;
	        });
	    };
	    /**
	     * 获取仓库
	     *
	     * @returns {Array}
	     */
	    Trunk.prototype.getTrunk = function () {
	        return this.trunk;
	    };
	    /**
	     * 根据 componentName 查找对应的 prototype
	     *
	     * @param {string} componentName
	     * @returns {Prototype}
	     */
	    Trunk.prototype.getPrototype = function (componentName) {
	        if (!componentName) {
	            vu_logger_1.default.error('ERROR: no component name found while get Prototype');
	            return null;
	        }
	        var name = componentName.split('.');
	        var namespace = name.length > 1 ? name[0] : '';
	        var i = this.trunk.length;
	        var bundle;
	        var ns;
	        var prototype;
	        while (i-- > 0) {
	            bundle = this.trunk[i];
	            ns = bundle.getNamespace();
	            if (ns === '' || namespace === ns) {
	                prototype = bundle.get(componentName);
	                if (prototype) {
	                    return prototype;
	                }
	            }
	        }
	        return null;
	    };
	    Trunk.prototype.getPrototypeById = function (id) {
	        var i = this.trunk.length;
	        var bundle;
	        var prototype;
	        while (i-- > 0) {
	            bundle = this.trunk[i];
	            prototype = bundle.getById(id);
	            if (prototype) {
	                return prototype;
	            }
	        }
	        return null;
	    };
	    Trunk.prototype.getPrototypeView = function (componentName) {
	        var prototype = this.getPrototype(componentName);
	        return prototype ? prototype.getView() : null;
	    };
	    Trunk.prototype.loadComponentBundleList = function (componentBundleList) {
	        var _this = this;
	        Promise.all(componentBundleList.map(function (componentBundle) {
	            var name = componentBundle.name, version = componentBundle.version, path = componentBundle.path, bundleContextInfo = __rest(componentBundle, ["name", "version", "path"]);
	            return _this.loadComponentBundle(name, version, path, __assign(__assign({}, bundleContextInfo), { isDIYComponent: componentBundle.isDIYComponent, isSilence: true }));
	        })).then(function (results) {
	            results.forEach(function (r) { return _this.getBundle().addComponentBundle(r); });
	            _this.emitter.emit('trunkchange');
	        });
	    };
	    Trunk.prototype.loadComponentBundle = function (name, version, path, options) {
	        var _this = this;
	        var bundleList = [];
	        return new Promise(function (resolve, reject) {
	            if (options && options.isDIYComponent) {
	                var result = __assign({ name: name, version: version, path: path }, options);
	                if (util_1.isFunction(_this.beforeLoad)) {
	                    result = _this.beforeLoad(result);
	                }
	                return _this.componentBundleLoader.load(result.name, result.version, result.path)
	                    .then(function (b) {
	                    if (util_1.isFunction(_this.afterLoad)) {
	                        _this.afterLoad(b, __assign({ name: name, path: path, version: version }, options));
	                    }
	                    if (!options.isSilence) {
	                        _this.getBundle().addComponentBundle([b]);
	                        _this.emitter.emit('trunkchange');
	                    }
	                    resolve([b]);
	                })
	                    .catch(function (e) {
	                    _this.bus.emit('ve.error.networkError', e);
	                    reject(e);
	                });
	            }
	            else {
	                _this.componentBundleLoader.load(name, version, 'build/prototype.js')
	                    .then(function (b) {
	                    bundleList.push(b);
	                    return _this.componentBundleLoader.load(name, version, 'build/prototypeView.js');
	                })
	                    .then(function (b) {
	                    bundleList.push(b);
	                    if (!options.isSilence) {
	                        _this.getBundle().addComponentBundle(bundleList);
	                        _this.emitter.emit('trunkchange');
	                    }
	                    resolve(bundleList);
	                })
	                    .catch(function (e) {
	                    _this.bus.emit('ve.error.networkError', e);
	                    reject(e);
	                });
	            }
	        });
	    };
	    Trunk.prototype.removeComponentBundle = function (name) {
	        this.getBundle().removeComponentBundle(name);
	        this.emitter.emit('trunkchange');
	    };
	    Trunk.prototype.mockComponentPrototype = function (bundle) {
	        if (!this.componentPrototypeMocker) {
	            vu_logger_1.default.error('ERROR: no component prototypeMocker is set');
	        }
	        return this.componentPrototypeMocker
	            && this.componentPrototypeMocker.mockPrototype(bundle);
	    };
	    Trunk.prototype.beforeLoadBundle = function (fn) {
	        this.beforeLoad = fn;
	    };
	    Trunk.prototype.afterLoadBundle = function (fn) {
	        this.afterLoad = fn;
	    };
	    Trunk.prototype.onTrunkChange = function (func) {
	        var _this = this;
	        this.emitter.on('trunkchange', func);
	        return function () {
	            _this.emitter.removeListener('trunkchange', func);
	        };
	    };
	    Trunk.prototype.parseList = function (list) {
	        var _this = this;
	        if (this.trunk.length < 1) {
	            throw new Error('Must addBundle to Trunk before call parseList.');
	        }
	        return list.map(function (item) {
	            if (!item) {
	                return null;
	            }
	            var prototype = null;
	            if (typeof item === 'string') {
	                prototype = _this.getPrototype(item);
	            }
	            else if (item.componentName) {
	                prototype = _this.getPrototype(item.componentName);
	                if (prototype) {
	                    prototype = prototype.clone(item);
	                }
	            }
	            return prototype;
	        }).filter(function (item) { return item != null; });
	    };
	    return Trunk;
	}());
	exports.default = Trunk;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(34);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(35);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(33)))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var EventEmitter = __webpack_require__(11);
	var busInstance;
	/**
	 * Bus class as an EventEmitter
	 *
	 * @class Bus
	 */
	var Bus = /** @class */ (function () {
	    function Bus() {
	        if (busInstance) {
	            return busInstance;
	        }
	        busInstance = this;
	        this.emitter = new EventEmitter();
	    }
	    Bus.prototype.getEmitter = function () {
	        return this.emitter;
	    };
	    // alias to sub
	    Bus.prototype.on = function (event, func) {
	        return this.sub(event, func);
	    };
	    // alias to unsub
	    Bus.prototype.off = function (event, func) {
	        this.unsub(event, func);
	    };
	    // alias to pub
	    Bus.prototype.emit = function (event) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return this.pub.apply(this, __spreadArrays([event], args));
	    };
	    Bus.prototype.sub = function (event, func) {
	        var _this = this;
	        this.emitter.on(event, func);
	        return function () {
	            _this.emitter.removeListener(event, func);
	        };
	    };
	    Bus.prototype.once = function (event, func) {
	        var _this = this;
	        this.emitter.once(event, func);
	        return function () {
	            _this.emitter.removeListener(event, func);
	        };
	    };
	    Bus.prototype.unsub = function (event, func) {
	        if (func) {
	            this.emitter.removeListener(event, func);
	        }
	        else {
	            this.emitter.removeAllListeners(event);
	        }
	    };
	    /**
	     * Release & Publish Events
	     *
	     * @param {string} event 事件名称
	     * @param {...any[]} args 事件参数
	     * @memberof Bus
	     */
	    Bus.prototype.pub = function (event) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        vu_logger_1.default.info.apply(vu_logger_1.default, __spreadArrays(['INFO:', 'eventData:', event], args));
	        return (_a = this.emitter).emit.apply(_a, __spreadArrays([event], args));
	    };
	    Bus.prototype.removeListener = function (eventName, callback) {
	        return this.emitter.removeListener(eventName, callback);
	    };
	    return Bus;
	}());
	exports.default = Bus;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var PID = 0;
	var GlobalNodeCanDragConfig = [];
	var GlobalPropsReducers = [];
	var GlobalPropsConfigure = [];
	var GlobalExtraActions = [];
	var Overrides = {};
	function addGlobalPropsReducer(reducer) {
	    GlobalPropsReducers.push(reducer);
	}
	function addGlobalPropsConfigure(config) {
	    GlobalPropsConfigure.push(config);
	}
	function addGlobalExtraActions(actions) {
	    GlobalExtraActions.push(actions);
	}
	function addGlobalNodeCanDragConfig(drag) {
	    if (!lodash_1.isFunction(drag)) {
	        /* tslint:disable no-console */
	        console.error('ERROR: the global canDrag configure should be a function.');
	        return;
	    }
	    GlobalNodeCanDragConfig.push(drag);
	}
	function removeGlobalPropsConfigure(name) {
	    var l = GlobalPropsConfigure.length;
	    while (l-- > 0) {
	        if (GlobalPropsConfigure[l].name === name) {
	            GlobalPropsConfigure.splice(l, 1);
	        }
	    }
	}
	function overridePropsConfigure(componentName, configure) {
	    Overrides[componentName] = configure;
	}
	var DISPLAY_TYPE;
	(function (DISPLAY_TYPE) {
	    DISPLAY_TYPE["NONE"] = "none";
	    DISPLAY_TYPE["PLAIN"] = "plain";
	    DISPLAY_TYPE["INLINE"] = "inline";
	    DISPLAY_TYPE["BLOCK"] = "block";
	    DISPLAY_TYPE["ACCORDION"] = "accordion";
	    DISPLAY_TYPE["TAB"] = "tab";
	    DISPLAY_TYPE["ENTRY"] = "entry";
	})(DISPLAY_TYPE = exports.DISPLAY_TYPE || (exports.DISPLAY_TYPE = {}));
	var Prototype = /** @class */ (function () {
	    function Prototype(options, extraConfigs) {
	        if (extraConfigs === void 0) { extraConfigs = {}; }
	        /**
	         * is this prototype auto-generated by prototypeMocker
	         * from a normal VIEW file (React Component Class)
	         */
	        this.autoGenerated = false;
	        this.options = options;
	        this.id = "prototype-" + PID++;
	        if (extraConfigs.autoGenerated) {
	            this.autoGenerated = extraConfigs.autoGenerated;
	        }
	        if (this.options.hasSlot && !this.isContainer()) {
	            this.options.isContainer = true;
	            this.options.canDropIn = function () { return false; };
	        }
	    }
	    Prototype.prototype.getId = function () {
	        return this.id;
	    };
	    Prototype.prototype.getConfig = function (configName) {
	        if (configName) {
	            return this.options[configName];
	        }
	        return this.options;
	    };
	    Prototype.prototype.getPackageName = function () {
	        return this.packageName || this.options.packageName;
	    };
	    Prototype.prototype.getContextInfo = function (name) {
	        return name ? lodash_1.get(this.options, ['context', name], '') : this.options;
	    };
	    Prototype.prototype.getTitle = function () {
	        return this.options.title || this.getComponentName();
	    };
	    Prototype.prototype.getComponentName = function () {
	        return this.componentName || this.options.componentName || null;
	    };
	    Prototype.prototype.getDocUrl = function () {
	        return this.options.docUrl;
	    };
	    Prototype.prototype.getDefaultProps = function () {
	        return this.options.defaultProps || {};
	    };
	    Prototype.prototype.getPropConfigs = function () {
	        return this.options;
	    };
	    Prototype.prototype.getExtraActions = function () {
	        var extraActions = this.options.extraActions;
	        if (!extraActions) {
	            return GlobalExtraActions;
	        }
	        if (!Array.isArray(extraActions)) {
	            extraActions = [extraActions];
	        }
	        return __spreadArrays(GlobalExtraActions, extraActions);
	    };
	    Prototype.prototype.getCategory = function () {
	        if (this.category !== undefined) {
	            return this.category;
	        }
	        if (this.options.hasOwnProperty('category')) {
	            return this.options.category;
	        }
	        return '*';
	    };
	    Prototype.prototype.hasSlot = function () {
	        return this.options.hasSlot;
	    };
	    Prototype.prototype.setCategory = function (category) {
	        this.category = category;
	    };
	    Prototype.prototype.getIcon = function () {
	        return this.options.icon || '';
	    };
	    Prototype.prototype.setView = function (view) {
	        this.view = view;
	    };
	    Prototype.prototype.getView = function () {
	        return this.view || this.options.view || null;
	    };
	    Prototype.prototype.getInitialChildren = function () {
	        return this.options.initialChildren || null;
	    };
	    Prototype.prototype.getConfigure = function () {
	        var res = (this.options.configure || []).slice();
	        GlobalPropsConfigure.forEach(function (config) {
	            var position = config.position || 'bottom';
	            if (position === 'top') {
	                res.unshift(config);
	            }
	            else if (position === 'bottom') {
	                res.push(config);
	            }
	            else if (lodash_1.isObject(position.before || position.after)) {
	                var _a = position.before || position.after, prop_1 = _a.prop, value_1 = _a.value;
	                var index = -1;
	                if (prop_1 && value_1) {
	                    index = res.findIndex(function (e) { return e[prop_1] === value_1; });
	                }
	                if (index > -1) {
	                    if (position.hasOwnProperty('after')) {
	                        index += 1;
	                    }
	                    res.splice(index, 0, config);
	                }
	            }
	        });
	        var override = Overrides[this.getComponentName()];
	        if (override) {
	            if (Array.isArray(override)) {
	                res = override;
	            }
	            else {
	                var l = res.length;
	                var item = void 0;
	                while (l-- > 0) {
	                    item = res[l];
	                    if (item.name in override) {
	                        if (override[item.name]) {
	                            res.splice(l, 1, override[item.name]);
	                        }
	                        else {
	                            res.splice(l, 1);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    };
	    Prototype.prototype.getRectSelector = function () {
	        return this.options.rectSelector;
	    };
	    Prototype.prototype.isInline = function () {
	        return this.options.isInline != null ? this.options.isInline : null;
	    };
	    Prototype.prototype.isContainer = function () {
	        if (lodash_1.isFunction(this.options.isContainer)) {
	            return this.options.isContainer(this);
	        }
	        return this.options.isContainer != null ? this.options.isContainer : false;
	    };
	    Prototype.prototype.isModal = function () {
	        return this.options.isModal || false;
	    };
	    Prototype.prototype.isFloating = function () {
	        return this.options.isFloating || false;
	    };
	    Prototype.prototype.isAutoGenerated = function () {
	        return this.autoGenerated;
	    };
	    Prototype.prototype.setPackageName = function (name) {
	        this.packageName = name;
	    };
	    Prototype.prototype.setComponentName = function (componentName) {
	        this.componentName = componentName;
	    };
	    /**
	     * transform value from hot-value to view
	     */
	    Prototype.prototype.reduce = function (props) {
	        var reducers = this.options.reducers || [];
	        if (!Array.isArray(reducers)) {
	            reducers = [reducers];
	        }
	        // prepend global reducers
	        reducers = GlobalPropsReducers.concat(reducers);
	        if (reducers.length < 1) {
	            return props;
	        }
	        props = reducers.reduce(function (xprops, reducer) {
	            if (typeof reducer === 'function') {
	                return reducer(xprops);
	            }
	            return xprops;
	        }, props);
	        return props;
	    };
	    Prototype.prototype.transformToActive = function (props) {
	        var transducers = this.options.transducers;
	        if (!transducers) {
	            return props;
	        }
	        if (!Array.isArray(transducers)) {
	            transducers = [transducers];
	        }
	        props = transducers.reduce(function (xprops, transducer) {
	            if (transducer && typeof transducer.toActive === 'function') {
	                return transducer.toActive(xprops);
	            }
	            return xprops;
	        }, props);
	        return props;
	    };
	    Prototype.prototype.transformToStatic = function (props) {
	        var transducers = this.options.transducers;
	        if (!transducers) {
	            return props;
	        }
	        if (!Array.isArray(transducers)) {
	            transducers = [transducers];
	        }
	        props = transducers.reduce(function (xprops, transducer) {
	            if (transducer && typeof transducer.toStatic === 'function') {
	                return transducer.toStatic(xprops);
	            }
	            return xprops;
	        }, props);
	        return props;
	    };
	    Prototype.prototype.canDragging = function (node) {
	        if (this.canSelecting()) {
	            var draggable = ((this.options.canDragging === false)
	                || (this.options.canDraging === false))
	                ? false : true;
	            if (GlobalNodeCanDragConfig.length > 0) {
	                if (!lodash_1.flow(GlobalNodeCanDragConfig)(node)) {
	                    return false;
	                }
	            }
	            if (lodash_1.isFunction(draggable)) {
	                return draggable.call(node, node);
	            }
	            return draggable;
	        }
	        return false;
	    };
	    Prototype.prototype.canHovering = function () {
	        return this.options.canHovering != null ? this.options.canHovering : true;
	    };
	    Prototype.prototype.canSelecting = function () {
	        return this.options.canSelecting != null ? this.options.canSelecting : true;
	    };
	    Prototype.prototype.canOperating = function () {
	        return this.options.canOperating != null ? this.options.canOperating : true;
	    };
	    Prototype.prototype.canSetting = function () {
	        return this.canSelecting();
	    };
	    Prototype.prototype.canUseCondition = function () {
	        return this.options.canUseCondition != null ? this.options.canUseCondition : true;
	    };
	    Prototype.prototype.canLoop = function () {
	        return this.options.canLoop != null ? this.options.canLoop : true;
	    };
	    Prototype.prototype.canDropTo = function (container) {
	        if (!this.canDragging()) {
	            return false;
	        }
	        var oCanDropTo = this.options.canDropTo != null
	            ? this.options.canDropTo
	            : this.options.canDropto;
	        if (oCanDropTo != null) {
	            return this.xcan(oCanDropTo, container);
	        }
	        return true;
	    };
	    Prototype.prototype.canDropIn = function (dragment) {
	        var oCanDropIn = this.options.canDropIn != null
	            ? this.options.canDropIn
	            : this.options.canDroping;
	        if (oCanDropIn != null) {
	            return this.xcan(oCanDropIn, dragment);
	        }
	        return true;
	    };
	    Prototype.prototype.didDropIn = function (dragment, container) {
	        var fn = this.options.didDropIn;
	        if (typeof fn === 'function') {
	            fn.call(container || this, dragment);
	        }
	    };
	    Prototype.prototype.didDropOut = function (dragment, container) {
	        var fn = this.options.didDropOut;
	        if (typeof fn === 'function') {
	            fn.call(container || this, dragment);
	        }
	    };
	    Prototype.prototype.canContain = function (dragment) {
	        var oCanContain = this.options.canContain;
	        if (oCanContain != null) {
	            return this.xcan(oCanContain, dragment);
	        }
	        return true;
	    };
	    Prototype.prototype.clone = function (options) {
	        return new Prototype(lodash_1.assign({}, this.options, options || {}));
	    };
	    Prototype.prototype.xcan = function (ocan, placement) {
	        var t = typeof ocan;
	        if (t === 'function') {
	            return ocan(placement);
	        }
	        else if (t === 'string') {
	            return ocan.trim().split(/[ ,;|]+/).indexOf(placement.getComponentName()) > -1;
	        }
	        return ocan;
	    };
	    Prototype.addGlobalNodeCanDragConfig = addGlobalNodeCanDragConfig;
	    Prototype.addGlobalPropsReducer = addGlobalPropsReducer;
	    Prototype.addGlobalPropsConfigure = addGlobalPropsConfigure;
	    Prototype.addGlobalExtraActions = addGlobalExtraActions;
	    Prototype.removeGlobalPropsConfigure = removeGlobalPropsConfigure;
	    Prototype.overridePropsConfigure = overridePropsConfigure;
	    Prototype.create = function create(options, extraConfigs) {
	        if (extraConfigs === void 0) { extraConfigs = {}; }
	        return new Prototype(options, extraConfigs);
	    };
	    return Prototype;
	}());
	exports.default = Prototype;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(39);
	var Insertion = /** @class */ (function () {
	    function Insertion(insertion) {
	        this.index = insertion.nearIndex;
	        this.near = insertion.near;
	        this.nearAfter = insertion.nearAfter;
	        this.nearEdge = insertion.nearEdge;
	        this.nearContainerDisplay = insertion.nearContainerDisplay;
	        if (this.nearAfter && this.index >= 0) {
	            this.index += 1;
	        }
	    }
	    Insertion.prototype.getIndex = function () {
	        return this.index;
	    };
	    Insertion.prototype.getNear = function () {
	        return this.near;
	    };
	    Insertion.prototype.getNearRect = function () {
	        return this.near ? this.near.getRect() : null;
	    };
	    /**
	     * 是否是垂直的
	     */
	    Insertion.prototype.isVertical = function () {
	        return (!this.isNearEdge()
	            && ((this.near && this.near.isInline())
	                || (this.nearContainerDisplay
	                    && this.nearContainerDisplay.display === node_1.DisplayType.FLEX
	                    && this.nearContainerDisplay.flexDirection === node_1.FlexDirection.ROW)));
	    };
	    Insertion.prototype.isNearEdge = function () {
	        return this.nearEdge;
	    };
	    Insertion.prototype.isNearAfter = function () {
	        return this.nearAfter;
	    };
	    return Insertion;
	}());
	exports.Insertion = Insertion;
	var Location = /** @class */ (function () {
	    function Location(container, insertion) {
	        this.container = container;
	        this.insertion = insertion instanceof Insertion ? insertion : new Insertion(insertion);
	    }
	    Location.prototype.createLocation = function (container, insertion) {
	        return new Location(container, new Insertion(insertion));
	    };
	    Location.prototype.getContainer = function () {
	        return this.container;
	    };
	    Location.prototype.getInsertion = function () {
	        return this.insertion;
	    };
	    return Location;
	}());
	exports.Location = Location;
	function createLocation(container, insertion) {
	    return new Location(container, new Insertion(insertion));
	}
	exports.createLocation = createLocation;
	Object.defineProperty(Location, 'Insertion', {
	    value: Insertion,
	});
	exports.default = Location;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var immutable_1 = __webpack_require__(40);
	var const_1 = __webpack_require__(12);
	var bus_1 = __webpack_require__(36);
	var exchange_1 = __webpack_require__(20);
	var location_1 = __webpack_require__(38);
	var trunk_1 = __webpack_require__(31);
	var viewport_1 = __webpack_require__(41);
	var props_1 = __webpack_require__(42);
	var uniqueId = __webpack_require__(4).uniqueId;
	var bus = new bus_1.default();
	var DisplayType;
	(function (DisplayType) {
	    DisplayType["INLINE"] = "inline";
	    DisplayType["BLOCK"] = "block";
	    DisplayType["INLINE_BLOCK"] = "inline-block";
	    DisplayType["FLEX"] = "flex";
	})(DisplayType = exports.DisplayType || (exports.DisplayType = {}));
	var FlexDirection;
	(function (FlexDirection) {
	    FlexDirection["ROW"] = "row";
	    FlexDirection["ROW_REVERSE"] = "row-reverse";
	    FlexDirection["COLUMN"] = "column";
	    FlexDirection["COLUMN_REVERSE"] = "column-reverse";
	})(FlexDirection = exports.FlexDirection || (exports.FlexDirection = {}));
	function isPointInRect(point, rect) {
	    return (point.clientY >= rect.top
	        && point.clientY <= rect.bottom
	        && (point.clientX >= rect.left && point.clientX <= rect.right));
	}
	function distanceToRect(point, rect) {
	    var minX = Math.min(Math.abs(point.clientX - rect.left), Math.abs(point.clientX - rect.right));
	    var minY = Math.min(Math.abs(point.clientY - rect.top), Math.abs(point.clientY - rect.bottom));
	    if (point.clientX >= rect.left && point.clientX <= rect.right) {
	        minX = 0;
	    }
	    if (point.clientY >= rect.top && point.clientY <= rect.bottom) {
	        minY = 0;
	    }
	    return Math.sqrt(Math.pow(minX, 2) + Math.pow(minY, 2));
	}
	function distanceToEdge(point, rect) {
	    var distanceTop = Math.abs(point.clientY - rect.top);
	    var distanceBottom = Math.abs(point.clientY - rect.bottom);
	    return {
	        distance: Math.min(distanceTop, distanceBottom),
	        nearAfter: distanceBottom < distanceTop,
	    };
	}
	function isNearAfter(point, rect, inline, containerDisplay) {
	    if (inline
	        || (containerDisplay
	            && containerDisplay.display === DisplayType.FLEX
	            && (containerDisplay.flexDirection === FlexDirection.ROW
	                || containerDisplay.flexDirection === FlexDirection.ROW_REVERSE))) {
	        return (Math.abs(point.clientX - rect.left) + Math.abs(point.clientY - rect.top) >
	            Math.abs(point.clientX - rect.right) + Math.abs(point.clientY - rect.bottom));
	    }
	    return Math.abs(point.clientY - rect.top) > Math.abs(point.clientY - rect.bottom);
	}
	function getNodeProps(dataProps, nodeData) {
	    var condition = nodeData.condition, loop = nodeData.loop, loopArgs = nodeData.loopArgs;
	    var nodeProps = __assign({}, dataProps);
	    if (condition != null && dataProps) {
	        nodeProps.__condition__ = condition;
	    }
	    if (loop && dataProps) {
	        nodeProps.__loop__ = loop;
	    }
	    if (loopArgs && dataProps) {
	        nodeProps.__loopArgs__ = loopArgs;
	    }
	    return nodeProps;
	}
	var Node = /** @class */ (function () {
	    function Node(page, data, parent, options) {
	        var _this = this;
	        this.page = page;
	        this.parent = parent || null;
	        this.emitter = new EventEmitter();
	        var isHot = immutable_1.Map.isMap(data);
	        var children;
	        if (data.getComponentName) {
	            // from a prototype
	            this.proto = data;
	            this.id = uniqueId(null, 'node', 'engine-node');
	            this.componentName = this.proto.getComponentName();
	            this.props = new props_1.Props(this, this.proto.getConfigure(), this.proto.getDefaultProps());
	            var childrenInitial = this.proto.getInitialChildren();
	            if (typeof childrenInitial === 'function') {
	                children = childrenInitial.call(this, this.props);
	            }
	            else if (Array.isArray(childrenInitial)) {
	                children = childrenInitial;
	            }
	        }
	        else if (isHot) {
	            // from Immutable data
	            this.id = data.get('id');
	            this.componentName = data.get('componentName');
	            this.proto = new trunk_1.default().getPrototype(this.getComponentName()) || null;
	            if (this.proto) {
	                this.props = new props_1.Props(this, this.proto.getConfigure(), data.get('props'));
	            }
	            children = data.get('children');
	        }
	        else {
	            // from simple schema structure
	            data = this.transformInitData(data);
	            this.id = uniqueId(data.id, 'node', 'engine-node');
	            if (options && options.reserveSchemaNodeId) {
	                this.id = data.id || this.id;
	            }
	            this.componentName = data.componentName;
	            this.proto = new trunk_1.default().getPrototype(this.getComponentName()) || null;
	            if (this.proto) {
	                var dataProps = this.proto.transformToActive(data.props || {});
	                var nodeProps = getNodeProps(dataProps, data);
	                this.props = new props_1.Props(this, this.proto.getConfigure(), nodeProps);
	            }
	            this.initialPropsData = data.props;
	            children = data.children;
	            if (!children && this.isContainer()) {
	                var childrenInitial = this.proto.getInitialChildren();
	                if (typeof childrenInitial === 'function') {
	                    children = childrenInitial.call(this, this.props);
	                }
	                else if (Array.isArray(childrenInitial)) {
	                    children = childrenInitial;
	                }
	            }
	        }
	        this.valid = this.proto != null;
	        if (this.ableToModifyChildren()) {
	            if (children) {
	                if (isHot) {
	                    children = immutable_1.List.isList(children) ? children.toArray() : [];
	                }
	                else {
	                    children = Array.isArray(children) ? children : [];
	                }
	            }
	            else {
	                children = [];
	            }
	            var SubNodeType_1 = options && options.SubNodeType;
	            if (SubNodeType_1) {
	                this.children = children.map(function (child) { return new SubNodeType_1(_this.page, child, _this, options); });
	            }
	            else {
	                this.children = children.map(function (child) { return new Node(_this.page, child, _this, options); });
	            }
	        }
	        if (this.props) {
	            this.props.init();
	        }
	        this.status = {
	            dragging: false,
	            dropping: false,
	            hovering: false,
	            inPlaceEditing: false,
	            locking: false,
	            pseudo: false,
	            selected: false,
	            visibility: localStorage.getItem(this.getId() + "_visibility") !== 'hidden',
	        };
	        this.hotData = isHot
	            ? data
	            : immutable_1.Map({
	                children: this.ableToModifyChildren() ? immutable_1.List(this.children.map(function (node) { return node.getHotData(); })) : null,
	                componentName: this.getComponentName(),
	                id: this.getId(),
	                props: this.props ? this.props.getHotData() : null,
	            });
	        new bus_1.default().emit(const_1.VE_EVENTS.VE_NODE_CREATED, this);
	    }
	    Node.prototype.addRecord = function (title) {
	        var hotData = this.hotData.merge({
	            children: this.ableToModifyChildren() ? immutable_1.List(this.children.map(function (node) { return node.getHotData(); })) : [],
	            props: this.props ? this.props.getHotData() : null,
	        });
	        if (hotData.equals(this.hotData)) {
	            return;
	        }
	        title = title || 'Alter node';
	        this.hotData = hotData;
	        if (this.isRoot()) {
	            this.page.addHistory(title);
	        }
	        else if (this.parent) {
	            this.parent.addRecord(title);
	        }
	    };
	    Node.prototype.setPropValue = function (prop, value) {
	        if (this.props) {
	            this.props.setPropValue(prop, value);
	        }
	    };
	    Node.prototype.setStatus = function (field, flag) {
	        if (!this.status.hasOwnProperty(field)) {
	            return;
	        }
	        if (flag !== this.status[field]) {
	            if (field === 'pseudo' && flag && !this.status.selected) {
	                return;
	            }
	            if (field === 'selected' && !flag) {
	                this.status.pseudo = false;
	            }
	            if (field === 'visibility') {
	                localStorage.setItem(this.getId() + "_visibility", flag ? 'visible' : 'hidden'); // @todo 重构的时候重写
	            }
	            this.status[field] = flag;
	            this.emitter.emit('statuschange', this.status, field);
	        }
	    };
	    Node.prototype.setLock = function (flag) {
	        if (flag) {
	            exchange_1.default.lock(this);
	        }
	        else if (this.isLocking()) {
	            exchange_1.default.lock(null);
	        }
	    };
	    Node.prototype.setInPlaceEdit = function (flag) {
	        if (flag) {
	            exchange_1.default.inPlaceEdit(this);
	        }
	        else if (this.isInPlaceEditing()) {
	            exchange_1.default.inPlaceEdit(null);
	        }
	    };
	    Node.prototype.setParent = function (parent) {
	        if (parent === this.parent) {
	            return;
	        }
	        if (this.parent) {
	            this.parent.didDropOut(this);
	        }
	        this.parent = parent;
	        if (parent) {
	            parent.didDropIn(this);
	        }
	    };
	    Node.prototype.setProps = function (props) {
	        this.props = props;
	        bus.emit(const_1.VE_EVENTS.VE_NODE_PROPS_REPLACE, this.props, this);
	        this.emitter.emit('node.propsReplace', props);
	    };
	    Node.prototype.setHotData = function (hotData, options) {
	        var _this = this;
	        if (!immutable_1.Map.isMap(hotData)) {
	            return;
	        }
	        this.hotData = hotData;
	        if (this.ableToModifyChildren()) {
	            // diff children
	            var children = hotData.get('children');
	            var has_1 = {};
	            if (this.children) {
	                this.children.forEach(function (node) {
	                    has_1[node.getId()] = node;
	                });
	            }
	            this.children = (immutable_1.List.isList(children) ? children.toArray() : []).map(function (child) {
	                var id = child.get('id');
	                var node;
	                if (has_1.hasOwnProperty(id)) {
	                    node = has_1[id];
	                    delete has_1[id];
	                    node.setHotData(child, options);
	                }
	                else {
	                    node = new Node(_this.page, child, _this);
	                }
	                return node;
	            });
	            Object.keys(has_1).forEach(function (id) { return has_1[id].destroy(); });
	            this.emitter.emit('childrenchange', this.children);
	        }
	        if (this.props) {
	            this.props.setHotData(hotData.get('props'), {
	                disableMutator: true,
	            });
	        }
	    };
	    Node.prototype.setPrototype = function (proto) {
	        this.proto = proto;
	    };
	    Node.prototype.getHotData = function () {
	        return this.hotData;
	    };
	    Node.prototype.getId = function () {
	        return this.id;
	    };
	    Node.prototype.getStatus = function (field) {
	        return field ? this.status[field] : this.status;
	    };
	    Node.prototype.getChildren = function () {
	        return this.children;
	    };
	    Node.prototype.getParent = function () {
	        return this.parent;
	    };
	    Node.prototype.getPage = function () {
	        return this.page;
	    };
	    Node.prototype.getRoot = function () {
	        return this.getPage().getRoot();
	    };
	    Node.prototype.getPrototype = function () {
	        return this.proto;
	    };
	    Node.prototype.getExtraActions = function () {
	        var _this = this;
	        var actions = this.proto ? this.proto.getExtraActions() : [];
	        return actions.map(function (action) {
	            if (action && typeof action === 'function') {
	                return action.call(_this);
	            }
	            return action;
	        });
	    };
	    Node.prototype.getProps = function () {
	        return this.props;
	    };
	    Node.prototype.getProp = function (prop, createNewPropIfEmpty) {
	        return this.props ? this.props.getProp(prop, createNewPropIfEmpty) : null;
	    };
	    Node.prototype.getPropValue = function (prop) {
	        var resultProp = this.getProp(prop);
	        if (resultProp) {
	            return resultProp.getValue();
	        }
	        return null;
	    };
	    Node.prototype.getStaticProps = function (forSave) {
	        var props = {};
	        if (this.props) {
	            if (forSave) {
	                props = this.props.toData();
	            }
	            else {
	                props = this.props.toProps();
	            }
	            props = this.proto.transformToStatic(props);
	            if (!forSave) {
	                props = this.proto.reduce(props);
	            }
	        }
	        return props;
	    };
	    /**
	     * 获取组件标题
	     */
	    Node.prototype.getTitle = function () {
	        if (!this.proto) {
	            return this.getComponentName();
	        }
	        if (this.proto.getComponentName() === 'Slot') {
	            return this.getPropValue('slotTitle')
	                || this.getPropValue('slotName')
	                || this.getComponentName();
	        }
	        return this.proto.getTitle();
	    };
	    /**
	     * 获取组件标识
	     */
	    Node.prototype.getComponentName = function () {
	        return this.proto ? this.proto.getComponentName() : this.componentName || 'UnknownComponent';
	    };
	    /**
	     * 获取图标
	     */
	    Node.prototype.getIcon = function () {
	        return this.proto ? this.proto.getIcon() : '';
	    };
	    Node.prototype.getSuitablePlace = function (node, ref, dropIn) {
	        if (ref === void 0) { ref = null; }
	        if (dropIn === void 0) { dropIn = false; }
	        if (this.isRoot() || (this.isContainer() && dropIn)) {
	            if (this.canDropIn(node) && !(node.isNode && node.containsNode(this))) {
	                return { container: this, ref: ref };
	            }
	            else if (this.isRoot() && this.children.length > 0) {
	                /**
	                 * if the root element is not allowed to be dropped in
	                 * use the nearest child element as drop-in replacement
	                 */
	                var dropElement = this.children.filter(function (c) { return c.canDropIn(node); })[0];
	                if (dropElement) {
	                    return { container: dropElement, ref: ref };
	                }
	            }
	        }
	        var parent = this.getParent();
	        if (parent) {
	            return parent.getSuitablePlace(node, this, true);
	        }
	        return null;
	    };
	    Node.prototype.getIndex = function () {
	        var parent = this.getParent();
	        return parent ? parent.indexOf(this) : 0;
	    };
	    Node.prototype.getChild = function (index) {
	        if (!this.children) {
	            return null;
	        }
	        var l = this.children.length;
	        if (index >= l) {
	            return null;
	        }
	        if (index < 0) {
	            return null;
	        }
	        return this.children[index];
	    };
	    /**
	     * 获取矩形区域
	     */
	    Node.prototype.getRect = function () {
	        var prototype = this.getPrototype();
	        var rectSelector = prototype ? prototype.getRectSelector() : null;
	        var node = this.getDOMNode();
	        if (node) {
	            if (rectSelector) {
	                var rectNode = node.querySelector(rectSelector);
	                if (rectNode) {
	                    return rectNode.getBoundingClientRect();
	                }
	            }
	            return node.getBoundingClientRect();
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * 获取DOM节点
	     *
	     * @returns {DOMElement}
	     */
	    Node.prototype.getDOMNode = function () {
	        return this.getPage().findDOMNode(this.getId());
	    };
	    Node.prototype.isLocking = function () {
	        return exchange_1.default.getLocking() === this;
	    };
	    Node.prototype.isInPlaceEditing = function () {
	        return exchange_1.default.getInPlaceEditing() === this;
	    };
	    Node.prototype.isRoot = function () {
	        return false;
	    };
	    /**
	     * 是否可见
	     */
	    Node.prototype.isVisible = function () {
	        var device = viewport_1.default.getDevice().toUpperCase();
	        var visibility = this.getPropValue('visibility');
	        if (visibility == null || visibility === 'ALL') {
	            return true;
	        }
	        if (Array.isArray(visibility) && visibility.indexOf(device) > -1) {
	            return true;
	        }
	        return false;
	    };
	    Node.prototype.isVisibleInPane = function () {
	        return !!this.getStatus('visibility');
	    };
	    /**
	     * 是否是容器
	     */
	    Node.prototype.isContainer = function () {
	        return this.proto ? this.proto.isContainer() : false;
	    };
	    /**
	     * 是否行内元素
	     */
	    Node.prototype.isInline = function () {
	        var ret = this.proto ? this.proto.isInline() : null;
	        if (ret == null) {
	            var nativeNode = this.getDOMNode();
	            if (!nativeNode) {
	                return false;
	            }
	            var style = window.getComputedStyle(nativeNode);
	            return /^inline/.test(style.getPropertyValue('display'));
	        }
	        return ret;
	    };
	    Node.prototype.isEmpty = function () {
	        return !this.children || this.children.length < 1;
	    };
	    Node.prototype.isValid = function () {
	        return this.valid;
	    };
	    Node.prototype.isNode = function () {
	        return true;
	    };
	    Node.prototype.isMount = function () {
	        return this.getDOMNode() !== null;
	    };
	    /**
	     * 判断是否是一个节点的子级
	     * @param node 父级节点
	     * @param isRecursive 是否向上递归查找
	     */
	    Node.prototype.isChildOf = function (node, isRecursive) {
	        if (!isRecursive) {
	            return this.parent === node;
	        }
	        var child = this;
	        while (child.parent) {
	            if (child.parent === node) {
	                return true;
	            }
	            child = child.parent;
	        }
	        return false;
	    };
	    /**
	     * 能否拖动
	     */
	    Node.prototype.canDragging = function () {
	        var node = this;
	        return this.proto ? this.proto.canDragging(node) : false;
	    };
	    /**
	     * 能否悬停
	     */
	    Node.prototype.canHovering = function () {
	        return this.proto ? this.proto.canHovering() : true;
	    };
	    /**
	     * 能否选中
	     */
	    Node.prototype.canSelecting = function () {
	        return this.proto ? this.proto.canSelecting() : true;
	    };
	    /**
	     * 能否设置
	     */
	    Node.prototype.canSetting = function () {
	        return this.proto ? this.proto.canSetting() : true;
	    };
	    /**
	     * 能否操作
	     */
	    Node.prototype.canOperating = function () {
	        return this.proto ? this.proto.canOperating() : true;
	    };
	    /**
	     * 能否投至
	     *
	     * @param {Node} container
	     */
	    Node.prototype.canDropTo = function (container) {
	        return this.proto ? this.proto.canDropTo(container) : true;
	    };
	    /**
	     * 能否投入
	     *
	     * @param {Dragment} dragment
	     */
	    Node.prototype.canDropIn = function (dragment) {
	        return (this.proto ? this.proto.canDropIn(dragment) : false) && dragment.canDropTo(this);
	    };
	    Node.prototype.didDropIn = function (dragment) {
	        if (this.proto) {
	            this.proto.didDropIn(dragment, this);
	            if (this.parent) {
	                this.parent.didDropIn(dragment);
	            }
	        }
	    };
	    Node.prototype.didDropOut = function (dragment) {
	        if (this.proto) {
	            this.proto.didDropOut(dragment, this);
	            if (this.parent) {
	                this.parent.didDropOut(dragment);
	            }
	        }
	    };
	    Node.prototype.canContain = function (dragment) {
	        return this.isContainer() && dragment !== this && (this.proto ? this.proto.canContain(dragment) : false);
	    };
	    /**
	     * 定位
	     *
	     * @param {Dragment} dragment
	     * @param e
	     * @returns {Location}
	     */
	    Node.prototype.locate = function (dragment, e) {
	        var _this = this;
	        // 模态组件只能拖入到root节点
	        var isModal = dragment.isModal ? dragment.isModal() : dragment.getPrototype().isModal();
	        if (isModal) {
	            if (!this.isRoot()) {
	                return null;
	            }
	            else {
	                return location_1.createLocation(this, {
	                    near: this.children[0],
	                    nearAfter: false,
	                    nearContainerDisplay: null,
	                    nearEdge: true,
	                    nearIndex: 0,
	                });
	            }
	        }
	        // 当视图有模态组件时，只能拖入到模态组件或其children中
	        if (this.isRoot()) {
	            var modalManager = this.getPage().modalNodesManager;
	            var visibleModalNode = modalManager.getVisibleModalNode();
	            if (visibleModalNode) {
	                return visibleModalNode.locate(dragment, e);
	            }
	        }
	        // 当视图有悬浮组件时，优先判断能否拖入到悬浮组件中
	        if (this.isRoot() || (this.getPrototype().isModal() && !this.getPrototype().isFloating())) {
	            var floatingNodeManager = this.getPage().floatingNodesManager;
	            var floatingNodes = floatingNodeManager.getVisibleFloatingNodes();
	            floatingNodes = floatingNodes.filter(function (node) {
	                return node.isChildOf(_this, true);
	            });
	            if (floatingNodes && floatingNodes.length > 0) {
	                for (var i = 0, len = floatingNodes.length; i < len; i++) {
	                    var node_1 = floatingNodes[i];
	                    var rect_1 = node_1.getRect();
	                    if (!rect_1) {
	                        continue;
	                    }
	                    if (node_1.isContainer() && isPointInRect(e, rect_1)) {
	                        var location_2 = floatingNodes[i].locate(dragment, e);
	                        if (location_2) {
	                            return location_2;
	                        }
	                    }
	                }
	            }
	        }
	        if (!this.canContain(dragment) || !this.isVisible()) {
	            return null;
	        }
	        var edgeRect = this.getRect();
	        if (!edgeRect) {
	            return null;
	        }
	        var children = this.getChildren();
	        var node;
	        var rect;
	        var distance;
	        var near = null;
	        var nearDistance = null;
	        if (this.canDropIn(dragment)) {
	            var location_3;
	            var nearRect = null;
	            var nearIndex = 0;
	            var nearAfter = false;
	            var nearEdge = false;
	            for (var i = 0, l = children.length; i < l; i++) {
	                node = children[i];
	                rect = node.getRect();
	                if (!rect) {
	                    continue;
	                }
	                if (node.isContainer() && isPointInRect(e, rect)) {
	                    location_3 = node.locate(dragment, e);
	                    if (location_3) {
	                        return location_3;
	                    }
	                    distance = 0;
	                }
	                else {
	                    distance = distanceToRect(e, rect);
	                }
	                if (distance === 0) {
	                    nearDistance = distance;
	                    near = node;
	                    nearIndex = i;
	                    nearRect = rect;
	                    break;
	                }
	                if (nearDistance === null || distance < nearDistance) {
	                    nearDistance = distance;
	                    near = node;
	                    nearIndex = i;
	                    nearRect = rect;
	                }
	            }
	            var nearContainerDisplay = void 0;
	            if (near) {
	                var parentElement = near.getDOMNode().parentElement;
	                var parentStyle = window.getComputedStyle(parentElement);
	                nearContainerDisplay = {
	                    display: parentStyle.getPropertyValue('display'),
	                };
	                if (/^flex/.test(nearContainerDisplay.display)) {
	                    nearContainerDisplay.flexDirection =
	                        parentStyle.getPropertyValue('flex-direction') || FlexDirection.ROW;
	                }
	            }
	            if (near && nearRect) {
	                nearAfter = isNearAfter(e, nearRect, near.isInline(), nearContainerDisplay);
	            }
	            if (nearDistance !== 0) {
	                var edgeDistance = distanceToEdge(e, edgeRect);
	                distance = edgeDistance.distance;
	                if (nearDistance === null || distance < nearDistance) {
	                    nearAfter = edgeDistance.nearAfter;
	                    nearIndex = nearAfter ? children.length - 1 : 0;
	                    nearEdge = true;
	                }
	            }
	            return location_1.createLocation(this, {
	                near: near,
	                nearAfter: nearAfter,
	                nearContainerDisplay: nearContainerDisplay,
	                nearEdge: nearEdge,
	                nearIndex: nearIndex,
	            });
	        }
	        if (isPointInRect(e, edgeRect)) {
	            for (var i = 0, l = children.length; i < l; i++) {
	                node = children[i];
	                rect = node.getRect();
	                if (!node.isContainer() || !rect || rect.width <= 0 || rect.height <= 0) {
	                    continue;
	                }
	                distance = distanceToRect(e, rect);
	                if (distance === 0) {
	                    near = node;
	                    break;
	                }
	                if (nearDistance === null || distance < nearDistance) {
	                    nearDistance = distance;
	                    near = node;
	                }
	            }
	            return near ? near.locate(dragment, e) : null;
	        }
	        return null;
	    };
	    Node.prototype.select = function () {
	        exchange_1.default.select(this);
	    };
	    Node.prototype.hover = function () {
	        exchange_1.default.hover(this);
	    };
	    Node.prototype.lock = function () {
	        exchange_1.default.lock(this);
	    };
	    /**
	     * 插入节点
	     *
	     * @param {Node|Dragment} node
	     * @param {Insertion} insertion
	     * @param {boolean} noRecord 是否不需要加入 history
	     * @returns {Node}
	     */
	    Node.prototype.insert = function (node, insertion, index, noRecord) {
	        if (index == null) {
	            index = insertion ? insertion.getIndex() : this.children.length;
	            if (index === null) {
	                return node instanceof Node ? node : null;
	            }
	        }
	        if (!(node instanceof Node)) {
	            node = new Node(this.getPage(), node);
	        }
	        var i = this.children.indexOf(node);
	        if (i < 0) {
	            var oldContainer = node.getParent();
	            if (oldContainer && oldContainer !== this) {
	                oldContainer.removeChild(node, true);
	            }
	            node.setParent(this);
	            if (index < this.children.length) {
	                this.children.splice(index, 0, node);
	            }
	            else {
	                this.children.push(node);
	            }
	            if (!oldContainer) {
	                this.getPage().addNode(node);
	            }
	        }
	        else {
	            if (index > i) {
	                index -= 1;
	            }
	            if (index === i) {
	                return node;
	            }
	            this.children.splice(i, 1);
	            this.children.splice(index, 0, node);
	        }
	        if (!noRecord) {
	            this.addRecord();
	        }
	        this.emitter.emit('childrenchange', this.children);
	        return node;
	    };
	    Node.prototype.insertAfter = function (node, ref, noRecord) {
	        if (!this.ableToModifyChildren()) {
	            return null;
	        }
	        var index = this.children.length;
	        if (ref) {
	            index = this.indexOf(ref);
	            if (index < 0) {
	                return null;
	            }
	            index += 1;
	        }
	        return this.insert(node, null, index, noRecord);
	    };
	    Node.prototype.insertBefore = function (node, ref, noRecord) {
	        if (!this.ableToModifyChildren()) {
	            return null;
	        }
	        var index = 0;
	        if (ref) {
	            index = this.indexOf(ref);
	            if (index < 0) {
	                return null;
	            }
	        }
	        return this.insert(node, null, index, noRecord);
	    };
	    Node.prototype.indexOf = function (node) {
	        return this.children.indexOf(node);
	    };
	    Node.prototype.lastChild = function () {
	        if (!this.children) {
	            return null;
	        }
	        return this.getChild(this.children.length - 1);
	    };
	    Node.prototype.nextSibling = function () {
	        var parent = this.getParent();
	        return parent ? parent.getChild(this.getIndex() + 1) : null;
	    };
	    Node.prototype.prevSibling = function () {
	        var parent = this.getParent();
	        return parent ? parent.getChild(this.getIndex() - 1) : null;
	    };
	    Node.prototype.clone = function () {
	        var parent = this.getParent();
	        if (parent) {
	            var node = parent.insertAfter(this.toData(), this);
	            if (node) {
	                exchange_1.default.select(node);
	            }
	            this.reportModified(parent);
	        }
	    };
	    Node.prototype.mergeChildren = function (remover, adder, sorter) {
	        var _this = this;
	        var changed = 0;
	        if (remover) {
	            var willRemove = this.children.filter(remover);
	            if (willRemove.length > 0) {
	                willRemove.forEach(function (node) {
	                    var i = _this.children.indexOf(node);
	                    if (i > -1) {
	                        _this.children.splice(i, 1);
	                    }
	                    node.setParent(null);
	                    node.destroy();
	                });
	                changed = 1;
	            }
	        }
	        if (adder) {
	            var items = adder(this.children);
	            if (items && items.length > 0) {
	                items = items.map(function (child) { return new Node(_this.page, child, _this); });
	                this.children = this.children.concat(items);
	                changed = 1;
	            }
	        }
	        if (sorter) {
	            this.children = this.children.sort(sorter);
	            changed = 1;
	        }
	        if (changed) {
	            this.addRecord();
	            this.emitter.emit('childrenchange', this.children);
	            this.reportModified(this);
	        }
	    };
	    /**
	     * 移除子节点
	     *
	     * @param {Node} node
	     * @param {bool} move is move operation not delete
	     */
	    Node.prototype.removeChild = function (node, move, noRecord) {
	        var i = this.children.indexOf(node);
	        if (i > -1) {
	            this.children.splice(i, 1);
	            var parent_1 = this.getParent();
	            node.setParent(null);
	            if (!noRecord) {
	                this.addRecord();
	            }
	            this.emitter.emit('childrenchange', this.children);
	            if (!move) {
	                node.destroy();
	            }
	            this.reportModified(parent_1);
	        }
	    };
	    /**
	     * 替换子节点
	     *
	     * @param {Node} node
	     * @param {object} data
	     * @param {bool} keepData
	     */
	    Node.prototype.replaceChild = function (node, data, extraOptions) {
	        var parent = this.getParent();
	        var i = this.children.indexOf(node);
	        if (i > -1) {
	            var selected = exchange_1.default.getSelected() === node;
	            node.setParent(null);
	            node.destroy();
	            node = new Node(this.getPage(), data, this, __assign({}, (extraOptions || {})));
	            this.children.splice(i, 1, node);
	            this.page.addNode(node);
	            this.addRecord();
	            this.emitter.emit('childrenchange', this.children);
	            if (selected) {
	                exchange_1.default.select(node);
	            }
	        }
	        this.reportModified(parent);
	        return node;
	    };
	    /**
	     * 移除
	     */
	    Node.prototype.remove = function () {
	        var parent = this.getParent();
	        parent.removeChild(this);
	        this.reportModified(parent);
	    };
	    Node.prototype.replaceWith = function (data, inheritData) {
	        data = Object.assign({}, inheritData ? this.toData() : {}, data);
	        return this.getParent().replaceChild(this, data);
	    };
	    Node.prototype.mountChange = function () {
	        this.emitter.emit('mountchange');
	    };
	    Node.prototype.destroy = function () {
	        exchange_1.default.purge(this);
	        if (this.ableToModifyChildren()) {
	            this.getChildren().forEach(function (node) { return node.destroy(); });
	        }
	        this.getPage().destroyNode(this);
	        if (this.props) {
	            this.props.destroy();
	        }
	        this.emitter.emit('destroy');
	        this.emitter.removeAllListeners();
	        new bus_1.default().emit(const_1.VE_EVENTS.VE_NODE_DESTROY, this.getParent());
	    };
	    /**
	     * 是否包含元素
	     *
	     * @param {DOMElement} elem
	     * @returns {boolean}
	     */
	    Node.prototype.contains = function (elem) {
	        var node = this.getDOMNode();
	        return elem && node && node.contains(elem);
	    };
	    Node.prototype.containsNode = function (node) {
	        if (node === this) {
	            return true;
	        }
	        if (this.isContainer()) {
	            node = node.getParent();
	            while (node) {
	                if (node === this) {
	                    return true;
	                }
	                node = node.getParent();
	            }
	        }
	        return false;
	    };
	    /**
	     * 通过元素匹配查找节点
	     *
	     * @param {DOMElement} elem
	     * @returns {Node|null}
	     */
	    Node.prototype.findNode = function (elem) {
	        if (!this.contains(elem)) {
	            return null;
	        }
	        if (this.ableToModifyChildren()) {
	            var node = void 0;
	            for (var i = 0, l = this.children.length; i < l; i++) {
	                node = this.children[i].findNode(elem);
	                if (node) {
	                    return node;
	                }
	            }
	        }
	        return this;
	    };
	    /**
	     * 导出节点数据
	     *
	     * @returns {{props: Object, children:Array}}
	     */
	    Node.prototype.toData = function () {
	        var data = {
	            componentName: this.getComponentName(),
	            id: this.getId(),
	            props: this.getStaticProps(true),
	        };
	        if (data.props && data.props.__condition__ != null) {
	            data.condition = data.props.__condition__;
	            delete data.props.__condition__;
	        }
	        if (data.props && data.props.__loop__) {
	            data.loop = data.props.__loop__;
	            if (data.props.__loopArgs__) {
	                data.loopArgs = data.props.__loopArgs__;
	            }
	            delete data.props.__loop__;
	        }
	        if (data.props && data.props.__loopArgs__) {
	            delete data.props.__loopArgs__;
	        }
	        if (this.ableToModifyChildren()) {
	            data.children = this.children.filter(function (item) {
	                return item.componentName !== 'Slot';
	            }).map(function (node) { return node.toData(); }).filter(function (item) { return item != null; });
	        }
	        return data;
	    };
	    Node.prototype.onPropsReplace = function (func) {
	        var _this = this;
	        this.emitter.on('node.propsReplace', func);
	        return function () {
	            _this.emitter.removeListener('node.propsReplace', func);
	        };
	    };
	    Node.prototype.onPropsChange = function (func) {
	        return this.props ? this.props.onPropsChange(func) : function () { };
	    };
	    Node.prototype.onChildrenChange = function (func) {
	        var _this = this;
	        this.emitter.on('childrenchange', func);
	        return function () {
	            _this.emitter.removeListener('childrenchange', func);
	        };
	    };
	    Node.prototype.onVisibilityChange = function (func) {
	        var _this = this;
	        this.emitter.on('visibilitychange', func);
	        return function () {
	            _this.emitter.removeListener('visibilitychange', func);
	        };
	    };
	    Node.prototype.onStatusChange = function (func) {
	        var _this = this;
	        this.emitter.on('statuschange', func);
	        return function () {
	            _this.emitter.removeListener('statuschange', func);
	        };
	    };
	    Node.prototype.onMountChange = function (func) {
	        var _this = this;
	        this.emitter.on('mountchange', func);
	        return function () {
	            _this.emitter.removeListener('mountchange', func);
	        };
	    };
	    Node.prototype.onDestroy = function (func) {
	        var _this = this;
	        this.emitter.on('destroy', func);
	        return function () {
	            _this.emitter.removeListener('destroy', func);
	        };
	    };
	    /**
	     * isContainer or hasSlot
	     */
	    Node.prototype.ableToModifyChildren = function () {
	        return this.isContainer() || (this.proto && this.proto.hasSlot());
	    };
	    Node.prototype.transformInitData = function (data) {
	        if (data.props) {
	            Object.keys(data.props).forEach(function (key) {
	                if (data.props[key] && data.props[key].type === 'JSBlock') {
	                    if (!data.children) {
	                        data.children = [];
	                    }
	                    data.children.push(data.props[key].value);
	                }
	            });
	        }
	        return data;
	    };
	    Node.prototype.reportModified = function (node) {
	        if (!node) {
	            return;
	        }
	        if (node.isRoot()) {
	            return;
	        }
	        var fn = node.proto.getConfig('subtreeModified');
	        if (fn) {
	            fn.call(this, node);
	        }
	        if (node.parent && !node.parent.isRoot()) {
	            this.reportModified(node.parent);
	        }
	    };
	    Node.Props = props_1.Props;
	    return Node;
	}());
	exports.Node = Node;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var domReady = __webpack_require__(24);
	var EventEmitter = __webpack_require__(11);
	var flags_1 = __webpack_require__(23);
	function enterFullscreen() {
	    var elem = document.documentElement;
	    if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	    }
	}
	function exitFullscreen() {
	    if (document.exitFullscreen) {
	        document.exitFullscreen();
	    }
	}
	function isFullscreen() {
	    return lodash_1.get(document, 'fullscreen') || false;
	}
	var StyleResource = /** @class */ (function () {
	    function StyleResource(config) {
	        this.config = config || {};
	    }
	    StyleResource.prototype.matchDevice = function (device) {
	        var media = this.config.media;
	        if (!media || media === 'ALL' || media === '*') {
	            return true;
	        }
	        return media.toUpperCase() === device.toUpperCase();
	    };
	    StyleResource.prototype.init = function () {
	        if (this.inited) {
	            return;
	        }
	        this.inited = true;
	        var _a = this.config, type = _a.type, content = _a.content;
	        var styleElement;
	        if (type === 'URL') {
	            styleElement = document.createElement('link');
	            styleElement.href = content;
	            styleElement.rel = 'stylesheet';
	        }
	        else {
	            styleElement = document.createElement('style');
	            styleElement.setAttribute('type', 'text/css');
	            if (lodash_1.get(styleElement, 'styleSheet')) {
	                lodash_1.set(styleElement, 'styleSheet.cssText', content);
	            }
	            else {
	                styleElement.appendChild(document.createTextNode(content));
	            }
	        }
	        this.styleElement = styleElement;
	    };
	    StyleResource.prototype.apply = function () {
	        if (this.mounted) {
	            return;
	        }
	        this.init();
	        document.head.appendChild(this.styleElement);
	        this.mounted = true;
	    };
	    StyleResource.prototype.unmount = function () {
	        if (!this.mounted) {
	            return;
	        }
	        document.head.removeChild(this.styleElement);
	        this.mounted = false;
	    };
	    return StyleResource;
	}());
	var Viewport = /** @class */ (function () {
	    function Viewport() {
	        var _this = this;
	        this.preview = false;
	        this.emitter = new EventEmitter();
	        document.addEventListener('webkitfullscreenchange', function () {
	            _this.emitter.emit('fullscreenchange', _this.isFullscreen());
	        });
	        domReady(function () { return _this.applyMediaCSS(); });
	    }
	    Viewport.prototype.setFullscreen = function (flag) {
	        var fullscreen = this.isFullscreen();
	        if (fullscreen && !flag) {
	            exitFullscreen();
	        }
	        else if (!fullscreen && flag) {
	            enterFullscreen();
	        }
	    };
	    Viewport.prototype.toggleFullscreen = function () {
	        if (this.isFullscreen()) {
	            exitFullscreen();
	        }
	        else {
	            enterFullscreen();
	        }
	    };
	    Viewport.prototype.isFullscreen = function () {
	        return isFullscreen();
	    };
	    Viewport.prototype.setFocus = function (flag) {
	        if (this.focused && !flag) {
	            this.focused = false;
	            flags_1.default.remove('view-focused');
	            this.emitter.emit('focuschange', false);
	        }
	        else if (!this.focused && flag) {
	            this.focused = true;
	            flags_1.default.add('view-focused');
	            this.emitter.emit('focuschange', true);
	        }
	    };
	    Viewport.prototype.setFocusTarget = function (focusTarget) {
	        this.focusTarget = focusTarget;
	    };
	    Viewport.prototype.returnFocus = function () {
	        if (this.focusTarget) {
	            this.focusTarget.focus();
	        }
	    };
	    Viewport.prototype.isFocus = function () {
	        return this.focused;
	    };
	    Viewport.prototype.setPreview = function (flag) {
	        if (this.preview && !flag) {
	            this.preview = false;
	            flags_1.default.setPreviewMode(false);
	            this.emitter.emit('preview', false);
	            this.changeViewport();
	        }
	        else if (!this.preview && flag) {
	            this.preview = true;
	            flags_1.default.setPreviewMode(true);
	            this.emitter.emit('preview', true);
	            this.changeViewport();
	        }
	    };
	    Viewport.prototype.togglePreview = function () {
	        if (this.isPreview()) {
	            this.setPreview(false);
	        }
	        else {
	            this.setPreview(true);
	        }
	    };
	    Viewport.prototype.isPreview = function () {
	        return this.preview;
	    };
	    Viewport.prototype.setDevice = function (device) {
	        if (device === void 0) { device = 'pc'; }
	        if (this.getDevice() !== device) {
	            this.device = device;
	            flags_1.default.setSimulator(device);
	            this.applyMediaCSS();
	            this.emitter.emit('devicechange', device);
	            this.changeViewport();
	        }
	    };
	    Viewport.prototype.getDevice = function () {
	        return this.device || 'pc';
	    };
	    Viewport.prototype.changeViewport = function () {
	        this.emitter.emit('viewportchange', this.getViewport());
	    };
	    Viewport.prototype.getViewport = function () {
	        return (this.isPreview() ? 'preview' : 'design') + "-" + this.getDevice();
	    };
	    Viewport.prototype.applyMediaCSS = function () {
	        if (!document.head || !this.cssResourceSet) {
	            return;
	        }
	        var device = this.getDevice();
	        this.cssResourceSet.forEach(function (item) {
	            if (item.matchDevice(device)) {
	                item.apply();
	            }
	            else {
	                item.unmount();
	            }
	        });
	    };
	    Viewport.prototype.setGlobalCSS = function (resourceSet) {
	        if (this.cssResourceSet) {
	            this.cssResourceSet.forEach(function (item) {
	                item.unmount();
	            });
	        }
	        this.cssResourceSet = resourceSet.map(function (item) { return new StyleResource(item); }).reverse();
	        this.applyMediaCSS();
	    };
	    Viewport.prototype.setWithShell = function (shell) {
	        flags_1.default.setWithShell(shell);
	    };
	    Viewport.prototype.onFullscreenChange = function (func) {
	        var _this = this;
	        this.emitter.on('fullscreenchange', func);
	        return function () {
	            _this.emitter.removeListener('fullscreenchange', func);
	        };
	    };
	    Viewport.prototype.onPreview = function (func) {
	        var _this = this;
	        this.emitter.on('preview', func);
	        return function () {
	            _this.emitter.removeListener('preview', func);
	        };
	    };
	    Viewport.prototype.onDeviceChange = function (func) {
	        var _this = this;
	        this.emitter.on('devicechange', func);
	        return function () {
	            _this.emitter.removeListener('devicechange', func);
	        };
	    };
	    Viewport.prototype.onViewportChange = function (func) {
	        var _this = this;
	        this.emitter.on('viewportchange', func);
	        return function () {
	            _this.emitter.removeListener('viewportchange', func);
	        };
	    };
	    Viewport.prototype.onFocusChange = function (func) {
	        var _this = this;
	        this.emitter.on('focuschange', func);
	        return function () {
	            _this.emitter.removeListener('focuschange', func);
	        };
	    };
	    return Viewport;
	}());
	exports.default = new Viewport();


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var immutable_1 = __webpack_require__(40);
	var prototype_1 = __webpack_require__(37);
	var stages_1 = __webpack_require__(43);
	var compositeProp_1 = __webpack_require__(45);
	var prop_1 = __webpack_require__(46);
	var propsGroup_1 = __webpack_require__(48);
	var settingStage_1 = __webpack_require__(49);
	// 1: chain -1: start 0: discard
	// design for performance to avoid refresh UI elements duration iterations
	exports.CHAIN_START = -1;
	exports.CHAIN_REACH = 1;
	exports.CHAIN_HAS_REACH = 0;
	function releaseItems(items, target, dataGetter, inGroup) {
	    return (items || []).map(function (config) {
	        var item;
	        if (config.type === 'composite') {
	            item = new compositeProp_1.default(target, config, dataGetter(config.name));
	        }
	        else if (config.type === 'group') {
	            item = new propsGroup_1.default(target, config, dataGetter);
	        }
	        else {
	            item = new prop_1.default(target, config, dataGetter(config.name));
	        }
	        if (inGroup) {
	            item.inGroup = true;
	        }
	        return target.registerItem(item);
	    });
	}
	exports.releaseItems = releaseItems;
	var Props = /** @class */ (function () {
	    function Props(node, configure, data) {
	        var _this = this;
	        this.emitter = new EventEmitter();
	        this.node = node;
	        var isHot = immutable_1.Map.isMap(data);
	        var props;
	        if (!isHot) {
	            props = data || {};
	        }
	        else {
	            this.hotData = data;
	            this.hotProps = data.get('hotProps');
	            if (!immutable_1.Map.isMap(this.hotProps)) {
	                this.hotProps = immutable_1.Map({});
	            }
	            this.extraProps = data.get('extraProps');
	        }
	        var dataGetter = isHot
	            ? function (key) { return _this.hotProps.get(key); }
	            : function (key) { return props[key]; };
	        this.items = [];
	        this.itemsMap = {};
	        releaseItems(configure, this, dataGetter);
	        this.stage = new settingStage_1.default(this);
	        if (!isHot) {
	            var extraProps_1 = {};
	            Object.keys(props).forEach(function (prop) {
	                if (!(prop in _this.itemsMap)) {
	                    if (!extraProps_1) {
	                        extraProps_1 = {};
	                    }
	                    extraProps_1[prop] = props[prop];
	                }
	            });
	            if (extraProps_1) {
	                this.extraProps = immutable_1.Map(extraProps_1);
	            }
	        }
	    }
	    Props.prototype.registerItem = function (item) {
	        this.items.push(item);
	        this.itemsMap[item.getName()] = item;
	        return item;
	    };
	    Props.prototype.stagePush = function (name) {
	        var stage = stages_1.default.getStage(name);
	        if (!stage) {
	            var prop = this.getProp(name);
	            if (!prop || prop.isHidden()) {
	                return;
	            }
	            stage = new settingStage_1.default(prop);
	        }
	        stage.setPrevious(this.stage);
	        stage.setReferLeft(this.stage);
	        this.stage = stage;
	        this.emitter.emit('stagechange');
	    };
	    Props.prototype.stageBack = function () {
	        var stage = this.stage.getPrevious();
	        if (!stage) {
	            return;
	        }
	        stage.setReferRight(this.stage);
	        this.stage = stage;
	        this.emitter.emit('stagechange');
	    };
	    Props.prototype.getCurrentStage = function () {
	        return this.stage;
	    };
	    Props.prototype.isProps = function () {
	        return true;
	    };
	    Props.prototype.chainReach = function (prop) {
	        if (this.disableChain) {
	            return exports.CHAIN_HAS_REACH;
	        }
	        if (!this.setChain) {
	            this.setChain = [prop];
	            return exports.CHAIN_START;
	        }
	        else if (this.setChain.indexOf(prop) > -1) {
	            return exports.CHAIN_HAS_REACH;
	        }
	        this.setChain.push(prop);
	        return exports.CHAIN_REACH;
	    };
	    Props.prototype.hasReach = function (prop) {
	        return this.setChain.indexOf(prop) > -1;
	    };
	    Props.prototype.endChain = function () {
	        this.setChain = null;
	    };
	    Props.prototype.syncPass = function (prop) {
	        if (this.disableChain) {
	            return;
	        }
	        var isEnd = !this.syncChain;
	        if (!this.syncChain) {
	            this.syncChain = [];
	        }
	        else if (this.syncChain.indexOf(prop) > -1) {
	            return;
	        }
	        this.syncChain.push(prop);
	        this.items.forEach(function (item) { return item !== prop && item instanceof prop_1.default && item.sync(); });
	        if (isEnd) {
	            this.syncChain = null;
	            this.emitter.emit('propschange');
	        }
	    };
	    Props.prototype.init = function () {
	        if (this.inited) {
	            return;
	        }
	        var hotPropsMap = {};
	        this.getRealItems().forEach(function (prop) {
	            prop.init();
	            hotPropsMap[prop.getName()] = prop.getHotData();
	        });
	        if (!this.hotData) {
	            this.hotProps = immutable_1.Map(hotPropsMap);
	            this.hotData = immutable_1.Map({
	                extrasProps: this.extraProps || null,
	                hotProps: this.hotProps,
	            });
	        }
	        this.inited = true;
	    };
	    Props.prototype.isInited = function () {
	        return this.inited;
	    };
	    Props.prototype.modify = function (name) {
	        var hotPropsMap = {};
	        this.getRealItems().forEach(function (prop) {
	            hotPropsMap[prop.getName()] = prop.getHotData();
	        });
	        this.hotProps = this.hotProps.merge(hotPropsMap);
	        var hotData = this.hotData.merge({
	            extrasProps: this.extraProps || null,
	            hotProps: this.hotProps,
	        });
	        if (hotData.equals(this.hotData)) {
	            return;
	        }
	        this.hotData = hotData;
	        this.node.addRecord("Modify prop " + (name ? ":" + name : 's'));
	    };
	    Props.prototype.getNode = function () {
	        return this.node;
	    };
	    Props.prototype.getProp = function (name, createNew) {
	        var ns = name.split('.')[0];
	        var prop = this.itemsMap[ns];
	        if (!prop && createNew) {
	            prop = new prop_1.default(this, { name: name, display: prototype_1.DISPLAY_TYPE.NONE });
	            this.registerItem(prop);
	            prop.init();
	            return prop;
	        }
	        if (ns === name) {
	            return prop;
	        }
	        if (prop instanceof compositeProp_1.default) {
	            return prop.getProp(name);
	        }
	        return prop;
	    };
	    Props.prototype.getPropValue = function (name) {
	        var prop = this.getProp(name);
	        if (prop) {
	            return prop.getValue();
	        }
	        return null;
	    };
	    Props.prototype.setPropValue = function (name, value) {
	        var prop = this.getProp(name);
	        if (prop) {
	            prop.setValue(value);
	        }
	    };
	    Props.prototype.getItems = function (filter) {
	        if (filter) {
	            return this.items.filter(filter);
	        }
	        return this.items;
	    };
	    Props.prototype.getVisibleItems = function () {
	        this.getItems(function (item) { return !item.isHidden(); });
	    };
	    Props.prototype.getRealItems = function () {
	        return this.items.filter(function (item) { return item instanceof prop_1.default; });
	    };
	    Props.prototype.getHotData = function () {
	        return this.hotData;
	    };
	    Props.prototype.setHotData = function (hotData, options) {
	        var _this = this;
	        if (!immutable_1.Map.isMap(hotData)) {
	            return;
	        }
	        this.hotData = hotData;
	        this.extraProps = hotData.get('extraProps');
	        var props = hotData.get('hotProps');
	        this.hotProps = immutable_1.Map.isMap(props) ? props : immutable_1.Map({});
	        this.disableChain = true;
	        this.getRealItems().forEach(function (prop) {
	            prop.setHotData(_this.hotProps.get(prop.getName()), options);
	        });
	        this.emitter.emit('propschange');
	        this.disableChain = false;
	    };
	    /**
	     * 导出属性数据
	     *
	     * @returns {Object}
	     */
	    Props.prototype.toData = function () {
	        var props = immutable_1.Map.isMap(this.extraProps)
	            ? this.extraProps.toJS()
	            : (this.extraProps || {});
	        this.getRealItems().forEach(function (prop) {
	            if (!prop.isIgnore()) {
	                props[prop.getName()] = prop.toData();
	            }
	        });
	        return props;
	    };
	    /**
	     * Export props value
	     *
	     * @returns {Object}
	     */
	    Props.prototype.toProps = function () {
	        var props = {};
	        this.getRealItems().forEach(function (prop) {
	            props[prop.getName()] = prop.getValue(false, { disableAccessor: true });
	        });
	        return props;
	    };
	    Props.prototype.destroy = function () {
	        this.getRealItems().forEach(function (prop) { return prop.destroy(); });
	    };
	    Props.prototype.onPropsChange = function (func) {
	        var _this = this;
	        this.emitter.on('propschange', func);
	        return function () {
	            _this.emitter.removeListener('propschange', func);
	        };
	    };
	    Props.prototype.onStageChange = function (func) {
	        var _this = this;
	        this.emitter.on('stagechange', func);
	        return function () {
	            _this.emitter.removeListener('stagechange', func);
	        };
	    };
	    return Props;
	}());
	exports.Props = Props;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var pane_1 = __webpack_require__(44);
	var Stage = /** @class */ (function (_super) {
	    __extends(Stage, _super);
	    function Stage(config) {
	        var _this = _super.call(this, config) || this;
	        _this.isRoot = config.isRoot;
	        return _this;
	    }
	    Stage.prototype.getTip = function () {
	        return this.config.tip;
	    };
	    Stage.prototype.setPrevious = function (stage) {
	        this.previous = stage;
	    };
	    Stage.prototype.getPrevious = function () {
	        return this.previous;
	    };
	    Stage.prototype.hasBack = function () {
	        return this.previous && !this.isRoot;
	    };
	    Stage.prototype.setRefer = function (stage, direction) {
	        this.refer = { stage: stage, direction: direction };
	    };
	    Stage.prototype.setReferRight = function (stage) {
	        this.setRefer(stage, 'right');
	    };
	    Stage.prototype.setReferLeft = function (stage) {
	        this.setRefer(stage, 'left');
	    };
	    Stage.prototype.getRefer = function () {
	        var refer = this.refer;
	        this.refer = null;
	        return refer;
	    };
	    return Stage;
	}(pane_1.default));
	exports.Stage = Stage;
	var GLOBAL_STAGES = {};
	var Stages = {
	    Stage: Stage,
	    getStage: function (id) {
	        return GLOBAL_STAGES[id];
	    },
	    removeStage: function (id) {
	        delete GLOBAL_STAGES[id];
	    },
	    createStage: function (config) {
	        var stage = new Stage(config);
	        GLOBAL_STAGES[stage.getId()] = stage;
	        return stage.getId();
	    },
	    addGlobalStage: function (config) {
	        return Stages.createStage(config);
	    },
	};
	exports.default = Stages;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var React = __webpack_require__(5);
	var _a = __webpack_require__(4), testType = _a.testType, uniqueId = _a.uniqueId;
	var Pane = /** @class */ (function () {
	    function Pane(config) {
	        this.config = config;
	        this.emitter = new EventEmitter();
	        this.emitter.setMaxListeners(0);
	        this.id = config.id || uniqueId(null, 'pane', 'engine-pane');
	        if (config.init) {
	            config.init.call(this);
	        }
	        this.hidden = false;
	        this.content = this.initContent(config.content);
	    }
	    Pane.prototype.isHidden = function () {
	        return this.hidden;
	    };
	    Pane.prototype.getProps = function () {
	        return __assign({ pane: this }, this.config.props);
	    };
	    Pane.prototype.initContent = function (content) {
	        var type = testType(content);
	        var props = this.getProps();
	        if (type === 'ReactElement' && props) {
	            return React.cloneElement(content, props);
	        }
	        if (type === 'ReactClass') {
	            return React.createElement(content, props);
	        }
	        if (type === 'function') {
	            return content(props);
	        }
	        return content;
	    };
	    Pane.prototype.show = function () {
	        this.hidden = false;
	    };
	    Pane.prototype.hide = function () {
	        this.hidden = true;
	    };
	    Pane.prototype.getId = function () {
	        return this.id;
	    };
	    Pane.prototype.getTitle = function () {
	        return this.config.title || this.getName();
	    };
	    Pane.prototype.getName = function () {
	        return this.config.name || this.getId();
	    };
	    Pane.prototype.getContent = function () {
	        return this.content || '';
	    };
	    // 获得该 Pane 下的帮助信息
	    Pane.prototype.getTip = function () {
	        return this.config.tip;
	    };
	    Pane.prototype.destroy = function () {
	        if (this.config.destroy) {
	            this.config.destroy.call(this);
	        }
	    };
	    return Pane;
	}());
	exports.default = Pane;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var immutable_1 = __webpack_require__(40);
	var prop_1 = __webpack_require__(46);
	var props_1 = __webpack_require__(42);
	var CompositeProp = /** @class */ (function (_super) {
	    __extends(CompositeProp, _super);
	    function CompositeProp() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CompositeProp.prototype.beforeInit = function () {
	        var isHot = immutable_1.Map.isMap(this.initialData);
	        var dataGetter;
	        if (isHot) {
	            this.hotData = this.initialData;
	            var hotMap_1 = this.hotData;
	            if (this.hotData.get('type') === 'variable') {
	                hotMap_1 = this.hotData.get('maps') || new Map();
	                this.variableValue = this.hotData.get('variable');
	                this.useVariable = this.isSupportVariable();
	            }
	            dataGetter = function (key) { return hotMap_1.get(key); };
	        }
	        else {
	            var data_1 = this.initialData || {};
	            if (data_1.type === 'variable') {
	                this.useVariable = this.isSupportVariable();
	                this.variableValue = data_1.variable;
	                data_1 = data_1.maps || {};
	            }
	            dataGetter = function (key) { return data_1[key]; };
	        }
	        var defaultValue = null;
	        if (this.config.defaultValue !== undefined) {
	            defaultValue = this.config.defaultValue;
	        }
	        else if (typeof this.config.initialValue !== 'function') {
	            defaultValue = this.config.initialValue;
	        }
	        this.defaultValue = defaultValue;
	        this.level = (this.parent && this.parent.level || 0) + 1; // eslint-disable-line
	        this.itemsMap = {};
	        this.items = [];
	        props_1.releaseItems(this.config.items, this, dataGetter);
	    };
	    CompositeProp.prototype.registerItem = function (item) {
	        this.items.push(item);
	        this.itemsMap[item.getName()] = item;
	        return item;
	    };
	    CompositeProp.prototype.init = function (defaultValue) {
	        if (this.inited) {
	            return;
	        }
	        defaultValue = this.defaultValue || defaultValue || {};
	        var hotMap = {};
	        this.getRealItems().forEach(function (prop) {
	            var key = prop.getKey();
	            prop.init(defaultValue[key]);
	            hotMap[key] = prop.getHotData();
	        });
	        if (!this.hotData) {
	            this.hotData = immutable_1.fromJS(this.getMixValue(hotMap));
	        }
	        this.inited = true;
	    };
	    CompositeProp.prototype.getMixValue = function (value) {
	        if (value == null) {
	            value = this.getValue();
	        }
	        if (this.isUseVariable()) {
	            return {
	                maps: value,
	                type: 'variable',
	                variable: this.getVariableValue(),
	            };
	        }
	        return value;
	    };
	    /**
	     * 获得属性值
	     *
	     * @returns {*}
	     */
	    CompositeProp.prototype.getValue = function () {
	        var props = {};
	        this.getRealItems().forEach(function (prop) {
	            props[prop.getKey()] = prop.getValue();
	        });
	        var accessor = this.config.accessor;
	        if (accessor) {
	            props = accessor.call(this, props);
	        }
	        return props;
	    };
	    CompositeProp.prototype.toData = function () {
	        var props = {};
	        this.getRealItems().forEach(function (prop) {
	            if (!prop.isIgnore()) {
	                props[prop.getKey()] = prop.toData();
	            }
	        });
	        return this.getMixValue(props);
	    };
	    CompositeProp.prototype.getHotValue = function () {
	        var props = {};
	        this.getRealItems().forEach(function (prop) {
	            props[prop.getKey()] = prop.getHotValue();
	        });
	        return props;
	    };
	    /**
	     * 设置属性值
	     *
	     * @param {*} value
	     */
	    CompositeProp.prototype.setValue = function (value, isHotValue) {
	        var state = this.props.chainReach(this);
	        if (state === props_1.CHAIN_HAS_REACH) {
	            return;
	        }
	        this.loopLock = true;
	        var props = value || {};
	        if (isHotValue) {
	            this.getRealItems().forEach(function (prop) {
	                prop.setHotValue(props[prop.getKey()]);
	            });
	        }
	        else {
	            this.getRealItems().forEach(function (prop) {
	                prop.setValue(props[prop.getKey()]);
	            });
	        }
	        this.loopLock = null;
	        var mutator = this.config.mutator;
	        if (mutator) {
	            mutator.call(this, this.getValue(), this.getHotValue());
	        }
	        if (this.modify()) {
	            this.valueChange();
	            this.props.syncPass(this);
	        }
	        if (state === props_1.CHAIN_START) {
	            this.props.endChain();
	        }
	    };
	    CompositeProp.prototype.modify = function (name) {
	        if (this.loopLock) {
	            return false;
	        }
	        var hotMap = {};
	        this.getRealItems().forEach(function (prop) {
	            hotMap[prop.getKey()] = prop.getHotData();
	        });
	        var hotData = immutable_1.fromJS(this.getMixValue(hotMap));
	        if (hotData.equals(this.hotData)) {
	            return false;
	        }
	        this.hotData = hotData;
	        (this.parent || this.props).modify(name || this.getName());
	        return true;
	    };
	    CompositeProp.prototype.setHotData = function (hotData, options) {
	        if (!immutable_1.Map.isMap(hotData)) {
	            return;
	        }
	        this.hotData = hotData;
	        this.loopLock = true;
	        var hotMap = hotData;
	        if (hotData.get('type') === 'variable') {
	            hotMap = hotData.get('maps') || new Map();
	            this.useVariable = this.isSupportVariable();
	            this.variableValue = hotData.get('variable');
	        }
	        else {
	            this.useVariable = false;
	        }
	        this.getRealItems().forEach(function (prop) {
	            prop.setHotData(hotMap.get(prop.getKey()));
	        });
	        this.loopLock = null;
	        var mutator = this.config.mutator;
	        if (mutator && !options.disableMutator) {
	            mutator.call(this, this.getValue(), this.getHotValue());
	        }
	        this.valueChange();
	    };
	    CompositeProp.prototype.getProp = function (name) {
	        var ns = name.split('.').slice(0, this.level + 1).join('.');
	        var prop = this.itemsMap[ns];
	        if (ns === name) {
	            return prop;
	        }
	        if (prop instanceof CompositeProp) {
	            return prop.getProp(name);
	        }
	        return prop;
	    };
	    CompositeProp.prototype.isHidden = function () {
	        return _super.prototype.isHidden.call(this) || this.getVisibleItems().length < 1;
	    };
	    CompositeProp.prototype.isGroup = function () {
	        return true;
	    };
	    CompositeProp.prototype.getItems = function (filter) {
	        if (filter) {
	            return this.items.filter(filter);
	        }
	        return this.items;
	    };
	    CompositeProp.prototype.getVisibleItems = function () {
	        return this.getItems(function (item) { return !item.isHidden(); });
	    };
	    CompositeProp.prototype.getRealItems = function () {
	        return this.getItems(function (item) { return item instanceof prop_1.default; });
	    };
	    return CompositeProp;
	}(prop_1.default));
	exports.default = CompositeProp;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var events_1 = __webpack_require__(11);
	var immutable_1 = __webpack_require__(40);
	var React = __webpack_require__(5);
	var context_1 = __webpack_require__(9);
	var prototype_1 = __webpack_require__(37);
	var _a = __webpack_require__(4), uniqueId = _a.uniqueId, cloneDeep = _a.cloneDeep, isDataEqual = _a.isDataEqual, combineInitial = _a.combineInitial, Transducer = _a.Transducer;
	var I18nUtil = __webpack_require__(47);
	// 1: chain -1: start 0: discard
	var CHAIN_START = -1;
	var CHAIN_HAS_REACH = 0;
	var PROP_VALUE_CHANGED_TYPE;
	(function (PROP_VALUE_CHANGED_TYPE) {
	    /**
	     * normal set value
	     */
	    PROP_VALUE_CHANGED_TYPE["SET_VALUE"] = "SET_VALUE";
	    /**
	     * value changed caused by sub-prop value change
	     */
	    PROP_VALUE_CHANGED_TYPE["SUB_VALUE_CHANGE"] = "SUB_VALUE_CHANGE";
	})(PROP_VALUE_CHANGED_TYPE = exports.PROP_VALUE_CHANGED_TYPE || (exports.PROP_VALUE_CHANGED_TYPE = {}));
	/**
	 * Dynamic setter will use 've.plugin.setterProvider' to
	 * calculate setter type in runtime
	 */
	var dynamicSetterProvider;
	var Prop = /** @class */ (function () {
	    function Prop(parent, config, data) {
	        if (parent.isProps) {
	            this.props = parent;
	            this.parent = null;
	        }
	        else {
	            this.props = parent.getProps();
	            this.parent = parent;
	        }
	        this.id = uniqueId(null, 'prop', 'engine-prop');
	        this.config = config;
	        this.emitter = new events_1.EventEmitter();
	        this.emitter.setMaxListeners(100);
	        this.initialData = data;
	        this.useVariable = false;
	        dynamicSetterProvider = new context_1.default().getPlugin('ve.plugin.setterProvider');
	        this.beforeInit();
	    }
	    Prop.prototype.getId = function () {
	        return this.id;
	    };
	    Prop.prototype.isTab = function () {
	        return this.getDisplay() === 'tab';
	    };
	    Prop.prototype.isGroup = function () {
	        return false;
	    };
	    Prop.prototype.beforeInit = function () {
	        if (immutable_1.Map.isMap(this.initialData)) {
	            this.value = this.initialData.get('value');
	            if (this.value && typeof this.value.toJS === 'function') {
	                this.value = this.value.toJS();
	            }
	            this.hotData = this.initialData;
	        }
	        else {
	            this.value = this.initialData;
	        }
	        this.resolveValue();
	        var defaultValue = null;
	        if (this.config.defaultValue !== undefined) {
	            defaultValue = this.config.defaultValue;
	        }
	        else if (typeof this.config.initialValue !== 'function') {
	            defaultValue = this.config.initialValue;
	        }
	        this.defaultValue = defaultValue;
	        this.transducer = new Transducer(this, this.config);
	        this.initial = combineInitial(this, this.config);
	    };
	    Prop.prototype.resolveValue = function () {
	        if (this.value && this.value.type === 'variable') {
	            var _a = this.value, value = _a.value, variable = _a.variable;
	            this.value = value;
	            this.variableValue = variable;
	            this.useVariable = this.isSupportVariable();
	        }
	        else {
	            this.useVariable = false;
	        }
	    };
	    Prop.prototype.init = function (defaultValue) {
	        var _this = this;
	        if (this.inited) {
	            return;
	        }
	        this.value = this.initial(this.value, this.defaultValue != null ? this.defaultValue : defaultValue);
	        if (this.hotData) {
	            var tempVal = this.hotData.get('value');
	            // if we create a prop from runtime data, we don't need initial() or set with defaultValue process
	            // but if we got an empty value, we fill with the initial() process and default value
	            if (immutable_1.Iterable.isIterable(tempVal)) {
	                this.value = tempVal.toJS() || this.value;
	            }
	            else {
	                this.value = tempVal || this.value;
	            }
	            this.resolveValue();
	        }
	        this.i18nLink = I18nUtil.attach(this, this.value, function (val) { _this.setValue(val, false, true); });
	        // call config.accessor
	        var value = this.getValue();
	        if (this.hotData) {
	            this.hotValue = this.hotData.get('hotValue');
	            if (this.hotValue && immutable_1.Iterable.isIterable(this.hotValue)) {
	                this.hotValue = this.hotValue.toJS();
	            }
	        }
	        else {
	            try {
	                this.hotValue = this.transducer.toHot(value);
	            }
	            catch (e) {
	                vu_logger_1.default.log('ERROR_PROP_VALUE');
	                vu_logger_1.default.warn('属性初始化错误：', this);
	            }
	            this.hotData = immutable_1.fromJS({
	                hotValue: this.hotValue,
	                value: this.getMixValue(value),
	            });
	        }
	        this.inited = true;
	    };
	    Prop.prototype.isInited = function () {
	        return this.inited;
	    };
	    Prop.prototype.getHotData = function () {
	        return this.hotData;
	    };
	    Prop.prototype.getProps = function () {
	        return this.props;
	    };
	    Prop.prototype.getNode = function () {
	        return this.getProps().getNode();
	    };
	    /**
	     * 获得属性名称
	     *
	     * @returns {string}
	     */
	    Prop.prototype.getName = function () {
	        var ns = this.parent ? this.parent.getName() + "." : '';
	        return ns + this.config.name;
	    };
	    Prop.prototype.getKey = function () {
	        return this.config.name;
	    };
	    /**
	     * 获得属性标题
	     *
	     * @returns {string}
	     */
	    Prop.prototype.getTitle = function () {
	        return this.config.title || this.getName();
	    };
	    Prop.prototype.getTip = function () {
	        return this.config.tip || null;
	    };
	    Prop.prototype.getValue = function (disableCache, options) {
	        var accessor = this.config.accessor;
	        if (accessor && (!options || !options.disableAccessor)) {
	            var value = accessor.call(this, this.value);
	            if (!disableCache) {
	                this.value = value;
	            }
	            return value;
	        }
	        return this.value;
	    };
	    Prop.prototype.getMixValue = function (value) {
	        if (value == null) {
	            value = this.getValue();
	        }
	        if (this.isUseVariable()) {
	            value = {
	                type: 'variable',
	                value: value,
	                variable: this.getVariableValue(),
	            };
	        }
	        return value;
	    };
	    Prop.prototype.toData = function () {
	        return cloneDeep(this.getMixValue());
	    };
	    Prop.prototype.getDefaultValue = function () {
	        return this.defaultValue;
	    };
	    Prop.prototype.getHotValue = function () {
	        return this.hotValue;
	    };
	    Prop.prototype.getConfig = function (configName) {
	        if (configName) {
	            return this.config[configName];
	        }
	        return this.config;
	    };
	    Prop.prototype.sync = function () {
	        if (this.props.hasReach(this)) {
	            return;
	        }
	        var sync = this.config.sync;
	        if (sync) {
	            var value = sync.call(this, this.getValue(true), this.hotValue);
	            if (value !== undefined) {
	                this.setValue(value);
	            }
	        }
	        else {
	            // sync 的时候不再需要调用经过 accessor 处理之后的值了
	            // 这里之所以需要 setValue 是为了过 getValue() 中的 accessor 修饰函数
	            this.setValue(this.getValue(true), false, false, {
	                disableMutator: true,
	            });
	        }
	    };
	    Prop.prototype.isUseVariable = function () {
	        return this.useVariable;
	    };
	    Prop.prototype.isSupportVariable = function () {
	        return this.config.supportVariable;
	    };
	    Prop.prototype.setVariableValue = function (value) {
	        if (!this.isUseVariable()) {
	            return;
	        }
	        var state = this.props.chainReach(this);
	        if (state === CHAIN_HAS_REACH) {
	            return;
	        }
	        this.variableValue = value;
	        if (this.modify()) {
	            this.valueChange();
	            this.props.syncPass(this);
	        }
	        if (state === CHAIN_START) {
	            this.props.endChain();
	        }
	    };
	    Prop.prototype.setUseVariable = function (flag) {
	        if (this.useVariable === flag) {
	            return;
	        }
	        var state = this.props.chainReach(this);
	        if (state === CHAIN_HAS_REACH) {
	            return;
	        }
	        this.useVariable = flag;
	        this.expanded = true;
	        if (this.modify()) {
	            this.valueChange();
	            this.props.syncPass(this);
	        }
	        if (state === CHAIN_START) {
	            this.props.endChain();
	        }
	        this.emitter.emit('ve.prop.useVariableChange', { isUseVariable: flag });
	        if (this.config.useVariableChange) {
	            this.config.useVariableChange.call(this, { isUseVariable: flag });
	        }
	    };
	    Prop.prototype.getVariableValue = function () {
	        return this.variableValue;
	    };
	    /**
	     * @param value
	     * @param isHotValue 是否为设计器热状态值
	     * @param force 是否强制触发更新
	     */
	    Prop.prototype.setValue = function (value, isHotValue, force, extraOptions) {
	        var _this = this;
	        var state = this.props.chainReach(this);
	        if (state === CHAIN_HAS_REACH) {
	            return;
	        }
	        var preValue = this.value;
	        var preHotValue = this.hotValue;
	        if (isHotValue) {
	            this.hotValue = value;
	            this.value = this.transducer.toNative(this.hotValue);
	        }
	        else {
	            if (!isDataEqual(value, this.value)) {
	                this.hotValue = this.transducer.toHot(value);
	            }
	            this.value = value;
	        }
	        this.i18nLink = I18nUtil.attach(this, this.value, function (val) { return _this.setValue(val, false, true); });
	        var mutator = this.config.mutator;
	        if (!extraOptions) {
	            extraOptions = {};
	        }
	        if (mutator && !extraOptions.disableMutator) {
	            mutator.call(this, this.value, this.hotValue, preValue, preHotValue);
	        }
	        if (this.modify(force)) {
	            this.valueChange(extraOptions);
	            this.props.syncPass(this);
	        }
	        if (state === CHAIN_START) {
	            this.props.endChain();
	        }
	    };
	    Prop.prototype.setHotValue = function (hotValue, options) {
	        try {
	            this.setValue(hotValue, true, false, options);
	        }
	        catch (e) {
	            vu_logger_1.default.log('ERROR_PROP_VALUE');
	            vu_logger_1.default.warn('属性值设置错误：', e, hotValue);
	        }
	    };
	    /**
	     * 验证是否存在变更
	     * @param force 是否强制返回已变更
	     */
	    Prop.prototype.modify = function (force) {
	        var hotData = this.hotData.merge(immutable_1.fromJS({
	            hotValue: this.getHotValue(),
	            value: this.getMixValue(),
	        }));
	        if (!force && hotData.equals(this.hotData)) {
	            return false;
	        }
	        this.hotData = hotData;
	        (this.parent || this.props).modify(this.getName());
	        return true;
	    };
	    Prop.prototype.setHotData = function (hotData, options) {
	        if (!immutable_1.Map.isMap(hotData)) {
	            return;
	        }
	        this.hotData = hotData;
	        var value = hotData.get('value');
	        if (value && typeof value.toJS === 'function') {
	            value = value.toJS();
	        }
	        var hotValue = hotData.get('hotValue');
	        if (hotValue && typeof hotValue.toJS === 'function') {
	            hotValue = hotValue.toJS();
	        }
	        var preValue = value;
	        var preHotValue = hotValue;
	        this.value = value;
	        this.hotValue = hotValue;
	        this.resolveValue();
	        if (!options || !options.disableMutator) {
	            var mutator = this.config.mutator;
	            if (mutator) {
	                mutator.call(this, value, hotValue, preValue, preHotValue);
	            }
	        }
	        this.valueChange();
	    };
	    Prop.prototype.valueChange = function (options) {
	        if (this.loopLock) {
	            return;
	        }
	        this.emitter.emit('valuechange', options);
	        if (this.parent) {
	            this.parent.valueChange(options);
	        }
	    };
	    Prop.prototype.getDisplay = function () {
	        return this.config.display || this.config.fieldStyle || 'block';
	    };
	    Prop.prototype.isHidden = function () {
	        if (!this.isInited() || this.getDisplay() === prototype_1.DISPLAY_TYPE.NONE || this.isDisabled()) {
	            return true;
	        }
	        var hidden = this.config.hidden;
	        if (typeof hidden === 'function') {
	            hidden = hidden.call(this, this.getValue());
	        }
	        return hidden === true;
	    };
	    Prop.prototype.isDisabled = function () {
	        var disabled = this.config.disabled;
	        if (typeof disabled === 'function') {
	            disabled = disabled.call(this, this.getValue());
	        }
	        return disabled === true;
	    };
	    Prop.prototype.isIgnore = function () {
	        if (this.isDisabled()) {
	            return true;
	        }
	        var ignore = this.config.ignore;
	        if (typeof ignore === 'function') {
	            ignore = ignore.call(this, this.getValue());
	        }
	        return ignore === true;
	    };
	    Prop.prototype.isExpand = function () {
	        if (this.expanded == null) {
	            this.expanded = !(this.config.collapsed || this.config.fieldCollapsed);
	        }
	        return this.expanded;
	    };
	    Prop.prototype.toggleExpand = function () {
	        if (this.expanded) {
	            this.expanded = false;
	        }
	        else {
	            this.expanded = true;
	        }
	        this.emitter.emit('expandchange', this.expanded);
	    };
	    Prop.prototype.getSetter = function () {
	        if (dynamicSetterProvider) {
	            return dynamicSetterProvider.call(this, this, this.getNode().getPrototype());
	        }
	        var setterConfig = this.config.setter;
	        if (typeof setterConfig === 'function' && !(setterConfig.prototype instanceof React.Component)) {
	            return setterConfig.call(this, this.getValue());
	        }
	        if (Array.isArray(setterConfig)) {
	            var item = void 0;
	            for (var _i = 0, setterConfig_1 = setterConfig; _i < setterConfig_1.length; _i++) {
	                item = setterConfig_1[_i];
	                if (item.condition.call(this, this.getValue())) {
	                    return item.setter;
	                }
	            }
	            return setterConfig[0].setter;
	        }
	        return setterConfig;
	    };
	    Prop.prototype.getSetterData = function () {
	        if (Array.isArray(this.config.setter)) {
	            var item = void 0;
	            for (var _i = 0, _a = this.config.setter; _i < _a.length; _i++) {
	                item = _a[_i];
	                if (item.condition.call(this, this.getValue())) {
	                    return item;
	                }
	            }
	            return this.config.setter[0];
	        }
	        return {};
	    };
	    Prop.prototype.destroy = function () {
	        if (this.config.destroy) {
	            this.config.destroy();
	        }
	        if (this.i18nLink) {
	            this.i18nLink.detach();
	        }
	    };
	    Prop.prototype.onValueChange = function (func) {
	        var _this = this;
	        this.emitter.on('valuechange', func);
	        return function () {
	            _this.emitter.removeListener('valuechange', func);
	        };
	    };
	    Prop.prototype.onExpandChange = function (func) {
	        var _this = this;
	        this.emitter.on('expandchange', func);
	        return function () {
	            _this.emitter.removeListener('expandchange', func);
	        };
	    };
	    Prop.prototype.onUseVariableChange = function (func) {
	        var _this = this;
	        this.emitter.on('ve.prop.useVariableChange', func);
	        return function () {
	            _this.emitter.removeListener('ve.prop.useVariableChange', func);
	        };
	    };
	    /**
	     * Setters predefined as default options
	     * can by selected by user for every prop
	     *
	     * @static
	     * @memberof Prop
	     */
	    Prop.INSET_SETTER = {};
	    return Prop;
	}());
	exports.default = Prop;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _events = __webpack_require__(1);
	
		var _events2 = _interopRequireDefault(_events);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var keybase = Date.now();
		function keygen(maps) {
		  var key = void 0;
		  do {
		    key = 'i18n-' + (keybase++).toString(36);
		  } while (key in maps);
		  return key;
		}
	
		var DocItem = function () {
		  function DocItem(parent, doc, unInitial) {
		    _classCallCheck(this, DocItem);
	
		    this.parent = parent;
		    this.doc = _extends({
		      type: 'i18n'
		    }, doc);
		    delete this.doc.use;
		    this.emitter = new _events2.default();
		    this.inited = unInitial !== true;
		  }
	
		  DocItem.prototype.getKey = function getKey() {
		    return this.doc.key;
		  };
	
		  DocItem.prototype.getDoc = function getDoc(lang) {
		    if (lang) {
		      return this.doc[lang];
		    }
		    return this.doc;
		  };
	
		  DocItem.prototype.setDoc = function setDoc(doc, lang, initial) {
		    if (lang) {
		      this.doc[lang] = doc;
		    } else {
		      this.doc = _extends({}, this.doc, doc);
		      delete this.doc.use;
		    }
		    this.emitter.emit('change', this.doc);
	
		    if (initial) {
		      this.inited = true;
		    } else if (this.inited) {
		      this.parent._saveChange(this.doc.key, this.doc);
		    }
		  };
	
		  DocItem.prototype.remove = function remove() {
		    if (!this.inited) return Promise.reject('not initialized');
	
		    var _doc = this.doc,
		        key = _doc.key,
		        doc = _objectWithoutProperties(_doc, ['key']); // eslint-disable-line
	
	
		    this.emitter.emit('change', doc);
		    return this.parent.remove(this.getKey());
		  };
	
		  DocItem.prototype.onChange = function onChange(func) {
		    var _this = this;
	
		    this.emitter.on('change', func);
		    return function () {
		      _this.emitter.removeListener('change', func);
		    };
		  };
	
		  return DocItem;
		}();
	
		var I18nUtil = function () {
		  function I18nUtil() {
		    _classCallCheck(this, I18nUtil);
	
		    this.emitter = new _events2.default();
		    // original data source from remote
		    this.i18nData = {};
		    // current i18n records on the left pane
		    this.items = [];
		    this.maps = {};
		    // full list of i18n records for synchronized call
		    this.fullList = [];
		    this.fullMap = {};
	
		    this.config = {};
		    this.ready = false;
		  }
	
		  I18nUtil.prototype._prepareItems = function _prepareItems(items) {
		    var _this2 = this;
	
		    var isFull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		    var isSilent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
		    this[isFull ? 'fullList' : 'items'] = items.map(function (dict) {
		      var item = _this2[isFull ? 'fullMap' : 'maps'][dict.key];
		      if (item) {
		        item.setDoc(dict, null, true);
		      } else {
		        item = new DocItem(_this2, dict);
		        _this2[isFull ? 'fullMap' : 'maps'][dict.key] = item;
		      }
		      return item;
		    });
	
		    if (this.ready && !isSilent) {
		      this.emitter.emit('rowschange');
		      this.emitter.emit('change');
		    } else {
		      this.ready = true;
		      this.emitter.emit('ready');
		    }
		  };
	
		  I18nUtil.prototype._load = function _load() {
		    var _this3 = this;
	
		    var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		    var silent = arguments[1];
	
		    if (!this.config.loader) {
		      console.error(new Error('Please load loader while init I18nUtil.'));
		      return Promise.reject();
		    }
	
		    return this.config.loader(configs).then(function (data) {
		      _this3._prepareItems(data.data, configs.isFull, silent);
		      // set pagination data to i18nData
		      _this3.i18nData = data;
		      if (!silent) {
		        _this3.emitter.emit('rowschange');
		        _this3.emitter.emit('change');
		      }
		      return Promise.resolve(_this3.items.map(function (i) {
		        return i.getDoc();
		      }));
		    });
		  };
	
		  I18nUtil.prototype._saveToItems = function _saveToItems(key, dict) {
		    var item = null;
		    item = this.items.find(function (doc) {
		      return doc.getKey() === key;
		    });
		    if (!item) {
		      item = this.fullList.find(function (doc) {
		        return doc.getKey() === key;
		      });
		    }
	
		    if (item) {
		      item.setDoc(dict);
		    } else {
		      item = new DocItem(this, _extends({
		        key: key
		      }, dict));
		      this.items.unshift(item);
		      this.fullList.unshift(item);
		      this.maps[key] = item;
		      this.fullMap[key] = item;
		      this._saveChange(key, dict, true);
		    }
		  };
	
		  I18nUtil.prototype._saveChange = function _saveChange(key, dict, rowschange) {
		    if (rowschange) {
		      this.emitter.emit('rowschange');
		    }
		    this.emitter.emit('change');
		    if (dict === null) {
		      delete this.maps[key];
		      delete this.fullMap[key];
		    }
		    return this._save(key, dict);
		  };
	
		  I18nUtil.prototype._save = function _save(key, dict) {
		    var saver = dict === null ? this.config.remover : this.config.saver;
		    if (!saver) return Promise.reject('Saver function is not set');
		    return saver(key, dict);
		  };
	
		  I18nUtil.prototype.init = function init(config) {
		    this.config = config || {};
		    if (this.config.items) {
		      // inject to current page
		      this._prepareItems(this.config.items);
		    }
		    this._load();
		    this._load({ isFull: true });
		  };
	
		  I18nUtil.prototype.isReady = function isReady() {
		    return this.ready;
		  };
	
		  // add events updater when i18n record change
		  // we should notify engine's view to change
	
	
		  I18nUtil.prototype.attach = function attach(prop, value, updator) {
		    var isI18nValue = value && value.type === 'i18n' && value.key;
		    var key = isI18nValue ? value.key : null;
		    if (prop.i18nLink) {
		      if (isI18nValue && key === prop.i18nLink.key) {
		        return prop.i18nLink;
		      }
		      prop.i18nLink.detach();
		    }
	
		    if (isI18nValue) {
		      return {
		        key: key,
		        detach: this.getItem(key, value).onChange(updator)
		      };
		    }
	
		    return null;
		  };
	
		  /**
		   * 搜索 i18n 词条
		   *
		   * @param {any} keyword 搜索关键字
		   * @param {boolean} [silent=false] 是否刷新左侧的 i18n 数据
		   * @returns
		   *
		   * @memberof I18nUtil
		   */
	
	
		  I18nUtil.prototype.search = function search(keyword) {
		    var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		    return this._load({ keyword: keyword }, silent);
		  };
	
		  I18nUtil.prototype.load = function load() {
		    var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		    return this._load(configs);
		  };
	
		  I18nUtil.prototype.get = function get(key, lang) {
		    var item = this.getItem(key);
		    if (item) {
		      return item.getDoc(lang);
		    }
		    return null;
		  };
	
		  I18nUtil.prototype.getItem = function getItem(key, forceData) {
		    if (forceData && !this.maps[key] && !this.fullList[key]) {
		      var item = new DocItem(this, _extends({
		        key: key
		      }, forceData), true);
		      this.maps[key] = item;
		      this.fullMap[key] = item;
		      this.fullList.push(item);
		      this.items.push(item);
		    }
		    return this.maps[key] || this.fullMap[key];
		  };
	
		  I18nUtil.prototype.getItems = function getItems() {
		    return this.items;
		  };
	
		  I18nUtil.prototype.update = function update(key, doc, lang) {
		    var dict = this.get(key) || {};
		    if (!lang) {
		      dict = doc;
		    } else {
		      dict[lang] = doc;
		    }
		    this._saveToItems(key, dict);
		  };
	
		  I18nUtil.prototype.create = function create(doc, lang) {
		    var dict = lang ? _defineProperty({}, lang, doc) : doc;
		    var key = keygen(this.fullMap);
		    this._saveToItems(key, dict);
		    return key;
		  };
	
		  I18nUtil.prototype.remove = function remove(key) {
		    var index = this.items.findIndex(function (item) {
		      return item.getKey() === key;
		    });
		    var indexG = this.fullList.findIndex(function (item) {
		      return item.getKey() === key;
		    });
		    if (index > -1) {
		      this.items.splice(index, 1);
		    }
		    if (indexG > -1) {
		      this.fullList.splice(index, 1);
		    }
		    return this._saveChange(key, null, true);
		  };
	
		  I18nUtil.prototype.onReady = function onReady(func) {
		    var _this4 = this;
	
		    this.emitter.on('ready', func);
		    return function () {
		      _this4.emitter.removeListener('ready', func);
		    };
		  };
	
		  I18nUtil.prototype.onRowsChange = function onRowsChange(func) {
		    var _this5 = this;
	
		    this.emitter.on('rowschange', func);
		    return function () {
		      _this5.emitter.removeListener('rowschange', func);
		    };
		  };
	
		  I18nUtil.prototype.onChange = function onChange(func) {
		    var _this6 = this;
	
		    this.emitter.on('change', func);
		    return function () {
		      _this6.emitter.removeListener('change', func);
		    };
		  };
	
		  return I18nUtil;
		}();
	
		exports.default = new I18nUtil();
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(11);
	
	/***/ }
	/******/ ]);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var props_1 = __webpack_require__(42);
	var uniqueId = __webpack_require__(4).uniqueId;
	var Group = /** @class */ (function () {
	    function Group(target, config, dataGetter) {
	        this.id = uniqueId(null, 'group', 'engine-group');
	        this.node = target.getNode();
	        this.config = config || {};
	        this.name = this.config.name || this.id;
	        if (target.getName) {
	            this.name = target.getName() + "." + this.name;
	        }
	        this.expanded = !(this.config.collapsed || this.config.fieldCollapsed);
	        this.items = props_1.releaseItems(this.config.items, target, dataGetter, true);
	        this.emitter = new EventEmitter();
	    }
	    Group.prototype.getId = function () {
	        return this.id;
	    };
	    Group.prototype.getNode = function () {
	        return this.node;
	    };
	    Group.prototype.getProps = function () {
	        return this.getNode().getProps();
	    };
	    Group.prototype.getTip = function () {
	        return this.config.tip;
	    };
	    Group.prototype.getName = function () {
	        return this.name;
	    };
	    Group.prototype.getTitle = function () {
	        return this.config.title;
	    };
	    Group.prototype.getDisplay = function () {
	        return this.config.display || 'tab';
	    };
	    Group.prototype.getConfig = function () {
	        return '';
	    };
	    Group.prototype.isGroup = function () {
	        return true;
	    };
	    Group.prototype.isTab = function () {
	        return this.getDisplay() === 'tab';
	    };
	    Group.prototype.isIgnore = function () {
	        return true;
	    };
	    Group.prototype.isHidden = function () {
	        if (this.getDisplay() === 'none' || this.isDisabled() || this.getVisibleItems().length < 1) {
	            return true;
	        }
	        var hidden = this.config.hidden;
	        if (typeof hidden === 'function') {
	            hidden = hidden.call(this);
	        }
	        return hidden === true;
	    };
	    Group.prototype.isDisabled = function () {
	        var disabled = this.config.disabled;
	        if (typeof disabled === 'function') {
	            disabled = disabled.call(this);
	        }
	        return disabled === true;
	    };
	    Group.prototype.getItems = function (filter) {
	        if (filter) {
	            return this.items.filter(filter);
	        }
	        return this.items;
	    };
	    Group.prototype.getVisibleItems = function () {
	        return this.getItems(function (item) { return !item.isHidden(); });
	    };
	    Group.prototype.isExpand = function () {
	        return this.expanded;
	    };
	    Group.prototype.getVariableValue = function () {
	        return '';
	    };
	    Group.prototype.isUseVariable = function () {
	        return false;
	    };
	    Group.prototype.isSupportVariable = function () {
	        return false;
	    };
	    Group.prototype.setUseVariable = function () {
	        this.useVariable = false;
	    };
	    Group.prototype.setVariableValue = function () {
	        this.variableValue = '';
	    };
	    Group.prototype.onUseVariableChange = function () {
	        this.useVariable = false;
	    };
	    Group.prototype.toggleExpand = function () {
	        if (this.expanded) {
	            this.expanded = false;
	        }
	        else {
	            this.expanded = true;
	        }
	        this.emitter.emit('expandchange', this.expanded);
	    };
	    Group.prototype.onExpandChange = function (func) {
	        var _this = this;
	        this.emitter.on('expandchange', func);
	        return function () {
	            _this.emitter.removeListener('expandchange', func);
	        };
	    };
	    return Group;
	}());
	exports.default = Group;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var events_1 = __webpack_require__(11);
	var stages_1 = __webpack_require__(43);
	var propsGroup_1 = __webpack_require__(48);
	var propsTab_1 = __webpack_require__(50);
	var SettingStage = /** @class */ (function (_super) {
	    __extends(SettingStage, _super);
	    function SettingStage(target) {
	        var _this = this;
	        var isRoot = !!target.isProps;
	        var node = target.getNode();
	        _this = _super.call(this, {
	            isRoot: isRoot,
	            title: target.getTitle ? target.getTitle() : '',
	            tip: target.getTip ? target.getTip() : '',
	            id: isRoot ? node.getId() : target.getId(),
	        }) || this;
	        _this.node = node;
	        if (target.getItems) {
	            _this.tabs = target.getItems(function (item) { return item.isTab(); }) || [];
	            var items = target instanceof propsGroup_1.default
	                ? target.getItems(function (item) { return !item.isTab(); })
	                : target.getItems(function (item) { return !item.isTab() && !item.inGroup; });
	            if (items.length > 0) {
	                _this.tabs.push(new propsTab_1.default({
	                    id: _this.id,
	                    items: items,
	                    title: '其它',
	                }));
	            }
	        }
	        else {
	            _this.tabs = [target];
	        }
	        _this.emitter = new events_1.EventEmitter();
	        return _this;
	    }
	    SettingStage.prototype.getNode = function () {
	        return this.node;
	    };
	    SettingStage.prototype.stat = function () {
	        this.statTabs = this.tabs.filter(function (tab) { return !tab.isHidden(); });
	        if (this.statTabs.length < 1) {
	            this.currentTab = null;
	        }
	        if (this.currentTab && this.statTabs.indexOf(this.currentTab) < 0) {
	            this.currentTab = null;
	        }
	        if (!this.currentTab) {
	            this.currentTab = this.statTabs[0];
	        }
	    };
	    SettingStage.prototype.hasTabs = function () {
	        return this.statTabs.length > 1;
	    };
	    SettingStage.prototype.getTabs = function () {
	        return this.statTabs;
	    };
	    SettingStage.prototype.getCurrentTab = function () {
	        return this.currentTab;
	    };
	    SettingStage.prototype.setCurrentTab = function (tab) {
	        if (this.currentTab !== tab) {
	            this.currentTab = tab;
	            this.emitter.emit('currenttabchange');
	        }
	    };
	    SettingStage.prototype.onCurrentTabChange = function (func) {
	        var _this = this;
	        this.emitter.on('currenttabchange', func);
	        return function () {
	            _this.emitter.removeListener('currenttabchange', func);
	        };
	    };
	    return SettingStage;
	}(stages_1.default.Stage));
	exports.default = SettingStage;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var uniqueId = __webpack_require__(4).uniqueId;
	var Tab = /** @class */ (function () {
	    function Tab(config) {
	        this.config = config || {};
	        this.id = uniqueId(this.config.id, 'tab', 'engine-tab');
	        this.items = this.config.items || [];
	    }
	    Tab.prototype.isTab = function () {
	        return true;
	    };
	    Tab.prototype.isHidden = function () {
	        return this.getVisibleItems().length < 1;
	    };
	    Tab.prototype.getTip = function () {
	        return '';
	    };
	    Tab.prototype.getId = function () {
	        return this.id;
	    };
	    Tab.prototype.getTitle = function () {
	        return this.config.title;
	    };
	    Tab.prototype.getItems = function (filter) {
	        if (filter) {
	            return this.items.filter(filter);
	        }
	        return this.items;
	    };
	    Tab.prototype.getConfig = function () {
	        return '';
	    };
	    Tab.prototype.getVisibleItems = function () {
	        return this.getItems(function (item) { return !item.isHidden(); });
	    };
	    Tab.prototype.getVariableValue = function () {
	        return '';
	    };
	    Tab.prototype.isUseVariable = function () {
	        return false;
	    };
	    Tab.prototype.isSupportVariable = function () {
	        return false;
	    };
	    Tab.prototype.setUseVariable = function () {
	        this.useVariable = false;
	    };
	    Tab.prototype.setVariableValue = function () {
	        this.variableValue = '';
	    };
	    Tab.prototype.onUseVariableChange = function () {
	        this.useVariable = false;
	    };
	    return Tab;
	}());
	exports.default = Tab;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var actionpane_1 = __webpack_require__(52);
	var dockpane_1 = __webpack_require__(54);
	var stages_1 = __webpack_require__(43);
	var tabpane_1 = __webpack_require__(56);
	var widgets_1 = __webpack_require__(58);
	var dockPane = new dockpane_1.default();
	var actionPane = new actionpane_1.default();
	var tabPane = new tabpane_1.default();
	var widgets = new widgets_1.default();
	function add(config, extraConfig) {
	    if (typeof config === 'function') {
	        config = config.call(null);
	    }
	    if (!config || !config.type) {
	        return null;
	    }
	    if (extraConfig) {
	        config = __assign(__assign({}, config), extraConfig);
	    }
	    switch (config.type) {
	        case 'dock':
	            return dockPane.addDock(config);
	        case 'action':
	            return actionPane.addAction(config);
	        case 'tab':
	            return tabPane.addTab(config);
	        case 'widget':
	            return widgets.addWidget(config);
	        case 'stage':
	            return stages_1.default.addGlobalStage(config);
	        default:
	            return null;
	    }
	}
	exports.default = {
	    ActionPane: actionPane,
	    DockPane: dockPane,
	    Stages: stages_1.default,
	    TabPane: tabPane,
	    Widgets: widgets,
	    actionPane: actionPane,
	    add: add,
	    dockPane: dockPane,
	    tabPane: tabPane,
	    widgets: widgets,
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var flags_1 = __webpack_require__(23);
	var actionCore_1 = __webpack_require__(53);
	var ActionPane = /** @class */ (function () {
	    function ActionPane() {
	        this.actions = [];
	        this.emitter = new EventEmitter();
	    }
	    ActionPane.prototype.addAction = function (actionConfig) {
	        var action = new actionCore_1.default(actionConfig);
	        this.actions.push(action);
	        this.sortActions();
	        this.emitter.emit('actionschange', this.actions);
	    };
	    ActionPane.prototype.removeAction = function (action) {
	        if (typeof action === 'string') {
	            action = this.actions.find(function (item) { return item.getName() === action; });
	        }
	        var i = this.actions.indexOf(action);
	        if (i > -1) {
	            action.destroy();
	            this.actions.splice(i, 1);
	            this.emitter.emit('actionschange', this.actions);
	        }
	    };
	    ActionPane.prototype.getActions = function () {
	        return this.actions;
	    };
	    ActionPane.prototype.setActions = function (actions) {
	        if (actions === void 0) { actions = []; }
	        this.actions = actions;
	        this.sortActions();
	        this.emitter.emit('actionschange', this.actions);
	    };
	    ActionPane.prototype.hidePane = function () {
	        flags_1.default.add('hide-actionpane');
	    };
	    ActionPane.prototype.showPane = function () {
	        flags_1.default.remove('hide-actionpane');
	    };
	    ActionPane.prototype.onActionsChange = function (func) {
	        var _this = this;
	        this.emitter.on('actionschange', func);
	        return function () {
	            _this.emitter.removeListener('actionschange', func);
	        };
	    };
	    ActionPane.prototype.sortActions = function () {
	        this.actions.sort(function (prev, next) {
	            return (prev.getIndex()) <= (next.getIndex()) ? 1 : -1;
	        });
	    };
	    return ActionPane;
	}());
	exports.default = ActionPane;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var pane_1 = __webpack_require__(44);
	var ActionCore = /** @class */ (function (_super) {
	    __extends(ActionCore, _super);
	    function ActionCore() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ActionCore.prototype.getPlace = function () {
	        return this.config.place || 'left';
	    };
	    /**
	     * default to 0, without any priority, the action will
	     * be sorted from left to right with large index on the
	     * right
	     */
	    ActionCore.prototype.getIndex = function () {
	        return this.config.index || 0;
	    };
	    return ActionCore;
	}(pane_1.default));
	exports.default = ActionCore;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var bus_1 = __webpack_require__(36);
	var dragengine_1 = __webpack_require__(21);
	var flags_1 = __webpack_require__(23);
	var viewport_1 = __webpack_require__(41);
	var dockCore_1 = __webpack_require__(55);
	var DockPane = /** @class */ (function () {
	    function DockPane() {
	        var _this = this;
	        this.stashedDock = null;
	        this.emitter = new EventEmitter();
	        this.docks = [];
	        this.miniMode = false;
	        this.bus = new bus_1.default();
	        viewport_1.default.onFocusChange(function (flag) {
	            if (flag && _this.activedDock && _this.activedDock.getCurrentPosition() === 'default') {
	                _this.activeDock(null);
	            }
	        });
	        // 引擎开始拖拽的时候需要隐藏正在展示的 dockPane
	        dragengine_1.default.onDragstart(function () {
	            _this.stashedDock = _this.activedDock;
	            _this.activeDock(null);
	        });
	        // 引擎结束拖拽的时候还原之前的状态
	        dragengine_1.default.onDragend(function () {
	            _this.activeDock(_this.stashedDock || null);
	            _this.stashedDock = null;
	        });
	    }
	    DockPane.prototype.activeDock = function (dock) {
	        var _this = this;
	        if (typeof dock === 'string') {
	            dock = this.docks.find(function (item) { return item.getName() === dock; });
	        }
	        if (this.activedDock === dock) {
	            return;
	        }
	        if (this.activedDock) {
	            this.activedDock.setActive(false);
	            this.emitter.emit('ve.dockPane.hideDock', this.docks.find(function (item) { return item.getName() === _this.activedDock.getName(); }));
	        }
	        if (dock) {
	            dock.setActive(true);
	            flags_1.default.setHideSlate(false);
	            this.bus.emit('ve.dock_pane.active_doc', dock);
	            this.emitter.emit('ve.dockPane.showDock', dock);
	        }
	        else {
	            flags_1.default.setHideSlate(true);
	        }
	        this.activedDock = dock;
	    };
	    /**
	     * 添加一个泊位
	     *
	     * @param {object} dockConfig
	     */
	    DockPane.prototype.addDock = function (dockConfig) {
	        var dock = new dockCore_1.default(dockConfig);
	        var index = dockConfig.index;
	        if (index == null) {
	            index = this.docks.length;
	        }
	        this.docks.splice(index, 0, dock);
	        this.emitter.emit('dockschange', this.docks);
	    };
	    DockPane.prototype.addDockContent = function (name, content) {
	        var dock = this.docks.find(function (item) { return item.getName() === name; });
	        if (dock) {
	            dock.addContent(content);
	        }
	    };
	    DockPane.prototype.removeDock = function (dock) {
	        if (typeof dock === 'string') {
	            dock = this.docks.find(function (item) { return item.getName() === dock; });
	        }
	        var i = this.docks.indexOf(dock);
	        if (i > -1) {
	            this.docks.splice(i, 1);
	            dock.destroy();
	            if (this.activedDock === dock) {
	                this.activeDock(this.docks[0]);
	            }
	            this.emitter.emit('dockschange', this.docks);
	        }
	    };
	    DockPane.prototype.getDocks = function () {
	        return this.docks;
	    };
	    DockPane.prototype.onDocksChange = function (func) {
	        var _this = this;
	        this.emitter.on('dockschange', func);
	        return function () {
	            _this.emitter.removeListener('dockschange', func);
	        };
	    };
	    DockPane.prototype.onDockShow = function (fn) {
	        var _this = this;
	        this.emitter.on('ve.dockPane.showDock', fn);
	        return function () {
	            _this.emitter.removeListener('ve.dockPane.showDock', fn);
	        };
	    };
	    DockPane.prototype.onDockHide = function (fn) {
	        var _this = this;
	        this.emitter.on('ve.dockPane.hideDock', fn);
	        return function () {
	            _this.emitter.removeListener('ve.dockPane.hideDock', fn);
	        };
	    };
	    return DockPane;
	}());
	exports.default = DockPane;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var pane_1 = __webpack_require__(44);
	function getCachedPosition(dockPaneName) {
	    return window.localStorage && window.localStorage.getItem("__ve.dockpane." + dockPaneName + ".position__");
	}
	function setPositionCache(dockPaneName, position) {
	    if (window.localStorage) {
	        window.localStorage.setItem("__ve.dockpane." + dockPaneName + ".position__", position);
	    }
	}
	var DockCore = /** @class */ (function (_super) {
	    __extends(DockCore, _super);
	    function DockCore(config) {
	        var _this = _super.call(this, config) || this;
	        if (_this.config.contents && Array.isArray(_this.config.contents)) {
	            _this.contents = _this.config.contents;
	            _this.contents.forEach(function (item) {
	                item.content = _this.initContent(item.content);
	            });
	        }
	        else {
	            _this.contents = [{
	                    content: _this.content,
	                    title: _this.getTitle(),
	                }];
	        }
	        _this.description = _this.config.description || _this.getTitles().join('/');
	        _this.currentIndex = 0;
	        _this.position = getCachedPosition(config.name);
	        return _this;
	    }
	    DockCore.prototype.getPlace = function () {
	        return this.config.place || 'top';
	    };
	    DockCore.prototype.getTitles = function () {
	        return this.contents.map(function (item) { return item.title; });
	    };
	    DockCore.prototype.getDescription = function () {
	        return this.description;
	    };
	    DockCore.prototype.getMenu = function () {
	        return this.config.menu || this.getTitle();
	    };
	    DockCore.prototype.getWidth = function () {
	        return this.config.width || 200;
	    };
	    DockCore.prototype.getMaxWidth = function () {
	        return this.config.maxWidth || 1000;
	    };
	    DockCore.prototype.getHeight = function () {
	        return this.config.height || 300;
	    };
	    DockCore.prototype.getMaxHeight = function () {
	        return this.config.maxHeight || 1000;
	    };
	    DockCore.prototype.getSupportedPositions = function () {
	        if (!this.config.position) {
	            return ['default'];
	        }
	        return Array.isArray(this.config.position) ? this.config.position : [this.config.position];
	    };
	    DockCore.prototype.getCurrentPosition = function () {
	        if (this.position) {
	            return this.position;
	        }
	        return this.getSupportedPositions()[0];
	    };
	    DockCore.prototype.setPosition = function (position) {
	        if (this.position !== position) {
	            this.position = position;
	            setPositionCache(this.config.name, position);
	            this.emitter.emit('positionchange', position);
	        }
	    };
	    DockCore.prototype.showTitleBar = function () {
	        return !this.config.hideTitleBar;
	    };
	    DockCore.prototype.getContent = function () {
	        return this.contents[this.currentIndex].content || null;
	    };
	    DockCore.prototype.getCurrentContentConfig = function () {
	        return this.contents[this.currentIndex] || null;
	    };
	    DockCore.prototype.getContents = function () {
	        return this.contents;
	    };
	    // 是否只是动作，不需要出发弹窗
	    DockCore.prototype.isAction = function () {
	        return this.config.isAction;
	    };
	    DockCore.prototype.addContent = function (content) {
	        if (!content) {
	            return;
	        }
	        content.content = this.initContent(content.content);
	        this.contents.push(content);
	        this.emitter.emit('contentschange');
	    };
	    DockCore.prototype.getCurrentIndex = function () {
	        return this.currentIndex;
	    };
	    DockCore.prototype.activeIndex = function (index) {
	        if (index === this.currentIndex) {
	            return;
	        }
	        this.currentIndex = index;
	        this.emitter.emit('contentschange');
	    };
	    /**
	     * 是否激活
	     *
	     * @returns {boolean}
	     */
	    DockCore.prototype.isActive = function () {
	        return this.actived;
	    };
	    /**
	     * 是否初始化
	     *
	     * @returns {boolean}
	     */
	    DockCore.prototype.isInitialize = function () {
	        return this.isInitialized;
	    };
	    DockCore.prototype.setActive = function (flag) {
	        if (this.actived && !flag) {
	            this.actived = false;
	            this.emitter.emit('activechange', this.actived);
	        }
	        else if (!this.actived && flag) {
	            this.actived = true;
	            this.isInitialized = true;
	            this.emitter.emit('activechange', this.actived);
	        }
	    };
	    DockCore.prototype.onActiveChange = function (func) {
	        var _this = this;
	        this.emitter.on('activechange', func);
	        return function () {
	            _this.emitter.removeListener('activechange', func);
	        };
	    };
	    DockCore.prototype.onContentsChange = function (func) {
	        var _this = this;
	        this.emitter.on('contentschange', func);
	        return function () {
	            _this.emitter.removeListener('contentschange', func);
	        };
	    };
	    DockCore.prototype.onPositonChange = function (func) {
	        var _this = this;
	        this.emitter.on('positionchange', func);
	        return function () {
	            _this.emitter.removeListener('positionchange', func);
	        };
	    };
	    return DockCore;
	}(pane_1.default));
	exports.default = DockCore;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var tabCore_1 = __webpack_require__(57);
	var TabPane = /** @class */ (function () {
	    function TabPane() {
	        this.tabs = [];
	        this.emitter = new EventEmitter();
	        this.activedTab = null;
	    }
	    /**
	     *
	     * @param tabConfig
	     * @param  index
	     */
	    TabPane.prototype.addTab = function (tabConfig, index) {
	        var tab = new tabCore_1.default(tabConfig);
	        if (index == null) {
	            index = this.tabs.length;
	        }
	        this.tabs.splice(index, 0, tab);
	        if (!this.activedTab) {
	            this.activeTab(tab);
	        }
	        this.emitter.emit('tabschange', this.tabs);
	    };
	    TabPane.prototype.removeTab = function (tab) {
	        if (typeof tab === 'string') {
	            tab = this.tabs.find(function (item) { return item.getName() === tab; });
	        }
	        var i = this.tabs.indexOf(tab);
	        if (i > -1) {
	            tab.destroy();
	            this.tabs.splice(i, 1);
	            if (this.activedTab === tab) {
	                this.activeTab(this.tabs[0]);
	            }
	            this.emitter.emit('tabschange', this.tabs);
	        }
	    };
	    /**
	     * 获得所有标签项
	     *
	     * @returns {Tabs[]}
	     */
	    TabPane.prototype.getTabs = function () {
	        return this.tabs;
	    };
	    /**
	     * 获得当前激活的标签项
	     *
	     * @returns {null|TabCore}
	     */
	    TabPane.prototype.getActivedTab = function () {
	        return this.activedTab;
	    };
	    TabPane.prototype.activeTab = function (tab) {
	        if (typeof tab === 'string') {
	            tab = this.tabs.find(function (item) { return item.getName() === tab; });
	        }
	        if (this.activedTab === tab) {
	            return;
	        }
	        if (this.activedTab) {
	            this.activedTab.setActive(false);
	        }
	        if (tab) {
	            tab.setActive(true);
	        }
	        this.activedTab = tab;
	    };
	    TabPane.prototype.onTabsChange = function (func) {
	        var _this = this;
	        this.emitter.on('tabschange', func);
	        return function () {
	            _this.emitter.removeListener('tabschange', func);
	        };
	    };
	    return TabPane;
	}());
	exports.default = TabPane;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var pane_1 = __webpack_require__(44);
	var TabCore = /** @class */ (function (_super) {
	    __extends(TabCore, _super);
	    function TabCore() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * 是否激活
	     *
	     * @returns {boolean}
	     */
	    TabCore.prototype.isActive = function () {
	        return this.actived;
	    };
	    TabCore.prototype.setActive = function (flag) {
	        if (this.actived && !flag) {
	            this.actived = false;
	            this.emitter.emit('activechange', this.actived);
	        }
	        else if (!this.actived && flag) {
	            this.actived = true;
	            this.emitter.emit('activechange', this.actived);
	        }
	    };
	    TabCore.prototype.onActiveChange = function (func) {
	        var _this = this;
	        this.emitter.on('activechange', func);
	        return function () {
	            _this.emitter.removeListener('activechange', func);
	        };
	    };
	    return TabCore;
	}(pane_1.default));
	exports.default = TabCore;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var widgetsCore_1 = __webpack_require__(59);
	var Widgets = /** @class */ (function () {
	    function Widgets() {
	        this.emitter = new EventEmitter();
	        this.widgets = [];
	    }
	    Widgets.prototype.addWidget = function (widgetConfig) {
	        this.widgets.push(new widgetsCore_1.default(widgetConfig));
	        this.emitter.emit('widgetschange', this.widgets);
	    };
	    Widgets.prototype.getWidgets = function () {
	        return this.widgets;
	    };
	    Widgets.prototype.onWidgetsChange = function (func) {
	        var _this = this;
	        this.emitter.on('widgetschange', func);
	        return function () {
	            _this.emitter.removeListener('widgetschange', func);
	        };
	    };
	    return Widgets;
	}());
	exports.default = Widgets;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var pane_1 = __webpack_require__(44);
	var Widget = /** @class */ (function (_super) {
	    __extends(Widget, _super);
	    function Widget() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return Widget;
	}(pane_1.default));
	exports.default = Widget;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var immutable_1 = __webpack_require__(40);
	var Pages = __webpack_require__(61);
	var Project = /** @class */ (function () {
	    function Project() {
	    }
	    Project.prototype.getParam = function (name) {
	        var value = this.params.get(name);
	        return value.toJS ? value.toJS() : value;
	    };
	    Project.prototype.setParam = function (name, value) {
	        this.params = this.params.set(name, immutable_1.fromJS(value));
	        return this.params;
	    };
	    Project.prototype.getPages = function () {
	        return Pages;
	    };
	    Project.prototype.getType = function () {
	        return this.params.get('schemaType');
	    };
	    Project.prototype.getVersion = function () {
	        return this.params.get('schemaVersion');
	    };
	    Project.prototype.init = function (project) {
	        var pages = project.pages, params = __rest(project, ["pages"]);
	        this.params = immutable_1.fromJS(params);
	        Pages.setPages(pages);
	    };
	    Project.prototype.toData = function () {
	        return __assign(__assign({}, this.params.toJS()), { pages: this.getPages().toData() });
	    };
	    return Project;
	}());
	exports.default = new Project();


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var pages_1 = __webpack_require__(62);
	exports.default = new pages_1.default();


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var lodash_1 = __webpack_require__(7);
	var vu_logger_1 = __webpack_require__(6);
	var env_1 = __webpack_require__(10);
	var exchange_1 = __webpack_require__(20);
	var flags_1 = __webpack_require__(23);
	var dragengine_1 = __webpack_require__(21);
	var index_1 = __webpack_require__(16);
	var page_1 = __webpack_require__(63);
	var StyleSheet = __webpack_require__(84);
	var Pages = /** @class */ (function () {
	    function Pages() {
	        var _this = this;
	        this.pages = [];
	        this.emitter = new EventEmitter();
	        this.emitter.setMaxListeners(0);
	        this.currentPage = null;
	        exchange_1.default.onIntoView(function (node, insertion) {
	            var page = node.getPage();
	            if (page === _this.currentPage) {
	                page.scrollIntoNode(node, insertion);
	            }
	        });
	        flags_1.default.onFlagsChange(function () { return index_1.default.touch(true); });
	        env_1.default.onEnvChange(function () { return index_1.default.touch(true); });
	        dragengine_1.default.addSensor(this);
	    }
	    /** start: sensor for DragEngine **/
	    Pages.prototype.isEnabled = function () {
	        return this.currentPage && this.currentPage.isEnabled();
	    };
	    Pages.prototype.isEnter = function (e) {
	        return this.currentPage && this.currentPage.isEnter(e);
	    };
	    Pages.prototype.isInRange = function (e) {
	        return this.currentPage && this.currentPage.isInRange(e);
	    };
	    Pages.prototype.deactive = function () {
	        return this.currentPage && this.currentPage.deactive();
	    };
	    Pages.prototype.orient = function (dragment, e) {
	        return this.currentPage && this.currentPage.orient(dragment, e);
	    };
	    /** end: sensor for DragEngine **/
	    /**
	     * 初始化页面集数据
	     *
	     * @param {Object[]} pagesdata
	     */
	    Pages.prototype.setPages = function (pagesdata) {
	        var _this = this;
	        if (this.pages) {
	            this.pages.forEach(function (page) {
	                page.destroy();
	            });
	        }
	        this.pages = pagesdata ? pagesdata.map(function (data) {
	            try {
	                return new page_1.Page(data);
	            }
	            catch (e) {
	                vu_logger_1.default.error('ERROR: create new page error', e);
	                return null;
	            }
	        }).filter(function (item) { return item !== null; }) : [];
	        // delay the execution of pageChange event to avoid invalid repaint
	        setTimeout(function () {
	            _this.emitter.emit('pageschange', _this.pages);
	            _this.setCurrentPage(_this.getPage(0));
	        });
	    };
	    /**
	     * 导出页面集数据
	     *
	     * @returns {Object[]}
	     */
	    Pages.prototype.toData = function () {
	        return this.pages.map(function (page) { return page.toData(); });
	    };
	    /**
	     * 添加页面
	     *
	     * @param {Object} data
	     * @returns {Page}
	     */
	    Pages.prototype.addPage = function (data) {
	        var page = new page_1.Page(data);
	        this.pages.push(page);
	        this.emitter.emit('pageschange', this.pages);
	        if (!this.currentPage) {
	            this.setCurrentPage(page);
	        }
	        return page;
	    };
	    Pages.prototype.getPage = function (fn) {
	        if (typeof fn === 'number') {
	            return this.pages[fn];
	        }
	        else if (typeof fn === 'function') {
	            return lodash_1.find(this.pages, fn);
	        }
	        return null;
	    };
	    /**
	     * 删除页面
	     *
	     * @param {Page} page
	     */
	    Pages.prototype.removePage = function (page) {
	        var i = this.pages.indexOf(page);
	        if (i >= 0) {
	            page.destroy();
	            this.pages.splice(i, 1);
	            if (this.currentPage === page) {
	                this.setCurrentPage(this.getPage(0));
	            }
	        }
	        this.emitter.emit('pageschange', this.pages);
	    };
	    /**
	     * 插入页面, 用于排序
	     *
	     * @param {Page} page
	     * @param {int} index
	     */
	    Pages.prototype.insertPage = function (page, index) {
	        var i = this.pages.indexOf(page);
	        if (i >= 0) {
	            this.pages.splice(i, 1);
	            this.pages.splice(index > i ? (index - 1) : index, 0, page);
	            this.emitter.emit('pageschange', this.pages);
	        }
	    };
	    Pages.prototype.sortPages = function (pages) {
	        this.pages = pages;
	        this.emitter.emit('pageschange', this.pages);
	    };
	    /**
	     * 获取所有页面
	     *
	     * @returns {Page[]}
	     */
	    Pages.prototype.getPages = function () {
	        return this.pages;
	    };
	    /**
	     * 设置当前页面
	     *
	     * @param {Page} page
	     */
	    Pages.prototype.setCurrentPage = function (page) {
	        if (page === this.currentPage) {
	            return;
	        }
	        StyleSheet.clear();
	        exchange_1.default.purge();
	        if (this.currentPage) {
	            this.currentPage.setVisible(false);
	        }
	        if (page && this.pages.indexOf(page) < 0) {
	            page = null;
	        }
	        if (page) {
	            this.currentPage = page;
	            page.setVisible(true);
	        }
	        this.emitter.emit('currentpagechange', this.currentPage);
	    };
	    /**
	     * 获取当前页面
	     *
	     * @returns {Page|null}
	     */
	    Pages.prototype.getCurrentPage = function () {
	        return this.currentPage;
	    };
	    Pages.prototype.onPagesChange = function (func) {
	        var _this = this;
	        this.emitter.on('pageschange', func);
	        return function () {
	            _this.emitter.removeListener('pageschange', func);
	        };
	    };
	    Pages.prototype.onCurrentPageChange = function (func) {
	        var _this = this;
	        this.emitter.on('currentpagechange', func);
	        return function () {
	            _this.emitter.removeListener('currentpagechange', func);
	        };
	    };
	    return Pages;
	}());
	exports.default = Pages;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	var visualpage_1 = __webpack_require__(64);
	var const_1 = __webpack_require__(12);
	var bus_1 = __webpack_require__(36);
	var scroller_1 = __webpack_require__(77);
	var floatingNodesManager_1 = __webpack_require__(78);
	var history_1 = __webpack_require__(79);
	var modalNodesManager_1 = __webpack_require__(81);
	var node_1 = __webpack_require__(39);
	var root_1 = __webpack_require__(82);
	var ve_utils_1 = __webpack_require__(4);
	var immutable_1 = __webpack_require__(40);
	var context_1 = __webpack_require__(9);
	var Page = /** @class */ (function () {
	    function Page(data) {
	        var _this = this;
	        this.rootNodeVisitorMap = {};
	        var id = data.id, componentsTree = data.componentsTree, props = data.props, children = data.children, params = data.params, addonsData = __rest(data, ["id", "componentsTree", "props", "children", "params"]);
	        this.emitter = new EventEmitter();
	        this.bus = new bus_1.default();
	        var rootData = componentsTree ? componentsTree[0] : {
	            children: children,
	            props: props,
	        };
	        this.root = new root_1.default(this, rootData);
	        this.params = new immutable_1.Map(params || {});
	        this.addonsData = addonsData || {};
	        this.history = new history_1.default(function (hotData) {
	            var nativeData = {
	                layout: _this.root.getHotData(),
	                params: _this.params,
	            };
	            return hotData ? hotData.merge(nativeData) : new immutable_1.Map(nativeData);
	        }, function (hotData) {
	            _this.setHotParams(hotData.get('params'));
	            _this.root.setHotData(hotData.get('layout'), { disableMutator: true });
	        });
	        this.id = ve_utils_1.uniqueId(id, 'page', 'engine-page');
	        this.readyState = false;
	        this.visible = false;
	        this.addons = [];
	        // TODO: use visitor pattern
	        this.modalNodesManager = new modalNodesManager_1.default(this);
	        // TODO: use visitor pattern
	        this.floatingNodesManager = new floatingNodesManager_1.default(this);
	        this.ctx = new context_1.default();
	        if (!!this.ctx.getModule('VisualPage')) {
	            this.VisualPage = this.ctx.getModule('VisualPage');
	        }
	        else {
	            this.VisualPage = visualpage_1.default;
	        }
	    }
	    Page.prototype.getParam = function (name) {
	        return this.params.get(name);
	    };
	    Page.prototype.setHotParams = function (params) {
	        if (params.equals(this.params)) {
	            return false;
	        }
	        this.params = params;
	        this.emitter.emit('paramschange', this.params);
	        return true;
	    };
	    Page.prototype.setParam = function (name, value) {
	        var params = this.params.set(name, value);
	        this.setHotParams(params);
	        this.addHistory('Change page params');
	    };
	    Page.prototype.registerAddon = function (name, exportData) {
	        if (['id', 'params', 'layout'].indexOf(name) > -1) {
	            throw new Error('addon name cannot be id, params, layout');
	        }
	        var i = this.addons.findIndex(function (item) { return item.name === name; });
	        if (i > -1) {
	            this.addons.splice(i, 1);
	        }
	        this.addons.push({
	            exportData: exportData,
	            name: name,
	        });
	    };
	    Page.prototype.exportAddonData = function () {
	        var addons = __assign({}, this.addonsData);
	        this.addons.forEach(function (addon) {
	            var data = addon.exportData();
	            if (data === null) {
	                delete addons[addon.name];
	            }
	            else {
	                addons[addon.name] = data;
	            }
	        });
	        return addons;
	    };
	    Page.prototype.getAddonData = function (name) {
	        var addon = this.addons.find(function (item) { return item.name === name; });
	        if (addon) {
	            return addon.exportData();
	        }
	        return this.addonsData[name];
	    };
	    Page.prototype.acceptRootNodeVisitor = function (visitorName, visitorFn) {
	        if (visitorName === void 0) { visitorName = 'default'; }
	        var visitorResult = {};
	        if (!visitorName) {
	            /* tslint:disable no-console */
	            console.warn('Invalid or empty RootNodeVisitor name.');
	        }
	        try {
	            visitorResult = visitorFn.call(this, this.root);
	            this.rootNodeVisitorMap[visitorName] = visitorResult;
	        }
	        catch (e) {
	            console.error('RootNodeVisitor is not valid.');
	        }
	        return visitorResult;
	    };
	    Page.prototype.getRootNodeVisitor = function (name) {
	        return this.rootNodeVisitorMap[name];
	    };
	    /**
	     * 导出页面数据
	     */
	    Page.prototype.toData = function () {
	        return __assign({ id: this.id, componentsTree: [this.root.toData()], params: this.params.toJS() }, this.exportAddonData());
	        // return {
	        //   id: this.id,
	        //   layout: this.root.toData(),
	        //   params: this.params.toJS(),
	        //   ...this.exportAddonData(),
	        // };
	    };
	    Page.prototype.addHistory = function (title) {
	        this.history.log(title);
	    };
	    Page.prototype.getHotData = function () {
	        return this.history.getHotData();
	    };
	    /**
	     * 获得运行时页面唯一ID
	     *
	     * @returns {string}
	     */
	    Page.prototype.getId = function () {
	        return this.id;
	    };
	    /**
	     * 设置页面可见性
	     *
	     * @internal
	     * @param {boolean} flag
	     */
	    Page.prototype.setVisible = function (flag) {
	        if (flag && !this.visible) {
	            this.visible = true;
	            this.emitter.emit('visiblechange', this.visible);
	        }
	        else if (!flag && this.visible) {
	            this.visible = false;
	            this.emitter.emit('visiblechange', this.visible);
	        }
	    };
	    /**
	     * 获得页面历史操作记录
	     *
	     * @returns {History}
	     */
	    Page.prototype.getHistory = function () {
	        return this.history;
	    };
	    /**
	     * 是否可见
	     *
	     * @returns {boolean}
	     */
	    Page.prototype.isVisible = function () {
	        return this.visible;
	    };
	    /**
	     * 是否已准备好
	     *
	     * @returns {boolean}
	     */
	    Page.prototype.isReady = function () {
	        return this.readyState;
	    };
	    /**
	     * 获得页面根节点
	     *
	     * @returns {*}
	     */
	    Page.prototype.getRoot = function () {
	        return this.root;
	    };
	    Page.prototype.getDocument = function () {
	        return this.document;
	    };
	    Page.prototype.createNode = function (data) {
	        return new node_1.Node(this, data);
	    };
	    Page.prototype.mount = function (doc) {
	        var _this = this;
	        this.scroller = new scroller_1.default(this, doc);
	        var render = function () {
	            _this.document = doc;
	            // render data to view
	            _this.willUnmount = _this.VisualPage.render(_this, function () {
	                _this.readyState = true;
	                _this.emitter.emit('ready');
	                _this.bus.emit(const_1.VE_EVENTS.VE_PAGE_PAGE_READY, _this);
	            });
	        };
	        if (this.isVisible()) {
	            render();
	        }
	        else {
	            var detach_1 = this.onVisibleChange(function (visible) {
	                if (visible) {
	                    render();
	                    detach_1();
	                }
	            });
	        }
	    };
	    Page.prototype.unmount = function () {
	        if (this.willUnmount) {
	            this.willUnmount();
	            this.willUnmount = null;
	        }
	        this.readyState = false;
	    };
	    /**
	     * 根据点获得元素
	     *
	     * @internal
	     * @param {Point} e
	     * @returns {DOMElement|null}
	     */
	    Page.prototype.getElementFromPoint = function (e) {
	        var node = e.target;
	        if (!node || node.nodeType === document.DOCUMENT_NODE) {
	            return document.body;
	        }
	        else if (node.nodeType !== document.ELEMENT_NODE) {
	            return node.parentNode;
	        }
	        return node;
	    };
	    Page.prototype.getNodeFromPoint = function (e) {
	        var elem = this.getElementFromPoint(e);
	        return this.root.findNode(elem);
	    };
	    /**
	     * 获得边界
	     *
	     * @returns {ClientRect}
	     */
	    Page.prototype.getBounds = function () {
	        return this.document.getBoundingClientRect();
	    };
	    Page.prototype.scroll = function () {
	        var _this = this;
	        clearTimeout(this.scrolling);
	        this.scrolling = window.setTimeout(function () {
	            _this.scrolling = null;
	        }, 50);
	        this.emitter.emit('scroll', this.getScrollTop());
	    };
	    Page.prototype.inScrolling = function () {
	        return this.scrolling;
	    };
	    /**
	     * 滚动至节点
	     *
	     * @param node
	     * @param {Insertion} insertion
	     */
	    Page.prototype.scrollIntoNode = function (node, insertion) {
	        var _this = this;
	        this.tryScrollAgain = null;
	        if (this.sensitive) {
	            return;
	        }
	        var bounds = this.root.getRect();
	        var rect = insertion ? insertion.getNearRect() : node.getRect();
	        var y;
	        var scroll = false;
	        if (insertion && rect) {
	            y = insertion.isNearAfter() ? rect.bottom : rect.top;
	            if (y < bounds.top || y > bounds.bottom) {
	                scroll = true;
	            }
	        }
	        else {
	            if (!rect) {
	                if (!this.tryScrollAgain) {
	                    this.tryScrollAgain = requestAnimationFrame(function () { return _this.scrollIntoNode(node); });
	                }
	                return;
	            }
	            y = rect.top + rect.height / 2;
	            scroll = rect.height > bounds.height
	                ? (rect.top > bounds.bottom || rect.bottom < bounds.top)
	                : (rect.top < bounds.top || rect.bottom > bounds.bottom);
	        }
	        if (scroll && this.scroller) {
	            this.scroller.scrollTo(Math.min(y + this.getScrollTop() - bounds.top - bounds.height / 2, this.getScrollHeight() - bounds.height));
	        }
	    };
	    /**
	     * 查找节点
	     *
	     * @param componentId
	     * @returns {DOMElement}
	     */
	    Page.prototype.findDOMNode = function (componentId) {
	        return this.VisualPage.findDOMNode(componentId); // esline-disable-line
	    };
	    /**
	     * 获得滚动上距离
	     *
	     * @returns {number}
	     */
	    Page.prototype.getScrollTop = function () {
	        return this.document ? this.document.scrollTop : 0;
	    };
	    /**
	     * 获得滚动高度
	     *
	     * @returns {number}
	     */
	    Page.prototype.getScrollHeight = function () {
	        return this.document.scrollHeight;
	    };
	    /**
	     * 敏感件接口
	     */
	    Page.prototype.isEnabled = function () {
	        return this.document !== null;
	    };
	    Page.prototype.isEnter = function (e) {
	        var rect = this.getBounds();
	        if (!rect) {
	            return false;
	        }
	        return e.clientX >= rect.left && e.clientX <= rect.right
	            && e.clientY >= rect.top && e.clientY <= rect.bottom;
	    };
	    Page.prototype.isInRange = function (e) {
	        var rect = this.getBounds();
	        if (!rect) {
	            return false;
	        }
	        return e.clientX <= rect.right;
	    };
	    Page.prototype.orient = function (dragment, e) {
	        this.sensitive = true;
	        this.scroller.scrolling(e);
	        return this.root.locate(dragment, e);
	    };
	    Page.prototype.deactivate = function () {
	        this.sensitive = false;
	        this.scroller.scrolling(null);
	    };
	    /**
	     * alias to deactivate
	     * @deprecated
	     */
	    Page.prototype.deactive = function () {
	        this.deactivate();
	    };
	    Page.prototype.destroy = function () {
	        this.unmount();
	        this.root.destroy();
	        this.history.destroy();
	        this.emitter.removeAllListeners();
	        if (this.modalNodesManager.willDestroy) {
	            this.modalNodesManager.willDestroy.forEach(function (off) {
	                off();
	            });
	        }
	        if (this.floatingNodesManager.willDestroy) {
	            this.floatingNodesManager.willDestroy.forEach(function (off) {
	                off();
	            });
	        }
	    };
	    Page.prototype.destroyNode = function (node) {
	        this.emitter.emit('nodedestroy', node);
	    };
	    Page.prototype.addNode = function (node) {
	        this.emitter.emit('nodecreate', node);
	    };
	    Page.prototype.refresh = function () {
	        this.emitter.emit('ve.page.refresh');
	    };
	    Page.prototype.startRefresh = function () {
	        if (this.refreshCount) {
	            this.refreshCount += 1;
	        }
	        else {
	            this.refreshCount = 1;
	        }
	    };
	    Page.prototype.endRefresh = function () {
	        if (this.refreshCount > 0) {
	            this.refreshCount -= 1;
	        }
	    };
	    Page.prototype.canRefresh = function () {
	        return this.refreshCount > 0;
	    };
	    Page.prototype.onRefresh = function (func) {
	        var _this = this;
	        this.emitter.on('ve.page.refresh', func);
	        return function () {
	            _this.emitter.removeListener('ve.page.refresh', func);
	        };
	    };
	    Page.prototype.onScroll = function (func) {
	        var _this = this;
	        this.emitter.on('scroll', func);
	        return function () {
	            _this.emitter.removeListener('scroll', func);
	        };
	    };
	    Page.prototype.onVisibleChange = function (func) {
	        var _this = this;
	        this.emitter.on('visiblechange', func);
	        return function () {
	            _this.emitter.removeListener('visiblechange', func);
	        };
	    };
	    Page.prototype.onParamsChange = function (func) {
	        var _this = this;
	        this.emitter.on('paramschange', func);
	        return function () {
	            _this.emitter.removeListener('paramschange', func);
	        };
	    };
	    Page.prototype.onReady = function (func) {
	        var _this = this;
	        this.emitter.once('ready', func);
	        return function () {
	            _this.emitter.removeListener('ready', func);
	        };
	    };
	    Page.prototype.onNodeDestroy = function (func) {
	        var _this = this;
	        this.emitter.on('nodedestroy', func);
	        return function () {
	            _this.emitter.removeListener('nodedestroy', func);
	        };
	    };
	    Page.prototype.onNodeCreate = function (func) {
	        var _this = this;
	        this.emitter.on('nodecreate', func);
	        return function () {
	            _this.emitter.removeListener('nodecreate', func);
	        };
	    };
	    return Page;
	}());
	exports.Page = Page;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var React = __webpack_require__(5);
	var ReactDOM = __webpack_require__(8);
	var page_1 = __webpack_require__(65);
	function render(page, callback) {
	    try {
	        ReactDOM.render(React.createElement(page_1.default, { page: page }), page.getDocument(), callback);
	    }
	    catch (e) {
	        vu_logger_1.default.log('ERROR_PAGE_RENDER');
	        vu_logger_1.default.error('ERROR:', e);
	    }
	    return function () {
	        ReactDOM.unmountComponentAtNode(page.getDocument());
	    };
	}
	function findDOMNode(id) {
	    return page_1.default.getDOMNode(id);
	}
	exports.default = { render: render, findDOMNode: findDOMNode };


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var env_1 = __webpack_require__(10);
	var trunk_1 = __webpack_require__(31);
	var viewport_1 = __webpack_require__(41);
	var leaf_1 = __webpack_require__(66);
	var renderUtils_1 = __webpack_require__(67);
	var Page = /** @class */ (function (_super) {
	    __extends(Page, _super);
	    function Page(props) {
	        var _this = _super.call(this, props) || this;
	        _this.trunk = new trunk_1.default();
	        return _this;
	    }
	    Page.prototype.componentWillMount = function () {
	        var _this = this;
	        var page = this.props.page;
	        this.willDetach = [
	            page.onRefresh(function () {
	                if (!page.isVisible()) {
	                    return;
	                }
	                _this.updatePage();
	            }),
	            viewport_1.default.onViewportChange(function () {
	                if (!page.isVisible()) {
	                    return;
	                }
	                _this.updatePage();
	            }),
	            env_1.default.onEnvChange(function () {
	                if (!page.isVisible()) {
	                    return;
	                }
	                _this.updatePage();
	            }),
	            page.onVisibleChange(function (flag) {
	                if (flag) {
	                    _this.updatePage();
	                }
	            }),
	        ];
	    };
	    Page.prototype.updatePage = function () {
	        var page = this.props.page;
	        page.startRefresh();
	        this.forceUpdate(function () {
	            page.endRefresh();
	        });
	    };
	    Page.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    Page.prototype.render = function () {
	        if (!this.trunk.isReady()) {
	            return (React.createElement("div", null));
	        }
	        var leaf = this.props.page.getRoot();
	        return React.createElement(leaf_1.default, {
	            _componentName: leaf.getComponentName(),
	            leaf: leaf,
	        });
	    };
	    Page.getDOMNode = function getDOMNode(id) {
	        return renderUtils_1.NativeNodeCache[id];
	    };
	    return Page;
	}(React.Component));
	exports.default = Page;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var lodash_1 = __webpack_require__(7);
	var React = __webpack_require__(5);
	var ReactDOM = __webpack_require__(8);
	var context_1 = __webpack_require__(9);
	var const_1 = __webpack_require__(12);
	var placeholders_1 = __webpack_require__(15);
	var renderUtils_1 = __webpack_require__(67);
	var VE_NODE_PROPS_DECORATOR = const_1.VE_HOOKS.VE_NODE_PROPS_DECORATOR;
	var context = new context_1.default();
	var REACT_VERSION_IS_15 = React.version && React.version.startsWith('15');
	var Leaf = /** @class */ (function (_super) {
	    __extends(Leaf, _super);
	    function Leaf() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            hasError: false,
	        };
	        return _this;
	    }
	    Leaf.prototype.componentWillMount = function () {
	        var _this = this;
	        this.leaf = this.props.leaf;
	        this.willDetach = [
	            this.leaf.onPropsChange(function () { return _this.forceUpdate(); }),
	            this.leaf.onChildrenChange(function () { return _this.forceUpdate(); }),
	            this.leaf.onStatusChange(function (status, field) {
	                if (field === 'dragging' || field === 'dropping' || field === 'pseudo' || field === 'visibility') {
	                    _this.forceUpdate();
	                }
	            }),
	        ];
	        /**
	         * while props replaced
	         * bind the new event on it
	         */
	        this.leaf.onPropsReplace(function (props) {
	            _this.willDetach[0]();
	            _this.willDetach[0] = _this.leaf.onPropsChange(function () {
	                _this.forceUpdate();
	            });
	        });
	    };
	    Leaf.prototype.componentDidMount = function () {
	        this.modifyDOM();
	    };
	    Leaf.prototype.shouldComponentUpdate = function (nextProps) {
	        var pageCanRefresh = this.leaf.getPage().canRefresh();
	        if (pageCanRefresh) {
	            return pageCanRefresh;
	        }
	        var getExtProps = function (obj) {
	            var leaf = obj.leaf, props = __rest(obj, ["leaf"]);
	            return props;
	        };
	        return !renderUtils_1.shallowEqual(getExtProps(this.props), getExtProps(nextProps));
	    };
	    Leaf.prototype.componentDidUpdate = function () {
	        this.modifyDOM();
	    };
	    Leaf.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	        if (this.styleSheet) {
	            this.styleSheet.parentNode.removeChild(this.styleSheet);
	        }
	        renderUtils_1.setNativeNode(this.leaf, null);
	    };
	    Leaf.prototype.componentDidCatch = function (error, info) {
	        var _this = this;
	        vu_logger_1.default.log('ERROR_PAGE_RENDER');
	        vu_logger_1.default.info('ERROR:', error, info);
	        this.setState({ hasError: true }, function () {
	            _this.forceUpdate();
	        });
	    };
	    Leaf.prototype.modifyDOM = function () {
	        var shell = ReactDOM.findDOMNode(this);
	        var leaf = this.leaf;
	        if (shell) {
	            renderUtils_1.setNativeNode(leaf, shell);
	            if (leaf.getStatus('dragging')) {
	                lodash_1.get(shell, 'classList').add('engine-dragging');
	            }
	            else {
	                lodash_1.get(shell, 'classList').remove('engine-dragging');
	            }
	            lodash_1.each(lodash_1.get(shell, 'classList'), function (cls) {
	                if (cls.substring(0, 8) === '-pseudo-') {
	                    lodash_1.get(shell, 'classList').remove(cls);
	                }
	            });
	            var pseudo = leaf.getStatus('pseudo');
	            if (pseudo) {
	                lodash_1.get(shell, 'classList').add("-pseudo-" + pseudo);
	            }
	        }
	        else {
	            renderUtils_1.setNativeNode(leaf, null);
	        }
	    };
	    Leaf.prototype.render = function () {
	        var props = lodash_1.omit(this.props, ['leaf']);
	        var leaf = this.props.leaf;
	        var componentName = leaf.getComponentName();
	        var View = renderUtils_1.getView(componentName);
	        if (!View) {
	            return React.createElement(placeholders_1.UnknownComponent, { _componentName: componentName });
	        }
	        var staticProps = __assign(__assign(__assign({}, leaf.getStaticProps(false)), props), { _componentName: componentName, _leaf: leaf, componentId: leaf.getId() });
	        if (!leaf.isVisibleInPane()) {
	            return null;
	        }
	        if (!leaf.isVisible()) {
	            return React.createElement(placeholders_1.HiddenComponent, __assign({}, staticProps));
	        }
	        if ((REACT_VERSION_IS_15 && !renderUtils_1.isValidComponent(View, staticProps))
	            || this.state.hasError) {
	            return React.createElement(placeholders_1.FaultComponent, { _componentName: componentName });
	        }
	        var propsDecorator = context.getPlugin(VE_NODE_PROPS_DECORATOR);
	        if (propsDecorator) {
	            staticProps = propsDecorator(staticProps);
	        }
	        if (this.styleSheet) {
	            this.styleSheet.parentNode.removeChild(this.styleSheet);
	        }
	        this.styleSheet = renderUtils_1.createNodeStyleSheet(staticProps);
	        if (leaf.ableToModifyChildren()) {
	            var children = leaf.getChildren()
	                .filter(function (child) { return child.getComponentName() !== 'Slot'; })
	                .map(function (child) { return React.createElement(Leaf, { key: child.getId(), leaf: child }); });
	            var insertion = leaf.getStatus('dropping');
	            if (children.length < 1 && insertion && insertion.getIndex() !== null) {
	                children = [React.createElement(placeholders_1.InsertionGhost, { key: 'insertion' })];
	            }
	            else if (insertion && insertion.isNearEdge()) {
	                if (insertion.isNearAfter()) {
	                    children.push(React.createElement(placeholders_1.InsertionGhost, { key: 'insertion' }));
	                }
	                else {
	                    children.unshift(React.createElement(placeholders_1.InsertionGhost, { key: 'insertion' }));
	                }
	            }
	            staticProps = __assign(__assign({}, staticProps), this.processSlots(this.leaf.getChildren()));
	            return (React.createElement(View, __assign({}, staticProps), children));
	        }
	        return React.createElement(View, __assign({}, staticProps));
	    };
	    Leaf.prototype.processSlots = function (children) {
	        var slots = {};
	        children.forEach(function (child) {
	            if (child.getComponentName() === 'Slot') {
	                slots[child.getPropValue('slotName')] = React.createElement(Leaf, { key: child.getId(), leaf: child });
	            }
	        });
	        return slots;
	    };
	    Leaf.displayName = 'Leaf';
	    return Leaf;
	}(React.Component));
	exports.default = Leaf;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var lodash_1 = __webpack_require__(7);
	var React = __webpack_require__(5);
	var ReactDOMServer = __webpack_require__(68);
	var trunk_1 = __webpack_require__(31);
	var viewport_1 = __webpack_require__(41);
	var toCss = __webpack_require__(74).toCss;
	var renderToStaticMarkup = ReactDOMServer.renderToStaticMarkup;
	var privateRender = lodash_1.get(React, '__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED');
	function ucfirst(s) {
	    return s.charAt(0).toUpperCase() + s.substring(1);
	}
	function isValidComponent(Component, props) {
	    return tryRender(Component, props);
	}
	exports.isValidComponent = isValidComponent;
	// idea by @alex.mm
	function tryRender(RenderView, props) {
	    var result = true;
	    var reactTestUtils = lodash_1.get(React, 'addons.TestUtils');
	    var view;
	    // react dom-server shall be imported individually
	    if (lodash_1.get(ReactDOMServer, 'version', '16.0.0') >= '16.0.0') {
	        return true;
	    }
	    try {
	        if (renderToStaticMarkup) {
	            // react >= 15.6.x && react <= 16.0.0
	            view = React.createElement(RenderView, props);
	            renderToStaticMarkup(view);
	        }
	        else if (privateRender) {
	            // react <= 15.3.x
	            var renderToStaticMarkup_1 = privateRender.renderToStaticMarkup;
	            view = React.createElement(RenderView, props);
	            renderToStaticMarkup_1(view);
	        }
	        else if (reactTestUtils) {
	            // with test utils
	            var renderer = reactTestUtils.createRenderer();
	            renderer.render(React.createElement(RenderView, props));
	        }
	        else {
	            console.warn("The current React version " + React.version + " is not support pre-render.");
	        }
	    }
	    catch (e) {
	        result = false;
	        vu_logger_1.default.log('ERROR_COMPONENT_RENDER');
	        vu_logger_1.default.error('ERROR:', e + ". Check the component '" + props._componentName + "'.");
	    }
	    return result;
	}
	exports.tryRender = tryRender;
	function shallowEqual(obj, tObj) {
	    for (var i in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, i) && obj[i] !== tObj[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.shallowEqual = shallowEqual;
	exports.NativeNodeCache = {};
	function setNativeNode(leaf, node) {
	    var id = leaf.getId();
	    if (exports.NativeNodeCache[id] === node) {
	        return;
	    }
	    exports.NativeNodeCache[id] = node;
	    leaf.mountChange();
	}
	exports.setNativeNode = setNativeNode;
	function getView(componentName) {
	    var view = new trunk_1.default().getPrototypeView(componentName);
	    if (!view) {
	        return null;
	    }
	    var viewport = viewport_1.default.getViewport();
	    if (viewport) {
	        var _a = viewport.split('-', 2).map(ucfirst), mode = _a[0], device = _a[1];
	        if (view.hasOwnProperty(device)) {
	            view = view[device];
	        }
	        if (view.hasOwnProperty(mode)) {
	            view = view[mode];
	        }
	    }
	    return view;
	}
	exports.getView = getView;
	function createNodeStyleSheet(props) {
	    if (props && props.fieldId) {
	        var styleProp = props.__style__;
	        if (lodash_1.isObject(styleProp)) {
	            styleProp = toCss(styleProp);
	        }
	        if (typeof styleProp === 'string') {
	            var s = document.createElement('style');
	            var cssId = '_style_pesudo_' + props.fieldId;
	            var cssClass = '_css_pesudo_' + props.fieldId;
	            props.className = cssClass;
	            s.setAttribute('type', 'text/css');
	            s.setAttribute('id', cssId);
	            document.getElementsByTagName('head')[0].appendChild(s);
	            s.appendChild(document.createTextNode(styleProp.replace(/(^| |\n|\}):root($| |\{)/g, '$1.' + cssClass + '$2')));
	            return s;
	        }
	    }
	}
	exports.createNodeStyleSheet = createNodeStyleSheet;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(69);
	} else {
	  module.exports = __webpack_require__(71);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.12.0
	 * react-dom-server.browser.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(70),l=__webpack_require__(5);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,w=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
	60116,ka=t?Symbol.for("react.fundamental"):60117,la=t?Symbol.for("react.scope"):60119,C=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;C.hasOwnProperty("ReactCurrentDispatcher")||(C.ReactCurrentDispatcher={current:null});C.hasOwnProperty("ReactCurrentBatchConfig")||(C.ReactCurrentBatchConfig={suspense:null});
	function ma(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
	function D(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case w:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
	case ia:return D(a.type);case ja:if(a=1===a._status?a._result:null)return D(a)}return null}var na={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function oa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=na;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
	var pa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,qa=Object.prototype.hasOwnProperty,ra={},sa={};
	function ta(a){if(qa.call(sa,a))return!0;if(qa.call(ra,a))return!1;if(pa.test(a))return sa[a]=!0;ra[a]=!0;return!1}function ua(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function va(a,b,c,d){if(null===b||"undefined"===typeof b||ua(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
	M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
	K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var wa=/["'&<>]/;
	function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=wa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
	function xa(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||va(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+"="+('"'+N(b)+'"')}return ta(a)?a+"="+('"'+N(b)+'"'):""}function ya(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var za="function"===typeof Object.is?Object.is:ya,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Aa(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ba(){null===Q?null===P?(R=!1,P=Q=Aa()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Aa()):(R=!0,Q=Q.next);return Q}function Ca(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Da(a,b){return"function"===typeof b?b(a):b}
	function Ea(a,b,c){O=W();Q=Ba();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Da?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Fa.bind(null,O,a);return[Q.memoizedState,a]}
	function Fa(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ga(){}
	var X=0,Ha={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ba();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!za(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ea,useRef:function(a){O=W();Q=Ba();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
	a):b},useState:function(a){return Ea(Da,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ga,useEffect:Ga,useDebugValue:Ga,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ia={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	var Ka={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},La=k({menuitem:!0},Ka),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
	gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ma=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
	var Na=/([A-Z])/g,Oa=/^ms-/,Z=l.Children.toArray,Pa=C.ReactCurrentDispatcher,Qa={listing:!0,pre:!0,textarea:!0},Ra=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Sa={},Ta={};function Ua(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Va=Object.prototype.hasOwnProperty,Wa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Xa(a,b){if(void 0===a)throw Error(q(152,D(b)||"Component"));}
	function Ya(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=oa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var v=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=v&&(e.state=k({},e.state,v))}}else if(O={},e=g(d.props,
	f,m),e=Ca(g,d.props,e,f),null==e||null==e.render){a=e;Xa(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
	h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{v=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,v,d.props,f):p;null!=p&&(y?(y=!1,v=k({},v,p)):k(v,p))}e.state=v}}else x=null;a=e.render();Xa(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,D(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
	typeof g)break;d(f,g)}return{child:a,context:b}}
	var Za=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ia.html,children:a,childIndex:0,context:na,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
	b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
	this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Pa.current;Pa.current=Ha;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
	e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
	v="";try{v+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=v}}return g[0]}finally{Pa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Ya(a,b,this.threadID);a=b.child;
	b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
	"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Ca(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
	context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ka:throw Error(q(338));case ja:switch(c=a.type,ma(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
	}case la:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ia.html&&Ja(c);if(!Sa.hasOwnProperty(c)){if(!Ra.test(c))throw Error(q(65,c));Sa[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
	h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Ua(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
	d,{selected:h,children:I})}}if(h=d){if(La[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Va.call(h,z)){var m=h[z];if(null!=m){if("style"===
	z){n=void 0;var v="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ta.hasOwnProperty(A))A=Ta[A];else{var T=A.replace(Na,"-$1").toLowerCase().replace(Oa,"-ms-");A=Ta[A]=T}v+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";v+=y;r=";"}}m=v||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
	!1;break b;default:y=!0}y?Wa.hasOwnProperty(z)||(n=z,n=ta(n)&&null!=m?n+"="+('"'+N(m)+'"'):""):n=xa(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";Ka.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Qa[c]&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
	f?Ja(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),$a={renderToString:function(a){a=new Za(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Za(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
	},version:"16.12.0"},ab={default:$a},bb=ab&&$a||ab;module.exports=bb.default||bb;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.12.0
	 * react-dom-server.browser.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	
	
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';
	
	var _assign = __webpack_require__(70);
	var React = __webpack_require__(5);
	var checkPropTypes = __webpack_require__(72);
	
	// Do not require this module directly! Use normal `invariant` calls with
	// template literal strings. The messages will be replaced with error codes
	// during build.
	
	// TODO: this is special because it gets imported during build.
	
	var ReactVersion = '16.12.0';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	var warningWithoutStack = function () {};
	
	{
	  warningWithoutStack = function (condition, format) {
	    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (args.length > 8) {
	      // Check before the condition to catch violations early.
	      throw new Error('warningWithoutStack() currently supports at most 8 arguments.');
	    }
	
	    if (condition) {
	      return;
	    }
	
	    if (typeof console !== 'undefined') {
	      var argsWithFormat = args.map(function (item) {
	        return '' + item;
	      });
	      argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	      // breaks IE9: https://github.com/facebook/react/issues/13610
	
	      Function.prototype.apply.call(console.error, console, argsWithFormat);
	    }
	
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	var warningWithoutStack$1 = warningWithoutStack;
	
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?
	
	
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
	
	var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
	// Current owner and dispatcher used to share the same ref,
	// but PR #14548 split them out to better support the react-debug-tools package.
	
	if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) {
	  ReactSharedInternals.ReactCurrentDispatcher = {
	    current: null
	  };
	}
	
	if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) {
	  ReactSharedInternals.ReactCurrentBatchConfig = {
	    suspense: null
	  };
	}
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = warningWithoutStack$1;
	
	{
	  warning = function (condition, format) {
	    if (condition) {
	      return;
	    }
	
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum(); // eslint-disable-next-line react-internal/warning-and-invariant-args
	
	    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    warningWithoutStack$1.apply(void 0, [false, format + '%s'].concat(args, [stack]));
	  };
	}
	
	var warning$1 = warning;
	
	var Uninitialized = -1;
	var Pending = 0;
	var Resolved = 1;
	var Rejected = 2;
	function refineResolvedLazyComponent(lazyComponent) {
	  return lazyComponent._status === Resolved ? lazyComponent._result : null;
	}
	function initializeLazyComponentType(lazyComponent) {
	  if (lazyComponent._status === Uninitialized) {
	    lazyComponent._status = Pending;
	    var ctor = lazyComponent._ctor;
	    var thenable = ctor();
	    lazyComponent._result = thenable;
	    thenable.then(function (moduleObject) {
	      if (lazyComponent._status === Pending) {
	        var defaultExport = moduleObject.default;
	
	        {
	          if (defaultExport === undefined) {
	            warning$1(false, 'lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + "const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
	          }
	        }
	
	        lazyComponent._status = Resolved;
	        lazyComponent._result = defaultExport;
	      }
	    }, function (error) {
	      if (lazyComponent._status === Pending) {
	        lazyComponent._status = Rejected;
	        lazyComponent._result = error;
	      }
	    });
	  }
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = innerType.displayName || innerType.name || '';
	  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
	}
	
	function getComponentName(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }
	
	  {
	    if (typeof type.tag === 'number') {
	      warningWithoutStack$1(false, 'Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }
	
	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }
	
	  if (typeof type === 'string') {
	    return type;
	  }
	
	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';
	
	    case REACT_PORTAL_TYPE:
	      return 'Portal';
	
	    case REACT_PROFILER_TYPE:
	      return "Profiler";
	
	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';
	
	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';
	
	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';
	  }
	
	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        return 'Context.Consumer';
	
	      case REACT_PROVIDER_TYPE:
	        return 'Context.Provider';
	
	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');
	
	      case REACT_MEMO_TYPE:
	        return getComponentName(type.type);
	
	      case REACT_LAZY_TYPE:
	        {
	          var thenable = type;
	          var resolvedThenable = refineResolvedLazyComponent(thenable);
	
	          if (resolvedThenable) {
	            return getComponentName(resolvedThenable);
	          }
	
	          break;
	        }
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	var lowPriorityWarningWithoutStack = function () {};
	
	{
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarningWithoutStack = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(void 0, [format].concat(args));
	    }
	  };
	}
	
	var lowPriorityWarningWithoutStack$1 = lowPriorityWarningWithoutStack;
	
	var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
	var describeComponentFrame = function (name, source, ownerName) {
	  var sourceInfo = '';
	
	  if (source) {
	    var path = source.fileName;
	    var fileName = path.replace(BEFORE_SLASH_RE, '');
	
	    {
	      // In DEV, include code for a common special case:
	      // prefer "folder/index.js" instead of just "index.js".
	      if (/^index\./.test(fileName)) {
	        var match = path.match(BEFORE_SLASH_RE);
	
	        if (match) {
	          var pathBeforeSlash = match[1];
	
	          if (pathBeforeSlash) {
	            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
	            fileName = folderName + '/' + fileName;
	          }
	        }
	      }
	    }
	
	    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
	  } else if (ownerName) {
	    sourceInfo = ' (created by ' + ownerName + ')';
	  }
	
	  return '\n    in ' + (name || 'Unknown') + sourceInfo;
	};
	
	// Helps identify side effects in render-phase lifecycle hooks and setState
	// reducers by double invoking them in Strict Mode.
	
	 // To preserve the "Pause on caught exceptions" behavior of the debugger, we
	// replay the begin phase of a failed component inside invokeGuardedCallback.
	
	 // Warn about deprecated, async-unsafe lifecycles; relates to RFC #6:
	
	var warnAboutDeprecatedLifecycles = true; // Gather advanced timing metrics for Profiler subtrees.
	
	 // Trace which interactions trigger each commit.
	
	 // SSR experiments
	
	var enableSuspenseServerRenderer = false;
	 // Only used in www builds.
	
	 // Only used in www builds.
	
	 // Disable javascript: URL strings in href for XSS protection.
	
	var disableJavaScriptURLs = false; // React Fire: prevent the value and checked attributes from syncing
	// with their related DOM properties
	
	 // These APIs will no longer be "unstable" in the upcoming 16.7 release,
	// Control this behavior with a flag to support 16.6 minor releases in the meanwhile.
	
	
	 // Experimental React Flare event system and event components support.
	
	var enableFlareAPI = false; // Experimental Host Component support.
	
	var enableFundamentalAPI = false; // Experimental Scope support.
	
	var enableScopeAPI = false; // New API for JSX transforms to target - https://github.com/reactjs/rfcs/pull/107
	
	 // We will enforce mocking scheduler with scheduler/unstable_mock at some point. (v17?)
	// Till then, we warn about the missing mock, but still fallback to a legacy mode compatible version
	
	 // For tests, we flush suspense fallbacks in an act scope;
	// *except* in some of our own tests, where we test incremental loading states.
	
	 // Add a callback property to suspense to notify which promises are currently
	// in the update queue. This allows reporting and tracing of what is causing
	// the user to see a loading state.
	// Also allows hydration callbacks to fire when a dehydrated boundary gets
	// hydrated or deleted.
	
	 // Part of the simplification of React.createElement so we can eventually move
	// from React.createElement to React.jsx
	// https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md
	
	
	
	var disableLegacyContext = false;
	
	 // Flag to turn event.target and event.currentTarget in ReactNative from a reactTag to a component instance
	
	var ReactDebugCurrentFrame$1;
	var didWarnAboutInvalidateContextType;
	
	{
	  ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
	  didWarnAboutInvalidateContextType = new Set();
	}
	
	var emptyObject = {};
	
	{
	  Object.freeze(emptyObject);
	}
	
	function maskContext(type, context) {
	  var contextTypes = type.contextTypes;
	
	  if (!contextTypes) {
	    return emptyObject;
	  }
	
	  var maskedContext = {};
	
	  for (var contextName in contextTypes) {
	    maskedContext[contextName] = context[contextName];
	  }
	
	  return maskedContext;
	}
	
	function checkContextTypes(typeSpecs, values, location) {
	  {
	    checkPropTypes(typeSpecs, values, location, 'Component', ReactDebugCurrentFrame$1.getCurrentStack);
	  }
	}
	
	function validateContextBounds(context, threadID) {
	  // If we don't have enough slots in this context to store this threadID,
	  // fill it in without leaving any holes to ensure that the VM optimizes
	  // this as non-holey index properties.
	  // (Note: If `react` package is < 16.6, _threadCount is undefined.)
	  for (var i = context._threadCount | 0; i <= threadID; i++) {
	    // We assume that this is the same as the defaultValue which might not be
	    // true if we're rendering inside a secondary renderer but they are
	    // secondary because these use cases are very rare.
	    context[i] = context._currentValue2;
	    context._threadCount = i + 1;
	  }
	}
	function processContext(type, context, threadID, isClass) {
	  if (isClass) {
	    var contextType = type.contextType;
	
	    {
	      if ('contextType' in type) {
	        var isValid = // Allow null for conditional declaration
	        contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
	
	        if (!isValid && !didWarnAboutInvalidateContextType.has(type)) {
	          didWarnAboutInvalidateContextType.add(type);
	          var addendum = '';
	
	          if (contextType === undefined) {
	            addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
	          } else if (typeof contextType !== 'object') {
	            addendum = ' However, it is set to a ' + typeof contextType + '.';
	          } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
	            addendum = ' Did you accidentally pass the Context.Provider instead?';
	          } else if (contextType._context !== undefined) {
	            // <Context.Consumer>
	            addendum = ' Did you accidentally pass the Context.Consumer instead?';
	          } else {
	            addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
	          }
	
	          warningWithoutStack$1(false, '%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(type) || 'Component', addendum);
	        }
	      }
	    }
	
	    if (typeof contextType === 'object' && contextType !== null) {
	      validateContextBounds(contextType, threadID);
	      return contextType[threadID];
	    }
	
	    if (disableLegacyContext) {
	      {
	        if (type.contextTypes) {
	          warningWithoutStack$1(false, '%s uses the legacy contextTypes API which is no longer supported. ' + 'Use React.createContext() with static contextType instead.', getComponentName(type) || 'Unknown');
	        }
	      }
	
	      return emptyObject;
	    } else {
	      var maskedContext = maskContext(type, context);
	
	      {
	        if (type.contextTypes) {
	          checkContextTypes(type.contextTypes, maskedContext, 'context');
	        }
	      }
	
	      return maskedContext;
	    }
	  } else {
	    if (disableLegacyContext) {
	      {
	        if (type.contextTypes) {
	          warningWithoutStack$1(false, '%s uses the legacy contextTypes API which is no longer supported. ' + 'Use React.createContext() with React.useContext() instead.', getComponentName(type) || 'Unknown');
	        }
	      }
	
	      return undefined;
	    } else {
	      var _maskedContext = maskContext(type, context);
	
	      {
	        if (type.contextTypes) {
	          checkContextTypes(type.contextTypes, _maskedContext, 'context');
	        }
	      }
	
	      return _maskedContext;
	    }
	  }
	}
	
	// Allocates a new index for each request. Tries to stay as compact as possible so that these
	// indices can be used to reference a tightly packed array. As opposed to being used in a Map.
	// The first allocated index is 1.
	var nextAvailableThreadIDs = new Uint16Array(16);
	
	for (var i = 0; i < 15; i++) {
	  nextAvailableThreadIDs[i] = i + 1;
	}
	
	nextAvailableThreadIDs[15] = 0;
	
	function growThreadCountAndReturnNextAvailable() {
	  var oldArray = nextAvailableThreadIDs;
	  var oldSize = oldArray.length;
	  var newSize = oldSize * 2;
	
	  if (!(newSize <= 0x10000)) {
	    {
	      throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
	    }
	  }
	
	  var newArray = new Uint16Array(newSize);
	  newArray.set(oldArray);
	  nextAvailableThreadIDs = newArray;
	  nextAvailableThreadIDs[0] = oldSize + 1;
	
	  for (var _i = oldSize; _i < newSize - 1; _i++) {
	    nextAvailableThreadIDs[_i] = _i + 1;
	  }
	
	  nextAvailableThreadIDs[newSize - 1] = 0;
	  return oldSize;
	}
	
	function allocThreadID() {
	  var nextID = nextAvailableThreadIDs[0];
	
	  if (nextID === 0) {
	    return growThreadCountAndReturnNextAvailable();
	  }
	
	  nextAvailableThreadIDs[0] = nextAvailableThreadIDs[nextID];
	  return nextID;
	}
	function freeThreadID(id) {
	  nextAvailableThreadIDs[id] = nextAvailableThreadIDs[0];
	  nextAvailableThreadIDs[0] = id;
	}
	
	// A reserved attribute.
	// It is handled by React separately and shouldn't be written to the DOM.
	var RESERVED = 0; // A simple string attribute.
	// Attributes that aren't in the whitelist are presumed to have this type.
	
	var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
	// "enumerated" attributes with "true" and "false" as possible values.
	// When true, it should be set to a "true" string.
	// When false, it should be set to a "false" string.
	
	var BOOLEANISH_STRING = 2; // A real boolean attribute.
	// When true, it should be present (set either to an empty string or its name).
	// When false, it should be omitted.
	
	var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
	// When true, it should be present (set either to an empty string or its name).
	// When false, it should be omitted.
	// For any other value, should be present with that value.
	
	var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
	// When falsy, it should be removed.
	
	var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
	// When falsy, it should be removed.
	
	var POSITIVE_NUMERIC = 6;
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
	/* eslint-enable max-len */
	
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
	
	var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
	var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	function isAttributeNameSafe(attributeName) {
	  if (hasOwnProperty$1.call(validatedAttributeNameCache, attributeName)) {
	    return true;
	  }
	
	  if (hasOwnProperty$1.call(illegalAttributeNameCache, attributeName)) {
	    return false;
	  }
	
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	
	  illegalAttributeNameCache[attributeName] = true;
	
	  {
	    warning$1(false, 'Invalid attribute name: `%s`', attributeName);
	  }
	
	  return false;
	}
	function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
	  if (propertyInfo !== null) {
	    return propertyInfo.type === RESERVED;
	  }
	
	  if (isCustomComponentTag) {
	    return false;
	  }
	
	  if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
	    return true;
	  }
	
	  return false;
	}
	function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
	  if (propertyInfo !== null && propertyInfo.type === RESERVED) {
	    return false;
	  }
	
	  switch (typeof value) {
	    case 'function': // $FlowIssue symbol is perfectly valid here
	
	    case 'symbol':
	      // eslint-disable-line
	      return true;
	
	    case 'boolean':
	      {
	        if (isCustomComponentTag) {
	          return false;
	        }
	
	        if (propertyInfo !== null) {
	          return !propertyInfo.acceptsBooleans;
	        } else {
	          var prefix = name.toLowerCase().slice(0, 5);
	          return prefix !== 'data-' && prefix !== 'aria-';
	        }
	      }
	
	    default:
	      return false;
	  }
	}
	function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
	  if (value === null || typeof value === 'undefined') {
	    return true;
	  }
	
	  if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
	    return true;
	  }
	
	  if (isCustomComponentTag) {
	    return false;
	  }
	
	  if (propertyInfo !== null) {
	    switch (propertyInfo.type) {
	      case BOOLEAN:
	        return !value;
	
	      case OVERLOADED_BOOLEAN:
	        return value === false;
	
	      case NUMERIC:
	        return isNaN(value);
	
	      case POSITIVE_NUMERIC:
	        return isNaN(value) || value < 1;
	    }
	  }
	
	  return false;
	}
	function getPropertyInfo(name) {
	  return properties.hasOwnProperty(name) ? properties[name] : null;
	}
	
	function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL) {
	  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
	  this.attributeName = attributeName;
	  this.attributeNamespace = attributeNamespace;
	  this.mustUseProperty = mustUseProperty;
	  this.propertyName = name;
	  this.type = type;
	  this.sanitizeURL = sanitizeURL;
	} // When adding attributes to this list, be sure to also add them to
	// the `possibleStandardNames` module to ensure casing and incorrect
	// name warnings.
	
	
	var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
	
	['children', 'dangerouslySetInnerHTML', // TODO: This prevents the assignment of defaultValue to regular
	// elements (not just inputs). Now that ReactDOMInput assigns to the
	// defaultValue property -- do we need this?
	'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, RESERVED, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false);
	}); // A few React string attributes have a different name.
	// This is a mapping from React prop names to the attribute names.
	
	[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
	  var name = _ref[0],
	      attributeName = _ref[1];
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are "enumerated" HTML attributes that accept "true" and "false".
	// In React, we let users pass `true` and `false` even though technically
	// these aren't boolean attributes (they are coerced to strings).
	
	['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are "enumerated" SVG attributes that accept "true" and "false".
	// In React, we let users pass `true` and `false` even though technically
	// these aren't boolean attributes (they are coerced to strings).
	// Since these are SVG attributes, their attribute names are case-sensitive.
	
	['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are HTML boolean attributes.
	
	['allowFullScreen', 'async', // Note: there is a special case that prevents it from being written to the DOM
	// on the client side because the browsers are inconsistent. Instead we call focus().
	'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless', // Microdata
	'itemScope'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are the few React props that we set as DOM properties
	// rather than attributes. These are all booleans.
	
	['checked', // Note: `option.selected` is not updated if `select.multiple` is
	// disabled with `removeAttribute`. We have special logic for handling this.
	'multiple', 'muted', 'selected'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are HTML attributes that are "overloaded booleans": they behave like
	// booleans, but can also accept a string value.
	
	['capture', 'download'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are HTML attributes that must be positive numbers.
	
	['cols', 'rows', 'size', 'span'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, // mustUseProperty
	  name, // attributeName
	  null, // attributeNamespace
	  false);
	}); // These are HTML attributes that must be numbers.
	
	['rowSpan', 'start'].forEach(function (name) {
	  properties[name] = new PropertyInfoRecord(name, NUMERIC, false, // mustUseProperty
	  name.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false);
	});
	var CAMELIZE = /[\-\:]([a-z])/g;
	
	var capitalize = function (token) {
	  return token[1].toUpperCase();
	}; // This is a list of all SVG attributes that need special casing, namespacing,
	// or boolean value assignment. Regular attributes that just accept strings
	// and have the same names are omitted, just like in the HTML whitelist.
	// Some of these attributes can be hard to find. This list was created by
	// scrapping the MDN documentation.
	
	
	['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, null, // attributeNamespace
	  false);
	}); // String SVG attributes with the xlink namespace.
	
	['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, 'http://www.w3.org/1999/xlink', false);
	}); // String SVG attributes with the xml namespace.
	
	['xml:base', 'xml:lang', 'xml:space'].forEach(function (attributeName) {
	  var name = attributeName.replace(CAMELIZE, capitalize);
	  properties[name] = new PropertyInfoRecord(name, STRING, false, // mustUseProperty
	  attributeName, 'http://www.w3.org/XML/1998/namespace', false);
	}); // These attribute exists both in HTML and SVG.
	// The attribute name is case-sensitive in SVG so we can't just use
	// the React name like we do for attributes that exist only in HTML.
	
	['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
	  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
	  attributeName.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  false);
	}); // These attributes accept URLs. These must not allow javascript: URLS.
	// These will also need to accept Trusted Types object in the future.
	
	var xlinkHref = 'xlinkHref';
	properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, // mustUseProperty
	'xlink:href', 'http://www.w3.org/1999/xlink', true);
	['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
	  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, // mustUseProperty
	  attributeName.toLowerCase(), // attributeName
	  null, // attributeNamespace
	  true);
	});
	
	var ReactDebugCurrentFrame$2 = null;
	
	{
	  ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
	} // A javascript: URL can contain leading C0 control or \u0020 SPACE,
	// and any newline or tab are filtered out as if they're not part of the URL.
	// https://url.spec.whatwg.org/#url-parsing
	// Tab or newline are defined as \r\n\t:
	// https://infra.spec.whatwg.org/#ascii-tab-or-newline
	// A C0 control is a code point in the range \u0000 NULL to \u001F
	// INFORMATION SEPARATOR ONE, inclusive:
	// https://infra.spec.whatwg.org/#c0-control-or-space
	
	/* eslint-disable max-len */
	
	
	var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
	var didWarn = false;
	
	function sanitizeURL(url) {
	  if (disableJavaScriptURLs) {
	    if (!!isJavaScriptProtocol.test(url)) {
	      {
	        throw Error("React has blocked a javascript: URL as a security precaution." + (ReactDebugCurrentFrame$2.getStackAddendum()));
	      }
	    }
	  } else if (true && !didWarn && isJavaScriptProtocol.test(url)) {
	    didWarn = true;
	    warning$1(false, 'A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
	  }
	}
	
	// code copied and modified from escape-html
	
	/**
	 * Module variables.
	 * @private
	 */
	var matchHtmlRegExp = /["'&<>]/;
	/**
	 * Escapes special characters and HTML entities in a given html string.
	 *
	 * @param  {string} string HTML string to escape for later insertion
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	
	        break;
	
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	} // end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	
	
	function escapeTextForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	
	  return escapeHtml(text);
	}
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextForBrowser(value) + '"';
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	
	/**
	 * Creates markup for the ID property.
	 *
	 * @param {string} id Unescaped ID.
	 * @return {string} Markup string.
	 */
	
	
	function createMarkupForRoot() {
	  return ROOT_ATTRIBUTE_NAME + '=""';
	}
	/**
	 * Creates markup for a property.
	 *
	 * @param {string} name
	 * @param {*} value
	 * @return {?string} Markup string, or null if the property was invalid.
	 */
	
	function createMarkupForProperty(name, value) {
	  var propertyInfo = getPropertyInfo(name);
	
	  if (name !== 'style' && shouldIgnoreAttribute(name, propertyInfo, false)) {
	    return '';
	  }
	
	  if (shouldRemoveAttribute(name, value, propertyInfo, false)) {
	    return '';
	  }
	
	  if (propertyInfo !== null) {
	    var attributeName = propertyInfo.attributeName;
	    var type = propertyInfo.type;
	
	    if (type === BOOLEAN || type === OVERLOADED_BOOLEAN && value === true) {
	      return attributeName + '=""';
	    } else {
	      if (propertyInfo.sanitizeURL) {
	        value = '' + value;
	        sanitizeURL(value);
	      }
	
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    }
	  } else if (isAttributeNameSafe(name)) {
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  }
	
	  return '';
	}
	/**
	 * Creates markup for a custom property.
	 *
	 * @param {string} name
	 * @param {*} value
	 * @return {string} Markup string, or empty string if the property was invalid.
	 */
	
	function createMarkupForCustomAttribute(name, value) {
	  if (!isAttributeNameSafe(name) || value == null) {
	    return '';
	  }
	
	  return name + '=' + quoteAttributeValueForBrowser(value);
	}
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	  ;
	}
	
	var is$1 = typeof Object.is === 'function' ? Object.is : is;
	
	var currentlyRenderingComponent = null;
	var firstWorkInProgressHook = null;
	var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook
	
	var isReRender = false; // Whether an update was scheduled during the currently executing render pass.
	
	var didScheduleRenderPhaseUpdate = false; // Lazily created map of render-phase updates
	
	var renderPhaseUpdates = null; // Counter to prevent infinite loops.
	
	var numberOfReRenders = 0;
	var RE_RENDER_LIMIT = 25;
	var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook
	
	var currentHookNameInDev;
	
	function resolveCurrentlyRenderingComponent() {
	  if (!(currentlyRenderingComponent !== null)) {
	    {
	      throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
	    }
	  }
	
	  {
	    !!isInHookUserCodeInDev ? warning$1(false, 'Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://fb.me/rules-of-hooks') : void 0;
	  }
	
	  return currentlyRenderingComponent;
	}
	
	function areHookInputsEqual(nextDeps, prevDeps) {
	  if (prevDeps === null) {
	    {
	      warning$1(false, '%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
	    }
	
	    return false;
	  }
	
	  {
	    // Don't bother comparing lengths in prod because these arrays should be
	    // passed inline.
	    if (nextDeps.length !== prevDeps.length) {
	      warning$1(false, 'The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + nextDeps.join(', ') + "]", "[" + prevDeps.join(', ') + "]");
	    }
	  }
	
	  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
	    if (is$1(nextDeps[i], prevDeps[i])) {
	      continue;
	    }
	
	    return false;
	  }
	
	  return true;
	}
	
	function createHook() {
	  if (numberOfReRenders > 0) {
	    {
	      {
	        throw Error("Rendered more hooks than during the previous render");
	      }
	    }
	  }
	
	  return {
	    memoizedState: null,
	    queue: null,
	    next: null
	  };
	}
	
	function createWorkInProgressHook() {
	  if (workInProgressHook === null) {
	    // This is the first hook in the list
	    if (firstWorkInProgressHook === null) {
	      isReRender = false;
	      firstWorkInProgressHook = workInProgressHook = createHook();
	    } else {
	      // There's already a work-in-progress. Reuse it.
	      isReRender = true;
	      workInProgressHook = firstWorkInProgressHook;
	    }
	  } else {
	    if (workInProgressHook.next === null) {
	      isReRender = false; // Append to the end of the list
	
	      workInProgressHook = workInProgressHook.next = createHook();
	    } else {
	      // There's already a work-in-progress. Reuse it.
	      isReRender = true;
	      workInProgressHook = workInProgressHook.next;
	    }
	  }
	
	  return workInProgressHook;
	}
	
	function prepareToUseHooks(componentIdentity) {
	  currentlyRenderingComponent = componentIdentity;
	
	  {
	    isInHookUserCodeInDev = false;
	  } // The following should have already been reset
	  // didScheduleRenderPhaseUpdate = false;
	  // firstWorkInProgressHook = null;
	  // numberOfReRenders = 0;
	  // renderPhaseUpdates = null;
	  // workInProgressHook = null;
	
	}
	function finishHooks(Component, props, children, refOrContext) {
	  // This must be called after every function component to prevent hooks from
	  // being used in classes.
	  while (didScheduleRenderPhaseUpdate) {
	    // Updates were scheduled during the render phase. They are stored in
	    // the `renderPhaseUpdates` map. Call the component again, reusing the
	    // work-in-progress hooks and applying the additional updates on top. Keep
	    // restarting until no more updates are scheduled.
	    didScheduleRenderPhaseUpdate = false;
	    numberOfReRenders += 1; // Start over from the beginning of the list
	
	    workInProgressHook = null;
	    children = Component(props, refOrContext);
	  }
	
	  currentlyRenderingComponent = null;
	  firstWorkInProgressHook = null;
	  numberOfReRenders = 0;
	  renderPhaseUpdates = null;
	  workInProgressHook = null;
	
	  {
	    isInHookUserCodeInDev = false;
	  } // These were reset above
	  // currentlyRenderingComponent = null;
	  // didScheduleRenderPhaseUpdate = false;
	  // firstWorkInProgressHook = null;
	  // numberOfReRenders = 0;
	  // renderPhaseUpdates = null;
	  // workInProgressHook = null;
	
	
	  return children;
	}
	
	function readContext(context, observedBits) {
	  var threadID = currentThreadID;
	  validateContextBounds(context, threadID);
	
	  {
	    !!isInHookUserCodeInDev ? warning$1(false, 'Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().') : void 0;
	  }
	
	  return context[threadID];
	}
	
	function useContext(context, observedBits) {
	  {
	    currentHookNameInDev = 'useContext';
	  }
	
	  resolveCurrentlyRenderingComponent();
	  var threadID = currentThreadID;
	  validateContextBounds(context, threadID);
	  return context[threadID];
	}
	
	function basicStateReducer(state, action) {
	  return typeof action === 'function' ? action(state) : action;
	}
	
	function useState(initialState) {
	  {
	    currentHookNameInDev = 'useState';
	  }
	
	  return useReducer(basicStateReducer, // useReducer has a special case to support lazy useState initializers
	  initialState);
	}
	function useReducer(reducer, initialArg, init) {
	  {
	    if (reducer !== basicStateReducer) {
	      currentHookNameInDev = 'useReducer';
	    }
	  }
	
	  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	  workInProgressHook = createWorkInProgressHook();
	
	  if (isReRender) {
	    // This is a re-render. Apply the new render phase updates to the previous
	    // current hook.
	    var queue = workInProgressHook.queue;
	    var dispatch = queue.dispatch;
	
	    if (renderPhaseUpdates !== null) {
	      // Render phase updates are stored in a map of queue -> linked list
	      var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	
	      if (firstRenderPhaseUpdate !== undefined) {
	        renderPhaseUpdates.delete(queue);
	        var newState = workInProgressHook.memoizedState;
	        var update = firstRenderPhaseUpdate;
	
	        do {
	          // Process this render phase update. We don't have to check the
	          // priority because it will always be the same as the current
	          // render's.
	          var action = update.action;
	
	          {
	            isInHookUserCodeInDev = true;
	          }
	
	          newState = reducer(newState, action);
	
	          {
	            isInHookUserCodeInDev = false;
	          }
	
	          update = update.next;
	        } while (update !== null);
	
	        workInProgressHook.memoizedState = newState;
	        return [newState, dispatch];
	      }
	    }
	
	    return [workInProgressHook.memoizedState, dispatch];
	  } else {
	    {
	      isInHookUserCodeInDev = true;
	    }
	
	    var initialState;
	
	    if (reducer === basicStateReducer) {
	      // Special case for `useState`.
	      initialState = typeof initialArg === 'function' ? initialArg() : initialArg;
	    } else {
	      initialState = init !== undefined ? init(initialArg) : initialArg;
	    }
	
	    {
	      isInHookUserCodeInDev = false;
	    }
	
	    workInProgressHook.memoizedState = initialState;
	
	    var _queue = workInProgressHook.queue = {
	      last: null,
	      dispatch: null
	    };
	
	    var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
	
	    return [workInProgressHook.memoizedState, _dispatch];
	  }
	}
	
	function useMemo(nextCreate, deps) {
	  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	  workInProgressHook = createWorkInProgressHook();
	  var nextDeps = deps === undefined ? null : deps;
	
	  if (workInProgressHook !== null) {
	    var prevState = workInProgressHook.memoizedState;
	
	    if (prevState !== null) {
	      if (nextDeps !== null) {
	        var prevDeps = prevState[1];
	
	        if (areHookInputsEqual(nextDeps, prevDeps)) {
	          return prevState[0];
	        }
	      }
	    }
	  }
	
	  {
	    isInHookUserCodeInDev = true;
	  }
	
	  var nextValue = nextCreate();
	
	  {
	    isInHookUserCodeInDev = false;
	  }
	
	  workInProgressHook.memoizedState = [nextValue, nextDeps];
	  return nextValue;
	}
	
	function useRef(initialValue) {
	  currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
	  workInProgressHook = createWorkInProgressHook();
	  var previousRef = workInProgressHook.memoizedState;
	
	  if (previousRef === null) {
	    var ref = {
	      current: initialValue
	    };
	
	    {
	      Object.seal(ref);
	    }
	
	    workInProgressHook.memoizedState = ref;
	    return ref;
	  } else {
	    return previousRef;
	  }
	}
	
	function useLayoutEffect(create, inputs) {
	  {
	    currentHookNameInDev = 'useLayoutEffect';
	  }
	
	  warning$1(false, 'useLayoutEffect does nothing on the server, because its effect cannot ' + "be encoded into the server renderer's output format. This will lead " + 'to a mismatch between the initial, non-hydrated UI and the intended ' + 'UI. To avoid this, useLayoutEffect should only be used in ' + 'components that render exclusively on the client. ' + 'See https://fb.me/react-uselayouteffect-ssr for common fixes.');
	}
	
	function dispatchAction(componentIdentity, queue, action) {
	  if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
	    {
	      throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
	    }
	  }
	
	  if (componentIdentity === currentlyRenderingComponent) {
	    // This is a render phase update. Stash it in a lazily-created map of
	    // queue -> linked list of updates. After this render pass, we'll restart
	    // and apply the stashed updates on top of the work-in-progress hook.
	    didScheduleRenderPhaseUpdate = true;
	    var update = {
	      action: action,
	      next: null
	    };
	
	    if (renderPhaseUpdates === null) {
	      renderPhaseUpdates = new Map();
	    }
	
	    var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
	
	    if (firstRenderPhaseUpdate === undefined) {
	      renderPhaseUpdates.set(queue, update);
	    } else {
	      // Append the update to the end of the list.
	      var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
	
	      while (lastRenderPhaseUpdate.next !== null) {
	        lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
	      }
	
	      lastRenderPhaseUpdate.next = update;
	    }
	  } else {// This means an update has happened after the function component has
	    // returned. On the server this is a no-op. In React Fiber, the update
	    // would be scheduled for a future render.
	  }
	}
	
	function useCallback(callback, deps) {
	  // Callbacks are passed as they are in the server environment.
	  return callback;
	}
	
	function useResponder(responder, props) {
	  return {
	    props: props,
	    responder: responder
	  };
	}
	
	function useDeferredValue(value, config) {
	  resolveCurrentlyRenderingComponent();
	  return value;
	}
	
	function useTransition(config) {
	  resolveCurrentlyRenderingComponent();
	
	  var startTransition = function (callback) {
	    callback();
	  };
	
	  return [startTransition, false];
	}
	
	function noop() {}
	
	var currentThreadID = 0;
	function setCurrentThreadID(threadID) {
	  currentThreadID = threadID;
	}
	var Dispatcher = {
	  readContext: readContext,
	  useContext: useContext,
	  useMemo: useMemo,
	  useReducer: useReducer,
	  useRef: useRef,
	  useState: useState,
	  useLayoutEffect: useLayoutEffect,
	  useCallback: useCallback,
	  // useImperativeHandle is not run in the server environment
	  useImperativeHandle: noop,
	  // Effects are not run in the server environment.
	  useEffect: noop,
	  // Debugging effect
	  useDebugValue: noop,
	  useResponder: useResponder,
	  useDeferredValue: useDeferredValue,
	  useTransition: useTransition
	};
	
	var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
	var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
	var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	var Namespaces = {
	  html: HTML_NAMESPACE,
	  mathml: MATH_NAMESPACE,
	  svg: SVG_NAMESPACE
	}; // Assumes there is no parent namespace.
	
	function getIntrinsicNamespace(type) {
	  switch (type) {
	    case 'svg':
	      return SVG_NAMESPACE;
	
	    case 'math':
	      return MATH_NAMESPACE;
	
	    default:
	      return HTML_NAMESPACE;
	  }
	}
	function getChildNamespace(parentNamespace, type) {
	  if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
	    // No (or default) parent namespace: potential entry point.
	    return getIntrinsicNamespace(type);
	  }
	
	  if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
	    // We're leaving SVG.
	    return HTML_NAMESPACE;
	  } // By default, pass namespace below.
	
	
	  return parentNamespace;
	}
	
	var ReactDebugCurrentFrame$3 = null;
	var ReactControlledValuePropTypes = {
	  checkPropTypes: null
	};
	
	{
	  ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
	  var hasReadOnlyValue = {
	    button: true,
	    checkbox: true,
	    image: true,
	    hidden: true,
	    radio: true,
	    reset: true,
	    submit: true
	  };
	  var propTypes = {
	    value: function (props, propName, componentName) {
	      if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableFlareAPI && props.listeners) {
	        return null;
	      }
	
	      return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	    },
	    checked: function (props, propName, componentName) {
	      if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableFlareAPI && props.listeners) {
	        return null;
	      }
	
	      return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	    }
	  };
	  /**
	   * Provide a linked `value` attribute for controlled forms. You should not use
	   * this outside of the ReactDOM controlled form components.
	   */
	
	  ReactControlledValuePropTypes.checkPropTypes = function (tagName, props) {
	    checkPropTypes(propTypes, props, 'prop', tagName, ReactDebugCurrentFrame$3.getStackAddendum);
	  };
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
	
	};
	
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// or add stack by default to invariants where possible.
	
	var HTML = '__html';
	var ReactDebugCurrentFrame$4 = null;
	
	{
	  ReactDebugCurrentFrame$4 = ReactSharedInternals.ReactDebugCurrentFrame;
	}
	
	function assertValidProps(tag, props) {
	  if (!props) {
	    return;
	  } // Note the use of `==` which checks for null or undefined.
	
	
	  if (voidElementTags[tag]) {
	    if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
	      {
	        throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + (ReactDebugCurrentFrame$4.getStackAddendum()));
	      }
	    }
	  }
	
	  if (props.dangerouslySetInnerHTML != null) {
	    if (!(props.children == null)) {
	      {
	        throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
	      }
	    }
	
	    if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
	      {
	        throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
	      }
	    }
	  }
	
	  {
	    !(props.suppressContentEditableWarning || !props.contentEditable || props.children == null) ? warning$1(false, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	  }
	
	  if (!(props.style == null || typeof props.style === 'object')) {
	    {
	      throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + (ReactDebugCurrentFrame$4.getStackAddendum()));
	    }
	  }
	}
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridArea: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	
	
	var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	
	function dangerousStyleValue(name, value, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	
	  if (isEmpty) {
	    return '';
	  }
	
	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return ('' + value).trim();
	}
	
	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 */
	
	function hyphenateStyleName(name) {
	  return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}
	
	function isCustomComponent(tagName, props) {
	  if (tagName.indexOf('-') === -1) {
	    return typeof props.is === 'string';
	  }
	
	  switch (tagName) {
	    // These are reserved SVG and MathML elements.
	    // We don't mind this whitelist too much because we expect it to never grow.
	    // The alternative is to track the namespace in a few places which is convoluted.
	    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
	    case 'annotation-xml':
	    case 'color-profile':
	    case 'font-face':
	    case 'font-face-src':
	    case 'font-face-uri':
	    case 'font-face-format':
	    case 'font-face-name':
	    case 'missing-glyph':
	      return false;
	
	    default:
	      return true;
	  }
	}
	
	var warnValidStyle = function () {};
	
	{
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	  var msPattern$1 = /^-ms-/;
	  var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
	
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	  var warnedForInfinityValue = false;
	
	  var camelize = function (string) {
	    return string.replace(hyphenPattern, function (_, character) {
	      return character.toUpperCase();
	    });
	  };
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    warning$1(false, 'Unsupported style property %s. Did you mean %s?', name, // As Andi Smith suggests
	    // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	    // is converted to lowercase `ms`.
	    camelize(name.replace(msPattern$1, 'ms-')));
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    warning$1(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    warning$1(false, "Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
	  };
	
	  var warnStyleValueIsNaN = function (name, value) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    warning$1(false, '`NaN` is an invalid value for the `%s` css style property.', name);
	  };
	
	  var warnStyleValueIsInfinity = function (name, value) {
	    if (warnedForInfinityValue) {
	      return;
	    }
	
	    warnedForInfinityValue = true;
	    warning$1(false, '`Infinity` is an invalid value for the `%s` css style property.', name);
	  };
	
	  warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	
	    if (typeof value === 'number') {
	      if (isNaN(value)) {
	        warnStyleValueIsNaN(name, value);
	      } else if (!isFinite(value)) {
	        warnStyleValueIsInfinity(name, value);
	      }
	    }
	  };
	}
	
	var warnValidStyle$1 = warnValidStyle;
	
	var ariaProperties = {
	  'aria-current': 0,
	  // state
	  'aria-details': 0,
	  'aria-disabled': 0,
	  // state
	  'aria-hidden': 0,
	  // state
	  'aria-invalid': 0,
	  // state
	  'aria-keyshortcuts': 0,
	  'aria-label': 0,
	  'aria-roledescription': 0,
	  // Widget Attributes
	  'aria-autocomplete': 0,
	  'aria-checked': 0,
	  'aria-expanded': 0,
	  'aria-haspopup': 0,
	  'aria-level': 0,
	  'aria-modal': 0,
	  'aria-multiline': 0,
	  'aria-multiselectable': 0,
	  'aria-orientation': 0,
	  'aria-placeholder': 0,
	  'aria-pressed': 0,
	  'aria-readonly': 0,
	  'aria-required': 0,
	  'aria-selected': 0,
	  'aria-sort': 0,
	  'aria-valuemax': 0,
	  'aria-valuemin': 0,
	  'aria-valuenow': 0,
	  'aria-valuetext': 0,
	  // Live Region Attributes
	  'aria-atomic': 0,
	  'aria-busy': 0,
	  'aria-live': 0,
	  'aria-relevant': 0,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': 0,
	  'aria-grabbed': 0,
	  // Relationship Attributes
	  'aria-activedescendant': 0,
	  'aria-colcount': 0,
	  'aria-colindex': 0,
	  'aria-colspan': 0,
	  'aria-controls': 0,
	  'aria-describedby': 0,
	  'aria-errormessage': 0,
	  'aria-flowto': 0,
	  'aria-labelledby': 0,
	  'aria-owns': 0,
	  'aria-posinset': 0,
	  'aria-rowcount': 0,
	  'aria-rowindex': 0,
	  'aria-rowspan': 0,
	  'aria-setsize': 0
	};
	
	var warnedProperties = {};
	var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
	
	function validateProperty(tagName, name) {
	  if (hasOwnProperty$2.call(warnedProperties, name) && warnedProperties[name]) {
	    return true;
	  }
	
	  if (rARIACamel.test(name)) {
	    var ariaName = 'aria-' + name.slice(4).toLowerCase();
	    var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	    // DOM properties, then it is an invalid aria-* attribute.
	
	    if (correctName == null) {
	      warning$1(false, 'Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
	      warnedProperties[name] = true;
	      return true;
	    } // aria-* attributes should be lowercase; suggest the lowercase version.
	
	
	    if (name !== correctName) {
	      warning$1(false, 'Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
	      warnedProperties[name] = true;
	      return true;
	    }
	  }
	
	  if (rARIA.test(name)) {
	    var lowerCasedName = name.toLowerCase();
	    var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
	    // DOM properties, then it is an invalid aria-* attribute.
	
	    if (standardName == null) {
	      warnedProperties[name] = true;
	      return false;
	    } // aria-* attributes should be lowercase; suggest the lowercase version.
	
	
	    if (name !== standardName) {
	      warning$1(false, 'Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
	      warnedProperties[name] = true;
	      return true;
	    }
	  }
	
	  return true;
	}
	
	function warnInvalidARIAProps(type, props) {
	  var invalidProps = [];
	
	  for (var key in props) {
	    var isValid = validateProperty(type, key);
	
	    if (!isValid) {
	      invalidProps.push(key);
	    }
	  }
	
	  var unknownPropString = invalidProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (invalidProps.length === 1) {
	    warning$1(false, 'Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
	  } else if (invalidProps.length > 1) {
	    warning$1(false, 'Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
	  }
	}
	
	function validateProperties(type, props) {
	  if (isCustomComponent(type, props)) {
	    return;
	  }
	
	  warnInvalidARIAProps(type, props);
	}
	
	var didWarnValueNull = false;
	function validateProperties$1(type, props) {
	  if (type !== 'input' && type !== 'textarea' && type !== 'select') {
	    return;
	  }
	
	  if (props != null && props.value === null && !didWarnValueNull) {
	    didWarnValueNull = true;
	
	    if (type === 'select' && props.multiple) {
	      warning$1(false, '`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
	    } else {
	      warning$1(false, '`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	
	/**
	 * Ordered list of injected plugins.
	 */
	
	
	
	/**
	 * Mapping from event name to dispatch config
	 */
	
	
	/**
	 * Mapping from registration name to plugin module
	 */
	
	var registrationNameModules = {};
	/**
	 * Mapping from registration name to event name
	 */
	
	
	/**
	 * Mapping from lowercase registration names to the properly cased version,
	 * used to warn in the case of missing event handlers. Available
	 * only in true.
	 * @type {Object}
	 */
	
	var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
	
	/**
	 * Injects an ordering of plugins (by plugin name). This allows the ordering
	 * to be decoupled from injection of the actual plugins so that ordering is
	 * always deterministic regardless of packaging, on-the-fly injection, etc.
	 *
	 * @param {array} InjectedEventPluginOrder
	 * @internal
	 * @see {EventPluginHub.injection.injectEventPluginOrder}
	 */
	
	
	/**
	 * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	 * in the ordering injected by `injectEventPluginOrder`.
	 *
	 * Plugins can be injected as part of page initialization or on-the-fly.
	 *
	 * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	 * @internal
	 * @see {EventPluginHub.injection.injectEventPluginsByName}
	 */
	
	// When adding attributes to the HTML or SVG whitelist, be sure to
	// also add them to this module to ensure casing and incorrect name
	// warnings.
	var possibleStandardNames = {
	  // HTML
	  accept: 'accept',
	  acceptcharset: 'acceptCharset',
	  'accept-charset': 'acceptCharset',
	  accesskey: 'accessKey',
	  action: 'action',
	  allowfullscreen: 'allowFullScreen',
	  alt: 'alt',
	  as: 'as',
	  async: 'async',
	  autocapitalize: 'autoCapitalize',
	  autocomplete: 'autoComplete',
	  autocorrect: 'autoCorrect',
	  autofocus: 'autoFocus',
	  autoplay: 'autoPlay',
	  autosave: 'autoSave',
	  capture: 'capture',
	  cellpadding: 'cellPadding',
	  cellspacing: 'cellSpacing',
	  challenge: 'challenge',
	  charset: 'charSet',
	  checked: 'checked',
	  children: 'children',
	  cite: 'cite',
	  class: 'className',
	  classid: 'classID',
	  classname: 'className',
	  cols: 'cols',
	  colspan: 'colSpan',
	  content: 'content',
	  contenteditable: 'contentEditable',
	  contextmenu: 'contextMenu',
	  controls: 'controls',
	  controlslist: 'controlsList',
	  coords: 'coords',
	  crossorigin: 'crossOrigin',
	  dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
	  data: 'data',
	  datetime: 'dateTime',
	  default: 'default',
	  defaultchecked: 'defaultChecked',
	  defaultvalue: 'defaultValue',
	  defer: 'defer',
	  dir: 'dir',
	  disabled: 'disabled',
	  disablepictureinpicture: 'disablePictureInPicture',
	  download: 'download',
	  draggable: 'draggable',
	  enctype: 'encType',
	  for: 'htmlFor',
	  form: 'form',
	  formmethod: 'formMethod',
	  formaction: 'formAction',
	  formenctype: 'formEncType',
	  formnovalidate: 'formNoValidate',
	  formtarget: 'formTarget',
	  frameborder: 'frameBorder',
	  headers: 'headers',
	  height: 'height',
	  hidden: 'hidden',
	  high: 'high',
	  href: 'href',
	  hreflang: 'hrefLang',
	  htmlfor: 'htmlFor',
	  httpequiv: 'httpEquiv',
	  'http-equiv': 'httpEquiv',
	  icon: 'icon',
	  id: 'id',
	  innerhtml: 'innerHTML',
	  inputmode: 'inputMode',
	  integrity: 'integrity',
	  is: 'is',
	  itemid: 'itemID',
	  itemprop: 'itemProp',
	  itemref: 'itemRef',
	  itemscope: 'itemScope',
	  itemtype: 'itemType',
	  keyparams: 'keyParams',
	  keytype: 'keyType',
	  kind: 'kind',
	  label: 'label',
	  lang: 'lang',
	  list: 'list',
	  loop: 'loop',
	  low: 'low',
	  manifest: 'manifest',
	  marginwidth: 'marginWidth',
	  marginheight: 'marginHeight',
	  max: 'max',
	  maxlength: 'maxLength',
	  media: 'media',
	  mediagroup: 'mediaGroup',
	  method: 'method',
	  min: 'min',
	  minlength: 'minLength',
	  multiple: 'multiple',
	  muted: 'muted',
	  name: 'name',
	  nomodule: 'noModule',
	  nonce: 'nonce',
	  novalidate: 'noValidate',
	  open: 'open',
	  optimum: 'optimum',
	  pattern: 'pattern',
	  placeholder: 'placeholder',
	  playsinline: 'playsInline',
	  poster: 'poster',
	  preload: 'preload',
	  profile: 'profile',
	  radiogroup: 'radioGroup',
	  readonly: 'readOnly',
	  referrerpolicy: 'referrerPolicy',
	  rel: 'rel',
	  required: 'required',
	  reversed: 'reversed',
	  role: 'role',
	  rows: 'rows',
	  rowspan: 'rowSpan',
	  sandbox: 'sandbox',
	  scope: 'scope',
	  scoped: 'scoped',
	  scrolling: 'scrolling',
	  seamless: 'seamless',
	  selected: 'selected',
	  shape: 'shape',
	  size: 'size',
	  sizes: 'sizes',
	  span: 'span',
	  spellcheck: 'spellCheck',
	  src: 'src',
	  srcdoc: 'srcDoc',
	  srclang: 'srcLang',
	  srcset: 'srcSet',
	  start: 'start',
	  step: 'step',
	  style: 'style',
	  summary: 'summary',
	  tabindex: 'tabIndex',
	  target: 'target',
	  title: 'title',
	  type: 'type',
	  usemap: 'useMap',
	  value: 'value',
	  width: 'width',
	  wmode: 'wmode',
	  wrap: 'wrap',
	  // SVG
	  about: 'about',
	  accentheight: 'accentHeight',
	  'accent-height': 'accentHeight',
	  accumulate: 'accumulate',
	  additive: 'additive',
	  alignmentbaseline: 'alignmentBaseline',
	  'alignment-baseline': 'alignmentBaseline',
	  allowreorder: 'allowReorder',
	  alphabetic: 'alphabetic',
	  amplitude: 'amplitude',
	  arabicform: 'arabicForm',
	  'arabic-form': 'arabicForm',
	  ascent: 'ascent',
	  attributename: 'attributeName',
	  attributetype: 'attributeType',
	  autoreverse: 'autoReverse',
	  azimuth: 'azimuth',
	  basefrequency: 'baseFrequency',
	  baselineshift: 'baselineShift',
	  'baseline-shift': 'baselineShift',
	  baseprofile: 'baseProfile',
	  bbox: 'bbox',
	  begin: 'begin',
	  bias: 'bias',
	  by: 'by',
	  calcmode: 'calcMode',
	  capheight: 'capHeight',
	  'cap-height': 'capHeight',
	  clip: 'clip',
	  clippath: 'clipPath',
	  'clip-path': 'clipPath',
	  clippathunits: 'clipPathUnits',
	  cliprule: 'clipRule',
	  'clip-rule': 'clipRule',
	  color: 'color',
	  colorinterpolation: 'colorInterpolation',
	  'color-interpolation': 'colorInterpolation',
	  colorinterpolationfilters: 'colorInterpolationFilters',
	  'color-interpolation-filters': 'colorInterpolationFilters',
	  colorprofile: 'colorProfile',
	  'color-profile': 'colorProfile',
	  colorrendering: 'colorRendering',
	  'color-rendering': 'colorRendering',
	  contentscripttype: 'contentScriptType',
	  contentstyletype: 'contentStyleType',
	  cursor: 'cursor',
	  cx: 'cx',
	  cy: 'cy',
	  d: 'd',
	  datatype: 'datatype',
	  decelerate: 'decelerate',
	  descent: 'descent',
	  diffuseconstant: 'diffuseConstant',
	  direction: 'direction',
	  display: 'display',
	  divisor: 'divisor',
	  dominantbaseline: 'dominantBaseline',
	  'dominant-baseline': 'dominantBaseline',
	  dur: 'dur',
	  dx: 'dx',
	  dy: 'dy',
	  edgemode: 'edgeMode',
	  elevation: 'elevation',
	  enablebackground: 'enableBackground',
	  'enable-background': 'enableBackground',
	  end: 'end',
	  exponent: 'exponent',
	  externalresourcesrequired: 'externalResourcesRequired',
	  fill: 'fill',
	  fillopacity: 'fillOpacity',
	  'fill-opacity': 'fillOpacity',
	  fillrule: 'fillRule',
	  'fill-rule': 'fillRule',
	  filter: 'filter',
	  filterres: 'filterRes',
	  filterunits: 'filterUnits',
	  floodopacity: 'floodOpacity',
	  'flood-opacity': 'floodOpacity',
	  floodcolor: 'floodColor',
	  'flood-color': 'floodColor',
	  focusable: 'focusable',
	  fontfamily: 'fontFamily',
	  'font-family': 'fontFamily',
	  fontsize: 'fontSize',
	  'font-size': 'fontSize',
	  fontsizeadjust: 'fontSizeAdjust',
	  'font-size-adjust': 'fontSizeAdjust',
	  fontstretch: 'fontStretch',
	  'font-stretch': 'fontStretch',
	  fontstyle: 'fontStyle',
	  'font-style': 'fontStyle',
	  fontvariant: 'fontVariant',
	  'font-variant': 'fontVariant',
	  fontweight: 'fontWeight',
	  'font-weight': 'fontWeight',
	  format: 'format',
	  from: 'from',
	  fx: 'fx',
	  fy: 'fy',
	  g1: 'g1',
	  g2: 'g2',
	  glyphname: 'glyphName',
	  'glyph-name': 'glyphName',
	  glyphorientationhorizontal: 'glyphOrientationHorizontal',
	  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
	  glyphorientationvertical: 'glyphOrientationVertical',
	  'glyph-orientation-vertical': 'glyphOrientationVertical',
	  glyphref: 'glyphRef',
	  gradienttransform: 'gradientTransform',
	  gradientunits: 'gradientUnits',
	  hanging: 'hanging',
	  horizadvx: 'horizAdvX',
	  'horiz-adv-x': 'horizAdvX',
	  horizoriginx: 'horizOriginX',
	  'horiz-origin-x': 'horizOriginX',
	  ideographic: 'ideographic',
	  imagerendering: 'imageRendering',
	  'image-rendering': 'imageRendering',
	  in2: 'in2',
	  in: 'in',
	  inlist: 'inlist',
	  intercept: 'intercept',
	  k1: 'k1',
	  k2: 'k2',
	  k3: 'k3',
	  k4: 'k4',
	  k: 'k',
	  kernelmatrix: 'kernelMatrix',
	  kernelunitlength: 'kernelUnitLength',
	  kerning: 'kerning',
	  keypoints: 'keyPoints',
	  keysplines: 'keySplines',
	  keytimes: 'keyTimes',
	  lengthadjust: 'lengthAdjust',
	  letterspacing: 'letterSpacing',
	  'letter-spacing': 'letterSpacing',
	  lightingcolor: 'lightingColor',
	  'lighting-color': 'lightingColor',
	  limitingconeangle: 'limitingConeAngle',
	  local: 'local',
	  markerend: 'markerEnd',
	  'marker-end': 'markerEnd',
	  markerheight: 'markerHeight',
	  markermid: 'markerMid',
	  'marker-mid': 'markerMid',
	  markerstart: 'markerStart',
	  'marker-start': 'markerStart',
	  markerunits: 'markerUnits',
	  markerwidth: 'markerWidth',
	  mask: 'mask',
	  maskcontentunits: 'maskContentUnits',
	  maskunits: 'maskUnits',
	  mathematical: 'mathematical',
	  mode: 'mode',
	  numoctaves: 'numOctaves',
	  offset: 'offset',
	  opacity: 'opacity',
	  operator: 'operator',
	  order: 'order',
	  orient: 'orient',
	  orientation: 'orientation',
	  origin: 'origin',
	  overflow: 'overflow',
	  overlineposition: 'overlinePosition',
	  'overline-position': 'overlinePosition',
	  overlinethickness: 'overlineThickness',
	  'overline-thickness': 'overlineThickness',
	  paintorder: 'paintOrder',
	  'paint-order': 'paintOrder',
	  panose1: 'panose1',
	  'panose-1': 'panose1',
	  pathlength: 'pathLength',
	  patterncontentunits: 'patternContentUnits',
	  patterntransform: 'patternTransform',
	  patternunits: 'patternUnits',
	  pointerevents: 'pointerEvents',
	  'pointer-events': 'pointerEvents',
	  points: 'points',
	  pointsatx: 'pointsAtX',
	  pointsaty: 'pointsAtY',
	  pointsatz: 'pointsAtZ',
	  prefix: 'prefix',
	  preservealpha: 'preserveAlpha',
	  preserveaspectratio: 'preserveAspectRatio',
	  primitiveunits: 'primitiveUnits',
	  property: 'property',
	  r: 'r',
	  radius: 'radius',
	  refx: 'refX',
	  refy: 'refY',
	  renderingintent: 'renderingIntent',
	  'rendering-intent': 'renderingIntent',
	  repeatcount: 'repeatCount',
	  repeatdur: 'repeatDur',
	  requiredextensions: 'requiredExtensions',
	  requiredfeatures: 'requiredFeatures',
	  resource: 'resource',
	  restart: 'restart',
	  result: 'result',
	  results: 'results',
	  rotate: 'rotate',
	  rx: 'rx',
	  ry: 'ry',
	  scale: 'scale',
	  security: 'security',
	  seed: 'seed',
	  shaperendering: 'shapeRendering',
	  'shape-rendering': 'shapeRendering',
	  slope: 'slope',
	  spacing: 'spacing',
	  specularconstant: 'specularConstant',
	  specularexponent: 'specularExponent',
	  speed: 'speed',
	  spreadmethod: 'spreadMethod',
	  startoffset: 'startOffset',
	  stddeviation: 'stdDeviation',
	  stemh: 'stemh',
	  stemv: 'stemv',
	  stitchtiles: 'stitchTiles',
	  stopcolor: 'stopColor',
	  'stop-color': 'stopColor',
	  stopopacity: 'stopOpacity',
	  'stop-opacity': 'stopOpacity',
	  strikethroughposition: 'strikethroughPosition',
	  'strikethrough-position': 'strikethroughPosition',
	  strikethroughthickness: 'strikethroughThickness',
	  'strikethrough-thickness': 'strikethroughThickness',
	  string: 'string',
	  stroke: 'stroke',
	  strokedasharray: 'strokeDasharray',
	  'stroke-dasharray': 'strokeDasharray',
	  strokedashoffset: 'strokeDashoffset',
	  'stroke-dashoffset': 'strokeDashoffset',
	  strokelinecap: 'strokeLinecap',
	  'stroke-linecap': 'strokeLinecap',
	  strokelinejoin: 'strokeLinejoin',
	  'stroke-linejoin': 'strokeLinejoin',
	  strokemiterlimit: 'strokeMiterlimit',
	  'stroke-miterlimit': 'strokeMiterlimit',
	  strokewidth: 'strokeWidth',
	  'stroke-width': 'strokeWidth',
	  strokeopacity: 'strokeOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  suppresscontenteditablewarning: 'suppressContentEditableWarning',
	  suppresshydrationwarning: 'suppressHydrationWarning',
	  surfacescale: 'surfaceScale',
	  systemlanguage: 'systemLanguage',
	  tablevalues: 'tableValues',
	  targetx: 'targetX',
	  targety: 'targetY',
	  textanchor: 'textAnchor',
	  'text-anchor': 'textAnchor',
	  textdecoration: 'textDecoration',
	  'text-decoration': 'textDecoration',
	  textlength: 'textLength',
	  textrendering: 'textRendering',
	  'text-rendering': 'textRendering',
	  to: 'to',
	  transform: 'transform',
	  typeof: 'typeof',
	  u1: 'u1',
	  u2: 'u2',
	  underlineposition: 'underlinePosition',
	  'underline-position': 'underlinePosition',
	  underlinethickness: 'underlineThickness',
	  'underline-thickness': 'underlineThickness',
	  unicode: 'unicode',
	  unicodebidi: 'unicodeBidi',
	  'unicode-bidi': 'unicodeBidi',
	  unicoderange: 'unicodeRange',
	  'unicode-range': 'unicodeRange',
	  unitsperem: 'unitsPerEm',
	  'units-per-em': 'unitsPerEm',
	  unselectable: 'unselectable',
	  valphabetic: 'vAlphabetic',
	  'v-alphabetic': 'vAlphabetic',
	  values: 'values',
	  vectoreffect: 'vectorEffect',
	  'vector-effect': 'vectorEffect',
	  version: 'version',
	  vertadvy: 'vertAdvY',
	  'vert-adv-y': 'vertAdvY',
	  vertoriginx: 'vertOriginX',
	  'vert-origin-x': 'vertOriginX',
	  vertoriginy: 'vertOriginY',
	  'vert-origin-y': 'vertOriginY',
	  vhanging: 'vHanging',
	  'v-hanging': 'vHanging',
	  videographic: 'vIdeographic',
	  'v-ideographic': 'vIdeographic',
	  viewbox: 'viewBox',
	  viewtarget: 'viewTarget',
	  visibility: 'visibility',
	  vmathematical: 'vMathematical',
	  'v-mathematical': 'vMathematical',
	  vocab: 'vocab',
	  widths: 'widths',
	  wordspacing: 'wordSpacing',
	  'word-spacing': 'wordSpacing',
	  writingmode: 'writingMode',
	  'writing-mode': 'writingMode',
	  x1: 'x1',
	  x2: 'x2',
	  x: 'x',
	  xchannelselector: 'xChannelSelector',
	  xheight: 'xHeight',
	  'x-height': 'xHeight',
	  xlinkactuate: 'xlinkActuate',
	  'xlink:actuate': 'xlinkActuate',
	  xlinkarcrole: 'xlinkArcrole',
	  'xlink:arcrole': 'xlinkArcrole',
	  xlinkhref: 'xlinkHref',
	  'xlink:href': 'xlinkHref',
	  xlinkrole: 'xlinkRole',
	  'xlink:role': 'xlinkRole',
	  xlinkshow: 'xlinkShow',
	  'xlink:show': 'xlinkShow',
	  xlinktitle: 'xlinkTitle',
	  'xlink:title': 'xlinkTitle',
	  xlinktype: 'xlinkType',
	  'xlink:type': 'xlinkType',
	  xmlbase: 'xmlBase',
	  'xml:base': 'xmlBase',
	  xmllang: 'xmlLang',
	  'xml:lang': 'xmlLang',
	  xmlns: 'xmlns',
	  'xml:space': 'xmlSpace',
	  xmlnsxlink: 'xmlnsXlink',
	  'xmlns:xlink': 'xmlnsXlink',
	  xmlspace: 'xmlSpace',
	  y1: 'y1',
	  y2: 'y2',
	  y: 'y',
	  ychannelselector: 'yChannelSelector',
	  z: 'z',
	  zoomandpan: 'zoomAndPan'
	};
	
	var validateProperty$1 = function () {};
	
	{
	  var warnedProperties$1 = {};
	  var _hasOwnProperty = Object.prototype.hasOwnProperty;
	  var EVENT_NAME_REGEX = /^on./;
	  var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
	  var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
	  var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
	
	  validateProperty$1 = function (tagName, name, value, canUseEventSystem) {
	    if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
	      return true;
	    }
	
	    var lowerCasedName = name.toLowerCase();
	
	    if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
	      warning$1(false, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
	      warnedProperties$1[name] = true;
	      return true;
	    } // We can't rely on the event system being injected on the server.
	
	
	    if (canUseEventSystem) {
	      if (registrationNameModules.hasOwnProperty(name)) {
	        return true;
	      }
	
	      var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
	
	      if (registrationName != null) {
	        warning$1(false, 'Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
	        warnedProperties$1[name] = true;
	        return true;
	      }
	
	      if (EVENT_NAME_REGEX.test(name)) {
	        warning$1(false, 'Unknown event handler property `%s`. It will be ignored.', name);
	        warnedProperties$1[name] = true;
	        return true;
	      }
	    } else if (EVENT_NAME_REGEX.test(name)) {
	      // If no event plugins have been injected, we are in a server environment.
	      // So we can't tell if the event name is correct for sure, but we can filter
	      // out known bad ones like `onclick`. We can't suggest a specific replacement though.
	      if (INVALID_EVENT_NAME_REGEX.test(name)) {
	        warning$1(false, 'Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
	      }
	
	      warnedProperties$1[name] = true;
	      return true;
	    } // Let the ARIA attribute hook validate ARIA attributes
	
	
	    if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
	      return true;
	    }
	
	    if (lowerCasedName === 'innerhtml') {
	      warning$1(false, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
	      warnedProperties$1[name] = true;
	      return true;
	    }
	
	    if (lowerCasedName === 'aria') {
	      warning$1(false, 'The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
	      warnedProperties$1[name] = true;
	      return true;
	    }
	
	    if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
	      warning$1(false, 'Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
	      warnedProperties$1[name] = true;
	      return true;
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warning$1(false, 'Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
	      warnedProperties$1[name] = true;
	      return true;
	    }
	
	    var propertyInfo = getPropertyInfo(name);
	    var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
	
	    if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
	      var standardName = possibleStandardNames[lowerCasedName];
	
	      if (standardName !== name) {
	        warning$1(false, 'Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
	        warnedProperties$1[name] = true;
	        return true;
	      }
	    } else if (!isReserved && name !== lowerCasedName) {
	      // Unknown attributes should have lowercase casing since that's how they
	      // will be cased anyway with server rendering.
	      warning$1(false, 'React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
	      warnedProperties$1[name] = true;
	      return true;
	    }
	
	    if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
	      if (value) {
	        warning$1(false, 'Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
	      } else {
	        warning$1(false, 'Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
	      }
	
	      warnedProperties$1[name] = true;
	      return true;
	    } // Now that we've validated casing, do not validate
	    // data types for reserved props
	
	
	    if (isReserved) {
	      return true;
	    } // Warn when a known attribute is a bad type
	
	
	    if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
	      warnedProperties$1[name] = true;
	      return false;
	    } // Warn when passing the strings 'false' or 'true' into a boolean prop
	
	
	    if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
	      warning$1(false, 'Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
	      warnedProperties$1[name] = true;
	      return true;
	    }
	
	    return true;
	  };
	}
	
	var warnUnknownProperties = function (type, props, canUseEventSystem) {
	  var unknownProps = [];
	
	  for (var key in props) {
	    var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);
	
	    if (!isValid) {
	      unknownProps.push(key);
	    }
	  }
	
	  var unknownPropString = unknownProps.map(function (prop) {
	    return '`' + prop + '`';
	  }).join(', ');
	
	  if (unknownProps.length === 1) {
	    warning$1(false, 'Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
	  } else if (unknownProps.length > 1) {
	    warning$1(false, 'Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
	  }
	};
	
	function validateProperties$2(type, props, canUseEventSystem) {
	  if (isCustomComponent(type, props)) {
	    return;
	  }
	
	  warnUnknownProperties(type, props, canUseEventSystem);
	}
	
	var toArray = React.Children.toArray; // This is only used in DEV.
	// Each entry is `this.stack` from a currently executing renderer instance.
	// (There may be more than one because ReactDOMServer is reentrant).
	// Each stack is an array of frames which may contain nested stacks of elements.
	
	var currentDebugStacks = [];
	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var ReactDebugCurrentFrame;
	var prevGetCurrentStackImpl = null;
	
	var getCurrentServerStackImpl = function () {
	  return '';
	};
	
	var describeStackFrame = function (element) {
	  return '';
	};
	
	var validatePropertiesInDevelopment = function (type, props) {};
	
	var pushCurrentDebugStack = function (stack) {};
	
	var pushElementToDebugStack = function (element) {};
	
	var popCurrentDebugStack = function () {};
	
	var hasWarnedAboutUsingContextAsConsumer = false;
	
	{
	  ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	
	  validatePropertiesInDevelopment = function (type, props) {
	    validateProperties(type, props);
	    validateProperties$1(type, props);
	    validateProperties$2(type, props,
	    /* canUseEventSystem */
	    false);
	  };
	
	  describeStackFrame = function (element) {
	    var source = element._source;
	    var type = element.type;
	    var name = getComponentName(type);
	    var ownerName = null;
	    return describeComponentFrame(name, source, ownerName);
	  };
	
	  pushCurrentDebugStack = function (stack) {
	    currentDebugStacks.push(stack);
	
	    if (currentDebugStacks.length === 1) {
	      // We are entering a server renderer.
	      // Remember the previous (e.g. client) global stack implementation.
	      prevGetCurrentStackImpl = ReactDebugCurrentFrame.getCurrentStack;
	      ReactDebugCurrentFrame.getCurrentStack = getCurrentServerStackImpl;
	    }
	  };
	
	  pushElementToDebugStack = function (element) {
	    // For the innermost executing ReactDOMServer call,
	    var stack = currentDebugStacks[currentDebugStacks.length - 1]; // Take the innermost executing frame (e.g. <Foo>),
	
	    var frame = stack[stack.length - 1]; // and record that it has one more element associated with it.
	
	    frame.debugElementStack.push(element); // We only need this because we tail-optimize single-element
	    // children and directly handle them in an inner loop instead of
	    // creating separate frames for them.
	  };
	
	  popCurrentDebugStack = function () {
	    currentDebugStacks.pop();
	
	    if (currentDebugStacks.length === 0) {
	      // We are exiting the server renderer.
	      // Restore the previous (e.g. client) global stack implementation.
	      ReactDebugCurrentFrame.getCurrentStack = prevGetCurrentStackImpl;
	      prevGetCurrentStackImpl = null;
	    }
	  };
	
	  getCurrentServerStackImpl = function () {
	    if (currentDebugStacks.length === 0) {
	      // Nothing is currently rendering.
	      return '';
	    } // ReactDOMServer is reentrant so there may be multiple calls at the same time.
	    // Take the frames from the innermost call which is the last in the array.
	
	
	    var frames = currentDebugStacks[currentDebugStacks.length - 1];
	    var stack = ''; // Go through every frame in the stack from the innermost one.
	
	    for (var i = frames.length - 1; i >= 0; i--) {
	      var frame = frames[i]; // Every frame might have more than one debug element stack entry associated with it.
	      // This is because single-child nesting doesn't create materialized frames.
	      // Instead it would push them through `pushElementToDebugStack()`.
	
	      var debugElementStack = frame.debugElementStack;
	
	      for (var ii = debugElementStack.length - 1; ii >= 0; ii--) {
	        stack += describeStackFrame(debugElementStack[ii]);
	      }
	    }
	
	    return stack;
	  };
	}
	
	var didWarnDefaultInputValue = false;
	var didWarnDefaultChecked = false;
	var didWarnDefaultSelectValue = false;
	var didWarnDefaultTextareaValue = false;
	var didWarnInvalidOptionChildren = false;
	var didWarnAboutNoopUpdateForComponent = {};
	var didWarnAboutBadClass = {};
	var didWarnAboutModulePatternComponent = {};
	var didWarnAboutDeprecatedWillMount = {};
	var didWarnAboutUndefinedDerivedState = {};
	var didWarnAboutUninitializedState = {};
	var valuePropNames = ['value', 'defaultValue'];
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	}; // We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	
	var validatedTagCache = {};
	
	function validateDangerousTag(tag) {
	  if (!validatedTagCache.hasOwnProperty(tag)) {
	    if (!VALID_TAG_REGEX.test(tag)) {
	      {
	        throw Error("Invalid tag: " + tag);
	      }
	    }
	
	    validatedTagCache[tag] = true;
	  }
	}
	
	var styleNameCache = {};
	
	var processStyleName = function (styleName) {
	  if (styleNameCache.hasOwnProperty(styleName)) {
	    return styleNameCache[styleName];
	  }
	
	  var result = hyphenateStyleName(styleName);
	  styleNameCache[styleName] = result;
	  return result;
	};
	
	function createMarkupForStyles(styles) {
	  var serialized = '';
	  var delimiter = '';
	
	  for (var styleName in styles) {
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	
	    var isCustomProperty = styleName.indexOf('--') === 0;
	    var styleValue = styles[styleName];
	
	    {
	      if (!isCustomProperty) {
	        warnValidStyle$1(styleName, styleValue);
	      }
	    }
	
	    if (styleValue != null) {
	      serialized += delimiter + (isCustomProperty ? styleName : processStyleName(styleName)) + ':';
	      serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
	      delimiter = ';';
	    }
	  }
	
	  return serialized || null;
	}
	
	function warnNoop(publicInstance, callerName) {
	  {
	    var _constructor = publicInstance.constructor;
	    var componentName = _constructor && getComponentName(_constructor) || 'ReactClass';
	    var warningKey = componentName + '.' + callerName;
	
	    if (didWarnAboutNoopUpdateForComponent[warningKey]) {
	      return;
	    }
	
	    warningWithoutStack$1(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op.\n\nPlease check the code for the %s component.', callerName, callerName, componentName);
	    didWarnAboutNoopUpdateForComponent[warningKey] = true;
	  }
	}
	
	function shouldConstruct(Component) {
	  return Component.prototype && Component.prototype.isReactComponent;
	}
	
	function getNonChildrenInnerMarkup(props) {
	  var innerHTML = props.dangerouslySetInnerHTML;
	
	  if (innerHTML != null) {
	    if (innerHTML.__html != null) {
	      return innerHTML.__html;
	    }
	  } else {
	    var content = props.children;
	
	    if (typeof content === 'string' || typeof content === 'number') {
	      return escapeTextForBrowser(content);
	    }
	  }
	
	  return null;
	}
	
	function flattenTopLevelChildren(children) {
	  if (!React.isValidElement(children)) {
	    return toArray(children);
	  }
	
	  var element = children;
	
	  if (element.type !== REACT_FRAGMENT_TYPE) {
	    return [element];
	  }
	
	  var fragmentChildren = element.props.children;
	
	  if (!React.isValidElement(fragmentChildren)) {
	    return toArray(fragmentChildren);
	  }
	
	  var fragmentChildElement = fragmentChildren;
	  return [fragmentChildElement];
	}
	
	function flattenOptionChildren(children) {
	  if (children === undefined || children === null) {
	    return children;
	  }
	
	  var content = ''; // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	
	    content += child;
	
	    {
	      if (!didWarnInvalidOptionChildren && typeof child !== 'string' && typeof child !== 'number') {
	        didWarnInvalidOptionChildren = true;
	        warning$1(false, 'Only strings and numbers are supported as <option> children.');
	      }
	    }
	  });
	  return content;
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var STYLE = 'style';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null,
	  suppressHydrationWarning: null
	};
	
	function createOpenTagMarkup(tagVerbatim, tagLowercase, props, namespace, makeStaticMarkup, isRootElement) {
	  var ret = '<' + tagVerbatim;
	
	  for (var propKey in props) {
	    if (!hasOwnProperty.call(props, propKey)) {
	      continue;
	    }
	
	    if (enableFlareAPI && propKey === 'listeners') {
	      continue;
	    }
	
	    var propValue = props[propKey];
	
	    if (propValue == null) {
	      continue;
	    }
	
	    if (propKey === STYLE) {
	      propValue = createMarkupForStyles(propValue);
	    }
	
	    var markup = null;
	
	    if (isCustomComponent(tagLowercase, props)) {
	      if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	        markup = createMarkupForCustomAttribute(propKey, propValue);
	      }
	    } else {
	      markup = createMarkupForProperty(propKey, propValue);
	    }
	
	    if (markup) {
	      ret += ' ' + markup;
	    }
	  } // For static pages, no need to put React ID and checksum. Saves lots of
	  // bytes.
	
	
	  if (makeStaticMarkup) {
	    return ret;
	  }
	
	  if (isRootElement) {
	    ret += ' ' + createMarkupForRoot();
	  }
	
	  return ret;
	}
	
	function validateRenderResult(child, type) {
	  if (child === undefined) {
	    {
	      {
	        throw Error((getComponentName(type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
	      }
	    }
	  }
	}
	
	function resolve(child, context, threadID) {
	  while (React.isValidElement(child)) {
	    // Safe because we just checked it's an element.
	    var element = child;
	    var Component = element.type;
	
	    {
	      pushElementToDebugStack(element);
	    }
	
	    if (typeof Component !== 'function') {
	      break;
	    }
	
	    processChild(element, Component);
	  } // Extra closure so queue and replace can be captured properly
	
	
	  function processChild(element, Component) {
	    var isClass = shouldConstruct(Component);
	    var publicContext = processContext(Component, context, threadID, isClass);
	    var queue = [];
	    var replace = false;
	    var updater = {
	      isMounted: function (publicInstance) {
	        return false;
	      },
	      enqueueForceUpdate: function (publicInstance) {
	        if (queue === null) {
	          warnNoop(publicInstance, 'forceUpdate');
	          return null;
	        }
	      },
	      enqueueReplaceState: function (publicInstance, completeState) {
	        replace = true;
	        queue = [completeState];
	      },
	      enqueueSetState: function (publicInstance, currentPartialState) {
	        if (queue === null) {
	          warnNoop(publicInstance, 'setState');
	          return null;
	        }
	
	        queue.push(currentPartialState);
	      }
	    };
	    var inst;
	
	    if (isClass) {
	      inst = new Component(element.props, publicContext, updater);
	
	      if (typeof Component.getDerivedStateFromProps === 'function') {
	        {
	          if (inst.state === null || inst.state === undefined) {
	            var componentName = getComponentName(Component) || 'Unknown';
	
	            if (!didWarnAboutUninitializedState[componentName]) {
	              warningWithoutStack$1(false, '`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, inst.state === null ? 'null' : 'undefined', componentName);
	              didWarnAboutUninitializedState[componentName] = true;
	            }
	          }
	        }
	
	        var partialState = Component.getDerivedStateFromProps.call(null, element.props, inst.state);
	
	        {
	          if (partialState === undefined) {
	            var _componentName = getComponentName(Component) || 'Unknown';
	
	            if (!didWarnAboutUndefinedDerivedState[_componentName]) {
	              warningWithoutStack$1(false, '%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', _componentName);
	              didWarnAboutUndefinedDerivedState[_componentName] = true;
	            }
	          }
	        }
	
	        if (partialState != null) {
	          inst.state = _assign({}, inst.state, partialState);
	        }
	      }
	    } else {
	      {
	        if (Component.prototype && typeof Component.prototype.render === 'function') {
	          var _componentName2 = getComponentName(Component) || 'Unknown';
	
	          if (!didWarnAboutBadClass[_componentName2]) {
	            warningWithoutStack$1(false, "The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', _componentName2, _componentName2);
	            didWarnAboutBadClass[_componentName2] = true;
	          }
	        }
	      }
	
	      var componentIdentity = {};
	      prepareToUseHooks(componentIdentity);
	      inst = Component(element.props, publicContext, updater);
	      inst = finishHooks(Component, element.props, inst, publicContext);
	
	      if (inst == null || inst.render == null) {
	        child = inst;
	        validateRenderResult(child, Component);
	        return;
	      }
	
	      {
	        var _componentName3 = getComponentName(Component) || 'Unknown';
	
	        if (!didWarnAboutModulePatternComponent[_componentName3]) {
	          warningWithoutStack$1(false, 'The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName3, _componentName3, _componentName3);
	          didWarnAboutModulePatternComponent[_componentName3] = true;
	        }
	      }
	    }
	
	    inst.props = element.props;
	    inst.context = publicContext;
	    inst.updater = updater;
	    var initialState = inst.state;
	
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	
	    if (typeof inst.UNSAFE_componentWillMount === 'function' || typeof inst.componentWillMount === 'function') {
	      if (typeof inst.componentWillMount === 'function') {
	        {
	          if (warnAboutDeprecatedLifecycles && inst.componentWillMount.__suppressDeprecationWarning !== true) {
	            var _componentName4 = getComponentName(Component) || 'Unknown';
	
	            if (!didWarnAboutDeprecatedWillMount[_componentName4]) {
	              lowPriorityWarningWithoutStack$1(false, // keep this warning in sync with ReactStrictModeWarning.js
	              'componentWillMount has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code from componentWillMount to componentDidMount (preferred in most cases) ' + 'or the constructor.\n' + '\nPlease update the following components: %s', _componentName4);
	              didWarnAboutDeprecatedWillMount[_componentName4] = true;
	            }
	          }
	        } // In order to support react-lifecycles-compat polyfilled components,
	        // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
	
	
	        if (typeof Component.getDerivedStateFromProps !== 'function') {
	          inst.componentWillMount();
	        }
	      }
	
	      if (typeof inst.UNSAFE_componentWillMount === 'function' && typeof Component.getDerivedStateFromProps !== 'function') {
	        // In order to support react-lifecycles-compat polyfilled components,
	        // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
	        inst.UNSAFE_componentWillMount();
	      }
	
	      if (queue.length) {
	        var oldQueue = queue;
	        var oldReplace = replace;
	        queue = null;
	        replace = false;
	
	        if (oldReplace && oldQueue.length === 1) {
	          inst.state = oldQueue[0];
	        } else {
	          var nextState = oldReplace ? oldQueue[0] : inst.state;
	          var dontMutate = true;
	
	          for (var i = oldReplace ? 1 : 0; i < oldQueue.length; i++) {
	            var partial = oldQueue[i];
	
	            var _partialState = typeof partial === 'function' ? partial.call(inst, nextState, element.props, publicContext) : partial;
	
	            if (_partialState != null) {
	              if (dontMutate) {
	                dontMutate = false;
	                nextState = _assign({}, nextState, _partialState);
	              } else {
	                _assign(nextState, _partialState);
	              }
	            }
	          }
	
	          inst.state = nextState;
	        }
	      } else {
	        queue = null;
	      }
	    }
	
	    child = inst.render();
	
	    {
	      if (child === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        child = null;
	      }
	    }
	
	    validateRenderResult(child, Component);
	    var childContext;
	
	    if (disableLegacyContext) {
	      {
	        var childContextTypes = Component.childContextTypes;
	
	        if (childContextTypes !== undefined) {
	          warningWithoutStack$1(false, '%s uses the legacy childContextTypes API which is no longer supported. ' + 'Use React.createContext() instead.', getComponentName(Component) || 'Unknown');
	        }
	      }
	    } else {
	      if (typeof inst.getChildContext === 'function') {
	        var _childContextTypes = Component.childContextTypes;
	
	        if (typeof _childContextTypes === 'object') {
	          childContext = inst.getChildContext();
	
	          for (var contextKey in childContext) {
	            if (!(contextKey in _childContextTypes)) {
	              {
	                throw Error((getComponentName(Component) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
	              }
	            }
	          }
	        } else {
	          warningWithoutStack$1(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', getComponentName(Component) || 'Unknown');
	        }
	      }
	
	      if (childContext) {
	        context = _assign({}, context, childContext);
	      }
	    }
	  }
	
	  return {
	    child: child,
	    context: context
	  };
	}
	
	var ReactDOMServerRenderer =
	/*#__PURE__*/
	function () {
	  // TODO: type this more strictly:
	  // DEV-only
	  function ReactDOMServerRenderer(children, makeStaticMarkup) {
	    var flatChildren = flattenTopLevelChildren(children);
	    var topFrame = {
	      type: null,
	      // Assume all trees start in the HTML namespace (not totally true, but
	      // this is what we did historically)
	      domNamespace: Namespaces.html,
	      children: flatChildren,
	      childIndex: 0,
	      context: emptyObject,
	      footer: ''
	    };
	
	    {
	      topFrame.debugElementStack = [];
	    }
	
	    this.threadID = allocThreadID();
	    this.stack = [topFrame];
	    this.exhausted = false;
	    this.currentSelectValue = null;
	    this.previousWasTextNode = false;
	    this.makeStaticMarkup = makeStaticMarkup;
	    this.suspenseDepth = 0; // Context (new API)
	
	    this.contextIndex = -1;
	    this.contextStack = [];
	    this.contextValueStack = [];
	
	    {
	      this.contextProviderStack = [];
	    }
	  }
	
	  var _proto = ReactDOMServerRenderer.prototype;
	
	  _proto.destroy = function destroy() {
	    if (!this.exhausted) {
	      this.exhausted = true;
	      this.clearProviders();
	      freeThreadID(this.threadID);
	    }
	  }
	  /**
	   * Note: We use just two stacks regardless of how many context providers you have.
	   * Providers are always popped in the reverse order to how they were pushed
	   * so we always know on the way down which provider you'll encounter next on the way up.
	   * On the way down, we push the current provider, and its context value *before*
	   * we mutated it, onto the stacks. Therefore, on the way up, we always know which
	   * provider needs to be "restored" to which value.
	   * https://github.com/facebook/react/pull/12985#issuecomment-396301248
	   */
	  ;
	
	  _proto.pushProvider = function pushProvider(provider) {
	    var index = ++this.contextIndex;
	    var context = provider.type._context;
	    var threadID = this.threadID;
	    validateContextBounds(context, threadID);
	    var previousValue = context[threadID]; // Remember which value to restore this context to on our way up.
	
	    this.contextStack[index] = context;
	    this.contextValueStack[index] = previousValue;
	
	    {
	      // Only used for push/pop mismatch warnings.
	      this.contextProviderStack[index] = provider;
	    } // Mutate the current value.
	
	
	    context[threadID] = provider.props.value;
	  };
	
	  _proto.popProvider = function popProvider(provider) {
	    var index = this.contextIndex;
	
	    {
	      !(index > -1 && provider === this.contextProviderStack[index]) ? warningWithoutStack$1(false, 'Unexpected pop.') : void 0;
	    }
	
	    var context = this.contextStack[index];
	    var previousValue = this.contextValueStack[index]; // "Hide" these null assignments from Flow by using `any`
	    // because conceptually they are deletions--as long as we
	    // promise to never access values beyond `this.contextIndex`.
	
	    this.contextStack[index] = null;
	    this.contextValueStack[index] = null;
	
	    {
	      this.contextProviderStack[index] = null;
	    }
	
	    this.contextIndex--; // Restore to the previous value we stored as we were walking down.
	    // We've already verified that this context has been expanded to accommodate
	    // this thread id, so we don't need to do it again.
	
	    context[this.threadID] = previousValue;
	  };
	
	  _proto.clearProviders = function clearProviders() {
	    // Restore any remaining providers on the stack to previous values
	    for (var index = this.contextIndex; index >= 0; index--) {
	      var context = this.contextStack[index];
	      var previousValue = this.contextValueStack[index];
	      context[this.threadID] = previousValue;
	    }
	  };
	
	  _proto.read = function read(bytes) {
	    if (this.exhausted) {
	      return null;
	    }
	
	    var prevThreadID = currentThreadID;
	    setCurrentThreadID(this.threadID);
	    var prevDispatcher = ReactCurrentDispatcher.current;
	    ReactCurrentDispatcher.current = Dispatcher;
	
	    try {
	      // Markup generated within <Suspense> ends up buffered until we know
	      // nothing in that boundary suspended
	      var out = [''];
	      var suspended = false;
	
	      while (out[0].length < bytes) {
	        if (this.stack.length === 0) {
	          this.exhausted = true;
	          freeThreadID(this.threadID);
	          break;
	        }
	
	        var frame = this.stack[this.stack.length - 1];
	
	        if (suspended || frame.childIndex >= frame.children.length) {
	          var footer = frame.footer;
	
	          if (footer !== '') {
	            this.previousWasTextNode = false;
	          }
	
	          this.stack.pop();
	
	          if (frame.type === 'select') {
	            this.currentSelectValue = null;
	          } else if (frame.type != null && frame.type.type != null && frame.type.type.$$typeof === REACT_PROVIDER_TYPE) {
	            var provider = frame.type;
	            this.popProvider(provider);
	          } else if (frame.type === REACT_SUSPENSE_TYPE) {
	            this.suspenseDepth--;
	            var buffered = out.pop();
	
	            if (suspended) {
	              suspended = false; // If rendering was suspended at this boundary, render the fallbackFrame
	
	              var fallbackFrame = frame.fallbackFrame;
	
	              if (!fallbackFrame) {
	                {
	                  throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
	                }
	              }
	
	              this.stack.push(fallbackFrame);
	              out[this.suspenseDepth] += '<!--$!-->'; // Skip flushing output since we're switching to the fallback
	
	              continue;
	            } else {
	              out[this.suspenseDepth] += buffered;
	            }
	          } // Flush output
	
	
	          out[this.suspenseDepth] += footer;
	          continue;
	        }
	
	        var child = frame.children[frame.childIndex++];
	        var outBuffer = '';
	
	        {
	          pushCurrentDebugStack(this.stack); // We're starting work on this frame, so reset its inner stack.
	
	          frame.debugElementStack.length = 0;
	        }
	
	        try {
	          outBuffer += this.render(child, frame.context, frame.domNamespace);
	        } catch (err) {
	          if (err != null && typeof err.then === 'function') {
	            if (enableSuspenseServerRenderer) {
	              if (!(this.suspenseDepth > 0)) {
	                {
	                  throw Error("A React component suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
	                }
	              }
	
	              suspended = true;
	            } else {
	              {
	                {
	                  throw Error("ReactDOMServer does not yet support Suspense.");
	                }
	              }
	            }
	          } else {
	            throw err;
	          }
	        } finally {
	          {
	            popCurrentDebugStack();
	          }
	        }
	
	        if (out.length <= this.suspenseDepth) {
	          out.push('');
	        }
	
	        out[this.suspenseDepth] += outBuffer;
	      }
	
	      return out[0];
	    } finally {
	      ReactCurrentDispatcher.current = prevDispatcher;
	      setCurrentThreadID(prevThreadID);
	    }
	  };
	
	  _proto.render = function render(child, context, parentNamespace) {
	    if (typeof child === 'string' || typeof child === 'number') {
	      var text = '' + child;
	
	      if (text === '') {
	        return '';
	      }
	
	      if (this.makeStaticMarkup) {
	        return escapeTextForBrowser(text);
	      }
	
	      if (this.previousWasTextNode) {
	        return '<!-- -->' + escapeTextForBrowser(text);
	      }
	
	      this.previousWasTextNode = true;
	      return escapeTextForBrowser(text);
	    } else {
	      var nextChild;
	
	      var _resolve = resolve(child, context, this.threadID);
	
	      nextChild = _resolve.child;
	      context = _resolve.context;
	
	      if (nextChild === null || nextChild === false) {
	        return '';
	      } else if (!React.isValidElement(nextChild)) {
	        if (nextChild != null && nextChild.$$typeof != null) {
	          // Catch unexpected special types early.
	          var $$typeof = nextChild.$$typeof;
	
	          if (!($$typeof !== REACT_PORTAL_TYPE)) {
	            {
	              throw Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
	            }
	          } // Catch-all to prevent an infinite loop if React.Children.toArray() supports some new type.
	
	
	          {
	            {
	              throw Error("Unknown element-like object type: " + $$typeof.toString() + ". This is likely a bug in React. Please file an issue.");
	            }
	          }
	        }
	
	        var nextChildren = toArray(nextChild);
	        var frame = {
	          type: null,
	          domNamespace: parentNamespace,
	          children: nextChildren,
	          childIndex: 0,
	          context: context,
	          footer: ''
	        };
	
	        {
	          frame.debugElementStack = [];
	        }
	
	        this.stack.push(frame);
	        return '';
	      } // Safe because we just checked it's an element.
	
	
	      var nextElement = nextChild;
	      var elementType = nextElement.type;
	
	      if (typeof elementType === 'string') {
	        return this.renderDOM(nextElement, context, parentNamespace);
	      }
	
	      switch (elementType) {
	        case REACT_STRICT_MODE_TYPE:
	        case REACT_CONCURRENT_MODE_TYPE:
	        case REACT_PROFILER_TYPE:
	        case REACT_SUSPENSE_LIST_TYPE:
	        case REACT_FRAGMENT_TYPE:
	          {
	            var _nextChildren = toArray(nextChild.props.children);
	
	            var _frame = {
	              type: null,
	              domNamespace: parentNamespace,
	              children: _nextChildren,
	              childIndex: 0,
	              context: context,
	              footer: ''
	            };
	
	            {
	              _frame.debugElementStack = [];
	            }
	
	            this.stack.push(_frame);
	            return '';
	          }
	
	        case REACT_SUSPENSE_TYPE:
	          {
	            if (enableSuspenseServerRenderer) {
	              var fallback = nextChild.props.fallback;
	
	              if (fallback === undefined) {
	                // If there is no fallback, then this just behaves as a fragment.
	                var _nextChildren3 = toArray(nextChild.props.children);
	
	                var _frame3 = {
	                  type: null,
	                  domNamespace: parentNamespace,
	                  children: _nextChildren3,
	                  childIndex: 0,
	                  context: context,
	                  footer: ''
	                };
	
	                {
	                  _frame3.debugElementStack = [];
	                }
	
	                this.stack.push(_frame3);
	                return '';
	              }
	
	              var fallbackChildren = toArray(fallback);
	
	              var _nextChildren2 = toArray(nextChild.props.children);
	
	              var fallbackFrame = {
	                type: null,
	                domNamespace: parentNamespace,
	                children: fallbackChildren,
	                childIndex: 0,
	                context: context,
	                footer: '<!--/$-->'
	              };
	              var _frame2 = {
	                fallbackFrame: fallbackFrame,
	                type: REACT_SUSPENSE_TYPE,
	                domNamespace: parentNamespace,
	                children: _nextChildren2,
	                childIndex: 0,
	                context: context,
	                footer: '<!--/$-->'
	              };
	
	              {
	                _frame2.debugElementStack = [];
	                fallbackFrame.debugElementStack = [];
	              }
	
	              this.stack.push(_frame2);
	              this.suspenseDepth++;
	              return '<!--$-->';
	            } else {
	              {
	                {
	                  throw Error("ReactDOMServer does not yet support Suspense.");
	                }
	              }
	            }
	          }
	        // eslint-disable-next-line-no-fallthrough
	
	        default:
	          break;
	      }
	
	      if (typeof elementType === 'object' && elementType !== null) {
	        switch (elementType.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            {
	              var element = nextChild;
	
	              var _nextChildren4;
	
	              var componentIdentity = {};
	              prepareToUseHooks(componentIdentity);
	              _nextChildren4 = elementType.render(element.props, element.ref);
	              _nextChildren4 = finishHooks(elementType.render, element.props, _nextChildren4, element.ref);
	              _nextChildren4 = toArray(_nextChildren4);
	              var _frame4 = {
	                type: null,
	                domNamespace: parentNamespace,
	                children: _nextChildren4,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };
	
	              {
	                _frame4.debugElementStack = [];
	              }
	
	              this.stack.push(_frame4);
	              return '';
	            }
	
	          case REACT_MEMO_TYPE:
	            {
	              var _element = nextChild;
	              var _nextChildren5 = [React.createElement(elementType.type, _assign({
	                ref: _element.ref
	              }, _element.props))];
	              var _frame5 = {
	                type: null,
	                domNamespace: parentNamespace,
	                children: _nextChildren5,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };
	
	              {
	                _frame5.debugElementStack = [];
	              }
	
	              this.stack.push(_frame5);
	              return '';
	            }
	
	          case REACT_PROVIDER_TYPE:
	            {
	              var provider = nextChild;
	              var nextProps = provider.props;
	
	              var _nextChildren6 = toArray(nextProps.children);
	
	              var _frame6 = {
	                type: provider,
	                domNamespace: parentNamespace,
	                children: _nextChildren6,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };
	
	              {
	                _frame6.debugElementStack = [];
	              }
	
	              this.pushProvider(provider);
	              this.stack.push(_frame6);
	              return '';
	            }
	
	          case REACT_CONTEXT_TYPE:
	            {
	              var reactContext = nextChild.type; // The logic below for Context differs depending on PROD or DEV mode. In
	              // DEV mode, we create a separate object for Context.Consumer that acts
	              // like a proxy to Context. This proxy object adds unnecessary code in PROD
	              // so we use the old behaviour (Context.Consumer references Context) to
	              // reduce size and overhead. The separate object references context via
	              // a property called "_context", which also gives us the ability to check
	              // in DEV mode if this property exists or not and warn if it does not.
	
	              {
	                if (reactContext._context === undefined) {
	                  // This may be because it's a Context (rather than a Consumer).
	                  // Or it may be because it's older React where they're the same thing.
	                  // We only want to warn if we're sure it's a new React.
	                  if (reactContext !== reactContext.Consumer) {
	                    if (!hasWarnedAboutUsingContextAsConsumer) {
	                      hasWarnedAboutUsingContextAsConsumer = true;
	                      warning$1(false, 'Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
	                    }
	                  }
	                } else {
	                  reactContext = reactContext._context;
	                }
	              }
	
	              var _nextProps = nextChild.props;
	              var threadID = this.threadID;
	              validateContextBounds(reactContext, threadID);
	              var nextValue = reactContext[threadID];
	
	              var _nextChildren7 = toArray(_nextProps.children(nextValue));
	
	              var _frame7 = {
	                type: nextChild,
	                domNamespace: parentNamespace,
	                children: _nextChildren7,
	                childIndex: 0,
	                context: context,
	                footer: ''
	              };
	
	              {
	                _frame7.debugElementStack = [];
	              }
	
	              this.stack.push(_frame7);
	              return '';
	            }
	          // eslint-disable-next-line-no-fallthrough
	
	          case REACT_FUNDAMENTAL_TYPE:
	            {
	              if (enableFundamentalAPI) {
	                var fundamentalImpl = elementType.impl;
	                var open = fundamentalImpl.getServerSideString(null, nextElement.props);
	                var getServerSideStringClose = fundamentalImpl.getServerSideStringClose;
	                var close = getServerSideStringClose !== undefined ? getServerSideStringClose(null, nextElement.props) : '';
	
	                var _nextChildren8 = fundamentalImpl.reconcileChildren !== false ? toArray(nextChild.props.children) : [];
	
	                var _frame8 = {
	                  type: null,
	                  domNamespace: parentNamespace,
	                  children: _nextChildren8,
	                  childIndex: 0,
	                  context: context,
	                  footer: close
	                };
	
	                {
	                  _frame8.debugElementStack = [];
	                }
	
	                this.stack.push(_frame8);
	                return open;
	              }
	
	              {
	                {
	                  throw Error("ReactDOMServer does not yet support the fundamental API.");
	                }
	              }
	            }
	          // eslint-disable-next-line-no-fallthrough
	
	          case REACT_LAZY_TYPE:
	            {
	              var _element2 = nextChild;
	              var lazyComponent = nextChild.type; // Attempt to initialize lazy component regardless of whether the
	              // suspense server-side renderer is enabled so synchronously
	              // resolved constructors are supported.
	
	              initializeLazyComponentType(lazyComponent);
	
	              switch (lazyComponent._status) {
	                case Resolved:
	                  {
	                    var _nextChildren9 = [React.createElement(lazyComponent._result, _assign({
	                      ref: _element2.ref
	                    }, _element2.props))];
	                    var _frame9 = {
	                      type: null,
	                      domNamespace: parentNamespace,
	                      children: _nextChildren9,
	                      childIndex: 0,
	                      context: context,
	                      footer: ''
	                    };
	
	                    {
	                      _frame9.debugElementStack = [];
	                    }
	
	                    this.stack.push(_frame9);
	                    return '';
	                  }
	
	                case Rejected:
	                  throw lazyComponent._result;
	
	                case Pending:
	                default:
	                  {
	                    {
	                      throw Error("ReactDOMServer does not yet support lazy-loaded components.");
	                    }
	                  }
	
	              }
	            }
	          // eslint-disable-next-line-no-fallthrough
	
	          case REACT_SCOPE_TYPE:
	            {
	              if (enableScopeAPI) {
	                var _nextChildren10 = toArray(nextChild.props.children);
	
	                var _frame10 = {
	                  type: null,
	                  domNamespace: parentNamespace,
	                  children: _nextChildren10,
	                  childIndex: 0,
	                  context: context,
	                  footer: ''
	                };
	
	                {
	                  _frame10.debugElementStack = [];
	                }
	
	                this.stack.push(_frame10);
	                return '';
	              }
	
	              {
	                {
	                  throw Error("ReactDOMServer does not yet support scope components.");
	                }
	              }
	            }
	        }
	      }
	
	      var info = '';
	
	      {
	        var owner = nextElement._owner;
	
	        if (elementType === undefined || typeof elementType === 'object' && elementType !== null && Object.keys(elementType).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
	        }
	
	        var ownerName = owner ? getComponentName(owner) : null;
	
	        if (ownerName) {
	          info += '\n\nCheck the render method of `' + ownerName + '`.';
	        }
	      }
	
	      {
	        {
	          throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (elementType == null ? elementType : typeof elementType) + "." + info);
	        }
	      }
	    }
	  };
	
	  _proto.renderDOM = function renderDOM(element, context, parentNamespace) {
	    var tag = element.type.toLowerCase();
	    var namespace = parentNamespace;
	
	    if (parentNamespace === Namespaces.html) {
	      namespace = getIntrinsicNamespace(tag);
	    }
	
	    {
	      if (namespace === Namespaces.html) {
	        // Should this check be gated by parent namespace? Not sure we want to
	        // allow <SVG> or <mATH>.
	        !(tag === element.type) ? warning$1(false, '<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', element.type) : void 0;
	      }
	    }
	
	    validateDangerousTag(tag);
	    var props = element.props;
	
	    if (tag === 'input') {
	      {
	        ReactControlledValuePropTypes.checkPropTypes('input', props);
	
	        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
	          warning$1(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', 'A component', props.type);
	          didWarnDefaultChecked = true;
	        }
	
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
	          warning$1(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', 'A component', props.type);
	          didWarnDefaultInputValue = true;
	        }
	      }
	
	      props = _assign({
	        type: undefined
	      }, props, {
	        defaultChecked: undefined,
	        defaultValue: undefined,
	        value: props.value != null ? props.value : props.defaultValue,
	        checked: props.checked != null ? props.checked : props.defaultChecked
	      });
	    } else if (tag === 'textarea') {
	      {
	        ReactControlledValuePropTypes.checkPropTypes('textarea', props);
	
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
	          warning$1(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
	          didWarnDefaultTextareaValue = true;
	        }
	      }
	
	      var initialValue = props.value;
	
	      if (initialValue == null) {
	        var defaultValue = props.defaultValue; // TODO (yungsters): Remove support for children content in <textarea>.
	
	        var textareaChildren = props.children;
	
	        if (textareaChildren != null) {
	          {
	            warning$1(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
	          }
	
	          if (!(defaultValue == null)) {
	            {
	              throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
	            }
	          }
	
	          if (Array.isArray(textareaChildren)) {
	            if (!(textareaChildren.length <= 1)) {
	              {
	                throw Error("<textarea> can only have at most one child.");
	              }
	            }
	
	            textareaChildren = textareaChildren[0];
	          }
	
	          defaultValue = '' + textareaChildren;
	        }
	
	        if (defaultValue == null) {
	          defaultValue = '';
	        }
	
	        initialValue = defaultValue;
	      }
	
	      props = _assign({}, props, {
	        value: undefined,
	        children: '' + initialValue
	      });
	    } else if (tag === 'select') {
	      {
	        ReactControlledValuePropTypes.checkPropTypes('select', props);
	
	        for (var i = 0; i < valuePropNames.length; i++) {
	          var propName = valuePropNames[i];
	
	          if (props[propName] == null) {
	            continue;
	          }
	
	          var isArray = Array.isArray(props[propName]);
	
	          if (props.multiple && !isArray) {
	            warning$1(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.', propName);
	          } else if (!props.multiple && isArray) {
	            warning$1(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.', propName);
	          }
	        }
	
	        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
	          warning$1(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
	          didWarnDefaultSelectValue = true;
	        }
	      }
	
	      this.currentSelectValue = props.value != null ? props.value : props.defaultValue;
	      props = _assign({}, props, {
	        value: undefined
	      });
	    } else if (tag === 'option') {
	      var selected = null;
	      var selectValue = this.currentSelectValue;
	      var optionChildren = flattenOptionChildren(props.children);
	
	      if (selectValue != null) {
	        var value;
	
	        if (props.value != null) {
	          value = props.value + '';
	        } else {
	          value = optionChildren;
	        }
	
	        selected = false;
	
	        if (Array.isArray(selectValue)) {
	          // multiple
	          for (var j = 0; j < selectValue.length; j++) {
	            if ('' + selectValue[j] === value) {
	              selected = true;
	              break;
	            }
	          }
	        } else {
	          selected = '' + selectValue === value;
	        }
	
	        props = _assign({
	          selected: undefined,
	          children: undefined
	        }, props, {
	          selected: selected,
	          children: optionChildren
	        });
	      }
	    }
	
	    {
	      validatePropertiesInDevelopment(tag, props);
	    }
	
	    assertValidProps(tag, props);
	    var out = createOpenTagMarkup(element.type, tag, props, namespace, this.makeStaticMarkup, this.stack.length === 1);
	    var footer = '';
	
	    if (omittedCloseTags.hasOwnProperty(tag)) {
	      out += '/>';
	    } else {
	      out += '>';
	      footer = '</' + element.type + '>';
	    }
	
	    var children;
	    var innerMarkup = getNonChildrenInnerMarkup(props);
	
	    if (innerMarkup != null) {
	      children = [];
	
	      if (newlineEatingTags[tag] && innerMarkup.charAt(0) === '\n') {
	        // text/html ignores the first character in these tags if it's a newline
	        // Prefer to break application/xml over text/html (for now) by adding
	        // a newline specifically to get eaten by the parser. (Alternately for
	        // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	        // \r is normalized out by HTMLTextAreaElement#value.)
	        // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	        // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	        // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	        // See: Parsing of "textarea" "listing" and "pre" elements
	        //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	        out += '\n';
	      }
	
	      out += innerMarkup;
	    } else {
	      children = toArray(props.children);
	    }
	
	    var frame = {
	      domNamespace: getChildNamespace(parentNamespace, element.type),
	      type: tag,
	      children: children,
	      childIndex: 0,
	      context: context,
	      footer: footer
	    };
	
	    {
	      frame.debugElementStack = [];
	    }
	
	    this.stack.push(frame);
	    this.previousWasTextNode = false;
	    return out;
	  };
	
	  return ReactDOMServerRenderer;
	}();
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://reactjs.org/docs/react-dom-server.html#rendertostring
	 */
	
	function renderToString(element) {
	  var renderer = new ReactDOMServerRenderer(element, false);
	
	  try {
	    var markup = renderer.read(Infinity);
	    return markup;
	  } finally {
	    renderer.destroy();
	  }
	}
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://reactjs.org/docs/react-dom-server.html#rendertostaticmarkup
	 */
	
	function renderToStaticMarkup(element) {
	  var renderer = new ReactDOMServerRenderer(element, true);
	
	  try {
	    var markup = renderer.read(Infinity);
	    return markup;
	  } finally {
	    renderer.destroy();
	  }
	}
	
	function renderToNodeStream() {
	  {
	    {
	      throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
	    }
	  }
	}
	
	function renderToStaticNodeStream() {
	  {
	    {
	      throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
	    }
	  }
	} // Note: when changing this, also consider https://github.com/facebook/react/issues/11526
	
	
	var ReactDOMServerBrowser = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup,
	  renderToNodeStream: renderToNodeStream,
	  renderToStaticNodeStream: renderToStaticNodeStream,
	  version: ReactVersion
	};
	
	var ReactDOMServerBrowser$1 = Object.freeze({
		default: ReactDOMServerBrowser
	});
	
	var ReactDOMServer = ( ReactDOMServerBrowser$1 && ReactDOMServerBrowser ) || ReactDOMServerBrowser$1;
	
	// TODO: decide on the top-level export form.
	// This is hacky but makes it work with both Rollup and Jest
	
	
	var server_browser = ReactDOMServer.default || ReactDOMServer;
	
	module.exports = server_browser;
	  })();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(73);
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(75);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pseudoMap = ['hover', 'focus', 'active', 'visited']; /**
	                                                          * just for legao
	                                                          * @author: jiushen
	                                                          */
	// 需要通过 Env 来判断是否需要
	
	var RE_CAMEL = /[A-Z]/g;
	var RE_HYPHEN = /[-\s]+(.)?/g;
	var CSS_REG = /:root(.*)\{.*/i;
	var PROPS_REG = /([^:]*):\s?(.*)/i;
	
	function isString(str) {
	  return {}.toString.call(str) === '[object String]';
	}
	
	function hyphenate(str) {
	  return str.replace(RE_CAMEL, function (w) {
	    return '-' + w;
	  }).toLowerCase();
	}
	
	function camelize(str) {
	  return str.replace(RE_HYPHEN, function (m, w) {
	    return w ? w.toUpperCase() : '';
	  });
	}
	/**
	 * convert
	 * {background-color: "red"}
	 * to
	 * background-color: red;
	 */
	function runtimeToCss(runtime) {
	  var css = [];
	  Object.keys(runtime).forEach(function (key) {
	    css.push('  ' + key + ': ' + runtime[key] + ';');
	  });
	  return css.join('\n');
	}
	
	function toNativeStyle(runtime) {
	  if (!runtime) {
	    return {};
	  }
	  if (runtime.default) {
	    var _normalized = {};
	    Object.keys(runtime).forEach(function (pseudo) {
	      _normalized[pseudo] = toNativeStyle(runtime[pseudo]);
	    });
	    return _normalized;
	  }
	
	  var normalized = {};
	  Object.keys(runtime).forEach(function (key) {
	    normalized[camelize(key)] = runtime[key];
	  });
	  return normalized;
	}
	
	function normalizeStyle(style) {
	  if (!style) {
	    return {};
	  }
	  if (style.default) {
	    var _normalized2 = {};
	    Object.keys(style).forEach(function (pseudo) {
	      _normalized2[pseudo] = normalizeStyle(style[pseudo]);
	    });
	    return _normalized2;
	  }
	
	  var normalized = {};
	  Object.keys(style).forEach(function (key) {
	    normalized[hyphenate(key)] = style[key];
	  });
	  return normalized;
	}
	
	function toCss(runtime) {
	  if (!runtime) {
	    return ':root {\n\n}';
	  }
	
	  if (runtime.default) {
	    var css = [];
	    Object.keys(runtime).forEach(function (pseudo) {
	      // 只需要对这四种做兼容
	      var prefix = pseudoMap.indexOf(pseudo) > -1 ? ':' : '';
	      css.push(':root' + (pseudo === 'default' ? '' : '' + prefix + pseudo) + ' {\n' + runtimeToCss(normalizeStyle(runtime[pseudo])) + '\n}\n');
	    });
	    return css.join('\n');
	  }
	
	  return ':root {\n' + runtimeToCss(normalizeStyle(runtime)) + '\n}\n';
	}
	
	function cssToRuntime(css) {
	  if (!css) {
	    return {};
	  }
	  var runtime = {};
	
	  if (CSS_REG.test(css)) {
	    var cssArr = css.trim().replace(/[\r\n]+/ig, '').split('}');
	    cssArr.forEach(function (rule) {
	      var res = /:root:?(.*)?{(.*)/ig.exec(rule.trim());
	      if (res) {
	        var pseudo = void 0;
	
	        if (res[1] && res[1].trim() && (0, _lodash2.default)(pseudoMap, function (pse) {
	          return res[1].indexOf(pse) === 0;
	        })) {
	          pseudo = res[1].trim();
	        } else if (res[1] && res[1].trim()) {
	          pseudo = res[1];
	        }
	
	        var s = {};
	        res[2].split(';').forEach(function (item) {
	          if (item) {
	            if (PROPS_REG.test(item)) {
	              var props = item.match(PROPS_REG);
	              var key = props[1];
	              var value = props[2];
	              if (key && value) {
	                s[key.trim()] = value.trim();
	              }
	            }
	          }
	        });
	
	        if (!pseudo) {
	          pseudo = 'default';
	        }
	        runtime[pseudo] = s;
	      }
	    });
	  }
	  return runtime;
	}
	
	function cssToStyle(css) {
	  try {
	    if (isString(css)) {
	      return toNativeStyle(cssToRuntime(css).default);
	    }
	    if (css.default) {
	      return toNativeStyle(normalizeStyle(css.default));
	    }
	    return toNativeStyle(normalizeStyle(css));
	  } catch (e) {}
	  return {};
	}
	
	exports.default = {
	  hyphenate: hyphenate,
	  camelize: camelize,
	  toNativeStyle: toNativeStyle,
	  normalizeStyle: normalizeStyle,
	  toCss: toCss,
	  cssToRuntime: cssToRuntime,
	  cssToStyle: cssToStyle
	};
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = some;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(76)(module)))

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function getWindow(elem) {
	    return elem && (elem.window === elem ? elem : (elem.nodeType === 9 && elem.defaultView));
	}
	function createApplier(elem) {
	    var win = getWindow(elem);
	    return function (val) {
	        if (val == null) {
	            return win ? win.pageYOffset : elem.scrollTop;
	        }
	        if (win) {
	            win.scrollTo(win.pageXOffset, val);
	        }
	        else {
	            elem.scrollTop = val;
	        }
	        return null;
	    };
	}
	function easing(n) {
	    return Math.sin(n * Math.PI / 2);
	}
	var Scroller = /** @class */ (function () {
	    function Scroller(area, target) {
	        this.area = area;
	        this.applier = createApplier(target);
	    }
	    Scroller.prototype.scrollTo = function (val) {
	        var _this = this;
	        if (this.inscrolling) {
	            return;
	        }
	        if (this.pid) {
	            this.cancel();
	        }
	        var pid;
	        var initVal = this.applier();
	        var end = function () {
	            _this.cancel();
	        };
	        if (initVal === val) {
	            end();
	            return;
	        }
	        var duration = 200;
	        var start = +new Date();
	        var animate = function () {
	            if (pid !== _this.pid) {
	                return;
	            }
	            var now = +new Date();
	            var time = Math.min(1, ((now - start) / duration));
	            var eased = easing(time);
	            _this.applier((eased * (val - initVal)) + initVal);
	            if (time < 1) {
	                _this.pid = pid = requestAnimationFrame(animate);
	            }
	            else {
	                end();
	            }
	        };
	        this.pid = pid = requestAnimationFrame(animate);
	    };
	    Scroller.prototype.scrolling = function (e) {
	        var _this = this;
	        this.cancel();
	        if (!e) {
	            return;
	        }
	        this.inscrolling = true;
	        var st;
	        var a;
	        var animate;
	        var y = e.clientY;
	        var bounds = this.area.getBounds();
	        if (!bounds) {
	            return;
	        }
	        var maxScrollHeight = this.area.getScrollHeight() - bounds.height;
	        if (y < bounds.top + 20) {
	            st = this.applier();
	            a = -Math.min(Math.max(bounds.top + 20 - y, 10), 50);
	            animate = function () {
	                if (st <= 0) {
	                    return;
	                }
	                st += a;
	                _this.applier(Math.max(st, 0));
	                _this.pid = requestAnimationFrame(animate);
	            };
	        }
	        else if (y > bounds.bottom - 20) {
	            st = this.applier();
	            a = Math.min(Math.max(y + 20 - bounds.bottom, 10), 50);
	            animate = function () {
	                if (st >= maxScrollHeight) {
	                    return;
	                }
	                st += a;
	                _this.applier(Math.min(st, maxScrollHeight));
	                _this.pid = requestAnimationFrame(animate);
	            };
	        }
	        if (animate) {
	            animate();
	        }
	    };
	    Scroller.prototype.cancel = function () {
	        if (this.pid) {
	            cancelAnimationFrame(this.pid);
	        }
	        this.pid = null;
	        this.inscrolling = false;
	    };
	    return Scroller;
	}());
	exports.default = Scroller;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	function getFloatingNodes(node) {
	    var nodes = [];
	    var prototype = node.getPrototype();
	    if (prototype && prototype.isFloating()) {
	        nodes.push(node);
	    }
	    var children = node.getChildren();
	    if (children) {
	        children.forEach(function (child) {
	            nodes = nodes.concat(getFloatingNodes(child));
	        });
	    }
	    return nodes;
	}
	var FloatingNodesManager = /** @class */ (function () {
	    function FloatingNodesManager(page) {
	        var _this = this;
	        this.page = page;
	        this.emitter = new EventEmitter();
	        this.setNodes();
	        this.willDestroy = [
	            page.onNodeCreate(function (node) { return _this.addNode(node); }),
	            page.onNodeDestroy(function (node) { return _this.removeNode(node); }),
	        ];
	    }
	    FloatingNodesManager.prototype.getFloatingNodes = function () {
	        return this.floatingNodes;
	    };
	    FloatingNodesManager.prototype.getVisibleFloatingNodes = function () {
	        var visibleNodes = this.floatingNodes
	            ? this.floatingNodes.filter(function (node) {
	                return !!node.getStatus('visibility');
	            })
	            : null;
	        return visibleNodes;
	    };
	    FloatingNodesManager.prototype.onFloatingNodesChange = function (func) {
	        var _this = this;
	        this.emitter.on('floatingNodesChange', func);
	        return function () {
	            _this.emitter.removeListener('floatingNodesChange', func);
	        };
	    };
	    FloatingNodesManager.prototype.addNode = function (node) {
	        var _this = this;
	        var prototype = node.getPrototype();
	        if (prototype && prototype.isFloating()) {
	            this.floatingNodes.push(node);
	            this.emitter.emit('floatingNodesChange');
	        }
	        var children = node.getChildren();
	        if (children && children.length > 0) {
	            children.forEach(function (child) {
	                _this.addNode(child);
	            });
	        }
	    };
	    FloatingNodesManager.prototype.removeNode = function (node) {
	        var prototype = node.getPrototype();
	        if (prototype && prototype.isFloating()) {
	            var index = this.floatingNodes.indexOf(node);
	            if (index >= 0) {
	                this.floatingNodes.splice(index, 1);
	            }
	            this.emitter.emit('floatingNodesChange');
	        }
	    };
	    FloatingNodesManager.prototype.setNodes = function () {
	        var nodes = getFloatingNodes(this.page.getRoot());
	        this.floatingNodes = nodes;
	        this.emitter.emit('floatingNodesChange');
	    };
	    return FloatingNodesManager;
	}());
	exports.default = FloatingNodesManager;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var EventEmitter = __webpack_require__(11);
	var bus_1 = __webpack_require__(36);
	var overlay_1 = __webpack_require__(16);
	var session_1 = __webpack_require__(80);
	var History = /** @class */ (function () {
	    function History(logger, redoer) {
	        this.logger = logger;
	        this.redoer = redoer;
	        this.session = new session_1.default(0, 'Open', logger());
	        this.records = [this.session];
	        this.session.end();
	        this.point = 0;
	        this.bus = new bus_1.default();
	        this.emitter = new EventEmitter();
	    }
	    History.prototype.getRecords = function () {
	        return this.records;
	    };
	    History.prototype.getCurrentCursor = function () {
	        return this.session.getCursor();
	    };
	    History.prototype.getHotData = function () {
	        return this.session.getData();
	    };
	    History.prototype.isModified = function () {
	        return this.point !== this.session.getCursor();
	    };
	    History.prototype.log = function (title) {
	        if (!this.session) {
	            return;
	        }
	        var currentHotData = this.session.getData();
	        var hotData = this.logger(currentHotData);
	        if (hotData.equals(currentHotData)) {
	            return;
	        }
	        if (this.session.isActive()) {
	            this.session.log(title, hotData);
	        }
	        else {
	            this.session.end();
	            var cursor = this.session.getCursor() + 1;
	            var session = new session_1.default(cursor, title, hotData);
	            this.session = session;
	            this.records.splice(cursor, this.records.length - cursor, session);
	        }
	        overlay_1.default.touch(true);
	        this.emitter.emit('statechange', this.getState());
	    };
	    History.prototype.go = function (cursor) {
	        if (!this.session) {
	            return;
	        }
	        this.session.end();
	        var currentCursor = this.session.getCursor();
	        cursor = +cursor;
	        if (cursor < 0) {
	            cursor = 0;
	        }
	        else if (cursor >= this.records.length) {
	            cursor = this.records.length - 1;
	        }
	        if (cursor === currentCursor) {
	            return;
	        }
	        var session = this.records[cursor];
	        var hotData = session.getData();
	        this.session = null;
	        try {
	            this.redoer(hotData);
	            this.emitter.emit('cursor', hotData);
	        }
	        catch (e) {
	            vu_logger_1.default.error('ERROR: redo action ', e);
	        }
	        this.session = session;
	        if (vu_logger_1.default.getEnv() !== 'production') {
	            console.groupCollapsed("Cursor(" + cursor + ") " + session.getTitle());
	            console.log("%c " + session.getTitle(), 'color:#9E9E9E;font-weight:bold;line-height:19px', hotData.toJS());
	            console.groupEnd();
	        }
	        overlay_1.default.touch(true);
	        this.emitter.emit('statechange', this.getState());
	    };
	    History.prototype.back = function () {
	        if (!this.session) {
	            return;
	        }
	        var cursor = this.getCurrentCursor() - 1;
	        this.bus.emit('ve.history.back', cursor);
	        this.go(cursor);
	    };
	    History.prototype.forward = function () {
	        if (!this.session) {
	            return;
	        }
	        var cursor = this.getCurrentCursor() + 1;
	        this.bus.emit('ve.history.forward', cursor);
	        this.go(cursor);
	    };
	    History.prototype.savePoint = function () {
	        if (!this.session) {
	            return;
	        }
	        this.session.end();
	        this.point = this.session.getCursor();
	        this.emitter.emit('statechange', this.getState());
	    };
	    /**
	     *  |    1     |     1    |    1     |
	     *  | -------- | -------- | -------- |
	     *  | modified | redoable | undoable |
	     *
	     * @returns {number}
	     */
	    History.prototype.getState = function () {
	        var cursor = this.session.getCursor();
	        var state = 7;
	        // undoable ?
	        if (cursor <= 0) {
	            state -= 1;
	        }
	        // redoable ?
	        if (cursor >= this.records.length - 1) {
	            state -= 2;
	        }
	        // modified ?
	        if (this.point === cursor) {
	            state -= 4;
	        }
	        return state;
	    };
	    History.prototype.onStateChange = function (func) {
	        var _this = this;
	        this.emitter.on('statechange', func);
	        return function () {
	            _this.emitter.removeListener('statechange', func);
	        };
	    };
	    History.prototype.onCursor = function (func) {
	        var _this = this;
	        this.emitter.on('cursor', func);
	        return function () {
	            _this.emitter.removeListener('cursor', func);
	        };
	    };
	    History.prototype.destroy = function () {
	        this.emitter.removeAllListeners();
	        this.records = [];
	    };
	    return History;
	}());
	exports.default = History;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	var Session = /** @class */ (function () {
	    function Session(cursor, title, data) {
	        this.cursor = cursor;
	        this.title = title;
	        if (vu_logger_1.default.getEnv() !== 'production') {
	            /* tslint:disable no-console */
	            console.groupCollapsed("History(" + cursor + ") " + title);
	        }
	        this.setTimer();
	        this.log(title, data);
	    }
	    Session.prototype.getCursor = function () {
	        return this.cursor;
	    };
	    Session.prototype.getTitle = function () {
	        return this.title;
	    };
	    Session.prototype.getData = function () {
	        return this.data;
	    };
	    Session.prototype.setTimer = function () {
	        var _this = this;
	        this.clearTimer();
	        this.activedTimer = window.setTimeout(function () { return _this.end(); }, Session.TIME_GAP_TO_LOG);
	    };
	    Session.prototype.clearTimer = function () {
	        if (this.activedTimer) {
	            clearTimeout(this.activedTimer);
	        }
	        this.activedTimer = null;
	    };
	    Session.prototype.log = function (title, data) {
	        if (!this.isActive()) {
	            return;
	        }
	        this.data = data;
	        if (vu_logger_1.default.getEnv() !== 'production') {
	            console.log("%c " + title, 'color:#03A9F4;font-weight:bold;line-height:19px', data.toJS && data.toJS());
	        }
	        this.setTimer();
	    };
	    Session.prototype.isActive = function () {
	        return this.activedTimer != null;
	    };
	    Session.prototype.end = function () {
	        this.clearTimer();
	        if (vu_logger_1.default.getEnv() !== 'production') {
	            try {
	                console.groupEnd();
	            }
	            catch (e) {
	                console.log('—— log end ——');
	            }
	        }
	    };
	    Session.TIME_GAP_TO_LOG = 1000;
	    return Session;
	}());
	exports.default = Session;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventEmitter = __webpack_require__(11);
	function getModalNodes(node) {
	    var nodes = [];
	    var prototype = node.getPrototype();
	    if (prototype && prototype.isModal()) {
	        nodes.push(node);
	    }
	    var children = node.getChildren();
	    if (children) {
	        children.forEach(function (child) {
	            nodes = nodes.concat(getModalNodes(child));
	        });
	    }
	    return nodes;
	}
	var ModalNodesManager = /** @class */ (function () {
	    function ModalNodesManager(page) {
	        var _this = this;
	        this.page = page;
	        this.emitter = new EventEmitter();
	        this.nodeRemoveEvents = {};
	        this.setNodes();
	        this.hideModalNodes();
	        this.willDestroy = [
	            page.onNodeCreate(function (node) { return _this.addNode(node); }),
	            page.onNodeDestroy(function (node) { return _this.removeNode(node); }),
	        ];
	    }
	    ModalNodesManager.prototype.getModalNodes = function () {
	        return this.modalNodes;
	    };
	    ModalNodesManager.prototype.getVisibleModalNode = function () {
	        var visibleNode = this.modalNodes
	            ? this.modalNodes.find(function (node) {
	                return !!node.getStatus('visibility');
	            })
	            : null;
	        return visibleNode;
	    };
	    ModalNodesManager.prototype.hideModalNodes = function () {
	        if (this.modalNodes) {
	            this.modalNodes.forEach(function (node) {
	                node.setStatus('visibility', false);
	            });
	        }
	    };
	    ModalNodesManager.prototype.setVisible = function (node) {
	        this.hideModalNodes();
	        node.setStatus('visibility', true);
	    };
	    ModalNodesManager.prototype.setInvisible = function (node) {
	        node.setStatus('visibility', false);
	    };
	    ModalNodesManager.prototype.onVisibleChange = function (func) {
	        var _this = this;
	        this.emitter.on('visibleChange', func);
	        return function () {
	            _this.emitter.removeListener('visibleChange', func);
	        };
	    };
	    ModalNodesManager.prototype.onModalNodesChange = function (func) {
	        var _this = this;
	        this.emitter.on('modalNodesChange', func);
	        return function () {
	            _this.emitter.removeListener('modalNodesChange', func);
	        };
	    };
	    ModalNodesManager.prototype.addNode = function (node) {
	        var prototype = node.getPrototype();
	        if (prototype && prototype.isModal()) {
	            this.hideModalNodes();
	            this.modalNodes.push(node);
	            this.addNodeEvent(node);
	            this.emitter.emit('modalNodesChange');
	            this.emitter.emit('visibleChange');
	        }
	    };
	    ModalNodesManager.prototype.removeNode = function (node) {
	        var prototype = node.getPrototype();
	        if (prototype && prototype.isModal()) {
	            var index = this.modalNodes.indexOf(node);
	            if (index >= 0) {
	                this.modalNodes.splice(index, 1);
	            }
	            this.removeNodeEvent(node);
	            this.emitter.emit('modalNodesChange');
	            if (node.getStatus('visibility')) {
	                this.emitter.emit('visibleChange');
	            }
	        }
	    };
	    ModalNodesManager.prototype.addNodeEvent = function (node) {
	        var _this = this;
	        this.nodeRemoveEvents[node.getId()] =
	            node.onStatusChange(function (status, field) {
	                if (field === 'visibility') {
	                    _this.emitter.emit('visibleChange');
	                }
	            });
	    };
	    ModalNodesManager.prototype.removeNodeEvent = function (node) {
	        if (this.nodeRemoveEvents[node.getId()]) {
	            this.nodeRemoveEvents[node.getId()]();
	            delete this.nodeRemoveEvents[node.getId()];
	        }
	    };
	    ModalNodesManager.prototype.setNodes = function () {
	        var _this = this;
	        var nodes = getModalNodes(this.page.getRoot());
	        this.modalNodes = nodes;
	        this.modalNodes.forEach(function (node) {
	            _this.addNodeEvent(node);
	        });
	        this.emitter.emit('modalNodesChange');
	    };
	    return ModalNodesManager;
	}());
	exports.default = ModalNodesManager;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var containerNode_1 = __webpack_require__(83);
	var node_1 = __webpack_require__(39);
	var Root = /** @class */ (function (_super) {
	    __extends(Root, _super);
	    function Root() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Root.prototype.setParent = function () {
	    };
	    Root.prototype.getRoot = function () {
	        return this;
	    };
	    Root.prototype.isRoot = function () {
	        return true;
	    };
	    Root.prototype.getComponentName = function () {
	        return this.proto ? this.proto.getComponentName() : (this.componentName || 'Page');
	    };
	    Root.prototype.findNode = function (elem) {
	        return _super.prototype.findNode.call(this, elem) || this;
	    };
	    Root.prototype.getRect = function () {
	        return this.getPage().getBounds();
	    };
	    Root.prototype.remove = function () {
	    };
	    Root.prototype.clone = function () {
	    };
	    return Root;
	}(containerNode_1.default));
	exports.default = Root;
	Object.defineProperty(node_1.Node, 'Root', {
	    value: Root,
	});


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ve_utils_1 = __webpack_require__(4);
	var node_1 = __webpack_require__(39);
	var lifeCycleNames = [
	    'constructor', 'didMount', 'willUnmount',
	];
	function fetchLifeCyclesToRoot(data) {
	    var props = data && data.props;
	    if (props) {
	        lifeCycleNames.forEach(function (lifeCycleName) {
	            var value = props[lifeCycleName];
	            if (props.hasOwnProperty(lifeCycleName) && value) {
	                if (!data.lifeCycles) {
	                    data.lifeCycles = {};
	                }
	                if (typeof value === 'string') {
	                    value = {
	                        type: 'js',
	                        compiled: value,
	                        source: value,
	                    };
	                }
	                data.lifeCycles[lifeCycleName] = value;
	            }
	            delete props[lifeCycleName];
	        });
	    }
	}
	function fetchLifeCyclesToProps(data) {
	    var result = __assign({}, data);
	    var lifeCycles = result && result.lifeCycles;
	    if (lifeCycles && Object.keys(lifeCycles).length > 0) {
	        if (!result.props) {
	            result.props = {};
	        }
	        else {
	            result.props = __assign({}, result.props);
	        }
	        Object.keys(lifeCycles).forEach(function (lifeCycleName) {
	            result.props[lifeCycleName] = lifeCycles[lifeCycleName];
	        });
	        delete result.lifeCycles;
	    }
	    return result;
	}
	/**
	 * 容器组件节点（Page、Block、Component）
	 */
	var addonNames = ['css', 'state', 'dataSource', 'methods'];
	var ContainerNode = /** @class */ (function (_super) {
	    __extends(ContainerNode, _super);
	    function ContainerNode(page, data, parent, options) {
	        var _this = _super.call(this, page, data, parent, options) || this;
	        var id = data.id, componentName = data.componentName, props = data.props, children = data.children, lifeCycles = data.lifeCycles, rawAddons = __rest(data, ["id", "componentName", "props", "children", "lifeCycles"]);
	        _this.rawAddons = rawAddons || {};
	        _this.addons = {};
	        return _this;
	    }
	    ContainerNode.prototype.toData = function () {
	        var superData = ve_utils_1.cloneDeep(_super.prototype.toData.call(this));
	        fetchLifeCyclesToRoot(superData);
	        return __assign(__assign({}, superData), this.exportAddonData());
	    };
	    ContainerNode.prototype.registerAddon = function (name, exportData) {
	        if (addonNames.indexOf(name) < 0) {
	            var nameListString = Object.keys(addonNames).join(',');
	            throw new Error("node addon name must one of [" + nameListString + "]");
	        }
	        if (this.addons[name]) {
	            throw new Error("node addon " + name + " exist");
	        }
	        this.addons[name] = exportData;
	    };
	    ContainerNode.prototype.getAddonData = function (name) {
	        var addon = this.addons[name];
	        if (addon) {
	            return addon();
	        }
	        return this.rawAddons[name];
	    };
	    ContainerNode.prototype.transformInitData = function (data) {
	        return fetchLifeCyclesToProps(data);
	    };
	    ContainerNode.prototype.exportAddonData = function () {
	        var _this = this;
	        var addons = __assign({}, this.rawAddons);
	        Object.keys(this.addons).forEach(function (name) {
	            var data = _this.addons[name]();
	            if (data) {
	                addons[name] = data;
	            }
	        });
	        return addons;
	    };
	    return ContainerNode;
	}(node_1.Node));
	exports.default = ContainerNode;
	ContainerNode.Root = node_1.Node.Root;
	ContainerNode.Props = node_1.Node.Props;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _vuStyleProcessor = __webpack_require__(1);
	
		var _vuStyleProcessor2 = _interopRequireDefault(_vuStyleProcessor);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window:true document:true */
	
	
		function memoize(fn) {
		  var memo = void 0;
		  return function memofiy() {
		    if (memo == null) memo = fn();
		    return memo;
		  };
		}
	
		var isOldIE = memoize(function () {
		  return (/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())
		  );
		});
		var singletonCssText = [];
		var singletonCounter = 0;
		var singletonStyleElement = null;
	
		function getClassName(selector) {
		  var m = /^\.(.*)$/.exec(selector);
		  if (m) {
		    return m[1];
		  }
		  return null;
		}
	
		function replaceSingletonCssText(index, replacement) {
		  singletonCssText[index] = replacement;
		  return singletonCssText.filter(Boolean).join('\n');
		}
	
		var Storage = function () {
		  function Storage() {
		    _classCallCheck(this, Storage);
	
		    this.styleElement = _vuStyleProcessor2.default.createStyleElement();
		  }
	
		  Storage.prototype.write = function write(css) {
		    var styleElement = this.styleElement;
		    if (styleElement.styleSheet) {
		      styleElement.styleSheet.cssText = css;
		    } else {
		      while (styleElement.firstChild) {
		        styleElement.removeChild(styleElement.firstChild);
		      }
		      styleElement.appendChild(document.createTextNode(css));
		    }
		  };
	
		  Storage.prototype.remove = function remove() {
		    var styleElement = this.styleElement;
		    styleElement.parentNode.removeChild(styleElement);
		  };
	
		  return Storage;
		}();
	
		var SingletonStorage = function () {
		  function SingletonStorage() {
		    _classCallCheck(this, SingletonStorage);
	
		    this.index = singletonCounter++;
		    if (!singletonStyleElement) {
		      singletonStyleElement = _vuStyleProcessor2.default.createStyleElement();
		    }
		    this.styleElement = singletonStyleElement;
		  }
	
		  SingletonStorage.prototype.write = function write(css) {
		    var index = this.index;
		    var styleElement = this.styleElement;
		    if (styleElement.styleSheet) {
		      styleElement.styleSheet.cssText = replaceSingletonCssText(index, css);
		    } else {
		      var cssNode = document.createTextNode(css);
		      var childNodes = styleElement.childNodes;
		      if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		      if (childNodes.length) {
		        styleElement.insertBefore(cssNode, childNodes[index]);
		      } else {
		        styleElement.appendChild(cssNode);
		      }
		    }
		  };
	
		  SingletonStorage.prototype.remove = function remove() {
		    this.write('');
		  };
	
		  return SingletonStorage;
		}();
	
		var StyleSheet = function () {
		  function StyleSheet() {
		    var _this = this;
	
		    _classCallCheck(this, StyleSheet);
	
		    this.maps = {};
		    this.precache = {};
		    this.ready = false;
		    this.isSingleton = isOldIE();
		    _vuStyleProcessor2.default.ready(function () {
		      return _this.prepare();
		    });
		  }
	
		  StyleSheet.prototype.setDesignMode = function setDesignMode(flag) {
		    _vuStyleProcessor2.default.setDesignMode(flag);
		  };
	
		  StyleSheet.prototype.setNamespace = function setNamespace(namespace) {
		    _vuStyleProcessor2.default.setNamespace(namespace);
		  };
	
		  StyleSheet.prototype.prepare = function prepare() {
		    this.ready = true;
		    for (var selector in this.precache) {
		      if (this.precache.hasOwnProperty(selector)) {
		        this.write(selector, this.precache[selector]);
		      }
		    }
		    this.precache = null;
		  };
	
		  StyleSheet.prototype.cache = function cache(selector, css) {
		    this.precache[selector] = css;
		  };
	
		  StyleSheet.prototype.write = function write(selector, css) {
		    if (!css) {
		      this.remove(selector);
		      return;
		    }
	
		    var storage = this.getStorage(selector);
		    storage.write(css);
		  };
	
		  StyleSheet.prototype.getStorage = function getStorage(selector) {
		    if (!this.maps[selector]) {
		      this.maps[selector] = this.isSingleton ? new SingletonStorage() : new Storage();
		    }
		    return this.maps[selector];
		  };
	
		  StyleSheet.prototype.remove = function remove(selector) {
		    var storage = this.maps[selector];
		    if (storage) {
		      storage.remove();
		      this.maps[selector] = null;
		    }
		  };
	
		  StyleSheet.prototype.clear = function clear() {
		    if (this.ready) {
		      for (var selector in this.maps) {
		        if (this.maps.hasOwnProperty(selector)) {
		          this.remove(selector);
		        }
		      }
		    } else {
		      this.precache = {};
		    }
		  };
	
		  // selector must be unique
	
	
		  StyleSheet.prototype.invoke = function invoke(selector, styles, className) {
		    /**
		     * styles = {
		     *   default: {},
		     *   hover: {},
		     *   focus: {},
		     *   active: {},
		     * }
		     * css = 'selector{}, selector:hover {}'
		     */
		    if (className && !_vuStyleProcessor2.default.isDesignMode()) {
		      return className;
		    }
		    if (!styles) {
		      return null;
		    }
		    var css = _vuStyleProcessor2.default.createCss(selector, styles);
		    if (this.ready) {
		      this.write(selector, css);
		    } else {
		      this.cache(selector, css);
		    }
		    return getClassName(selector);
		  };
	
		  return StyleSheet;
		}();
	
		if (!window.__visionStyleSheet) {
		  window.__visionStyleSheet = new StyleSheet();
		}
	
		exports.default = new StyleSheet();
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(85);
	
	/***/ }
	/******/ ]);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _domready = __webpack_require__(24);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _tocss = __webpack_require__(86);
	
	var _tocss2 = _interopRequireDefault(_tocss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window:true document:true */
	
	
	function memoize(fn) {
	  var memo = void 0;
	  return function memofiy() {
	    if (memo == null) memo = fn();
	    return memo;
	  };
	}
	
	var getHeadElement = memoize(function () {
	  return document.head || document.getElementsByTagName('head')[0];
	});
	var previousGlobalStyleElement = null;
	
	function beautifulClassName(componentName, id) {
	  return componentName.toLowerCase() + id.replace('node_', '-');
	}
	
	function insertStyleElement(styleElement) {
	  getHeadElement().appendChild(styleElement);
	}
	
	function _createStyleElement() {
	  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var styleElement = document.createElement('style');
	  styleElement.type = 'text/css';
	  styleElement.setAttribute('from', from);
	  insertStyleElement(styleElement);
	  return styleElement;
	}
	
	function removeGlobalCss() {
	  if (previousGlobalStyleElement) {
	    previousGlobalStyleElement.parentNode.removeChild(previousGlobalStyleElement);
	    previousGlobalStyleElement = null;
	  }
	}
	
	function writeGlobalCss(css) {
	  removeGlobalCss();
	  previousGlobalStyleElement = _createStyleElement('render-engine');
	  if (previousGlobalStyleElement.styleSheet) {
	    previousGlobalStyleElement.styleSheet.cssText = css;
	  } else {
	    previousGlobalStyleElement.appendChild(document.createTextNode(css));
	  }
	}
	
	var StyleProcessor = function () {
	  function StyleProcessor() {
	    var _this = this;
	
	    _classCallCheck(this, StyleProcessor);
	
	    this.cssCollection = [];
	    this.readyTask = [];
	    this.isReady = false;
	    if (getHeadElement()) {
	      this.prepare();
	    } else {
	      (0, _domready2.default)(function () {
	        return _this.prepare();
	      });
	    }
	  }
	
	  StyleProcessor.prototype.setNamespace = function setNamespace(namespace) {
	    // this.namespace = namespace;
	  };
	
	  StyleProcessor.prototype.setDesignMode = function setDesignMode(flag) {
	    this.designMode = flag;
	  };
	
	  StyleProcessor.prototype.isDesignMode = function isDesignMode() {
	    return this.designMode;
	  };
	
	  StyleProcessor.prototype.prepare = function prepare() {
	    this.isReady = true;
	    var doe = document.documentElement;
	    if (!doe.id) {
	      doe.id = 'rehtml-' + (+new Date()).toString(36);
	    }
	    this.namespace = '#' + doe.id;
	    var fn = void 0;
	    while ((fn = this.readyTask.shift()) != null) {
	      // eslint-disable-line
	      fn();
	    }
	  };
	
	  StyleProcessor.prototype.createCss = function createCss(selector, styles) {
	    var _this2 = this;
	
	    if (!styles) {
	      return '';
	    }
	    if (this.namespace && selector[0] === '.') {
	      selector = this.namespace + ' ' + selector;
	    }
	    if ({}.toString.call(styles) === '[object String]') {
	      if (/:root/ig.test(styles)) {
	        return styles.replace(/:root/ig, selector);
	      }
	      return selector + '{' + styles + '}';
	    }
	    if (styles.default) {
	      var css = [];
	      css.push(selector + '{' + (0, _tocss2.default)(styles.default) + '}');
	      ['hover', 'focus', 'active'].forEach(function (state) {
	        if (styles.hasOwnProperty(state)) {
	          var selectorStr = _this2.designMode ? selector + ':' + state + ',' + selector + '.-pseudo-' + state : selector + ':' + state;
	          css.push(selectorStr + '{' + (0, _tocss2.default)(styles[state]) + '}');
	        }
	      });
	      return css.join('\n');
	    }
	
	    return selector + '{' + (0, _tocss2.default)(styles) + '}';
	  };
	
	  StyleProcessor.prototype.addCssText = function addCssText(text) {
	    var i = this.cssCollection.indexOf(text);
	    if (i < 0) {
	      this.cssCollection.push(text);
	    }
	  };
	
	  StyleProcessor.prototype.clearCollection = function clearCollection() {
	    this.cssCollection = [];
	  };
	
	  StyleProcessor.prototype.collectStyle = function collectStyle(id, componentName, props) {
	    var className = beautifulClassName(componentName, id);
	    props.className = className;
	    if (props.style) {
	      this.addCssText(this.createCss('.' + className, props.style));
	    } else if (props.containerStyle) {
	      this.addCssText(this.createCss('.' + className, props.containerStyle));
	    }
	    if (props.itemStyle) {
	      this.addCssText(this.createCss('.' + className + '-item', props.itemStyle));
	    }
	    if (props.pageStyle) {
	      this.addCssText(this.createCss('body', props.pageStyle));
	    }
	  };
	
	  StyleProcessor.prototype.applyStyle = function applyStyle() {
	    var css = this.cssCollection.join('\n');
	    this.ready(function () {
	      return writeGlobalCss(css);
	    });
	  };
	
	  StyleProcessor.prototype.removeStyle = function removeStyle() {
	    removeGlobalCss();
	    return this;
	  };
	
	  StyleProcessor.prototype.ready = function ready(func) {
	    if (this.isReady) {
	      func();
	      return;
	    }
	    this.readyTask.push(func);
	  };
	
	  StyleProcessor.prototype.createStyleElement = function createStyleElement(from) {
	    return _createStyleElement(from);
	  };
	
	  return StyleProcessor;
	}();
	
	if (!window.__visionStyleProcessor) {
	  window.__visionStyleProcessor = new StyleProcessor();
	}
	
	exports.default = window.__visionStyleProcessor;
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = toCss;
	
	var _inlineStylePrefixer = __webpack_require__(87);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixer = new _inlineStylePrefixer2.default(typeof navigator !== 'undefined' && navigator || { userAgent: 'Chrome/20.0.1216.0' });
	
	var AutoUnitless = ['animation', 'columnCount', 'columns', 'fontWeight', 'opacity', 'order', 'zIndex', 'zoom', 'flex', 'boxFlex', 'transform', 'perspective', 'boxPack', 'boxAlign', 'colspan', 'rowspan', 'lineHeight', 'WebkitLineClamp'];
	
	var RE_CAMEL = /[A-Z]/g;
	var RE_HYPHEN = /[-\s]+(.)?/g;
	
	function hyphenate(str) {
	  return str.replace(RE_CAMEL, function (w) {
	    return '-' + w;
	  }).toLowerCase();
	}
	
	function camelize(str) {
	  return str.replace(RE_HYPHEN, function (m, w) {
	    return w ? w.toUpperCase() : '';
	  });
	}
	
	var objectHasOwn = Object.prototype.hasOwnProperty;
	
	function hasOwn(object, propertyName) {
	  return objectHasOwn.call(object, propertyName);
	}
	
	function isNumeric(val) {
	  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	  return type === 'number' || type === 'string' && val !== '' && val * 1 == val;
	}
	
	function toObject(styles) {
	  var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var key = void 0;
	  var value = void 0;
	  var property = void 0;
	  for (key in styles) {
	    if (!hasOwn(styles, key)) {
	      continue;
	    }
	
	    value = styles[key];
	    property = camelize(prepend ? prepend + key : key);
	
	    if (value == null || property == null || property === '') {
	      continue;
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      toObject(value, property + '-', result);
	      continue;
	    }
	
	    if (isNumeric(value) && AutoUnitless.indexOf(property) < 0) {
	      value = value + 'px';
	    }
	
	    result[property] = value;
	  }
	
	  return result;
	}
	
	function toCss(styles) {
	  var prefixed = prefixer.prefix(toObject(styles));
	  var collection = [];
	
	  var key = void 0;
	  for (key in prefixed) {
	    if (hasOwn(prefixed, key)) {
	      collection.push(hyphenate(key) + ':' + prefixed[key]);
	    }
	  }
	
	  return collection.join(';');
	}
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(88);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(105);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(108);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(90);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(91);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _prefixProps = __webpack_require__(109);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _position = __webpack_require__(110);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(112);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(113);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(114);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(115);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(116);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(117);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(118);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(120);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(121);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return (0, _sortPrefixedStyle2.default)(styles);
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(89);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(90);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(91);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(93);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(94);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(97);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(98);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(99);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(100);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(101);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(103);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(104);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(92);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(95);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(96);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(95);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(95);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(95);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(96);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(102);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(90);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(96);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(89);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(106);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie: [['msie']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	var browserByInfo = function browserByInfo(info) {
	  if (info.firefox) {
	    return 'firefox';
	  }
	  var name = '';
	
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  return name;
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  info.browser = browserByInfo(info);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	  info.osversion = parseFloat(info.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (info.browser === 'ios_saf' && info.version > info.osversion) {
	    info.version = info.osversion;
	    info.safari = true;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(107)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
	module.exports = exports["default"];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function position(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var browser = _ref.browserInfo.browser;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(102);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _unprefixProperty = __webpack_require__(119);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(111);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SymbolManager = /** @class */ (function () {
	    function SymbolManager() {
	        this.symbolMap = {};
	    }
	    SymbolManager.prototype.create = function (name) {
	        if (this.symbolMap[name]) {
	            return this.symbolMap[name];
	        }
	        this.symbolMap[name] = Symbol(name);
	        return this.symbolMap[name];
	    };
	    SymbolManager.prototype.get = function (name) {
	        return this.symbolMap[name];
	    };
	    return SymbolManager;
	}());
	exports.default = new SymbolManager();


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bus = __webpack_require__(36);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _bus2.default();
	
	/* eslint-disable */
	var _MAP = {
	  8: 'backspace',
	  9: 'tab',
	  13: 'enter',
	  16: 'shift',
	  17: 'ctrl',
	  18: 'alt',
	  20: 'capslock',
	  27: 'esc',
	  32: 'space',
	  33: 'pageup',
	  34: 'pagedown',
	  35: 'end',
	  36: 'home',
	  37: 'left',
	  38: 'up',
	  39: 'right',
	  40: 'down',
	  45: 'ins',
	  46: 'del',
	  91: 'meta',
	  93: 'meta',
	  224: 'meta'
	};
	
	var _KEYCODE_MAP = {
	  106: '*',
	  107: '+',
	  109: '-',
	  110: '.',
	  111: '/',
	  186: ';',
	  187: '=',
	  188: ',',
	  189: '-',
	  190: '.',
	  191: '/',
	  192: '`',
	  219: '[',
	  220: '\\',
	  221: ']',
	  222: '\''
	};
	
	var _SHIFT_MAP = {
	  '~': '`',
	  '!': '1',
	  '@': '2',
	  '#': '3',
	  '$': '4',
	  '%': '5',
	  '^': '6',
	  '&': '7',
	  '*': '8',
	  '(': '9',
	  ')': '0',
	  '_': '-',
	  '+': '=',
	  ':': ';',
	  '\"': '\'',
	  '<': ',',
	  '>': '.',
	  '?': '/',
	  '|': '\\'
	};
	
	var _SPECIAL_ALIASES = {
	  'option': 'alt',
	  'command': 'meta',
	  'return': 'enter',
	  'escape': 'esc',
	  'plus': '+',
	  'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	};
	
	var _REVERSE_MAP = void 0;
	
	/**
	 * loop through the f keys, f1 to f19 and add them to the map
	 * programatically
	 */
	for (var i = 1; i < 20; ++i) {
	  _MAP[111 + i] = 'f' + i;
	}
	
	/**
	 * loop through to map numbers on the numeric keypad
	 */
	for (var _i = 0; _i <= 9; ++_i) {
	  _MAP[_i + 96] = _i;
	}
	
	/**
	 * takes the event and returns the key character
	 *
	 * @param {Event} e
	 * @return {string}
	 */
	function _characterFromEvent(e) {
	
	  // for keypress events we should return the character as is
	  if (e.type == 'keypress') {
	    var character = String.fromCharCode(e.which);
	
	    // if the shift key is not pressed then it is safe to assume
	    // that we want the character to be lowercase.  this means if
	    // you accidentally have caps lock on then your key bindings
	    // will continue to work
	    //
	    // the only side effect that might not be desired is if you
	    // bind something like 'A' cause you want to trigger an
	    // event when capital A is pressed caps lock will no longer
	    // trigger the event.  shift+a will though.
	    if (!e.shiftKey) {
	      character = character.toLowerCase();
	    }
	
	    return character;
	  }
	
	  // for non keypress events the special maps are needed
	  if (_MAP[e.which]) {
	    return _MAP[e.which];
	  }
	
	  if (_KEYCODE_MAP[e.which]) {
	    return _KEYCODE_MAP[e.which];
	  }
	
	  // if it is not in the special map
	
	  // with keydown and keyup events the character seems to always
	  // come in as an uppercase character whether you are pressing shift
	  // or not.  we should make sure it is always lowercase for comparisons
	  return String.fromCharCode(e.which).toLowerCase();
	}
	
	/**
	 * checks if two arrays are equal
	 *
	 * @param {Array} modifiers1
	 * @param {Array} modifiers2
	 * @returns {boolean}
	 */
	function _modifiersMatch(modifiers1, modifiers2) {
	  return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	}
	
	/**
	 * takes a key event and figures out what the modifiers are
	 *
	 * @param {Event} e
	 * @returns {Array}
	 */
	function _eventModifiers(e) {
	  var modifiers = [];
	
	  if (e.shiftKey) {
	    modifiers.push('shift');
	  }
	
	  if (e.altKey) {
	    modifiers.push('alt');
	  }
	
	  if (e.ctrlKey) {
	    modifiers.push('ctrl');
	  }
	
	  if (e.metaKey) {
	    modifiers.push('meta');
	  }
	
	  return modifiers;
	}
	
	/**
	 * determines if the keycode specified is a modifier key or not
	 *
	 * @param {string} key
	 * @returns {boolean}
	 */
	function _isModifier(key) {
	  return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	}
	
	/**
	 * reverses the map lookup so that we can look for specific keys
	 * to see what can and can't use keypress
	 *
	 * @return {Object}
	 */
	function _getReverseMap() {
	  if (!_REVERSE_MAP) {
	    _REVERSE_MAP = {};
	    for (var key in _MAP) {
	
	      // pull out the numeric keypad from here cause keypress should
	      // be able to detect the keys from the character
	      if (key > 95 && key < 112) {
	        continue;
	      }
	
	      if (_MAP.hasOwnProperty(key)) {
	        _REVERSE_MAP[_MAP[key]] = key;
	      }
	    }
	  }
	  return _REVERSE_MAP;
	}
	
	/**
	 * picks the best action based on the key combination
	 *
	 * @param {string} key - character for key
	 * @param {Array} modifiers
	 * @param {string=} action passed in
	 */
	function _pickBestAction(key, modifiers, action) {
	
	  // if no action was picked in we should try to pick the one
	  // that we think would work best for this key
	  if (!action) {
	    action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	  }
	
	  // modifier keys don't work as expected with keypress,
	  // switch to keydown
	  if (action == 'keypress' && modifiers.length) {
	    action = 'keydown';
	  }
	
	  return action;
	}
	
	/**
	 * Converts from a string key combination to an array
	 *
	 * @param  {string} combination like "command+shift+l"
	 * @return {Array}
	 */
	function _keysFromString(combination) {
	  if (combination === '+') {
	    return ['+'];
	  }
	
	  combination = combination.replace(/\+{2}/g, '+plus');
	  return combination.split('+');
	}
	
	/**
	 * Gets info for a specific key combination
	 *
	 * @param  {string} combination key combination ("command+s" or "a" or "*")
	 * @param  {string=} action
	 * @returns {Object}
	 */
	function _getKeyInfo(combination, action) {
	  var keys = void 0;
	  var key = void 0;
	  var i = void 0;
	  var modifiers = [];
	
	  // take the keys from this pattern and figure out what the actual
	  // pattern is all about
	  keys = _keysFromString(combination);
	
	  for (i = 0; i < keys.length; ++i) {
	    key = keys[i];
	
	    // normalize key names
	    if (_SPECIAL_ALIASES[key]) {
	      key = _SPECIAL_ALIASES[key];
	    }
	
	    // if this is not a keypress event then we should
	    // be smart about using shift keys
	    // this will only work for US keyboards however
	    if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	      key = _SHIFT_MAP[key];
	      modifiers.push('shift');
	    }
	
	    // if this key is a modifier then add it to the list of modifiers
	    if (_isModifier(key)) {
	      modifiers.push(key);
	    }
	  }
	
	  // depending on what the key combination is
	  // we will try to pick the best event for it
	  action = _pickBestAction(key, modifiers, action);
	
	  return {
	    key: key,
	    modifiers: modifiers,
	    action: action
	  };
	}
	
	function HotKey() {
	  var self = this;
	
	  /**
	   * element to attach key events to
	   *
	   * @type {Element}
	   */
	  self.target = document;
	
	  /**
	   * a list of all the callbacks setup via HotKey.bind()
	   *
	   * @type {Object}
	   */
	  self._callbacks = {};
	
	  /**
	   * direct map of string combinations to callbacks used for trigger()
	   *
	   * @type {Object}
	   */
	  self._directMap = {};
	
	  /**
	   * keeps track of what level each sequence is at since multiple
	   * sequences can start out with the same sequence
	   *
	   * @type {Object}
	   */
	  var _sequenceLevels = {};
	
	  /**
	   * letiable to store the setTimeout call
	   *
	   * @type {null|number}
	   */
	  var _resetTimer = void 0;
	
	  /**
	   * temporary state where we will ignore the next keyup
	   *
	   * @type {boolean|string}
	   */
	  var _ignoreNextKeyup = false;
	
	  /**
	   * temporary state where we will ignore the next keypress
	   *
	   * @type {boolean}
	   */
	  var _ignoreNextKeypress = false;
	
	  /**
	   * are we currently inside of a sequence?
	   * type of action ("keyup" or "keydown" or "keypress") or false
	   *
	   * @type {boolean|string}
	   */
	  var _nextExpectedAction = false;
	
	  /**
	   * resets all sequence counters except for the ones passed in
	   *
	   * @param {Object} doNotReset
	   * @returns void
	   */
	  function _resetSequences(doNotReset) {
	    doNotReset = doNotReset || {};
	
	    var activeSequences = false,
	        key = void 0;
	
	    for (key in _sequenceLevels) {
	      if (doNotReset[key]) {
	        activeSequences = true;
	        continue;
	      }
	      _sequenceLevels[key] = 0;
	    }
	
	    if (!activeSequences) {
	      _nextExpectedAction = false;
	    }
	  }
	
	  /**
	   * finds all callbacks that match based on the keycode, modifiers,
	   * and action
	   *
	   * @param {string} character
	   * @param {Array} modifiers
	   * @param {Event|Object} e
	   * @param {string=} sequenceName - name of the sequence we are looking for
	   * @param {string=} combination
	   * @param {number=} level
	   * @returns {Array}
	   */
	  function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	    var i = void 0;
	    var callback = void 0;
	    var matches = [];
	    var action = e.type;
	
	    // if there are no events related to this keycode
	    if (!self._callbacks[character]) {
	      return [];
	    }
	
	    // if a modifier key is coming up on its own we should allow it
	    if (action == 'keyup' && _isModifier(character)) {
	      modifiers = [character];
	    }
	
	    // loop through all callbacks for the key that was pressed
	    // and see if any of them match
	    for (i = 0; i < self._callbacks[character].length; ++i) {
	      callback = self._callbacks[character][i];
	
	      // if a sequence name is not specified, but this is a sequence at
	      // the wrong level then move onto the next match
	      if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	        continue;
	      }
	
	      // if the action we are looking for doesn't match the action we got
	      // then we should keep going
	      if (action != callback.action) {
	        continue;
	      }
	
	      // if this is a keypress event and the meta key and control key
	      // are not pressed that means that we need to only look at the
	      // character, otherwise check the modifiers as well
	      //
	      // chrome will not fire a keypress if meta or control is down
	      // safari will fire a keypress if meta or meta+shift is down
	      // firefox will fire a keypress if meta or control is down
	      if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
	        var deleteCombo = !sequenceName && callback.combo == combination;
	        var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	        if (deleteCombo || deleteSequence) {
	          self._callbacks[character].splice(i, 1);
	        }
	
	        matches.push(callback);
	      }
	    }
	
	    return matches;
	  }
	
	  /**
	   * actually calls the callback function
	   *
	   * if your callback function returns false this will use the jquery
	   * convention - prevent default and stop propogation on the event
	   *
	   * @param {Function} callback
	   * @param {Event} e
	   * @returns void
	   */
	  function _fireCallback(callback, e, combo, sequence) {
	    if (callback(e, combo) === false) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	    bus.emit('ve.hotkey.callback.call', {
	      callback: callback,
	      e: e,
	      combo: combo,
	      sequence: sequence
	    });
	  }
	
	  function _handleKey(character, modifiers, e) {
	    var callbacks = _getMatches(character, modifiers, e);
	    var i = void 0;
	    var doNotReset = {};
	    var maxLevel = 0;
	    var processedSequenceCallback = false;
	
	    // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	    for (i = 0; i < callbacks.length; ++i) {
	      if (callbacks[i].seq) {
	        maxLevel = Math.max(maxLevel, callbacks[i].level);
	      }
	    }
	
	    // loop through matching callbacks for this key event
	    for (i = 0; i < callbacks.length; ++i) {
	
	      // fire for all sequence callbacks
	      // this is because if for example you have multiple sequences
	      // bound such as "g i" and "g t" they both need to fire the
	      // callback for matching g cause otherwise you can only ever
	      // match the first one
	      if (callbacks[i].seq) {
	
	        // only fire callbacks for the maxLevel to prevent
	        // subsequences from also firing
	        //
	        // for example 'a option b' should not cause 'option b' to fire
	        // even though 'option b' is part of the other sequence
	        //
	        // any sequences that do not match here will be discarded
	        // below by the _resetSequences call
	        if (callbacks[i].level != maxLevel) {
	          continue;
	        }
	
	        processedSequenceCallback = true;
	
	        // keep a list of which sequences were matches for later
	        doNotReset[callbacks[i].seq] = 1;
	        _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	        continue;
	      }
	
	      // if there were no sequence matches but we are still here
	      // that means this is a regular match so we should fire that
	      if (!processedSequenceCallback) {
	        _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	      }
	    }
	
	    var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	    if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	      _resetSequences(doNotReset);
	    }
	
	    _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	  };
	
	  function _handleKeyEvent(e) {
	
	    if (typeof e.which !== 'number') {
	      e.which = e.keyCode;
	    }
	
	    var character = _characterFromEvent(e);
	
	    // no character found then stop
	    if (!character) {
	      return;
	    }
	
	    // need to use === for the character check because the character can be 0
	    if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	      _ignoreNextKeyup = false;
	      return;
	    }
	
	    _handleKey(character, _eventModifiers(e), e);
	  }
	
	  function _resetSequenceTimer() {
	    clearTimeout(_resetTimer);
	    _resetTimer = setTimeout(_resetSequences, 1000);
	  }
	
	  function _bindSequence(combo, keys, callback, action) {
	
	    _sequenceLevels[combo] = 0;
	
	    function _increaseSequence(nextAction) {
	      return function () {
	        _nextExpectedAction = nextAction;
	        ++_sequenceLevels[combo];
	        _resetSequenceTimer();
	      };
	    }
	
	    function _callbackAndReset(e) {
	      _fireCallback(callback, e, combo);
	
	      if (action !== 'keyup') {
	        _ignoreNextKeyup = _characterFromEvent(e);
	      }
	
	      setTimeout(_resetSequences, 10);
	    }
	
	    for (var _i2 = 0; _i2 < keys.length; ++_i2) {
	      var isFinal = _i2 + 1 === keys.length;
	      var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[_i2 + 1]).action);
	      _bindSingle(keys[_i2], wrappedCallback, action, combo, _i2);
	    }
	  }
	
	  function _bindSingle(combination, callback, action, sequenceName, level) {
	
	    // store a direct mapped reference for use with HotKey.trigger
	    self._directMap[combination + ':' + action] = callback;
	
	    // make sure multiple spaces in a row become a single space
	    combination = combination.replace(/\s+/g, ' ');
	
	    var sequence = combination.split(' ');
	    var info = void 0;
	
	    // if this pattern is a sequence of keys then run through this method
	    // to reprocess each pattern one key at a time
	    if (sequence.length > 1) {
	      _bindSequence(combination, sequence, callback, action);
	      return;
	    }
	
	    info = _getKeyInfo(combination, action);
	
	    // make sure to initialize array if this is the first time
	    // a callback is added for this key
	    self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	    // remove an existing match if there is one
	    _getMatches(info.key, info.modifiers, { type: info.action }, sequenceName, combination, level);
	
	    // add this call back to the array
	    // if it is a sequence put it at the beginning
	    // if not put it at the end
	    //
	    // this is important because the way these are processed expects
	    // the sequence ones to come first
	    self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	      callback: callback,
	      modifiers: info.modifiers,
	      action: info.action,
	      seq: sequenceName,
	      level: level,
	      combo: combination
	    });
	  }
	
	  function _bindMultiple(combinations, callback, action) {
	    for (var _i3 = 0; _i3 < combinations.length; ++_i3) {
	      _bindSingle(combinations[_i3], callback, action);
	    }
	  };
	
	  this.bind = function (keys, callback, action) {
	    _bindMultiple(Array.isArray(keys) ? keys : [keys], callback, action);
	    return this;
	  };
	
	  this.handle = _handleKeyEvent;
	
	  document.addEventListener('keypress', _handleKeyEvent, false);
	  document.addEventListener('keydown', _handleKeyEvent, false);
	  document.addEventListener('keyup', _handleKeyEvent, false);
	}
	
	module.exports = new HotKey();

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(39);
	/**
	 * Virtual Node for only rendering componentView
	 * based on prototypeView.js
	 */
	var VirtualRenderingNode = /** @class */ (function (_super) {
	    __extends(VirtualRenderingNode, _super);
	    function VirtualRenderingNode() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VirtualRenderingNode.prototype.isVirtual = function () {
	        return true;
	    };
	    VirtualRenderingNode.prototype.isRoot = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.isVisibleInPane = function () {
	        return true;
	    };
	    VirtualRenderingNode.prototype.canDragging = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.canHovering = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.canSelecting = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.canOperating = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.canDropIn = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.canDropTo = function () {
	        return false;
	    };
	    VirtualRenderingNode.prototype.didDropIn = function () {
	        return;
	    };
	    VirtualRenderingNode.prototype.didDropOut = function () {
	        return;
	    };
	    /**
	     * do not allow to export to schemaData
	     */
	    VirtualRenderingNode.prototype.toData = function () {
	        return null;
	    };
	    return VirtualRenderingNode;
	}(node_1.Node));
	exports.VirtualRenderingNode = VirtualRenderingNode;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var schemaManager_1 = __webpack_require__(126);
	var visualDesigner_1 = __webpack_require__(128);
	var visualManager_1 = __webpack_require__(129);
	var visualRender_1 = __webpack_require__(130);
	exports.default = {
	    SchemaManager: schemaManager_1.default,
	    VisualDesigner: visualDesigner_1.default,
	    VisualManager: visualManager_1.default,
	    VisualRender: visualRender_1.default,
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var base_1 = __webpack_require__(127);
	var SchemaManager = /** @class */ (function (_super) {
	    __extends(SchemaManager, _super);
	    function SchemaManager() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SchemaManager.prototype.getManager = function () {
	        return this.visualManagerList[0];
	    };
	    SchemaManager.prototype.getManagerByName = function (name) {
	        return this.visualManagerList.filter(function (m) { return m.getName() === name; });
	    };
	    SchemaManager.prototype.getManagerById = function (id) {
	        return lodash_1.find(this.visualManagerList, function (m) { return m.getId() === id; });
	    };
	    SchemaManager.prototype.getManagerList = function () {
	        return this.visualManagerList;
	    };
	    SchemaManager.prototype.getSchemaManager = function () {
	        return this.schemaManagerList[0];
	    };
	    SchemaManager.prototype.getSchemaManagerById = function (id) {
	        return lodash_1.find(this.schemaManagerList, function (m) { return m.getId() === id; });
	    };
	    SchemaManager.prototype.getSchemaManagerByName = function (name) {
	        return this.schemaManagerList.filter(function (m) { return m.getName() === name; });
	    };
	    SchemaManager.prototype.getSchemaManagerList = function () {
	        return this.schemaManagerList;
	    };
	    SchemaManager.prototype.connectManager = function (manager) {
	        base_1.connectGeneralManager.call(this, manager, this.visualManagerList);
	        return this;
	    };
	    SchemaManager.prototype.connectSchemaManager = function (manager) {
	        base_1.connectGeneralManager.call(this, manager, this.schemaManagerList);
	        return this;
	    };
	    SchemaManager.prototype.connectManagerList = function (managerList) {
	        this.visualManagerList =
	            base_1.connectGeneralManagerList.call(this, managerList, this.visualManagerList);
	        return this;
	    };
	    SchemaManager.prototype.connectSchemaManagerList = function (managerList) {
	        this.schemaManagerList =
	            base_1.connectGeneralManagerList.call(this, managerList, this.schemaManagerList);
	        return this;
	    };
	    SchemaManager.prototype.notifyAllManagers = function (eventName) {
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return this.visualManagerList.map(function (m) { return m.emit(eventName, eventData); }).every(function (r) { return r; });
	    };
	    SchemaManager.prototype.notifyAllSchemaManagers = function (eventName) {
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return this.schemaManagerList.map(function (m) { return m.emit(eventName, eventData); }).every(function (r) { return r; });
	    };
	    SchemaManager.prototype.exportSchema = function () {
	        try {
	            return JSON.stringify(this.schemaData);
	        }
	        catch (e) {
	            throw new Error(e.message);
	        }
	    };
	    SchemaManager.prototype.exportSchemaObject = function () {
	        return lodash_1.cloneDeep(this.schemaData);
	    };
	    SchemaManager.prototype.importSchema = function (schemaString) {
	        try {
	            this.schemaData = JSON.parse(schemaString);
	            return this;
	        }
	        catch (e) {
	            throw new Error(e.message);
	        }
	    };
	    SchemaManager.prototype.importSchemaObject = function (schema) {
	        this.schemaData = schema;
	        return this;
	    };
	    return SchemaManager;
	}(base_1.BaseManager));
	exports.default = SchemaManager;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var bus_1 = __webpack_require__(36);
	var lodash_1 = __webpack_require__(7);
	function connectGeneralManager(manager, managerList) {
	    var index = lodash_1.findIndex(managerList, function (m) { return m.getId() === manager.getId(); });
	    if (index > -1) {
	        managerList.push(manager);
	    }
	    else {
	        managerList.splice(index, 1, manager);
	    }
	    return managerList;
	}
	exports.connectGeneralManager = connectGeneralManager;
	function connectGeneralManagerList(managerList, sourceManagerList) {
	    return lodash_1.unionBy(sourceManagerList, managerList, function (manager) { return manager.getId(); });
	}
	exports.connectGeneralManagerList = connectGeneralManagerList;
	var BaseManager = /** @class */ (function () {
	    function BaseManager(managerConfigs) {
	        if (managerConfigs === void 0) { managerConfigs = {}; }
	        this.name = managerConfigs.name || lodash_1.get(this, 'constructor', 'NAME');
	        this.id = lodash_1.uniqueId(this.name);
	        if (!managerConfigs.disableEvents) {
	            if (managerConfigs.emitter) {
	                // 使用自定义的满足 EventEmitter 接口要求的自定义事件对象
	                this.emitter = managerConfigs.emitter;
	            }
	            else {
	                // Bus 为单例模式
	                this.emitter = new bus_1.default();
	            }
	        }
	    }
	    BaseManager.prototype.getId = function () {
	        return this.id;
	    };
	    BaseManager.prototype.setName = function (name) {
	        this.name = name;
	        return this;
	    };
	    BaseManager.prototype.getName = function () {
	        return this.name;
	    };
	    BaseManager.prototype.getEventMap = function () {
	        /**
	         * Hack for get current constructor
	         * because if we write this.constructor.EVENTS
	         * ts compiler will show compiled error
	         */
	        return lodash_1.get(this, 'constructor', BaseManager.EVENTS);
	    };
	    BaseManager.prototype.on = function (eventName, callback) {
	        var _this = this;
	        this.emitter.on(eventName, callback);
	        return function () { return _this.emitter.removeListener(eventName, callback); };
	    };
	    BaseManager.prototype.emit = function (eventName) {
	        var _a;
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return (_a = this.emitter.emit).call.apply(_a, __spreadArrays([this.emitter, eventName], eventData));
	    };
	    BaseManager.EVENTS = {};
	    BaseManager.NAME = 'BaseManager';
	    return BaseManager;
	}());
	exports.BaseManager = BaseManager;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var react_1 = __webpack_require__(5);
	var bus_1 = __webpack_require__(36);
	var base_1 = __webpack_require__(127);
	var VisualDesigner = /** @class */ (function (_super) {
	    __extends(VisualDesigner, _super);
	    function VisualDesigner(props) {
	        var _this = _super.call(this, props) || this;
	        _this.defaultProps = {
	            name: 'defaultDesigner',
	            visualManagers: [],
	        };
	        _this.setName(props.name || lodash_1.get(_this, 'constructor', 'NAME'));
	        _this.connectManagerList(_this.props.visualManagers);
	        if (props.emitter) {
	            // 使用自定义的满足 EventEmitter 接口要求的自定义事件对象
	            _this.emitter = props.emitter;
	        }
	        else {
	            _this.emitter = new bus_1.default();
	        }
	        return _this;
	    }
	    VisualDesigner.prototype.getId = function () {
	        return this.id;
	    };
	    VisualDesigner.prototype.setName = function (name) {
	        this.name = name;
	        return this;
	    };
	    VisualDesigner.prototype.getName = function () {
	        return this.name;
	    };
	    VisualDesigner.prototype.getManager = function () {
	        return this.visualManagerList[0];
	    };
	    VisualDesigner.prototype.getManagerByName = function (name) {
	        return this.visualManagerList.filter(function (m) { return m.getName() === name; });
	    };
	    VisualDesigner.prototype.getManagerById = function (id) {
	        return lodash_1.find(this.visualManagerList, function (m) { return m.getId() === id; });
	    };
	    VisualDesigner.prototype.getManagerList = function () {
	        return this.visualManagerList;
	    };
	    VisualDesigner.prototype.connectManager = function (manager) {
	        base_1.connectGeneralManager.call(this, manager, this.visualManagerList);
	        return this;
	    };
	    VisualDesigner.prototype.connectManagerList = function (managerList) {
	        this.visualManagerList =
	            base_1.connectGeneralManagerList.call(this, managerList, this.visualManagerList);
	        return this;
	    };
	    VisualDesigner.prototype.getEventMap = function () {
	        /**
	         * Hack for get current constructor
	         * because if we write this.constructor.EVENTS
	         * ts compiler will show compiled error
	         */
	        return lodash_1.get(this, 'constructor', base_1.BaseManager.EVENTS);
	    };
	    VisualDesigner.prototype.notifyAllManagers = function (eventName) {
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return this.visualManagerList.map(function (m) { return m.emit(eventName, eventData); }).every(function (r) { return r; });
	    };
	    VisualDesigner.prototype.on = function (eventName, callback) {
	        var _this = this;
	        this.emitter.on(eventName, callback);
	        return function () { return _this.emitter.removeListener(eventName, callback); };
	    };
	    VisualDesigner.prototype.emit = function (eventName) {
	        var _a;
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return (_a = this.emitter.emit).call.apply(_a, __spreadArrays([this.emitter, eventName], eventData));
	    };
	    VisualDesigner.NAME = 'VisualDesigner';
	    VisualDesigner.EVENTS = {};
	    return VisualDesigner;
	}(react_1.Component));
	exports.default = VisualDesigner;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var base_1 = __webpack_require__(127);
	var VisualManager = /** @class */ (function (_super) {
	    __extends(VisualManager, _super);
	    function VisualManager() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VisualManager.prototype.getManager = function () {
	        return this.visualManagerList[0];
	    };
	    VisualManager.prototype.getManagerByName = function (name) {
	        return this.visualManagerList.filter(function (m) { return m.getName() === name; });
	    };
	    VisualManager.prototype.getManagerById = function (id) {
	        return lodash_1.find(this.visualManagerList, function (m) { return m.getId() === id; });
	    };
	    VisualManager.prototype.getManagerList = function () {
	        return this.visualManagerList;
	    };
	    VisualManager.prototype.getDesigner = function () {
	        return this.visualDesignerList[0];
	    };
	    VisualManager.prototype.getDesignerByName = function (name) {
	        return this.visualDesignerList.filter(function (m) { return m.getName() === name; });
	    };
	    VisualManager.prototype.getDesignerById = function (id) {
	        return lodash_1.find(this.visualDesignerList, function (m) { return m.getId() === id; });
	    };
	    VisualManager.prototype.getDesignerList = function () {
	        return this.visualDesignerList;
	    };
	    VisualManager.prototype.connectManager = function (manager) {
	        base_1.connectGeneralManager.call(this, manager, this.visualManagerList);
	        return this;
	    };
	    VisualManager.prototype.connectDesigner = function (manager) {
	        base_1.connectGeneralManager.call(this, manager, this.visualDesignerList);
	        return this;
	    };
	    VisualManager.prototype.connectManagerList = function (managerList) {
	        this.visualManagerList =
	            base_1.connectGeneralManagerList.call(this, managerList, this.visualManagerList);
	        return this;
	    };
	    VisualManager.prototype.connectDesignerList = function (managerList) {
	        this.visualDesignerList =
	            base_1.connectGeneralManagerList.call(this, managerList, this.visualDesignerList);
	        return this;
	    };
	    VisualManager.prototype.notifyAllManagers = function (eventName) {
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return this.getManagerList().map(function (m) { return m.emit(eventName, eventData); }).every(function (r) { return r; });
	    };
	    VisualManager.prototype.notifyAllDesigners = function (eventName) {
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return this.getDesignerList().map(function (m) { return m.emit(eventName, eventData); }).every(function (r) { return r; });
	    };
	    return VisualManager;
	}(base_1.BaseManager));
	exports.default = VisualManager;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var base_1 = __webpack_require__(127);
	var VisualRender = /** @class */ (function (_super) {
	    __extends(VisualRender, _super);
	    function VisualRender() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VisualRender.prototype.getManager = function () {
	        return this.visualManagerList[0];
	    };
	    VisualRender.prototype.getManagerByName = function (name) {
	        return this.visualManagerList.filter(function (m) { return m.getName() === name; });
	    };
	    VisualRender.prototype.getManagerById = function (id) {
	        return lodash_1.find(this.visualManagerList, function (m) { return m.getId() === id; });
	    };
	    VisualRender.prototype.getManagerList = function () {
	        return this.visualManagerList;
	    };
	    VisualRender.prototype.connectManager = function (manager) {
	        base_1.connectGeneralManager.call(this, manager, this.visualManagerList);
	        return this;
	    };
	    VisualRender.prototype.connectManagerList = function (managerList) {
	        this.visualManagerList =
	            base_1.connectGeneralManagerList.call(this, managerList, this.visualManagerList);
	        return this;
	    };
	    VisualRender.prototype.notifyAllManagers = function (eventName) {
	        var eventData = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventData[_i - 1] = arguments[_i];
	        }
	        return this.visualManagerList.map(function (m) { return m.emit(eventName, eventData); }).every(function (r) { return r; });
	    };
	    /**
	     * Render function
	     * @override
	     *
	     * @memberof VisualRender
	     */
	    VisualRender.prototype.render = function () {
	        return '';
	    };
	    return VisualRender;
	}(base_1.BaseManager));
	exports.default = VisualRender;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var ghost_1 = __webpack_require__(132);
	var panes_1 = __webpack_require__(231);
	function UI() {
	    return (React.createElement("div", { className: 'engine-main' },
	        React.createElement(panes_1.default, null),
	        React.createElement(ghost_1.default, null)));
	}
	exports.default = UI;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Icons = __webpack_require__(133);
	var React = __webpack_require__(5);
	var dragengine_1 = __webpack_require__(21);
	__webpack_require__(229);
	var Ghost = /** @class */ (function (_super) {
	    __extends(Ghost, _super);
	    function Ghost() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Ghost.prototype.componentWillMount = function () {
	        var _this = this;
	        this.dragment = null;
	        this.x = 0;
	        this.y = 0;
	        this.willDetach = [
	            dragengine_1.default.onDragstart(function (e, dragment) {
	                _this.dragment = dragment;
	                _this.x = e.clientX;
	                _this.y = e.clientY;
	                _this.forceUpdate();
	            }),
	            dragengine_1.default.onDrag(function (e) {
	                _this.x = e.clientX;
	                _this.y = e.clientY;
	                _this.forceUpdate();
	            }),
	            dragengine_1.default.onDragend(function () {
	                _this.dragment = null;
	                _this.x = 0;
	                _this.y = 0;
	                _this.forceUpdate();
	            }),
	        ];
	    };
	    Ghost.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Ghost.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    Ghost.prototype.render = function () {
	        if (!this.dragment) {
	            return null;
	        }
	        return (React.createElement("div", { className: 'engine-ghost', style: {
	                transform: "translate(" + this.x + "px, " + this.y + "px)",
	            } },
	            React.createElement(Icons, { className: 'engine-ghost-icon', name: this.dragment.getIcon() }),
	            React.createElement("div", { className: 'engine-ghost-title' }, this.dragment.getTitle())));
	    };
	    return Ghost;
	}(React.Component));
	exports.default = Ghost;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp, _class2, _temp2, _class3, _temp3;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(134);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _veInlineTip = __webpack_require__(135);
	
	var _veInlineTip2 = _interopRequireDefault(_veInlineTip);
	
	var _index = __webpack_require__(136);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var IconsList = Object.keys(_index2.default).map(function (name) {
	  return {
	    name: name,
	    icon: _index2.default[name]
	  };
	});
	var IconsDict = { default: _index2.default };
	
	function testType(src) {
	  var t = typeof src === 'undefined' ? 'undefined' : _typeof(src);
	  if (t === 'function' && src.prototype && (src.prototype.isReactComponent || src.prototype instanceof _react2.default.Component)) {
	    return 'ReactClass';
	  } else if (t === 'object' && _react2.default.isValidElement(src)) {
	    return 'ReactElement';
	  }
	  return t;
	}
	
	function hasIcon(name) {
	  var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
	
	  return IconsDict[namespace] && IconsDict[namespace][name];
	}
	
	var RE_NAME = /^(\w+)\.(.+)$/;
	function getIcon(name) {
	  var m = RE_NAME.exec(name);
	  var namespace = 'default';
	  if (m) {
	    namespace = m[1];
	    name = m[2];
	  }
	  if (hasIcon(name, namespace)) {
	    return IconsDict[namespace][name];
	  }
	  return null;
	}
	
	function getList() {
	  return IconsList;
	}
	
	function registerDict(namespace, dict) {
	  IconsDict[namespace] = dict;
	}
	
	var Icons = (_temp = _class = function (_React$Component) {
	  _inherits(Icons, _React$Component);
	
	  function Icons() {
	    _classCallCheck(this, Icons);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Icons.prototype.render = function render() {
	    var _props = this.props,
	        name = _props.name,
	        effect = _props.effect,
	        props = _objectWithoutProperties(_props, ['name', 'effect']);
	
	    var type = testType(name);
	
	    props.className = (0, _classnames2.default)('ve-svgicon', _defineProperty({}, 've-icon-effect-' + effect, effect), props.className);
	
	    if (type === 'ReactClass') {
	      return _react2.default.createElement(name, props);
	    }
	    if (type === 'ReactElement') {
	      return _react2.default.cloneElement(name, props);
	    }
	
	    var Icon = getIcon(name);
	    if (type === 'string' && Icon) {
	      return _react2.default.createElement(Icon, props);
	    }
	    return null;
	  };
	
	  return Icons;
	}(_react2.default.Component), _class.defaultProps = {
	  size: 'large',
	  name: 'success'
	}, _class.propTypes = {
	  name: _react2.default.PropTypes.any,
	  effect: _react2.default.PropTypes.string
	}, _temp);
	
	
	Icons.getIcon = getIcon;
	
	Icons.getList = getList;
	
	Icons.registerDict = registerDict;
	
	var Button = (_temp2 = _class2 = function (_React$Component2) {
	  _inherits(Button, _React$Component2);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Button.prototype.render = function render() {
	    var _props2 = this.props,
	        size = _props2.size,
	        text = _props2.text,
	        children = _props2.children,
	        name = _props2.name,
	        theme = _props2.theme,
	        effect = _props2.effect,
	        props = _objectWithoutProperties(_props2, ['size', 'text', 'children', 'name', 'theme', 'effect']);
	
	    var className = (0, _classnames2.default)('ve-icon-button', 've-icon-button-' + this.props.theme, props.className);
	    var contents = text || children;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, props, { className: className }),
	      _react2.default.createElement(Icons, { name: name, size: size || 'small', effect: effect }),
	      contents && _react2.default.createElement(
	        'span',
	        { className: 've-icon-contents' },
	        contents
	      )
	    );
	  };
	
	  return Button;
	}(_react2.default.Component), _class2.propTypes = {
	  className: _react2.default.PropTypes.string,
	  theme: _react2.default.PropTypes.string,
	  text: _react2.default.PropTypes.node,
	  children: _react2.default.PropTypes.node,
	  size: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	  name: _react2.default.PropTypes.any,
	  effect: _react2.default.PropTypes.string
	}, _class2.defaultProps = {
	  size: 'small',
	  theme: 'default'
	}, _temp2);
	
	
	Icons.Button = Button;
	
	var Tip = (_temp3 = _class3 = function (_React$Component3) {
	  _inherits(Tip, _React$Component3);
	
	  function Tip() {
	    _classCallCheck(this, Tip);
	
	    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	  }
	
	  Tip.prototype.render = function render() {
	    var _props3 = this.props,
	        size = _props3.size,
	        name = _props3.name,
	        url = _props3.url,
	        position = _props3.position,
	        children = _props3.children,
	        props = _objectWithoutProperties(_props3, ['size', 'name', 'url', 'position', 'children']);
	
	    props.className = (0, _classnames2.default)('ve-icon-tip', props.className);
	
	    if (url) {
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          onClick: function onClick(e) {
	            return e.stopPropagation();
	          }
	        }, props, {
	          target: '_blank',
	          rel: 'noopener noreferrer',
	          href: url
	        }),
	        _react2.default.createElement(Icons, { name: name || 'doubt', size: size || 'small' }),
	        _react2.default.createElement(
	          _veInlineTip2.default,
	          { position: position },
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'i',
	      props,
	      _react2.default.createElement(Icons, { name: name || 'doubt', size: size || 'small' }),
	      _react2.default.createElement(
	        _veInlineTip2.default,
	        { position: position },
	        children
	      )
	    );
	  };
	
	  return Tip;
	}(_react2.default.Component), _class3.propTypes = {
	  className: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.node,
	  size: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	  name: _react2.default.PropTypes.any,
	  url: _react2.default.PropTypes.string,
	  position: _react2.default.PropTypes.string
	}, _class3.defaultProps = {
	  size: 'small'
	}, _temp3);
	
	
	Icons.Tip = Tip;
	
	module.exports = Icons;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var InlineTip = (_temp = _class = function (_Component) {
	  _inherits(InlineTip, _Component);
	
	  function InlineTip() {
	    _classCallCheck(this, InlineTip);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  InlineTip.prototype.render = function render() {
	    var _props = this.props,
	        position = _props.position,
	        theme = _props.theme;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: { display: 'none' },
	        'data-role': 'tip', type: 'text/tip',
	        'data-position': position,
	        'data-theme': theme
	      },
	      this.props.children
	    );
	  };
	
	  return InlineTip;
	}(_react.Component), _class.propTypes = {
	  position: _react.PropTypes.string,
	  theme: _react.PropTypes.string,
	  children: _react.PropTypes.node
	}, _class.defaultProps = {
	  direction: 'auto',
	  theme: 'default'
	}, _class.displayName = 'InlineTip', _temp);
	exports.default = InlineTip;
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  add: __webpack_require__(137),
	  addSection: __webpack_require__(139),
	  addpage: __webpack_require__(140),
	  amindBoundary: __webpack_require__(141),
	  amindDownload: __webpack_require__(142),
	  amindHotkey: __webpack_require__(143),
	  amindRelation: __webpack_require__(144),
	  amindShare: __webpack_require__(145),
	  amindSmile: __webpack_require__(146),
	  amindSubTheme: __webpack_require__(147),
	  amindSummary: __webpack_require__(148),
	  amindTheme: __webpack_require__(149),
	  amindUndo: __webpack_require__(150),
	  arrow: __webpack_require__(151),
	  autoLayout: __webpack_require__(152),
	  blockDisable: __webpack_require__(153),
	  blockEnable: __webpack_require__(154),
	  'block-show': __webpack_require__(155),
	  'block-hidden': __webpack_require__(156),
	  'checkbox-active': __webpack_require__(157),
	  'checkbox-normal': __webpack_require__(158),
	  checkbox: __webpack_require__(159),
	  clear: __webpack_require__(160),
	  clone: __webpack_require__(161),
	  close: __webpack_require__(162),
	  datapool: __webpack_require__(163),
	  date: __webpack_require__(164),
	  dialog: __webpack_require__(165),
	  doubt: __webpack_require__(166),
	  download: __webpack_require__(167),
	  'drag-handler': __webpack_require__(168),
	  drag: __webpack_require__(169),
	  edit: __webpack_require__(170),
	  error: __webpack_require__(171),
	  exit: __webpack_require__(172),
	  expand: __webpack_require__(173),
	  forward: __webpack_require__(174),
	  fullscreen: __webpack_require__(175),
	  fullscreenexit: __webpack_require__(176),
	  global: __webpack_require__(177),
	  hidden: __webpack_require__(178),
	  history: __webpack_require__(179),
	  html: __webpack_require__(180),
	  info: __webpack_require__(181),
	  js: __webpack_require__(182),
	  keymap: __webpack_require__(183),
	  loading: __webpack_require__(184),
	  magicStick: __webpack_require__(185),
	  metadataField: __webpack_require__(186),
	  metadataFieldExtends: __webpack_require__(187),
	  metadataFieldset: __webpack_require__(188),
	  minus: __webpack_require__(189),
	  mobile: __webpack_require__(190),
	  more: __webpack_require__(191),
	  more2: __webpack_require__(192),
	  nonselected: __webpack_require__(193),
	  noradio: __webpack_require__(194),
	  outline: __webpack_require__(195),
	  page: __webpack_require__(196),
	  pc: __webpack_require__(197),
	  plus: __webpack_require__(198),
	  popup: __webpack_require__(199),
	  'position-top': __webpack_require__(200),
	  'position-bottom': __webpack_require__(201),
	  'position-left': __webpack_require__(202),
	  'position-right': __webpack_require__(203),
	  preview: __webpack_require__(204),
	  'radio-active': __webpack_require__(205),
	  'radio-normal': __webpack_require__(206),
	  radio: __webpack_require__(207),
	  remove: __webpack_require__(208),
	  save: __webpack_require__(209),
	  search: __webpack_require__(210),
	  section: __webpack_require__(211),
	  selection: __webpack_require__(212),
	  setting: __webpack_require__(213),
	  show: __webpack_require__(214),
	  'sort-handler': __webpack_require__(215),
	  success: __webpack_require__(216),
	  switch: __webpack_require__(217),
	  triangle: __webpack_require__(218),
	  unknow: __webpack_require__(219),
	  upload: __webpack_require__(220),
	  var: __webpack_require__(221),
	  warn: __webpack_require__(222),
	  'zoom-in': __webpack_require__(223),
	  'zoom-out': __webpack_require__(224),
	  delete: __webpack_require__(225),
	  rhino: __webpack_require__(226)
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Add(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M544 480V95.904A31.808 31.808 0 0 0 512 64c-17.792 0-32 14.272-32 31.904V480H95.904A31.808 31.808 0 0 0 64 512c0 17.792 14.272 32 31.904 32H480v384.096c0 17.824 14.336 31.904 32 31.904 17.792 0 32-14.272 32-31.904V544h384.096A31.808 31.808 0 0 0 960 512c0-17.792-14.272-32-31.904-32H544z' })
	  );
	}
	Add.displayName = 'Add';
	
	module.exports = Add;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
		var SizePresets = {
		  xsmall: 8,
		  small: 16,
		  medium: 20,
		  large: 30,
		  xlarge: 48
		};
	
		function IconBase(_ref) {
		  var fill = _ref.fill;
		  var size = _ref.size;
		  var viewBox = _ref.viewBox;
		  var style = _ref.style;
		  var children = _ref.children;
	
		  var props = _objectWithoutProperties(_ref, ["fill", "size", "viewBox", "style", "children"]);
	
		  if (SizePresets.hasOwnProperty(size)) {
		    size = SizePresets[size];
		  }
	
		  return _react2.default.createElement(
		    "svg",
		    _extends({
		      fill: "currentColor",
		      preserveAspectRatio: "xMidYMid meet",
		      width: size,
		      height: size,
		      viewBox: viewBox
		    }, props, {
		      style: _extends({
		        verticalAlign: 'middle',
		        color: fill
		      }, style)
		    }),
		    children
		  );
		}
	
		IconBase.defaultProps = {
		  size: 'large'
		};
	
		IconBase.propTypes = {
		  className: _react2.default.PropTypes.string,
		  fill: _react2.default.PropTypes.string,
		  size: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
		  children: _react2.default.PropTypes.node.isRequired,
		  viewBox: _react2.default.PropTypes.string.isRequired,
		  style: _react2.default.PropTypes.object
		};
	
		IconBase.displayName = 'IconBase';
	
		exports.default = IconBase;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = window.React;
	
	/***/ }
	/******/ ]);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AddSection(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M896 576V160.192A32.32 32.32 0 0 0 864 128h-704c-17.664 0-32 14.656-32 32v704c0 17.664 14.912 32 32.192 32H576v64h384V576h-64zM64 128.448C64 92.8 92.8 64 128.448 64h767.104C931.2 64 960 92.8 960 128.448V960H128.448C92.8 960 64 931.2 64 895.552V128.448zM256 288c0-17.664 14.72-32 32-32h448c17.664 0 32 14.848 32 32 0 17.664-14.72 32-32 32h-448a32.32 32.32 0 0 1-32-32z m0 192c0-17.664 13.76-32 31.872-32h256.256c17.6 0 31.872 14.848 31.872 32 0 17.664-13.76 32-31.872 32H287.872A32.256 32.256 0 0 1 256 480z' }),
	    React.createElement('path', { d: 'M768 704V543.68A32.192 32.192 0 0 0 736 512c-17.664 0-32 13.824-32 31.68V704H543.68a32.192 32.192 0 0 0-31.68 32c0 17.664 13.824 32 31.68 32H704v160.32c0 17.472 14.848 31.68 32 31.68 17.664 0 32-13.824 32-31.68V768h160.32a32.192 32.192 0 0 0 31.68-32c0-17.664-13.824-32-31.68-32H768z' })
	  );
	}
	AddSection.displayName = 'AddSection';
	
	module.exports = AddSection;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Addpage(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M893.44 339.456c-1.472-6.08-3.968-11.968-8.768-16.704L635.008 73.088C626.432 64.512 614.656 61.952 603.648 64L192 64C121.344 64 64 121.344 64 192l0 704c0 70.656 57.344 128 128 128l576 0c70.656 0 128-57.344 128-128L896 352C896 347.52 895.04 343.296 893.44 339.456zM640 177.92 782.08 320 640 320 640 177.92zM832 896c0 35.392-28.608 64-64 64L192 960c-35.392 0-64-28.608-64-64L128 192c0-35.392 28.608-64 64-64l384 0 0 224C576 369.664 590.336 384 608 384L832 384 832 896zM512 416C512 398.336 497.664 384 480 384S448 398.336 448 416L448 576 288 576C270.336 576 256 590.336 256 608S270.336 640 288 640L448 640l0 160C448 817.664 462.336 832 480 832S512 817.664 512 800L512 640l160 0c17.664 0 32-14.336 32-32S689.664 576 672 576L512 576 512 416z' })
	  );
	}
	Addpage.displayName = 'Addpage';
	
	module.exports = Addpage;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindBoundary(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M320 352h384a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H320a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32H352zM96 96h64v64H96V96z m0 128h64v64H96V224z m0 128h64v64H96v-64z m0 128h64v64H96v-64z m0 128h64v64H96v-64z m0 128h64v64H96v-64z m0 128h64v64H96v-64zM864 224h64v64h-64V224z m0 128h64v64h-64v-64z m0 128h64v64h-64v-64z m0 128h64v64h-64v-64z m0 128h64v64h-64v-64z m0 128h64v64h-64v-64zM608 96h64v64h-64V96z m128 0h64v64h-64V96z m128 0h64v64h-64V96zM480 96h64v64h-64V96z m-128 0h64v64h-64V96zM224 96h64v64H224V96z m384 768h64v64h-64v-64z m128 0h64v64h-64v-64z m-256 0h64v64h-64v-64z m-128 0h64v64h-64v-64z m-128 0h64v64H224v-64z' })
	  );
	}
	AmindBoundary.displayName = 'AmindBoundary';
	
	module.exports = AmindBoundary;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindDownload(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M793.6 358.4C768 227.2 652.8 128 512 128s-256 99.2-281.6 230.4C134.4 384 64 473.6 64 576c0 124.8 99.2 224 224 224h32v-64h-32c-89.6 0-160-70.4-160-160s70.4-160 160-160c0-124.8 99.2-224 224-224s224 99.2 224 224c89.6 0 160 70.4 160 160s-70.4 160-160 160h-32v64h32c124.8 0 224-99.2 224-224 0-102.4-70.4-192-166.4-217.6z' }),
	    React.createElement('path', { d: 'M588.8 748.8L550.4 784V512c0-19.2-16-32-32-32-19.2 0-32 16-32 32v272L448 748.8c-12.8-12.8-35.2-12.8-48 0-12.8 12.8-12.8 32 0 44.8l96 92.8c3.2 3.2 6.4 6.4 9.6 6.4 12.8 6.4 25.6 3.2 35.2-6.4l92.8-92.8c12.8-12.8 12.8-32 0-44.8-9.6-12.8-32-12.8-44.8 0z' })
	  );
	}
	AmindDownload.displayName = 'AmindDownload';
	
	module.exports = AmindDownload;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindHotkey(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M800 544h-96a32 32 0 0 1 0-64h64v-128a32 32 0 0 1 64 0v160a32 32 0 0 1-32 32zM128 192h768a64 64 0 0 1 64 64v512a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32H160z m64 64h64a32 32 0 0 1 0 64H224a32 32 0 0 1 0-64z m192 0h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64z m192 0h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64zM224 480h32a32 32 0 0 1 0 64H224a32 32 0 0 1 0-64z m160 0h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64z m160 0h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64zM224 640h32a32 32 0 0 1 0 64H224a32 32 0 0 1 0-64z m160 0h256a32 32 0 0 1 0 64h-256a32 32 0 0 1 0-64z m384 0h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64z' })
	  );
	}
	AmindHotkey.displayName = 'AmindHotkey';
	
	module.exports = AmindHotkey;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindRelation(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M851.648 355.264l45.92-94.176a32 32 0 0 1 57.536 28.064l-84.16 172.576a32 32 0 0 1-42.784 14.72l-172.576-84.16a32 32 0 1 1 28.064-57.536l110.208 53.76A288 288 0 0 0 224 448a32 32 0 0 1-64 0C160 253.6 317.6 96 512 96c162.304 0 298.944 109.856 339.648 259.264zM128 608h288a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32H160z m448-64h288a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64h-288a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32h-224z' })
	  );
	}
	AmindRelation.displayName = 'AmindRelation';
	
	module.exports = AmindRelation;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindShare(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M864 608a32 32 0 0 1 64 0v224a64 64 0 0 1-64 64H160a64 64 0 0 1-64-64V288a64 64 0 0 1 64-64h352a32 32 0 0 1 0 64H192a32 32 0 0 0-32 32v480a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-192zM809.984 265.12L684.16 177.664a29.632 29.632 0 0 1-7.36-41.44 30.144 30.144 0 0 1 41.792-7.328l196.608 136.64a29.632 29.632 0 0 1 7.36 41.44l-137.664 195.136a30.144 30.144 0 0 1-41.792 7.296 29.632 29.632 0 0 1-7.36-41.472l103.456-146.592c-195.84 20.64-348.384 185.088-348.384 384.896 0 16.416-13.44 29.76-30.016 29.76a29.888 29.888 0 0 1-30.016-29.76c0-222.72 164.32-407.392 379.2-441.12z' })
	  );
	}
	AmindShare.displayName = 'AmindShare';
	
	module.exports = AmindShare;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindSmile(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512 64c247.136 0 448 200.864 448 448s-200.864 448-448 448S64 759.136 64 512 264.864 64 512 64z m0 832c211.968 0 384-172.032 384-384S723.968 128 512 128 128 300.032 128 512s172.032 384 384 384zM288 416a64 64 0 1 1 128 0 64 64 0 0 1-128 0z m320 0a64 64 0 1 1 128 0 64 64 0 0 1-128 0z m50.368 196.8a30.72 30.72 0 0 1 8.928 41.824A182.048 182.048 0 0 1 512 741.344a182.048 182.048 0 0 1-155.296-86.72 30.72 30.72 0 0 1 8.96-41.824 29.44 29.44 0 0 1 41.024 9.088 123.68 123.68 0 0 0 210.624 0 29.44 29.44 0 0 1 41.056-9.088z' })
	  );
	}
	AmindSmile.displayName = 'AmindSmile';
	
	module.exports = AmindSmile;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindSubTheme(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M288 704H192a64 64 0 0 1-64-64V320a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64h448a64 64 0 0 1 64 64v96a64 64 0 0 1-64 64H192v288a32 32 0 0 0 32 32h64v-64a64 64 0 0 1 64-64h544a64 64 0 0 1 64 64v288a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64v-160z m96-128a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h480a32 32 0 0 0 32-32v-224a32 32 0 0 0-32-32H384z' })
	  );
	}
	AmindSubTheme.displayName = 'AmindSubTheme';
	
	module.exports = AmindSubTheme;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindSummary(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M894.56 543.968A352.16 352.16 0 0 1 704 825.632c-23.68 3.52-35.52-7.2-35.52-32.224 0-15.584 11.84-29.568 35.52-41.92A287.712 287.712 0 0 0 832 512c0-99.84-50.816-187.84-128-239.488-23.68-14.848-35.52-29.536-35.52-44.064 0-25.568 11.84-35.584 35.52-30.08a352.16 352.16 0 0 1 190.56 281.664L896 480h32a32 32 0 0 1 0 64h-32l-1.44-0.032zM128 576h416a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h352a32 32 0 0 0 32-32v-128a32 32 0 0 0-32-32H160zM128 128h416a64 64 0 0 1 64 64v192a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h352a32 32 0 0 0 32-32V224a32 32 0 0 0-32-32H160z' })
	  );
	}
	AmindSummary.displayName = 'AmindSummary';
	
	module.exports = AmindSummary;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindTheme(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M480 544v-224H288a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64h448a64 64 0 0 1 64 64v96a64 64 0 0 1-64 64h-192v224h320a64 64 0 0 1 64 64v256a64 64 0 0 1-64 64H160a64 64 0 0 1-64-64v-256a64 64 0 0 1 64-64h320z m-288 64a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-192a32 32 0 0 0-32-32H192z' })
	  );
	}
	AmindTheme.displayName = 'AmindTheme';
	
	module.exports = AmindTheme;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AmindUndo(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M173.504 372.8l126.24-126.176a32 32 0 1 0-45.28-45.248L73.376 382.4a31.904 31.904 0 0 0 0 45.248l181.12 181.024a32 32 0 0 0 45.248-45.248L173.088 436.8H640a256 256 0 0 1 256 256v96a32 32 0 0 0 64 0v-96c0-176.736-143.264-320-320-320H173.504zM640 1012.8v-64 64z' })
	  );
	}
	AmindUndo.displayName = 'AmindUndo';
	
	module.exports = AmindUndo;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Arrow(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512.002047 771.904425c-10.152221 0.518816-20.442588-2.800789-28.202319-10.598382L77.902254 315.937602c-14.548344-14.618952-14.548344-38.318724 0-52.933583 14.544251-14.614859 38.118156-14.614859 52.662407 0l381.437385 418.531212L893.432269 263.004019c14.544251-14.614859 38.125319-14.614859 52.662407 0 14.552437 14.614859 14.552437 38.314631 0 52.933583L540.205389 761.307066C532.451798 769.103636 522.158361 772.424264 512.002047 771.904425z' })
	  );
	}
	Arrow.displayName = 'Arrow';
	
	module.exports = Arrow;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function AutoLayout(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement(
	      'defs',
	      null,
	      React.createElement('style', { type: 'text/css' })
	    ),
	    React.createElement('path', { d: 'M0 0m170.666667 0l682.666666 0q170.666667 0 170.666667 170.666667l0 682.666666q0 170.666667-170.666667 170.666667l-682.666666 0q-170.666667 0-170.666667-170.666667l0-682.666666q0-170.666667 170.666667-170.666667Z', 'p-id': '2840' }),
	    React.createElement('path', { d: 'M64 192m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-213.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2841' }),
	    React.createElement('path', { d: 'M64 362.666667m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-213.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2842' }),
	    React.createElement('path', { d: 'M64 533.333333m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333334l0 42.666666q0 21.333333-21.333333 21.333334l-213.333334 0q-21.333333 0-21.333333-21.333334l0-42.666666q0-21.333333 21.333333-21.333334Z', opacity: '.22', 'p-id': '2843' }),
	    React.createElement('path', { d: 'M64 704m21.333333 0l853.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-853.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2844' }),
	    React.createElement('path', { d: 'M384 192m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-213.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2845' }),
	    React.createElement('path', { d: 'M384 362.666667m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-213.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2846' }),
	    React.createElement('path', { d: 'M384 533.333333m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333334l0 42.666666q0 21.333333-21.333333 21.333334l-213.333334 0q-21.333333 0-21.333333-21.333334l0-42.666666q0-21.333333 21.333333-21.333334Z', opacity: '.22', 'p-id': '2847' }),
	    React.createElement('path', { d: 'M704 192m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-213.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2848' }),
	    React.createElement('path', { d: 'M704 362.666667m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333333l0 42.666667q0 21.333333-21.333333 21.333333l-213.333334 0q-21.333333 0-21.333333-21.333333l0-42.666667q0-21.333333 21.333333-21.333333Z', opacity: '.22', 'p-id': '2849' }),
	    React.createElement('path', { d: 'M704 533.333333m21.333333 0l213.333334 0q21.333333 0 21.333333 21.333334l0 42.666666q0 21.333333-21.333333 21.333334l-213.333334 0q-21.333333 0-21.333333-21.333334l0-42.666666q0-21.333333 21.333333-21.333334Z', opacity: '.22', 'p-id': '2850' }),
	    React.createElement('path', { d: 'M252.266667 316.501333l90.837333-73.6a30.336 30.336 0 0 1 41.728 3.498667L803.84 729.002667a28.010667 28.010667 0 0 1-3.648 40.341333l-90.816 73.621333a30.336 30.336 0 0 1-41.728-3.52L248.597333 356.864a28.010667 28.010667 0 0 1 3.626667-40.362667h0.042667z m175.082666 157.098667L693.973333 780.693333l45.376-36.8-266.666666-307.114666-45.354667 36.821333z m-114.282666-131.626667l45.397333-36.8 76.16 87.722667-45.376 36.842667-76.16-87.765334h-0.021333z m-112.768 172.309334v-28.629334h29.632v28.629334h29.632v28.650666h-29.653334v28.629334H200.32V542.933333H170.666667v-28.650666h29.632zM704 256.576V170.666667h59.264v85.909333h88.874667v57.258667h-88.874667v85.909333H704v-85.909333h-88.896v-57.258667H704zM289.194667 686.08v-57.258667h59.242666v57.258667h59.264v57.28h-59.264v57.258667h-59.242666v-57.258667h-59.264V686.08h59.264z', 'p-id': '2851' })
	  );
	}
	AutoLayout.displayName = 'AutoLayout';
	
	module.exports = AutoLayout;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function BlockDisable(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 16 16' }, props),
	    React.createElement(
	      'g',
	      { stroke: 'none', 'stroke-width': '1', fillRule: 'evenodd' },
	      React.createElement(
	        'g',
	        { transform: 'translate(-53.000000, -228.000000)' },
	        React.createElement(
	          'g',
	          { transform: 'translate(53.000000, 134.000000)' },
	          React.createElement(
	            'g',
	            { id: 'Group-8', transform: 'translate(0.000000, 94.000000)' },
	            React.createElement('path', { d: 'M2,9 L5,9 C5.55228475,9 6,9.44771525 6,10 L6,13 C6,13.5522847 5.55228475,14 5,14 L2,14 C1.44771525,14 1,13.5522847 1,13 L1,10 C1,9.44771525 1.44771525,9 2,9 L2,9 Z M2,2 L5,2 C5.55228475,2 6,2.44771525 6,3 L6,6 C6,6.55228475 5.55228475,7 5,7 L2,7 C1.44771525,7 1,6.55228475 1,6 L1,3 L1,3 C1,2.44771525 1.44771525,2 2,2 L2,2 Z M11.2071068,1.67157288 L13.3284271,3.79289322 C13.7189514,4.18341751 13.7189514,4.81658249 13.3284271,5.20710678 L11.2071068,7.32842712 C10.8165825,7.71895142 10.1834175,7.71895142 9.79289322,7.32842712 L7.67157288,5.20710678 C7.28104858,4.81658249 7.28104858,4.18341751 7.67157288,3.79289322 L9.79289322,1.67157288 L9.79289322,1.67157288 C10.1834175,1.28104858 10.8165825,1.28104858 11.2071068,1.67157288 L11.2071068,1.67157288 Z M9,9 L12,9 C12.5522847,9 13,9.44771525 13,10 L13,13 C13,13.5522847 12.5522847,14 12,14 L9,14 C8.44771525,14 8,13.5522847 8,13 L8,10 C8,9.44771525 8.44771525,9 9,9 Z' })
	          )
	        )
	      )
	    )
	  );
	}
	BlockDisable.displayName = 'BlockDisable';
	
	module.exports = BlockDisable;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function BlockEnable(props) {
	    return React.createElement(
	        IconBase,
	        _extends({ viewBox: '0 0 16 16' }, props),
	        React.createElement(
	            'g',
	            { stroke: 'none', 'stroke-width': '1', fillRule: 'evenodd' },
	            React.createElement(
	                'g',
	                { transform: 'translate(-53.000000, -260.000000)' },
	                React.createElement(
	                    'g',
	                    { transform: 'translate(53.000000, 134.000000)' },
	                    React.createElement(
	                        'g',
	                        { transform: 'translate(0.000000, 126.000000)' },
	                        React.createElement(
	                            'g',
	                            { transform: 'translate(1.000000, 1.000000)' },
	                            React.createElement('path', { d: 'M3.11625574,7.818706 L1,7.818706 L1,7.818706 C0.44771525,7.818706 -6.76353751e-17,8.26642125 0,8.818706 L0,8.818706 L4.4408921e-16,11.9482017 C5.11724585e-16,12.5004865 0.44771525,12.9482017 1,12.9482017 L4,12.9482017 C4.14519117,12.9482017 4.28315532,12.9172592 4.40765783,12.8616087 C3.52923279,11.8180417 3,10.4708253 3,9 C3,8.59564614 3.03999887,8.20063452 3.11625574,7.818706 Z M5,4.52778699 L5,1.63741201 C5,1.08512726 4.55228475,0.637412008 4,0.637412008 L4,0.637412008 L1,0.637412008 L1,0.637412008 C0.44771525,0.637412008 -6.76353751e-17,1.08512726 0,1.63741201 L0,1.63741201 L4.4408921e-16,4.76690772 C5.11724585e-16,5.31919247 0.44771525,5.76690772 1,5.76690772 L1,5.76690772 L3.94470457,5.76690772 C4.23929586,5.30723698 4.59486606,4.89039168 5,4.52778699 Z M12.2694822,3.96821153 L12.3742108,3.863483 C12.7647351,3.4729587 12.7647351,2.83979373 12.3742108,2.44926943 L10.2528904,0.327949091 L10.2528904,0.327949091 C9.86236614,-0.062575201 9.22920116,-0.062575201 8.83867687,0.327949091 L8.83867687,0.327949091 L6.62578923,2.54083673 C6.34108728,2.82553868 6.26394015,3.23919867 6.39434785,3.59378944 C7.18237597,3.21328358 8.06628046,3 9,3 C10.2060188,3 11.328931,3.35582194 12.2694822,3.96821153 Z' }),
	                            React.createElement('path', { d: 'M9,14 C6.23857625,14 4,11.7614237 4,9 C4,6.23857625 6.23857625,4 9,4 C11.7614237,4 14,6.23857625 14,9 C14,11.7614237 11.7614237,14 9,14 Z M8.3851909,9.6787709 L7.32453073,8.61811072 C7.12926858,8.42284858 6.79838835,8.43714632 6.58548905,8.65004562 C6.37258975,8.86294492 6.35829201,9.19382515 6.55355415,9.3890873 L7.96776772,10.8033009 C8.06539879,10.9009319 8.19693438,10.946173 8.33067462,10.940394 C8.46441486,10.9346149 8.60035974,10.8778156 8.70680939,10.771366 L11.4713667,8.00680863 C11.684266,7.79390933 11.6985638,7.4630291 11.5033016,7.26776695 C11.3080395,7.07250481 10.9771592,7.08680255 10.7642599,7.29970185 L8.3851909,9.6787709 Z' })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	BlockEnable.displayName = 'BlockEnable';
	
	module.exports = BlockEnable;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function BlockShow(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M960 480h-64V160a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h192v64H127.712C92.512 960 64 931.2 64 896.288V127.68C64 92.512 92.8 64 127.712 64H896.32C931.488 64 960 92.8 960 127.712V480zM288 160h64v64H288V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m0 128h64v64h-64V288zM160 288h64v64H160V288z m0 128h64v64H160v-64z m0 128h64v64H160v-64z m0 128h64v64H160v-64zM160 160h64v64H160V160z m0 640h64v64H160v-64z' }),
	    React.createElement('path', { d: 'M672 956c-181.728 0-256.512-152.256-275.968-198.88a57.472 57.472 0 0 1 0-42.24c19.456-46.624 94.24-198.88 275.968-198.88 180.896 0 256.512 152.256 275.968 198.88 5.376 13.76 5.376 28.48 0 42.24-19.456 46.624-95.072 198.88-275.968 198.88z m0-120A100.32 100.32 0 0 0 772 736 100.32 100.32 0 0 0 672 636 100.32 100.32 0 0 0 572 736 100.32 100.32 0 0 0 672 836z m0-160A60.16 60.16 0 0 1 732 736 59.936 59.936 0 0 1 672 796 59.936 59.936 0 0 1 612 736 60.16 60.16 0 0 1 672 676z' })
	  );
	}
	BlockShow.displayName = 'BlockShow';
	
	module.exports = BlockShow;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function BlockHidden(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M960 480h-64V160a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h192v64H127.712C92.512 960 64 931.2 64 896.288V127.68C64 92.512 92.8 64 127.712 64H896.32C931.488 64 960 92.8 960 127.712V480zM288 160h64v64H288V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m0 128h64v64h-64V288zM160 288h64v64H160V288z m0 128h64v64H160v-64z m0 128h64v64H160v-64z m0 128h64v64H160v-64zM160 160h64v64H160V160z m0 640h64v64H160v-64z' }),
	    React.createElement('path', { d: 'M559.392 933.44l98.464-98.432a100.32 100.32 0 0 0 113.12-113.12l111.424-111.424a376.416 376.416 0 0 1 65.6 104.416c5.344 13.76 5.344 28.48 0 42.24-19.52 46.624-95.104 198.88-276 198.88-43.392 0-80.704-8.672-112.608-22.528z m-97.92-71.744c-36.416-40.544-56.64-83.424-65.44-104.576a57.472 57.472 0 0 1 0-42.24c19.456-46.624 94.24-198.88 275.968-198.88 43.296 0 80.576 8.736 112.512 22.656l-98.368 98.336a100.32 100.32 0 0 0-113.12 113.12l-111.552 111.584z m394.368-309.536a20 20 0 0 1 0 28.288L516.48 919.84a20 20 0 1 1-28.288-28.288L827.52 552.16a20 20 0 0 1 28.288 0z' })
	  );
	}
	BlockHidden.displayName = 'BlockHidden';
	
	module.exports = BlockHidden;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function CheckboxActive(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M0.00064 192.640399A192.19176 192.19176 0 0 1 192.640399 0.00064h638.719202A192.19176 192.19176 0 0 1 1023.99936 192.640399v638.719202A192.19176 192.19176 0 0 1 831.359601 1023.99936H192.640399A192.19176 192.19176 0 0 1 0.00064 831.359601V192.640399z m421.503473 436.351455L240.448339 448.00008 149.952453 538.495967l271.55166 271.55166 452.479435-452.543434-90.431887-90.495887-362.047548 361.983548z' })
	  );
	}
	CheckboxActive.displayName = 'CheckboxActive';
	
	module.exports = CheckboxActive;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function CheckboxNormal(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M0.00064 192.640399A192.19176 192.19176 0 0 1 192.640399 0.00064h638.719202A192.19176 192.19176 0 0 1 1023.99936 192.640399v638.719202A192.19176 192.19176 0 0 1 831.359601 1023.99936H192.640399A192.19176 192.19176 0 0 1 0.00064 831.359601V192.640399z m63.99992-0.255999v639.2312C64.00056 902.591512 121.472488 959.99944 192.3844 959.99944h639.2312A128.31984 128.31984 0 0 0 959.99944 831.6156V192.3844A128.31984 128.31984 0 0 0 831.6156 64.00056H192.3844A128.31984 128.31984 0 0 0 64.00056 192.3844z' })
	  );
	}
	CheckboxNormal.displayName = 'CheckboxNormal';
	
	module.exports = CheckboxNormal;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Checkbox(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M896 64H128c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z m0 800c0 19.2-12.8 32-32 32H160c-19.2 0-32-12.8-32-32V160c0-19.2 12.8-32 32-32h704c19.2 0 32 12.8 32 32v704z' }),
	    React.createElement('path', { d: 'M694.4 364.8l-227.2 227.2-112-112c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l134.4 134.4c6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l249.6-249.6c12.8-12.8 12.8-32 0-44.8-12.8-9.6-32-9.6-44.8 0z' })
	  );
	}
	Checkbox.displayName = 'Checkbox';
	
	module.exports = Checkbox;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Clear(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M557.248 512l158.56-158.528a31.904 31.904 0 0 0-0.16-45.12 31.808 31.808 0 0 0-45.12-0.16L512 466.752 353.472 308.16a31.904 31.904 0 0 0-45.12 0.16 31.808 31.808 0 0 0-0.16 45.12L466.752 512 308.16 670.528a31.904 31.904 0 0 0 0.16 45.12 31.808 31.808 0 0 0 45.12 0.16L512 557.248l158.528 158.56a31.904 31.904 0 0 0 45.12-0.16 31.808 31.808 0 0 0 0.16-45.12L557.248 512zM512 960C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z' })
	  );
	}
	Clear.displayName = 'Clear';
	
	module.exports = Clear;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Clone(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M192 256.16C192 220.736 220.704 192 256.16 192h639.68C931.264 192 960 220.704 960 256.16v639.68A64.16 64.16 0 0 1 895.84 960H256.16A64.16 64.16 0 0 1 192 895.84V256.16z m64 31.584v576.512a32 32 0 0 0 31.744 31.744h576.512a32 32 0 0 0 31.744-31.744V287.744A32 32 0 0 0 864.256 256H287.744A32 32 0 0 0 256 287.744zM288 192v64h64V192H288z m128 0v64h64V192h-64z m128 0v64h64V192h-64z m128 0v64h64V192h-64z m128 0v64h64V192h-64z m96 96v64h64V288h-64z m0 128v64h64v-64h-64z m0 128v64h64v-64h-64z m0 128v64h64v-64h-64z m0 128v64h64v-64h-64z m-96 96v64h64v-64h-64z m-128 0v64h64v-64h-64z m-128 0v64h64v-64h-64z m-128 0v64h64v-64h-64z m-128 0v64h64v-64H288z m-96-96v64h64v-64H192z m0-128v64h64v-64H192z m0-128v64h64v-64H192z m0-128v64h64v-64H192z m0-128v64h64V288H192z m160 416c0-17.664 14.592-32 32.064-32h319.872a31.968 31.968 0 1 1 0 64h-319.872A31.968 31.968 0 0 1 352 704z m0-128c0-17.664 14.4-32 32.224-32h383.552c17.792 0 32.224 14.208 32.224 32 0 17.664-14.4 32-32.224 32H384.224A32.032 32.032 0 0 1 352 576z m0-128c0-17.664 14.4-32 32.224-32h383.552c17.792 0 32.224 14.208 32.224 32 0 17.664-14.4 32-32.224 32H384.224A32.032 32.032 0 0 1 352 448z m512 47.936V192h-64V159.968A31.776 31.776 0 0 0 768.032 128H160A31.776 31.776 0 0 0 128 159.968V768c0 17.92 14.304 31.968 31.968 31.968H192v64h303.936H128.128A63.968 63.968 0 0 1 64 799.872V128.128C64 92.704 92.48 64 128.128 64h671.744C835.296 64 864 92.48 864 128.128v367.808z' })
	  );
	}
	Clone.displayName = 'Clone';
	
	module.exports = Clone;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Close(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M556.8 512l272-272c12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0L512 467.2 240 195.2c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l272 272-272 272c-12.8 12.8-12.8 32 0 44.8 12.8 12.8 32 12.8 44.8 0l272-272 272 272c12.8 12.8 32 12.8 44.8 0 12.8-12.8 12.8-32 0-44.8L556.8 512z' })
	  );
	}
	Close.displayName = 'Close';
	
	module.exports = Close;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Datapool(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M400 622.272c-118.912-7.264-220.544-37.504-280-79.712v81.408c0 55.488 121.056 101.568 280 110.4v55.904c-118.912-7.264-220.544-37.44-280-79.744v81.44H64V260C64 151.744 239.488 64 456 64c216.448 0 391.936 87.744 391.936 196v176.832h-56v-75.84c-68.576 56.896-193.408 94.976-335.968 94.976-142.56 0-267.36-38.08-336-94.976v94.976c0 55.488 121.088 101.6 280 110.432v55.872z m56 337.664c-216.512 0-392-75.2-392-168h56c0 61.888 150.4 112 336 112v56z m0-559.968c185.536 0 335.968-62.72 335.968-139.968 0-77.28-150.4-140-336-140-185.568 0-336 62.72-336 140 0 77.248 150.432 139.968 336 139.968z m487.264 367.36l-38.976-22.72c2.176-11.904 3.584-24.064 3.584-36.64a202.72 202.72 0 0 0-3.584-36.672l38.976-22.72c15.968-9.408 21.408-29.888 12.192-45.952l-33.28-58.176a33.152 33.152 0 0 0-45.568-12.32l-39.424 22.976a199.36 199.36 0 0 0-62.592-36.96v-28.576c0-18.528-14.88-33.6-33.312-33.6h-66.624a33.472 33.472 0 0 0-33.344 33.6v28.576a199.36 199.36 0 0 0-62.592 36.96l-39.424-22.976a33.152 33.152 0 0 0-45.536 12.32l-33.28 58.24a33.76 33.76 0 0 0 12.16 45.92l39.008 22.688c-2.304 12.064-3.52 24.352-3.584 36.672 0 12.576 1.376 24.736 3.584 36.672l-38.976 22.72c-16 9.376-21.44 29.856-12.224 45.92l33.312 58.176a33.152 33.152 0 0 0 45.536 12.32l39.424-22.944a198.784 198.784 0 0 0 62.592 36.96v28.544c0 18.56 14.912 33.6 33.344 33.6h66.624a33.472 33.472 0 0 0 33.312-33.6v-28.544a199.36 199.36 0 0 0 62.592-36.96l39.424 22.944a33.216 33.216 0 0 0 45.536-12.32l33.312-58.24a33.76 33.76 0 0 0-12.192-45.888z m-41.376 33.088l-15.36 26.144a15.52 15.52 0 0 1-20.992 5.472l-42.656-24.16a153.984 153.984 0 0 1-84.16 47.808v33.216c0 8.288-6.912 15.04-15.424 15.04h-30.688a15.232 15.232 0 0 1-15.36-15.104V855.68a153.984 153.984 0 0 1-84.192-47.808L550.4 832a15.52 15.52 0 0 1-21.024-5.472l-15.36-26.144a14.88 14.88 0 0 1 5.632-20.544l42.848-24.32a147.2 147.2 0 0 1-8.128-47.584c0-16.704 3.008-32.608 8.16-47.616l-42.88-24.32a14.88 14.88 0 0 1-5.6-20.512l15.36-26.176a15.52 15.52 0 0 1 20.992-5.472l42.656 24.192a153.984 153.984 0 0 1 84.16-47.808V527.04c0-8.32 6.88-15.04 15.392-15.04h30.72c8.48 0 15.36 6.72 15.36 15.104v33.152a153.984 153.984 0 0 1 84.16 47.808l42.688-24.192a15.52 15.52 0 0 1 20.992 5.472l15.36 26.176a14.88 14.88 0 0 1-5.6 20.544l-42.848 24.32c5.024 14.976 8.128 30.88 8.128 47.584 0 16.672-3.04 32.576-8.128 47.584l42.848 24.32a14.88 14.88 0 0 1 5.6 20.544z m-193.92-176.448a84 84 0 1 0 0 168 84 84 0 0 0 0-168z m0 112a28 28 0 1 1 0-56 28 28 0 0 1 0 56z' })
	  );
	}
	Datapool.displayName = 'Datapool';
	
	module.exports = Datapool;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Date(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M560 688h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m0-160h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m160 0h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m-320 0h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m320 160h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m0 160h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m-160 0h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m-320 0h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m0-160h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z' }),
	    React.createElement('path', { d: 'M896 128H768V96c0-16-12.8-32-32-32s-32 12.8-32 32v32H320V96c0-16-12.8-32-32-32s-32 12.8-32 32v32H128c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z m0 736c0 19.2-12.8 32-32 32H160c-19.2 0-32-12.8-32-32V368h768v496z m0-560H128v-80c0-19.2 12.8-32 32-32h96v32c0 16 12.8 32 32 32s32-12.8 32-32v-32h384v32c0 16 12.8 32 32 32s32-12.8 32-32v-32h96c19.2 0 32 12.8 32 32v80z' }),
	    React.createElement('path', { d: 'M240 528h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m160 160h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z m0 160h64c9.6 0 16-6.4 16-16v-64c0-9.6-6.4-16-16-16h-64c-9.6 0-16 6.4-16 16v64c0 9.6 6.4 16 16 16z' })
	  );
	}
	Date.displayName = 'Date';
	
	module.exports = Date;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Dialog(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M640 768H256c-19.2 0-32 12.8-32 32s16 32 32 32h384c19.2 0 32-12.8 32-32s-16-32-32-32zM896 64H256c-19.2 0-32 12.8-32 32s12.8 32 32 32h608c19.2 0 32 12.8 32 32v608c0 19.2 12.8 32 32 32s32-12.8 32-32V128c0-35.2-28.8-64-64-64z' }),
	    React.createElement('path', { d: 'M768 192H128c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h640c35.2 0 64-28.8 64-64V256c0-35.2-28.8-64-64-64z m0 672c0 16-16 32-32 32H160c-16 0-32-16-32-32V288c0-16 16-32 32-32h576c16 0 32 16 32 32v576z' })
	  );
	}
	Dialog.displayName = 'Dialog';
	
	module.exports = Dialog;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Doubt(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M473.536 593.408v-7.04c0-22.656 3.84-42.24 12.704-58.112 8.288-17.12 32.448-42.208 71.84-75.84l10.816-11.616c11.456-14.08 17.792-28.768 17.792-44.64 0-21.44-6.336-37.92-18.432-50.176-12.704-12.224-31.136-18.336-54.016-18.336-28.64 0-49.6 8.576-62.304 26.304-11.36 14.528-17.056 35.072-17.184 61.6a31.616 31.616 0 0 1 0.192 3.584c0 17.856-14.976 32.32-33.472 32.32-18.496 0-33.472-14.464-33.472-32.32a31.68 31.68 0 0 1 0.128-2.816H368c0-44.64 13.344-79.488 40.064-105.184 26.688-26.304 63.552-39.136 110.624-39.136 40.672 0 73.728 10.4 99.168 32.416 25.44 21.408 38.144 50.752 38.144 87.456 0 29.952-8.256 55.04-24.16 74.592-5.728 6.72-23.52 22.656-53.408 47.712a102.4 102.4 0 0 0-26.688 31.808 79.648 79.648 0 0 0-10.176 40.352v10.4h-0.064c-0.8 17.504-15.712 31.456-34.016 31.456-18.784 0-34.016-14.72-34.016-32.896 0-0.64 0-1.28 0.064-1.92zM512 960C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z m0-64c212.064 0 384-171.936 384-384S724.064 128 512 128 128 299.936 128 512s171.936 384 384 384z m-4.768-231.456c13.344 0 24.8 3.68 33.696 12.224 8.896 7.968 13.344 18.368 13.344 31.2s-5.088 23.232-13.984 31.808a48.8 48.8 0 0 1-33.056 12.224c-12.704 0-24.16-4.288-33.056-12.832a41.664 41.664 0 0 1-13.344-31.2c0-12.832 4.448-23.232 13.344-31.2 8.896-8.544 20.352-12.224 33.056-12.224z' })
	  );
	}
	Doubt.displayName = 'Doubt';
	
	module.exports = Doubt;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Download(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M483.2 822.4v-256c0-12.8 12.8-25.6 25.6-25.6s25.6 12.8 25.6 25.6v256l51.2-38.4c12.8-6.4 25.6-6.4 38.4 6.4 12.8 19.2 6.4 32-6.4 38.4l-96 70.4c0 6.4-6.4 6.4-12.8 6.4s-12.8 0-12.8-6.4l-96-70.4c-12.8-6.4-12.8-25.6-6.4-38.4 6.4-12.8 25.6-12.8 38.4-6.4l51.2 38.4z m-204.8-38.4h-19.2c-115.2 0-204.8-102.4-204.8-224 0-128 96-230.4 211.2-224 38.4-128 147.2-217.6 268.8-217.6 134.4 0 249.6 102.4 281.6 249.6 89.6 19.2 153.6 102.4 153.6 204.8 0 115.2-83.2 211.2-185.6 211.2-32 0-96 0-166.4-57.6-12.8-12.8-12.8-32 0-38.4 12.8-12.8 25.6-12.8 38.4 0 51.2 51.2 96 44.8 121.6 44.8h6.4c76.8 0 134.4-70.4 134.4-160 0-83.2-57.6-153.6-128-160-12.8 0-19.2-12.8-25.6-19.2-19.2-128-115.2-224-230.4-224-102.4 0-198.4 83.2-224 198.4 0 12.8-12.8 19.2-32 19.2h-25.6c-83.2 0-147.2 76.8-147.2 172.8 0 96 64 172.8 147.2 172.8h12.8c25.6 0 57.6 0 102.4-44.8 12.8-12.8 25.6-12.8 38.4 0 12.8 12.8 12.8 25.6 0 38.4-51.2 51.2-96 57.6-128 57.6z' })
	  );
	}
	Download.displayName = 'Download';
	
	module.exports = Download;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function DragHandler(props) {
			return React.createElement(
					IconBase,
					_extends({ viewBox: '43.5 80 1000 400' }, props),
					React.createElement('path', { d: 'M135.9,177.6c0,26.3,21.3,47.5,47.5,47.5s47.5-21.3,47.5-47.5l0,0c0-26.3-21.3-47.5-47.5-47.5\r S135.9,151.3,135.9,177.6z M376,177.6c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0\r c0-26.3-21.3-47.6-47.5-47.6C397.3,130,376,151.3,376,177.6C376,177.5,376,177.5,376,177.6z M616,177.6c0,26.3,21.3,47.6,47.5,47.6\r c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0c0-26.3-21.3-47.6-47.5-47.6C637.4,130,616.1,151.3,616,177.6\r C616,177.5,616,177.5,616,177.6z M856,177.6c0,26.3,21.3,47.6,47.5,47.6s47.6-21.3,47.6-47.5c0,0,0,0,0,0\r c0-26.3-21.3-47.6-47.5-47.6C877.3,130,856.1,151.3,856,177.6C856,177.5,856,177.5,856,177.6z M135.9,382.4\r c0,26.3,21.3,47.5,47.5,47.5s47.5-21.3,47.5-47.5s-21.3-47.5-47.5-47.5S135.9,356.2,135.9,382.4z M376,382.4\r c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0c0-26.3-21.3-47.6-47.5-47.6C397.3,334.9,376,356.1,376,382.4\r C376,382.4,376,382.4,376,382.4z M616,382.4c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0\r c0-26.3-21.3-47.6-47.5-47.6C637.4,334.9,616.1,356.1,616,382.4C616,382.4,616,382.4,616,382.4z M856,382.4\r c0,26.3,21.3,47.6,47.5,47.6c26.3,0,47.6-21.3,47.6-47.5c0,0,0,0,0,0c0-26.3-21.3-47.6-47.5-47.6C877.3,334.9,856.1,356.1,856,382.4\r C856,382.4,856,382.4,856,382.4z' })
			);
	}
	DragHandler.displayName = 'DragHandler';
	
	module.exports = DragHandler;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Drag(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 5 16' }, props),
	    React.createElement('path', { d: 'M0.499972716,6 L1.50002728,6 C1.77615459,6 2,6.22384541 2,6.49997272 C2,6.77610002 1.77615459,6.99994543 1.50002728,6.99994543 L0.499972716,6.99994543 C0.22384541,6.99994543 3.38158422e-17,6.77610002 0,6.49997272 C-3.38158422e-17,6.22384541 0.22384541,6 0.499972716,6 Z M0.499972716,3 L1.50002728,3 C1.77615459,3 2,3.22384541 2,3.49997272 C2,3.77610002 1.77615459,3.99994543 1.50002728,3.99994543 L0.499972716,3.99994543 C0.22384541,3.99994543 3.38158422e-17,3.77610002 0,3.49997272 C-3.38158422e-17,3.22384541 0.22384541,3 0.499972716,3 Z M0.499972716,7.28787148e-18 L1.50002728,5.55666624e-14 C1.77615459,7.07214574e-14 2,0.22384541 2,0.499972716 C2,0.776100022 1.77615459,0.999945432 1.50002728,0.999945432 L0.499972716,0.999945432 C0.22384541,0.999945432 3.38158422e-17,0.776100022 0,0.499972716 C-3.38158422e-17,0.22384541 0.22384541,5.0723721e-17 0.499972716,0 Z M0.5,9.00002729 L1.5,9.00002729 C1.77614237,9.00002729 2,9.22388491 2,9.50002729 C2,9.77616966 1.77614237,10.0000273 1.5,10.0000273 L0.5,10.0000273 C0.223857625,10.0000273 3.38176876e-17,9.77616966 0,9.50002729 C-3.38176876e-17,9.22388491 0.223857625,9.00002729 0.5,9.00002729 Z M0.5,12.0000273 L1.5,12.0000273 C1.77614237,12.0000273 2,12.2238849 2,12.5000273 C2,12.7761697 1.77614237,13.0000273 1.5,13.0000273 L0.5,13.0000273 C0.223857625,13.0000273 3.38176876e-17,12.7761697 0,12.5000273 C-3.38176876e-17,12.2238849 0.223857625,12.0000273 0.5,12.0000273 Z M0.5,15.0000273 L1.5,15.0000273 C1.77614237,15.0000273 2,15.2238849 2,15.5000273 C2,15.7761697 1.77614237,16.0000273 1.5,16.0000273 L0.5,16.0000273 C0.223857625,16.0000273 3.38176876e-17,15.7761697 0,15.5000273 C-3.38176876e-17,15.2238849 0.223857625,15.0000273 0.5,15.0000273 Z M3.49997272,6 L4.50002728,6 C4.77615459,6 5,6.22384541 5,6.49997272 C5,6.77610002 4.77615459,6.99994543 4.50002728,6.99994543 L3.49997272,6.99994543 C3.22384541,6.99994543 3,6.77610002 3,6.49997272 C3,6.22384541 3.22384541,6 3.49997272,6 Z M3.49997272,3 L4.50002728,3 C4.77615459,3 5,3.22384541 5,3.49997272 C5,3.77610002 4.77615459,3.99994543 4.50002728,3.99994543 L3.49997272,3.99994543 C3.22384541,3.99994543 3,3.77610002 3,3.49997272 C3,3.22384541 3.22384541,3 3.49997272,3 Z M3.49997272,7.28787148e-18 L4.50002728,5.55666624e-14 C4.77615459,7.07214574e-14 5,0.22384541 5,0.499972716 C5,0.776100022 4.77615459,0.999945432 4.50002728,0.999945432 L3.49997272,0.999945432 C3.22384541,0.999945432 3,0.776100022 3,0.499972716 C3,0.22384541 3.22384541,5.0723721e-17 3.49997272,0 Z M3.5,9.00002729 L4.5,9.00002729 C4.77614237,9.00002729 5,9.22388491 5,9.50002729 C5,9.77616966 4.77614237,10.0000273 4.5,10.0000273 L3.5,10.0000273 C3.22385763,10.0000273 3,9.77616966 3,9.50002729 C3,9.22388491 3.22385763,9.00002729 3.5,9.00002729 Z M3.5,12.0000273 L4.5,12.0000273 C4.77614237,12.0000273 5,12.2238849 5,12.5000273 C5,12.7761697 4.77614237,13.0000273 4.5,13.0000273 L3.5,13.0000273 C3.22385763,13.0000273 3,12.7761697 3,12.5000273 C3,12.2238849 3.22385763,12.0000273 3.5,12.0000273 Z M3.5,15.0000273 L4.5,15.0000273 C4.77614237,15.0000273 5,15.2238849 5,15.5000273 C5,15.7761697 4.77614237,16.0000273 4.5,16.0000273 L3.5,16.0000273 C3.22385763,16.0000273 3,15.7761697 3,15.5000273 C3,15.2238849 3.22385763,15.0000273 3.5,15.0000273 Z', id: 'Combined-Shape' })
	  );
	}
	Drag.displayName = 'Drag';
	
	module.exports = Drag;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Edit(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M707.872 289.6l-256.32 256.32 56.576 33.952 33.92 56.576 256.32-256.32-90.496-90.528z m45.28-45.248l90.496 90.496 22.624-22.624a32 32 0 0 0 0-45.248L821.024 221.76a32 32 0 0 0-45.248 0l-22.624 22.624z m-346.88 346.848l-15.168 15.2v90.496h90.496l15.2-15.2-33.92-56.544-56.576-33.952zM843.68 153.856l90.496 90.496a64 64 0 0 1 0 90.496L508.16 760.896h-181.024v-181.024L753.152 153.856a64 64 0 0 1 90.496 0zM576 96a32 32 0 0 1-32 32H160c-17.696 0-32 14.208-32 31.744v704.512c0 17.184 14.336 31.744 32 31.744h704c17.696 0 32-14.208 32-31.744V608a32 32 0 0 1 64 0v287.84C960 931.264 931.2 960 896.288 960H127.68C92.512 960 64 931.296 64 895.84V128.16C64 92.736 92.8 64 127.712 64H544a32 32 0 0 1 32 32z' })
	  );
	}
	Edit.displayName = 'Edit';
	
	module.exports = Edit;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Error(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M801.669 295.371l-56.156-56.151-224.623 224.622-224.622-224.622-56.159 56.151 224.625 224.627-224.625 224.623 56.159 56.159 224.622-224.626 224.623 224.626 56.156-56.159-224.623-224.623z' })
	  );
	}
	Error.displayName = 'Error';
	
	module.exports = Error;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Exit(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M723.872 478.4l-81.12-81.152L688 352l135.776 135.776L846.4 510.4 688 668.8l-45.248-45.28 81.12-81.12H384v-64h339.872zM576 896H256.192A64.16 64.16 0 0 1 192 831.84V192.16c0-35.424 28.704-64.16 64.192-64.16H576v64H288.224A31.968 31.968 0 0 0 256 223.744v576.512C256 817.44 270.4 832 288.224 832H576v64z' })
	  );
	}
	Exit.displayName = 'Exit';
	
	module.exports = Exit;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Expand(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M429.482667 60.032 372.906667 116.608 768.896 512.597333 372.949333 908.586667 429.482667 965.162667 882.048 512.597333Z' })
	  );
	}
	Expand.displayName = 'Expand';
	
	module.exports = Expand;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Forward(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M850.496 384H384v64h466.912l-126.656 126.624a32 32 0 1 0 45.28 45.248l181.088-181.024a31.904 31.904 0 0 0 0-45.248l-181.12-181.024a32 32 0 0 0-45.248 45.248L850.496 384zM64 704c0-176.736 143.264-320 320-320v64a256 256 0 0 0-256 256H64z m0 0h64v96a32 32 0 0 1-64 0v-96z' })
	  );
	}
	Forward.displayName = 'Forward';
	
	module.exports = Forward;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Fullscreen(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M600.224 378.496L818.752 160H704a32 32 0 0 1 0-64h192a31.904 31.904 0 0 1 32 32v192a32 32 0 0 1-64 0V205.248l-218.496 218.528a160.864 160.864 0 0 0-45.28-45.28z m45.28 221.76L864 818.72V704a32 32 0 0 1 64 0v192a31.904 31.904 0 0 1-32 32h-192a32 32 0 0 1 0-64h114.752l-218.528-218.496a160.864 160.864 0 0 0 45.28-45.28z m-221.76 45.248L205.28 864H320a32 32 0 0 1 0 64H128a31.904 31.904 0 0 1-32-32v-192a32 32 0 0 1 64 0v114.752l218.496-218.528a160.864 160.864 0 0 0 45.28 45.28z m-45.248-221.76L160 205.28V320a32 32 0 0 1-64 0V128a31.904 31.904 0 0 1 32-32h192a32 32 0 0 1 0 64H205.248l218.528 218.496a160.864 160.864 0 0 0-45.28 45.28z' })
	  );
	}
	Fullscreen.displayName = 'Fullscreen';
	
	module.exports = Fullscreen;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Fullscreenexit(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M685.248 640l211.424 211.424-45.248 45.248L640 685.248V800a32 32 0 0 1-64 0v-192a31.904 31.904 0 0 1 32-32h192a32 32 0 0 1 0 64h-114.752z m-346.496 0l-211.424 211.424 45.248 45.248L384 685.248V800a32 32 0 0 0 64 0v-192a31.904 31.904 0 0 0-32-32H224a32 32 0 0 0 0 64h114.752z m0-256L127.328 172.576 172.576 127.36 384 338.752V224a32 32 0 0 1 64 0v192a31.904 31.904 0 0 1-32 32H224a32 32 0 0 1 0-64h114.752z m346.496 0l211.424-211.424-45.248-45.248L640 338.752V224a32 32 0 0 0-64 0v192a31.904 31.904 0 0 0 32 32h192a32 32 0 0 0 0-64h-114.752z' })
	  );
	}
	Fullscreenexit.displayName = 'Fullscreenexit';
	
	module.exports = Fullscreenexit;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Global(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M162.816 672h199.68c-5.472-40.192-8.96-83.2-10.08-128H129.28c3.744 45.344 15.36 88.48 33.504 128z m37.248 64a384.32 384.32 0 0 0 223.712 149.824c-20.64-38.272-37.92-89.6-50.368-149.824H200.064z m661.12-64c18.144-39.52 29.76-82.656 33.504-128h-223.104a1166.624 1166.624 0 0 1-10.08 128h199.68z m-37.248 64H650.56c-12.448 60.192-29.728 111.552-50.368 149.824A384.32 384.32 0 0 0 823.904 736z m-399.232-64h174.592c4.544-39.52 7.424-82.656 8.384-128h-191.36c0.96 45.344 3.84 88.48 8.384 128z m9.312 64c17.44 96.896 45.856 160 77.984 160 32.128 0 60.544-63.104 77.984-160h-155.968z m-304.704-256h223.104c1.12-44.8 4.608-87.808 10.08-128h-199.68a381.632 381.632 0 0 0-33.504 128z m765.376 0a381.632 381.632 0 0 0-33.504-128h-199.68c5.472 40.192 8.96 83.2 10.08 128h223.104zM416.32 480h191.36a1379.936 1379.936 0 0 0-8.384-128h-174.592a1379.936 1379.936 0 0 0-8.384 128zM200.064 288h173.344c12.448-60.192 29.728-111.552 50.368-149.824A384.32 384.32 0 0 0 200.096 288z m623.872 0a384.32 384.32 0 0 0-223.712-149.824c20.64 38.272 37.92 89.6 50.368 149.824h173.344zM434.016 288h155.968C572.544 191.104 544.128 128 512 128c-32.128 0-60.544 63.104-77.984 160zM512 960C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z' })
	  );
	}
	Global.displayName = 'Global';
	
	module.exports = Global;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Hidden(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement(
	      'defs',
	      null,
	      React.createElement('style', { type: 'text/css' })
	    ),
	    React.createElement('path', { d: 'M183.423543 657.078213l163.499771-98.484012c-4.233418-14.908548-6.646374-30.585599-6.646374-46.852074 0-94.665033 76.739778-171.404812 171.404812-171.404812 45.983287 0 87.641059 18.20871 118.42518 47.679929l129.791042-78.17957c-73.254398-41.73145-157.866471-65.812915-248.216221-65.812915-192.742792 0-360.068705 108.505249-444.453604 267.715321C96.636944 567.228859 136.301316 616.355743 183.423543 657.078213zM841.253886 367.552144l-164.382884 99.015108c3.934612 14.415314 6.215562 29.513174 6.215562 45.174875 0 94.665033-76.739778 171.404812-171.404812 171.404812-45.361117 0-86.484723-17.747199-117.142977-46.515407l-129.419582 77.955466c72.874751 41.149189 156.893306 64.871473 246.563582 64.871473 192.742792 0 360.068705-108.505249 444.453604-267.717368C927.000805 456.773188 887.794875 408.054603 841.253886 367.552144zM420.280042 511.741104c0 0.550539 0.152473 1.060145 0.161682 1.608637l135.080511-81.366146c-13.065574-7.198959-27.854395-11.658528-43.826158-11.658528C461.20922 420.325068 420.280042 461.254246 420.280042 511.741104zM447.739441 576.947198l69.02098-41.574884L948.364369 275.395234c10.812253-6.512321 14.297634-20.558222 7.785314-31.369452-6.512321-10.812253-20.556175-14.296611-31.368428-7.785314L575.654762 446.537056l0 0-151.20577 91.078345 0 0L75.027787 748.090043c-10.812253 6.512321-14.297634 20.556175-7.785314 31.368428 6.512321 10.812253 20.556175 14.297634 31.369452 7.785314L447.739441 576.947198 447.739441 576.947198zM511.696078 603.157139c50.487881 0 91.416036-40.928155 91.416036-91.416036 0-0.549515-0.152473-1.057075-0.161682-1.605567l-135.079488 81.364099C480.935494 598.699618 495.724315 603.157139 511.696078 603.157139z' })
	  );
	}
	Hidden.displayName = 'Hidden';
	
	module.exports = Hidden;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function History(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M544 494.4l152.48 88.032a31.872 31.872 0 0 1 11.616 43.68c-8.832 15.296-28.544 20.48-43.616 11.776l-166.464-96.096a31.968 31.968 0 0 1-8.288-6.88 31.776 31.776 0 0 1-9.728-22.752v-256.32c0-17.6 14.208-31.84 32-31.84 17.664 0 32 14.592 32 31.84v238.592zM512 96c229.504 0 416 186.496 416 416s-186.496 416-416 416S96 741.504 96 512 282.496 96 512 96z m0 768c194.304 0 352-157.696 352-352S706.304 160 512 160 160 317.696 160 512s157.696 352 352 352z' })
	  );
	}
	History.displayName = 'History';
	
	module.exports = History;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Html(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M73.344 534.496a31.552 31.552 0 0 1 0-44.864v-0.064l224.384-224.192a31.712 31.712 0 1 1 44.896 44.864L140.672 512l201.952 201.824a31.68 31.68 0 0 1 0.064 44.928 31.936 31.936 0 0 1-44.96-0.064l-224.352-224.192h-0.032z m877.312 0v0.032l-224.384 224.192a31.936 31.936 0 0 1-44.96 0.064 31.68 31.68 0 0 1 0.064-44.928l201.952-201.824-201.952-201.792a31.712 31.712 0 1 1 44.896-44.864l224.352 224.192h0.032v0.032a31.552 31.552 0 0 1 0 44.864v0.032z' })
	  );
	}
	Html.displayName = 'Html';
	
	module.exports = Html;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Info(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M480 672v-192h-64c-17.664 0-32-14.208-32-32 0-17.664 14.208-32 32-32h96a31.904 31.904 0 0 1 32 31.84V672h64.096c17.6 0 31.904 14.208 31.904 32 0 17.664-14.496 32-31.904 32h-192.192A31.872 31.872 0 0 1 384 704c0-17.664 14.496-32 31.904-32H480z m32 288C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z m0-64c212.064 0 384-171.936 384-384S724.064 128 512 128 128 299.936 128 512s171.936 384 384 384zM448 304c0-26.496 21.312-48 48-48 26.496 0 48 21.312 48 48 0 26.496-21.312 48-48 48-26.496 0-48-21.312-48-48z' })
	  );
	}
	Info.displayName = 'Info';
	
	module.exports = Info;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Js(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M726.4 515.2c-12.8-6.4-41.6-16-83.2-28.8-28.8-9.6-48-16-54.4-19.2-16-6.4-22.4-19.2-22.4-32 0-16 6.4-25.6 19.2-32 9.6-6.4 25.6-9.6 44.8-9.6 22.4 0 41.6 3.2 54.4 12.8 12.8 9.6 19.2 22.4 25.6 41.6h51.2c-3.2-35.2-16-57.6-38.4-73.6-22.4-16-51.2-22.4-89.6-22.4-35.2 0-64 6.4-86.4 22.4-25.6 16-35.2 38.4-35.2 64s12.8 48 35.2 60.8c9.6 6.4 35.2 12.8 73.6 25.6 35.2 9.6 54.4 16 60.8 19.2 19.2 9.6 28.8 22.4 28.8 38.4 0 12.8-6.4 22.4-19.2 32-12.8 6.4-32 12.8-54.4 12.8-25.6 0-44.8-3.2-57.6-12.8-12.8-9.6-22.4-25.6-25.6-51.2h-51.2c3.2 38.4 16 67.2 44.8 86.4 22.4 16 54.4 22.4 92.8 22.4 41.6 0 73.6-9.6 96-22.4 22.4-16 32-38.4 32-64 0-32-12.8-54.4-41.6-70.4zM406.4 563.2c0 22.4-3.2 38.4-12.8 48-9.6 9.6-22.4 16-38.4 16-32 0-48-19.2-48-54.4v-9.6H256v12.8c0 28.8 9.6 54.4 25.6 70.4 16 16 41.6 25.6 73.6 25.6 38.4 0 64-9.6 80-25.6s22.4-41.6 22.4-80v-208h-51.2v204.8z' }),
	    React.createElement('path', { d: 'M896 128H128c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z m0 672c0 16-12.8 32-32 32H160c-19.2 0-32-16-32-32V224c0-16 12.8-32 32-32h704c19.2 0 32 16 32 32v576z' })
	  );
	}
	Js.displayName = 'Js';
	
	module.exports = Js;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Keymap(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M800 544h-96a32 32 0 0 1 0-64h64v-128a32 32 0 0 1 64 0v160a32 32 0 0 1-32 32zM128 192h768a64 64 0 0 1 64 64v512a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V256a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32H160z m64 64h64a32 32 0 1 1 0 64H224a32 32 0 1 1 0-64z m192 0h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64z m192 0h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64zM224 480h32a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z m160 0h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64z m160 0h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64zM224 640h32a32 32 0 0 1 0 64H224a32 32 0 0 1 0-64z m160 0h256a32 32 0 0 1 0 64h-256a32 32 0 0 1 0-64z m384 0h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64z' })
	  );
	}
	Keymap.displayName = 'Keymap';
	
	module.exports = Keymap;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Loading(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M192 512a32 32 0 0 1 64 0 256 256 0 1 0 256-256 32 32 0 0 1 0-64c176.736 0 320 143.264 320 320s-143.264 320-320 320S192 688.736 192 512z' })
	  );
	}
	Loading.displayName = 'Loading';
	
	module.exports = Loading;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function MagicStick(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement(
	      'defs',
	      null,
	      React.createElement('style', { type: 'text/css' })
	    ),
	    React.createElement('path', { d: 'M216.128 258.976L314.24 176.704a32 32 0 0 1 45.056 3.936L811.84 719.936a32 32 0 0 1-3.936 45.088l-98.08 82.272a32 32 0 0 1-45.056-3.936L212.16 304.064a32 32 0 0 1 3.936-45.088z m189.088 175.552l287.968 343.168 49.024-41.12-288-343.2-48.992 41.152zM281.792 287.424l49.024-41.12 82.272 98.048-49.024 41.152-82.24-98.08zM160 480v-32h32v32h32v32H192v32H160v-32H128v-32h32z m544-288V96h64v96h96v64h-96v96h-64V256h-96V192h96zM256 672v-64h64v64h64v64h-64v64H256v-64H192v-64h64z', 'p-id': '2962' })
	  );
	}
	MagicStick.displayName = 'MagicStick';
	
	module.exports = MagicStick;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function MetadataField(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 704h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H160zM768 64h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32h-64zM448 704h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32h-64zM448 64h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32h-64z m288 576h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32h-64zM448 384h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32h-64zM128 384h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m640 0h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32h-64zM160 448a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H160zM128 64h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H160z' })
	  );
	}
	MetadataField.displayName = 'MetadataField';
	
	module.exports = MetadataField;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function MetadataFieldExtends(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 64h256a64 64 0 0 1 64 64v256a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H160z m288 576h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32h-64zM128 704h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H160z m608-64h128a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64h-128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m128-512a32 32 0 0 1 32 32v384a32 32 0 0 1-64 0V256h-230.4l42.272 42.272a32 32 0 0 1-45.248 45.28L540.16 253.024a31.936 31.936 0 0 1-9.28-25.376 31.936 31.936 0 0 1 9.28-25.376l90.496-90.496a32 32 0 1 1 45.248 45.248L640.896 192H896z m-96 576a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32h-64z' })
	  );
	}
	MetadataFieldExtends.displayName = 'MetadataFieldExtends';
	
	module.exports = MetadataFieldExtends;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function MetadataFieldset(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 96h768a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32H160z m-32 224h768a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H160z m608 32h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64zM128 672h768a64 64 0 0 1 64 64v128a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H160z m608 32h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64z m0-576h32a32 32 0 0 1 0 64h-32a32 32 0 0 1 0-64z' })
	  );
	}
	MetadataFieldset.displayName = 'MetadataFieldset';
	
	module.exports = MetadataFieldset;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Minus(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 16 16' }, props),
	    React.createElement('path', { d: 'M8,1.07142857 C8.93571429,1.07142857 9.84285714,1.25535714 10.6964286,1.61607143 C11.5214286,1.96428571 12.2625,2.46428571 12.8982143,3.10178571 C13.5357143,3.7375 14.0357143,4.47857143 14.3839286,5.30357143 C14.7446429,6.15714286 14.9285714,7.06428571 14.9285714,8 C14.9285714,8.93571429 14.7446429,9.84285714 14.3839286,10.6964286 C14.0357143,11.5214286 13.5357143,12.2625 12.8982143,12.8982143 C12.2625,13.5357143 11.5214286,14.0357143 10.6964286,14.3839286 C9.84285714,14.7446429 8.93571429,14.9285714 8,14.9285714 C7.06428571,14.9285714 6.15714286,14.7446429 5.30357143,14.3839286 C4.47857143,14.0357143 3.7375,13.5357143 3.10178571,12.8982143 C2.46428571,12.2625 1.96428571,11.5214286 1.61607143,10.6964286 C1.25535714,9.84285714 1.07142857,8.93571429 1.07142857,8 C1.07142857,7.06428571 1.25535714,6.15714286 1.61607143,5.30357143 C1.96428571,4.47857143 2.46428571,3.7375 3.10178571,3.10178571 C3.7375,2.46428571 4.47857143,1.96428571 5.30357143,1.61607143 C6.15714286,1.25535714 7.06428571,1.07142857 8,1.07142857 L8,1.07142857 Z M8,0 C3.58214286,0 0,3.58214286 0,8 C0,12.4178571 3.58214286,16 8,16 C12.4178571,16 16,12.4178571 16,8 C16,3.58214286 12.4178571,0 8,0 Z' }),
	    React.createElement('path', { d: 'M11.8392857,7.46428571 L4.16071429,7.46428571 C3.86428571,7.46428571 3.625,7.70357143 3.625,8 C3.625,8.29642857 3.86428571,8.53571429 4.16071429,8.53571429 L11.8392857,8.53571429 C12.1357143,8.53571429 12.375,8.29642857 12.375,8 C12.375,7.70357143 12.1357143,7.46428571 11.8392857,7.46428571 Z' })
	  );
	}
	Minus.displayName = 'Minus';
	
	module.exports = Minus;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Mobile(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M561.895899 62.5895l-284.015565-0.192382c-11.704576 0-65.240887-0.140193-65.240887 64.309678l0.00921 759.979838c0 41.22696 35.080983 74.91727 77.954443 74.91727l442.785615 0c42.872436 0 77.95342-33.69031 77.95342-74.91727l0.01842-758.444878c0-65.844637-72.092945-65.844637-82.2247-65.844637L561.895899 62.5895zM462.103078 112.558565l99.79282 0c8.597819 0 12.483312 16.645099 12.483312 24.948205 0 8.267291-3.885494 24.985044-12.483312 24.985044l-99.79282 0c-8.595772 0-12.429077-16.71673-12.429077-24.985044C449.675024 114.143667 462.103078 112.558565 462.103078 112.558565zM512.009721 911.304312c-27.572986 0-49.888224-22.167882-49.888224-49.585325 0-27.453259 22.315238-49.584302 49.888224-49.584302 27.582195 0 49.895387 22.131043 49.895387 49.584302 0 27.417443-24.050766 49.951669-49.904597 49.951669M755.80219 774.34501 268.836353 774.34501 268.836353 212.461903l486.965837 0L755.80219 774.34501z' })
	  );
	}
	Mobile.displayName = 'Mobile';
	
	module.exports = Mobile;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function More(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 64h288a64 64 0 0 1 64 64v288a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H160z m448-64h288a64 64 0 0 1 64 64v288a64 64 0 0 1-64 64h-288a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32h-224z m-32 416h288a64 64 0 0 1 64 64v288a64 64 0 0 1-64 64h-288a64 64 0 0 1-64-64v-288a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-224a32 32 0 0 0-32-32h-224zM128 544h288a64 64 0 0 1 64 64v288a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64v-288a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32v-224a32 32 0 0 0-32-32H160z' })
	  );
	}
	More.displayName = 'More';
	
	module.exports = More;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function More2(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M192 608a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m320 0a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m320 0a96 96 0 1 1 0-192 96 96 0 0 1 0 192z' })
	  );
	}
	More2.displayName = 'More2';
	
	module.exports = More2;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Nonselected(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M0.00064 192.640399A192.19176 192.19176 0 0 1 192.640399 0.00064h638.719202A192.19176 192.19176 0 0 1 1023.99936 192.640399v638.719202A192.19176 192.19176 0 0 1 831.359601 1023.99936H192.640399A192.19176 192.19176 0 0 1 0.00064 831.359601V192.640399z m63.99992-0.255999v639.2312C64.00056 902.591512 121.472488 959.99944 192.3844 959.99944h639.2312A128.31984 128.31984 0 0 0 959.99944 831.6156V192.3844A128.31984 128.31984 0 0 0 831.6156 64.00056H192.3844A128.31984 128.31984 0 0 0 64.00056 192.3844z' })
	  );
	}
	Nonselected.displayName = 'Nonselected';
	
	module.exports = Nonselected;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Noradio(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z m0-64A448 448 0 1 0 512 64a448 448 0 0 0 0 896z' })
	  );
	}
	Noradio.displayName = 'Noradio';
	
	module.exports = Noradio;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Outline(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 96h512a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64z m32 64a32 32 0 1 0 0 64h448a32 32 0 0 0 0-64H160z m224 576h512a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64z m32 64a32 32 0 0 0 0 64h448a32 32 0 0 0 0-64H416z m-32-384h512a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64z m32 64a32 32 0 0 0 0 64h448a32 32 0 0 0 0-64H416z' })
	  );
	}
	Outline.displayName = 'Outline';
	
	module.exports = Outline;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Page(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M236.864 64h472.96L896 261.12V848c0 61.856-54.72 112-114.848 112H236.832C176.768 960 128 909.856 128 848v-672C128 114.144 176.736 64 236.864 64zM672 128v133.856a26.144 26.144 0 0 0 26.144 26.144H832l-160-160z m106.656 768c29.44 0 53.344-24.576 53.344-54.848V347.424h-160c-29.44 0-53.344-24.544-53.344-54.848V128H245.344C215.904 128 192 152.576 192 182.848v658.304C192 871.424 215.872 896 245.344 896h533.312z' })
	  );
	}
	Page.displayName = 'Page';
	
	module.exports = Page;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Pc(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M224 736h576V324.8C800 304.48 785.664 288 768 288H256c-17.696 0-32 16.48-32 36.8V672h576v64H224z m-0.96 64H128a64 64 0 0 1-64-64h96V287.68C160 252.544 188.8 224 223.712 224H800.32C835.488 224 864 252.736 864 287.68V736h96a64 64 0 0 1-64 64H223.072z' })
	  );
	}
	Pc.displayName = 'Pc';
	
	module.exports = Pc;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Plus(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M480 480V288a32 32 0 0 1 64 0v192h192a32 32 0 0 1 0 64H544v192a32 32 0 0 1-64 0V544H288a32.64 32.64 0 0 1-32-32 32 32 0 0 1 32-32h192z m32-416a448 448 0 0 1 448 448c0 247.424-200.576 448-448 448S64 759.424 64 512 264.576 64 512 64z m0 832a384 384 0 0 0 384-384c0-212.064-171.936-384-384-384S128 299.936 128 512s171.936 384 384 384z' })
	  );
	}
	Plus.displayName = 'Plus';
	
	module.exports = Plus;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Popup(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M968.00128 152.86784 215.11168 152.86784c-29.70112 0-53.77792 24.07936-53.77792 53.79072l0 215.10784L0 529.32096l161.33376 107.55456 0 215.12192c0 29.69856 24.0768 53.77536 53.77792 53.77536l752.8896 0c29.70112 0 53.77792-24.0768 53.77792-53.77536l0-645.3376C1021.7792 176.9472 997.70368 152.86784 968.00128 152.86784zM403.3344 609.99296c-44.54912 0-80.66688-36.11776-80.66688-80.672 0-44.55552 36.11776-80.672 80.66688-80.672 44.54912 0 80.66688 36.11776 80.66688 80.672C484.00128 573.87648 447.88352 609.99296 403.3344 609.99296zM779.77856 609.99296c-44.55168 0-80.66688-36.11776-80.66688-80.672 0-44.55552 36.11392-80.672 80.66688-80.672s80.66688 36.11776 80.66688 80.672C860.44544 573.87648 824.33152 609.99296 779.77856 609.99296z' })
	  );
	}
	Popup.displayName = 'Popup';
	
	module.exports = Popup;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function PositionTop(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 128h768a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v576a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V224a32 32 0 0 0-32-32H160z m64 64h576a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32z' })
	  );
	}
	PositionTop.displayName = 'PositionTop';
	
	module.exports = PositionTop;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function PositionBottom(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 128h768a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v576a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V224a32 32 0 0 0-32-32H160z m64 384h576a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32v-128a32 32 0 0 1 32-32z' })
	  );
	}
	PositionBottom.displayName = 'PositionBottom';
	
	module.exports = PositionBottom;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function PositionLeft(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 128h768a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v576a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V224a32 32 0 0 0-32-32H160z m64 64h128a32 32 0 0 1 32 32v448a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32z' })
	  );
	}
	PositionLeft.displayName = 'PositionLeft';
	
	module.exports = PositionLeft;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function PositionRight(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M128 128h768a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m32 64a32 32 0 0 0-32 32v576a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V224a32 32 0 0 0-32-32H160z m512 64h128a32 32 0 0 1 32 32v448a32 32 0 0 1-32 32h-128a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32z' })
	  );
	}
	PositionRight.displayName = 'PositionRight';
	
	module.exports = PositionRight;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Preview(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512 864c-290.752 0-410.4-243.584-441.568-318.208a91.968 91.968 0 0 1 0-67.584C101.6 403.584 221.248 160 512 160c289.408 0 410.4 243.584 441.568 318.208 8.576 22.08 8.576 45.536 0 67.584C922.4 620.416 801.408 864 512 864zM129.984 500.48a30.4 30.4 0 0 0 0 21.664C156.16 588.48 261.6 800 512 800s355.84-211.52 382.016-276.48a30.4 30.4 0 0 0 0-21.664C867.84 435.52 762.4 224 512 224S156.16 435.52 129.984 500.48zM512 672c-88.192 0-160-72.32-160-160s71.808-160 160-160 160 72.32 160 160-71.808 160-160 160z m0-256c-52.608 0-96 42.88-96 96s42.88 96 96 96 96-42.88 96-96-43.392-96-96-96z' })
	  );
	}
	Preview.displayName = 'Preview';
	
	module.exports = Preview;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function RadioActive(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z m0-256a256 256 0 1 0 0-512 256 256 0 0 0 0 512z' })
	  );
	}
	RadioActive.displayName = 'RadioActive';
	
	module.exports = RadioActive;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function RadioNormal(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z m0-64A448 448 0 1 0 512 64a448 448 0 0 0 0 896z' })
	  );
	}
	RadioNormal.displayName = 'RadioNormal';
	
	module.exports = RadioNormal;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Radio(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M512 512m-160 0a160 160 0 1 0 320 0 160 160 0 1 0-320 0Z' }),
	    React.createElement('path', { d: 'M512 64C265.6 64 64 265.6 64 512s201.6 448 448 448 448-201.6 448-448S758.4 64 512 64z m0 832C300.8 896 128 723.2 128 512S300.8 128 512 128s384 172.8 384 384-172.8 384-384 384z' })
	  );
	}
	Radio.displayName = 'Radio';
	
	module.exports = Radio;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Remove(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M224 256v639.84A64 64 0 0 0 287.84 960h448.32A64 64 0 0 0 800 895.84V256h64a32 32 0 1 0 0-64H160a32 32 0 1 0 0 64h64zM384 96c0-17.664 14.496-32 31.904-32h192.192C625.696 64 640 78.208 640 96c0 17.664-14.496 32-31.904 32H415.904A31.872 31.872 0 0 1 384 96z m-96 191.744C288 270.208 302.4 256 320.224 256h383.552C721.6 256 736 270.56 736 287.744v576.512C736 881.792 721.6 896 703.776 896H320.224A32.224 32.224 0 0 1 288 864.256V287.744zM352 352c0-17.696 14.208-32.032 32-32.032 17.664 0 32 14.24 32 32v448c0 17.664-14.208 32-32 32-17.664 0-32-14.24-32-32V352z m128 0c0-17.696 14.208-32.032 32-32.032 17.664 0 32 14.24 32 32v448c0 17.664-14.208 32-32 32-17.664 0-32-14.24-32-32V352z m128 0c0-17.696 14.208-32.032 32-32.032 17.664 0 32 14.24 32 32v448c0 17.664-14.208 32-32 32-17.664 0-32-14.24-32-32V352z' })
	  );
	}
	Remove.displayName = 'Remove';
	
	module.exports = Remove;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Save(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M256 128H160a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32h-96v320a64 64 0 0 1-64 64H320a64 64 0 0 1-64-64V128zM128 64h768a64 64 0 0 1 64 64v768a64 64 0 0 1-64 64H128a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64z m192 64v288a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V128H320z m288 64a32 32 0 0 1 32 32v128a32 32 0 0 1-64 0V224a32 32 0 0 1 32-32z' })
	  );
	}
	Save.displayName = 'Save';
	
	module.exports = Save;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Search(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M741.216 695.968l192.896 192.864a31.968 31.968 0 1 1-45.28 45.28L695.968 741.216A382.464 382.464 0 0 1 448 832C235.936 832 64 660.064 64 448S235.936 64 448 64s384 171.936 384 384c0 94.528-34.144 181.056-90.784 247.968zM448 768c176.736 0 320-143.264 320-320S624.736 128 448 128 128 271.264 128 448s143.264 320 320 320z' })
	  );
	}
	Search.displayName = 'Search';
	
	module.exports = Search;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Section(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M64 127.712C64 92.512 92.864 64 128.288 64h255.424C419.232 64 448 92.8 448 127.712V896.32c0 35.2-28.864 63.712-64.288 63.712H128.32C92.768 960 64 931.2 64 896.288V127.68z m64 32.32v703.936c0 17.728 14.272 32.032 31.904 32.032h192.192c17.408 0 31.904-14.336 31.904-32V160c0-17.696-14.272-32-31.904-32H159.904C142.496 128 128 142.336 128 160z m384-31.744C512 92.768 540.704 64 576.192 64h319.616C931.264 64 960 92.864 960 128.288v255.424c0 35.52-28.704 64.288-64.192 64.288h-319.616A64.288 64.288 0 0 1 512 383.712V128.32z m64 31.616v192.192a32 32 0 0 0 31.84 31.904h256.32c17.28 0 31.84-14.272 31.84-31.904V159.904A32 32 0 0 0 864.16 128h-256.32c-17.28 0-31.84 14.272-31.84 31.904z m-64 416.288c0-35.456 28.704-64.192 64.192-64.192h319.616c35.456 0 64.192 28.704 64.192 64.192v319.616A64.16 64.16 0 0 1 895.808 960h-319.616A64.16 64.16 0 0 1 512 895.808v-319.616z m64 31.68v256.288c0 17.28 14.272 31.84 31.84 31.84h256.32c17.28 0 31.84-14.272 31.84-31.84v-256.32c0-17.28-14.272-31.84-31.84-31.84h-256.32c-17.28 0-31.84 14.272-31.84 31.84z' })
	  );
	}
	Section.displayName = 'Section';
	
	module.exports = Section;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Selection(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M764.860624 946.487625l-18.420266 0 0-10.233062 18.420266 0L764.860624 946.487625 764.860624 946.487625zM705.506432 946.487625l-18.420266 0 0-10.233062 18.420266 0L705.506432 946.487625 705.506432 946.487625zM646.152241 946.487625l-18.420266 0 0-10.233062 18.420266 0L646.152241 946.487625 646.152241 946.487625zM586.79805 946.487625l-18.420266 0 0-10.233062 18.420266 0L586.79805 946.487625 586.79805 946.487625zM527.443858 946.487625l-18.420266 0 0-10.233062 18.420266 0L527.443858 946.487625 527.443858 946.487625zM468.089667 946.487625l-18.420266 0 0-10.233062 18.420266 0L468.089667 946.487625 468.089667 946.487625zM408.735476 946.487625l-18.420266 0 0-10.233062 18.420266 0L408.735476 946.487625 408.735476 946.487625zM349.381284 946.487625l-18.420266 0 0-10.233062 18.420266 0L349.381284 946.487625 349.381284 946.487625zM290.027093 946.487625l-18.420266 0 0-10.233062 18.420266 0L290.027093 946.487625 290.027093 946.487625zM88.426488 789.9228l-10.233481 0 0-16.372899 10.233481 0L88.426488 789.9228 88.426488 789.9228zM948.039939 785.825482l-10.233481 0 0-18.419512 10.233481 0L948.039939 785.825482 948.039939 785.825482zM88.426488 732.617653l-10.233481 0 0-18.419512 10.233481 0L88.426488 732.617653 88.426488 732.617653zM948.039939 726.473723l-10.233481 0 0-18.419512 10.233481 0L948.039939 726.473723 948.039939 726.473723zM88.426488 673.265894l-10.233481 0 0-18.419512 10.233481 0L88.426488 673.265894 88.426488 673.265894zM948.039939 667.121963l-10.233481 0 0-18.419512 10.233481 0L948.039939 667.121963 948.039939 667.121963zM88.426488 613.914134l-10.233481 0 0-18.419512 10.233481 0L88.426488 613.914134 88.426488 613.914134zM948.039939 607.770204l-10.233481 0 0-18.419512 10.233481 0L948.039939 607.770204 948.039939 607.770204zM88.426488 554.562375l-10.233481 0 0-18.419512 10.233481 0L88.426488 554.562375 88.426488 554.562375zM948.039939 548.418444l-10.233481 0 0-18.419512 10.233481 0L948.039939 548.418444 948.039939 548.418444zM88.426488 495.210615l-10.233481 0 0-18.419512 10.233481 0L88.426488 495.210615 88.426488 495.210615zM948.039939 489.066685l-10.233481 0 0-18.419512 10.233481 0L948.039939 489.066685 948.039939 489.066685zM88.426488 435.858856l-10.233481 0 0-18.419512 10.233481 0L88.426488 435.858856 88.426488 435.858856zM948.039939 429.714925l-10.233481 0 0-18.419512 10.233481 0L948.039939 429.714925 948.039939 429.714925zM88.426488 376.507096l-10.233481 0 0-18.419512 10.233481 0L88.426488 376.507096 88.426488 376.507096zM948.039939 370.363166l-10.233481 0 0-18.419512 10.233481 0L948.039939 370.363166 948.039939 370.363166zM88.426488 317.155337l-10.233481 0 0-18.419512 10.233481 0L88.426488 317.155337 88.426488 317.155337zM948.039939 311.011406l-10.233481 0 0-18.419512 10.233481 0L948.039939 311.011406 948.039939 311.011406zM88.426488 257.803577l-10.233481 0 0-18.419512 10.233481 0L88.426488 257.803577 88.426488 257.803577zM948.039939 251.659647l-10.233481 0 0-18.419512 10.233481 0L948.039939 251.659647 948.039939 251.659647zM756.670769 86.909395l-18.420266 0 0-10.233062 18.420266 0L756.670769 86.909395 756.670769 86.909395zM697.317601 86.909395l-18.420266 0 0-10.233062 18.420266 0L697.317601 86.909395 697.317601 86.909395zM637.963409 86.909395l-18.420266 0 0-10.233062 18.420266 0L637.963409 86.909395 637.963409 86.909395zM578.609218 86.909395l-18.420266 0 0-10.233062 18.420266 0L578.609218 86.909395 578.609218 86.909395zM519.255027 86.909395l-18.420266 0 0-10.233062 18.420266 0L519.255027 86.909395 519.255027 86.909395zM459.900835 86.909395l-18.420266 0 0-10.233062 18.420266 0L459.900835 86.909395 459.900835 86.909395zM400.546644 86.909395l-18.420266 0 0-10.233062 18.420266 0L400.546644 86.909395 400.546644 86.909395zM341.192452 86.909395l-18.420266 0 0-10.233062 18.420266 0L341.192452 86.909395 341.192452 86.909395zM281.838261 86.909395l-18.420266 0 0-10.233062 18.420266 0L281.838261 86.909395 281.838261 86.909395zM75.656127 947.957093l155.618503 0L231.27463 792.269241 75.656127 792.269241 75.656127 947.957093zM793.39464 947.957093l155.604176 0L948.998816 792.269241 793.39464 792.269241 793.39464 947.957093zM793.39464 74.139557l0 155.688875 155.604176 0L948.998816 74.139557 793.39464 74.139557zM75.656127 229.828432l155.618503 0L231.27463 74.139557 75.656127 74.139557 75.656127 229.828432zM671.369586 496.90214 365.919613 268.433682 409.915396 648.725988 495.789654 536.074302 612.952781 740.223888 647.216523 720.328769 529.721831 515.599991Z' })
	  );
	}
	Selection.displayName = 'Selection';
	
	module.exports = Selection;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Setting(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M965.824 405.952a180.48 180.48 0 0 1-117.12-85.376 174.464 174.464 0 0 1-16-142.08 22.208 22.208 0 0 0-7.04-23.552 480.576 480.576 0 0 0-153.6-89.216 23.104 23.104 0 0 0-24.32 5.76 182.208 182.208 0 0 1-135.68 57.92 182.208 182.208 0 0 1-133.12-56.64 23.104 23.104 0 0 0-26.88-7.04 478.656 478.656 0 0 0-153.6 89.856 22.208 22.208 0 0 0-7.04 23.552 174.464 174.464 0 0 1-16 141.44A180.48 180.48 0 0 1 58.24 405.952a22.4 22.4 0 0 0-17.28 17.792 455.08 455.08 0 0 0 0 176.512 22.4 22.4 0 0 0 17.28 17.792 180.48 180.48 0 0 1 117.12 84.736c25.408 42.944 31.232 94.592 16 142.08a22.208 22.208 0 0 0 7.04 23.552A480.576 480.576 0 0 0 352 957.632h7.68a23.04 23.04 0 0 0 16.64-7.04 184.128 184.128 0 0 1 266.944 0c6.592 8.96 18.752 11.968 28.8 7.04a479.36 479.36 0 0 0 156.16-88.576 22.208 22.208 0 0 0 7.04-23.552 174.464 174.464 0 0 1 13.44-142.72 180.48 180.48 0 0 1 117.12-84.736 22.4 22.4 0 0 0 17.28-17.792 452.613 452.613 0 0 0 0-176.512 23.04 23.04 0 0 0-17.28-17.792z m-42.88 169.408a218.752 218.752 0 0 0-128 98.112 211.904 211.904 0 0 0-21.76 156.736 415.936 415.936 0 0 1-112 63.68 217.472 217.472 0 0 0-149.12-63.68 221.312 221.312 0 0 0-149.12 63.68 414.592 414.592 0 0 1-112-63.68c12.8-53.12 4.288-109.12-23.68-156.096A218.752 218.752 0 0 0 101.12 575.36a386.176 386.176 0 0 1 0-127.36 218.752 218.752 0 0 0 128-98.112c27.2-47.552 34.944-103.68 21.76-156.8a415.296 415.296 0 0 1 112-63.68A221.44 221.44 0 0 0 512 187.392a218.24 218.24 0 0 0 149.12-57.984 413.952 413.952 0 0 1 112 63.744 211.904 211.904 0 0 0 23.04 156.096 218.752 218.752 0 0 0 128 98.112 386.65 386.65 0 0 1 0 127.36l-1.28 0.64z' }),
	    React.createElement('path', { d: 'M512 320.576c-105.984 0-192 85.568-192 191.104a191.552 191.552 0 0 0 192 191.104c106.112 0 192.064-85.568 192.064-191.104a190.72 190.72 0 0 0-56.256-135.168 192.448 192.448 0 0 0-135.744-55.936z m0 318.528c-70.656 0-128-57.088-128-127.424 0-70.4 57.344-127.36 128-127.36 70.72 0 128 56.96 128 127.36 0 33.792-13.44 66.176-37.44 90.112a128.32 128.32 0 0 1-90.496 37.312z' })
	  );
	}
	Setting.displayName = 'Setting';
	
	module.exports = Setting;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Show(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M1024 512c0 96-211.2 307.2-512 307.2-294.4 0-512-204.8-512-307.2s217.6-307.2 512-307.2c300.8 0 512 204.8 512 307.2l0 0zM512 262.4c-134.4 0-243.2 108.8-243.2 249.6s108.8 249.6 249.6 249.6c134.4 0 249.6-115.2 249.6-249.6-6.4-140.8-121.6-249.6-256-249.6l0 0zM512 352c-89.6 0-160 70.4-160 160s70.4 160 160 160c89.6 0 160-70.4 160-160s-70.4-160-160-160l0 0z' })
	  );
	}
	Show.displayName = 'Show';
	
	module.exports = Show;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function SortHandler(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M928 191.997 96 191.997c-8.837 0-16 7.163-16 16l0 32.004c0 8.835 7.163 15.998 16 15.998l832 0c8.837 0 16-7.163 16-15.998l0-32.004C944 199.161 936.837 191.997 928 191.997zM928 479.997 96 479.997c-8.837 0-16 7.163-16 16l0 32.004c0 8.835 7.163 15.998 16 15.998l832 0c8.837 0 16-7.163 16-15.998l0-32.004C944 487.161 936.837 479.997 928 479.997zM928 768.997 96 768.997c-8.837 0-16 7.163-16 16l0 32.004c0 8.835 7.163 15.998 16 15.998l832 0c8.837 0 16-7.163 16-15.998l0-32.004C944 776.161 936.837 768.997 928 768.997z' })
	  );
	}
	SortHandler.displayName = 'SortHandler';
	
	module.exports = SortHandler;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Success(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M886.4 240c-12.8-12.8-32-12.8-44.8 0L364.8 716.8l-182.4-182.4c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l204.8 204.8c6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6L886.4 284.8c12.8-12.8 12.8-32 0-44.8z' })
	  );
	}
	Success.displayName = 'Success';
	
	module.exports = Success;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Switch(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M734.56 576.032a29.344 29.344 0 0 1 17.44 4.736c7.68 4.928 12.832 12.896 14.944 21.728a38.56 38.56 0 0 1-3.2 26.88l-96 120.832c-8.864 17.024-28.448 22.848-43.744 13.024s-20.544-31.584-11.712-48.608l54.4-68.48H291.104a35.072 35.072 0 1 1 0-70.144h441.856l1.632 0.032zM289.44 448a29.344 29.344 0 0 1-17.44-4.736 35.264 35.264 0 0 1-14.944-21.728 38.56 38.56 0 0 1 3.2-26.88l96.032-120.832c8.832-17.024 28.416-22.848 43.712-13.024 15.296 9.824 20.544 31.584 11.712 48.608l-54.4 68.48h375.616a35.072 35.072 0 1 1 0 70.144H291.072l-1.6-0.032zM64 127.68C64 92.512 92.8 64 127.712 64H896.32C931.488 64 960 92.8 960 127.712V896.32c0 35.2-28.8 63.712-63.712 63.712H127.68C92.512 960 64 931.2 64 896.288V127.68z m64 32.32v703.936A32 32 0 0 0 160 896h704a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32z' })
	  );
	}
	Switch.displayName = 'Switch';
	
	module.exports = Switch;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Triangle(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M342.016 214.016l468.010667 297.984-468.010667 297.984 0-596.010667z' })
	  );
	}
	Triangle.displayName = 'Triangle';
	
	module.exports = Triangle;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Unknow(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M719.582779 893.666606l-38.867216 0c-20.878516 0-37.804001-16.925485-37.804001-37.804001l0-3.980661c0-20.878516 16.925485-37.804001 37.804001-37.804001l30.908964 0c90.695628 0 164.900677-74.205049 164.900677-164.900677L876.525204 308.566728c0-90.694605-74.204026-164.898631-164.898631-164.898631L374.376573 143.668097c-90.694605 0-164.898631 74.205049-164.898631 164.898631L209.477942 649.178289c0 90.695628 74.205049 164.900677 164.900677 164.900677l30.908964 0c20.878516 0 37.804001 16.925485 37.804001 37.804001l0 3.980661c0 20.878516-16.925485 37.804001-37.804001 37.804001L366.419344 893.667629c-127.902018 0-232.549404-104.647385-232.549404-232.549404L133.86994 296.628838c0-125.965923 101.521185-229.30143 226.77591-232.402047l-0.014326-0.147356 5.78782 0L719.582779 64.079434l5.78782 0-0.014326 0.147356c125.254725 3.100618 226.77591 106.436124 226.77591 232.402047l0 364.488365C952.132182 789.020244 847.484797 893.666606 719.582779 893.666606zM300.645314 445.579241l0.001023 0.007163c0-0.00614 0-0.011256 0-0.01842C300.646338 445.572078 300.645314 445.576171 300.645314 445.579241zM334.716294 479.651244c1.830695 0 3.590781-0.260943 5.343705-0.538259l-10.686387 0C331.125513 479.391325 332.886623 479.651244 334.716294 479.651244zM368.558054 447.866331c0.052189-0.77055 0.230244-1.503237 0.230244-2.287089 0-0.775666-0.177032-1.502213-0.228197-2.2656-0.010233 0.768503-0.058328 1.527796-0.058328 2.299369C368.501772 446.369234 368.547821 447.113177 368.558054 447.866331zM540.491914 854.579379m-39.087227 0a38.197 38.197 0 1 0 78.174454 0 38.197 38.197 0 1 0-78.174454 0ZM767.057023 427.820786c0-127.537721-103.389742-230.927463-230.927463-230.927463-124.848473 0-226.490408 99.090832-230.724849 222.907813-0.13303 1.321088-0.202615 2.660596-0.202615 4.0175 0 0.451278 0.052189 0.88823 0.067538 1.335415-0.010233 0.892323-0.067538 1.772366-0.067538 2.666736l0.201591 0c2.00568 19.945261 18.842137 35.514865 39.315424 35.514865 21.825075 0 39.517015-17.692964 39.517015-39.517015 0-0.89744-0.075725-1.774413-0.134053-2.657526 3.489474-80.96194 70.204945-145.535631 152.027485-145.535631 84.055394 0 152.195308 68.140936 152.195308 152.195308 0 76.522838-56.532551 139.671063-130.076544 150.408615l-10.543124 0c-24.814152 0-44.929282 20.11513-44.929282 44.929282l0 99.091856c-0.001023 0.105401-0.030699 0.202615-0.030699 0.308015 0 0.007163 0 0.014326 0 0.021489 0 0.11768 0.030699 0.227174 0.031722 0.344854l0 3.02387 0.277316 0c1.559519 17.819854 15.027252 32.136931 32.486902 34.904974l12.198833 0c17.708314-2.807952 31.306007-17.48421 32.533974-35.671431-0.011256-0.859577-0.064468-1.708921-0.064468-2.570545 0-0.881067 0.055259-1.747807 0.066515-2.625804-0.027629-0.422625-0.159636-0.811482-0.200568-1.231037L580.075445 654.519947C686.586271 633.991402 767.057023 540.325116 767.057023 427.820786z' })
	  );
	}
	Unknow.displayName = 'Unknow';
	
	module.exports = Unknow;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Upload(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M793.6 358.4C768 227.2 652.8 128 512 128s-256 99.2-281.6 230.4C134.4 384 64 473.6 64 576c0 124.8 99.2 224 224 224h32v-64h-32c-89.6 0-160-70.4-160-160s70.4-160 160-160c0-124.8 99.2-224 224-224s224 99.2 224 224c89.6 0 160 70.4 160 160s-70.4 160-160 160h-32v64h32c124.8 0 224-99.2 224-224 0-102.4-70.4-192-166.4-217.6z' }),
	    React.createElement('path', { d: 'M540.8 489.6c-12.8-9.6-25.6-12.8-38.4-6.4-3.2 0-6.4 3.2-9.6 6.4l-96 92.8c-12.8 12.8-12.8 32 0 44.8 12.8 12.8 35.2 12.8 48 0l38.4-35.2v272c0 19.2 16 32 32 32 19.2 0 32-16 32-32V592l38.4 35.2c12.8 12.8 35.2 12.8 48 0 12.8-12.8 12.8-32 0-44.8l-92.8-92.8z' })
	  );
	}
	Upload.displayName = 'Upload';
	
	module.exports = Upload;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Var(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M596.32 263.392c18.048 6.56 27.328 26.496 20.8 44.512l-151.04 414.912a34.72 34.72 0 1 1-65.28-23.744l151.04-414.912a34.72 34.72 0 0 1 44.48-20.768zM220.64 192H273.6v55.488H233.024c-26.112 0-38.464 14.4-38.464 44.544v134.304c0 42.496-19.936 71.264-59.104 85.664 39.168 16.448 59.104 44.544 59.104 85.664v134.976c0 28.8 12.352 43.84 38.464 43.84H273.6V832H220.672c-30.24 0-53.6-10.272-70.08-29.44-15.136-17.856-22.72-42.496-22.72-72.64v-128.832c0-19.872-4.096-34.24-12.352-43.2-9.6-10.944-26.784-16.416-51.52-17.792v-56.192c24.736-1.376 41.92-7.52 51.52-17.824 8.256-9.6 12.384-24 12.384-43.168V294.784c0-30.848 7.552-55.488 22.688-73.312C167.04 201.6 190.4 192 220.672 192z m529.792 0h52.896c30.24 0 53.6 9.6 70.08 29.44 15.136 17.856 22.72 42.496 22.72 73.344v128.128c0 19.2 4.096 34.24 13.024 43.84 8.96 9.6 26.112 15.776 50.848 17.152v56.192c-24.736 1.376-41.92 6.848-51.52 17.824-8.256 8.896-12.384 23.296-12.384 43.168v128.8c0 30.176-7.552 54.816-22.688 72.64-16.48 19.2-39.84 29.472-70.08 29.472h-52.896v-55.488h40.544c25.408 0 38.464-15.104 38.464-43.84v-135.04c0-41.088 19.232-69.184 59.104-85.632-39.872-14.4-59.104-43.168-59.104-85.664V292.032c0-30.144-13.056-44.544-38.464-44.544H750.4V192z' })
	  );
	}
	Var.displayName = 'Var';
	
	module.exports = Var;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Warn(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M849.12 928.704 174.88 928.704c-45.216 0-81.536-17.728-99.68-48.64-18.144-30.912-15.936-71.296 6.08-110.752L421.472 159.648c22.144-39.744 55.072-62.528 90.304-62.528s68.128 22.752 90.336 62.464l340.544 609.792c22.016 39.456 24.288 79.808 6.112 110.72C930.656 911.008 894.304 928.704 849.12 928.704zM511.808 161.12c-11.2 0-24.032 11.104-34.432 29.696L137.184 800.544c-10.656 19.136-13.152 36.32-6.784 47.168 6.368 10.816 22.592 17.024 44.48 17.024l674.24 0c21.92 0 38.112-6.176 44.48-17.024 6.336-10.816 3.872-28-6.816-47.136L546.24 190.816C535.872 172.224 522.976 161.12 511.808 161.12zM512 640c-17.664 0-32-14.304-32-32l0-288c0-17.664 14.336-32 32-32s32 14.336 32 32l0 288C544 625.696 529.664 640 512 640zM512 752.128m-48 0a1.5 1.5 0 1 0 96 0 1.5 1.5 0 1 0-96 0Z' })
	  );
	}
	Warn.displayName = 'Warn';
	
	module.exports = Warn;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function ZoomIn(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M818.752 160l-241.152 241.152a32 32 0 0 0 45.248 45.248L864 205.248V320a32 32 0 0 0 64 0V128a31.904 31.904 0 0 0-32-32h-192a32 32 0 0 0 0 64h114.752zM105.376 918.624A31.904 31.904 0 0 1 96 896v-192a32 32 0 0 1 64 0v114.752l241.152-241.152a32 32 0 0 1 45.248 45.248L205.248 864H320a32 32 0 0 1 0 64H128a31.904 31.904 0 0 1-22.624-9.376z' })
	  );
	}
	ZoomIn.displayName = 'ZoomIn';
	
	module.exports = ZoomIn;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function ZoomOut(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M370.752 608L129.6 849.152a32 32 0 0 0 45.248 45.248L416 653.248V768a32 32 0 0 0 64 0v-192a31.904 31.904 0 0 0-32-32H256a32 32 0 0 0 0 64h114.752z m182.624-137.376A31.904 31.904 0 0 1 544 448V256a32 32 0 0 1 64 0v114.752l241.152-241.152a32 32 0 1 1 45.248 45.248L653.248 416H768a32 32 0 0 1 0 64h-192a31.904 31.904 0 0 1-22.624-9.376z' })
	  );
	}
	ZoomOut.displayName = 'ZoomOut';
	
	module.exports = ZoomOut;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Delete(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 1024 1024' }, props),
	    React.createElement('path', { d: 'M922.795 231.912v37.345c0 5.446-1.751 9.92-5.252 13.421-3.501 3.501-7.975 5.252-13.421 5.252h-56.018v553.173c0 32.288-9.142 60.199-27.425 83.735-18.284 23.535-40.263 35.303-65.937 35.303H269.257c-25.675 0-47.654-11.379-65.937-34.136s-27.425-50.28-27.425-82.568V287.93h-56.018c-5.446 0-9.92-1.751-13.421-5.252-3.501-3.501-5.252-7.975-5.252-13.421v-37.345c0-5.446 1.751-9.92 5.252-13.421 3.501-3.501 7.975-5.252 13.421-5.252h180.307l40.846-97.447c5.835-14.393 16.338-26.647 31.51-36.761s30.537-15.171 46.098-15.171h186.725c15.56 0 30.926 5.057 46.098 15.171 15.171 10.115 25.675 22.368 31.51 36.761l40.846 97.447h180.307c5.446 0 9.92 1.751 13.421 5.252 3.5 3.501 5.25 7.975 5.25 13.421zM381.292 213.24h261.415l-28.009-68.271c-2.723-3.502-6.03-5.641-9.92-6.419H419.804c-3.89 0.778-7.197 2.917-9.92 6.419l-28.592 68.271z m392.123 627.863V287.93h-522.83v553.173c0 8.558 1.362 16.436 4.085 23.632 2.723 7.197 5.543 12.448 8.461 15.755 2.918 3.307 4.96 4.96 6.127 4.96h485.486c1.167 0 3.209-1.653 6.127-4.96 2.918-3.307 5.738-8.558 8.461-15.755 2.722-7.196 4.083-15.074 4.083-23.632z m-74.69-422.466v336.105c0 5.446-1.751 9.92-5.252 13.421-3.501 3.501-7.975 5.252-13.421 5.252h-37.345c-5.446 0-9.92-1.751-13.421-5.252-3.501-3.501-5.252-7.975-5.252-13.421V418.637c0-5.446 1.751-9.92 5.252-13.421 3.501-3.501 7.975-5.252 13.421-5.252h37.345c5.446 0 9.92 1.751 13.421 5.252 3.502 3.502 5.252 7.975 5.252 13.421z m-149.38 0v336.105c0 5.446-1.75 9.92-5.252 13.421-3.501 3.501-7.975 5.252-13.421 5.252h-37.345c-5.446 0-9.92-1.751-13.421-5.252-3.501-3.501-5.252-7.975-5.252-13.421V418.637c0-5.446 1.75-9.92 5.252-13.421 3.501-3.501 7.975-5.252 13.421-5.252h37.345c5.446 0 9.92 1.751 13.421 5.252 3.502 3.502 5.252 7.975 5.252 13.421z m-149.38 0v336.105c0 5.446-1.751 9.92-5.252 13.421-3.501 3.501-7.975 5.252-13.421 5.252h-37.345c-5.446 0-9.92-1.751-13.421-5.252-3.501-3.501-5.252-7.975-5.252-13.421V418.637c0-5.446 1.751-9.92 5.252-13.421 3.501-3.501 7.975-5.252 13.421-5.252h37.345c5.446 0 9.92 1.751 13.421 5.252 3.501 3.502 5.252 7.975 5.252 13.421z', 'p-id': '3390' })
	  );
	}
	Delete.displayName = 'Delete';
	
	module.exports = Delete;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(5);
	var IconBase = __webpack_require__(138);
	
	function Rhino(props) {
	  return React.createElement(
	    IconBase,
	    _extends({ viewBox: '0 0 18 19' }, props),
	    React.createElement(
	      'title',
	      null,
	      '\u6A21\u677F\u7BA1\u7406 copy'
	    ),
	    React.createElement(
	      'desc',
	      null,
	      'Created with Sketch.'
	    ),
	    React.createElement(
	      'g',
	      { id: 'Symbols', stroke: 'none', 'stroke-width': '1', fillRule: 'evenodd' },
	      React.createElement(
	        'g',
	        { id: '\u5168\u5C40/\u5DE6\u4FA7\u680F/\u6D45\u8272', transform: 'translate(-17.000000, -349.000000)' },
	        React.createElement(
	          'g',
	          { id: 'icon/\u901A\u7528\u7B26\u53F7/\u6A21\u677F-copy', transform: 'translate(16.000000, 348.000000)' },
	          React.createElement('path', { d: 'M3.75,4.89330893 L3.75,5 L7.5,5 L7.5,5.1298815 C7.5,4.02261602 8.40161769,3.125 9.4983112,3.125 L16.7516888,3.125 C17.8553256,3.125 18.75,4.0188998 18.75,5.1298815 L18.75,6.1201185 C18.75,7.22738398 17.8483823,8.125 16.7516888,8.125 L9.4983112,8.125 C8.3946744,8.125 7.5,7.2311002 7.5,6.1201185 L7.5,6.25 L3.75,6.25 L3.75,10.625 L7.5,10.625 L7.5,9.99881335 C7.5,9.30911278 8.05788925,8.75 8.74693081,8.75 L17.5030692,8.75 C18.1917301,8.75 18.75,9.30419147 18.75,9.99881335 L18.75,12.5011867 C18.75,13.1908872 18.1921108,13.75 17.5030692,13.75 L8.74693081,13.75 C8.05826994,13.75 7.5,13.1958085 7.5,12.5011867 L7.5,11.875 L3.75,11.875 L3.75,15.2605961 C3.75,15.8128808 4.19771525,16.2605961 4.75,16.2605961 L7.50350474,16.2605961 C7.56547348,15.2088613 8.44128222,14.375 9.4983112,14.375 L16.7516888,14.375 C17.8553256,14.375 18.75,15.2688998 18.75,16.3798815 L18.75,17.3701185 C18.75,18.477384 17.8483823,19.375 16.7516888,19.375 L9.4983112,19.375 C8.43534114,19.375 7.56621754,18.5457632 7.50360998,17.4920126 L4.5,17.4920126 C3.3954305,17.4920126 2.5,16.5965821 2.5,15.4920126 L2.5,4.89330893 C1.77175477,4.63591118 1.25,3.94138677 1.25,3.125 C1.25,2.08946609 2.08946609,1.25 3.125,1.25 C4.16053391,1.25 5,2.08946609 5,3.125 C5,3.94138677 4.47824523,4.63591118 3.75,4.89330893 Z M8.75,10.6308556 L8.75,11.8691444 C8.75,12.2229043 9.03173755,12.5 9.37927842,12.5 L16.8707216,12.5 C17.218782,12.5 17.5,12.2175563 17.5,11.8691444 L17.5,10.6308556 C17.5,10.2770957 17.2182625,10 16.8707216,10 L9.37927842,10 C9.03121797,10 8.75,10.2824437 8.75,10.6308556 Z M8.75,5.37744075 L8.75,5.87255925 C8.75,6.4280501 9.19938803,6.875 9.75373626,6.875 L16.4962637,6.875 C17.0540567,6.875 17.5,6.42619199 17.5,5.87255925 L17.5,5.37744075 C17.5,4.8219499 17.050612,4.375 16.4962637,4.375 L9.75373626,4.375 C9.19594333,4.375 8.75,4.82380801 8.75,5.37744075 Z M8.75,16.6274408 L8.75,17.1225592 C8.75,17.6780501 9.19938803,18.125 9.75373626,18.125 L16.4962637,18.125 C17.0540567,18.125 17.5,17.676192 17.5,17.1225592 L17.5,16.6274408 C17.5,16.0719499 17.050612,15.625 16.4962637,15.625 L9.75373626,15.625 C9.19594333,15.625 8.75,16.073808 8.75,16.6274408 Z', id: 'Combined-Shape' })
	        )
	      )
	    )
	  );
	}
	Rhino.displayName = 'Rhino';
	
	module.exports = Rhino;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(228);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../_css-loader@0.23.1@css-loader/index.js!../../../_less-loader@2.2.3@less-loader/index.js!./style.less", function() {
				var newContent = require("!!../../../_css-loader@0.23.1@css-loader/index.js!../../../_less-loader@2.2.3@less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes spinning{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes pulse{0%,to{transform:scale(1);opacity:.7}50%{transform:scale(1.02);opacity:1}}.ve-svgicon{max-height:100%;max-width:100%;box-sizing:border-box}.ve-icon-effect-spinning{animation:spining .9s infinite linear}.ve-icon-effect-pluse{animation:pulse 1s infinite linear}.ve-icon-button{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;cursor:pointer}.ve-icon-button>.ve-icon-contents{font-family:Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif;color:#fff;font-size:12px;margin-left:3px}.ve-icon-button.ve-icon-button-default{max-height:100%;overflow:hidden;opacity:.6}.ve-icon-button.ve-icon-button-default.active,.ve-icon-button.ve-icon-button-default.ve-active,.ve-icon-button.ve-icon-button-default:hover{opacity:1}.ve-icon-button.ve-icon-button-green{padding:4px 12px;border-radius:2px;background:rgba(57,180,132,.8)}.ve-icon-button.ve-icon-button-green.active,.ve-icon-button.ve-icon-button-green.ve-active,.ve-icon-button.ve-icon-button-green:hover{background:#39b484}.ve-icon-button.ve-icon-button-blue{padding:4px 12px;border-radius:2px;background:#5798ce}.ve-icon-button.ve-icon-button-blue.active,.ve-icon-button.ve-icon-button-blue.ve-active,.ve-icon-button.ve-icon-button-blue:hover{background:#4580b2}.ve-icon-button.ve-icon-button-disabled{cursor:not-allowed;opacity:.5}.ve-icon-button.ve-icon-button-disabled>.ve-icon-contents{color:#bdbdbd}.ve-icon-tip{display:inline-flex;align-items:center;justify-content:center;pointer-events:auto}", ""]);
	
	// exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(230);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./ghost.less", function() {
				var newContent = require("!!../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./ghost.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-ghost{box-sizing:border-box;position:fixed;z-index:99999;width:100px;height:24px;left:-15px;top:-12px;display:flex;align-items:center;pointer-events:none;background-color:rgba(0,0,0,.4);opacity:.5}.engine-ghost .engine-ghost-icon{display:block;height:24px;width:24px;margin-left:5px}.engine-ghost .engine-ghost-icon path{fill:var(--color-icon-normal,rgba(31,56,88,.4))}.engine-ghost .engine-ghost-title{flex:1;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;text-align:center;font-size:12px;text-overflow:ellipsis;color:#fff;white-space:nowrap;overflow:hidden}", ""]);
	
	// exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var index_1 = __webpack_require__(13);
	var panes_1 = __webpack_require__(51);
	var actionpane_1 = __webpack_require__(232);
	var dockpane_1 = __webpack_require__(235);
	var tabpane_1 = __webpack_require__(241);
	var workspacepane_1 = __webpack_require__(244);
	__webpack_require__(267);
	var dockPane = panes_1.default.dockPane;
	var Panes = /** @class */ (function (_super) {
	    __extends(Panes, _super);
	    function Panes(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            style: {},
	        };
	        return _this;
	    }
	    Panes.prototype.getDockSize = function (dock) {
	        var dockSize = dockpane_1.getCachedSize(dock.getName());
	        return dockSize || {
	            height: dock.getHeight(),
	            width: dock.getWidth(),
	        };
	    };
	    Panes.prototype.setStyle = function (position, size) {
	        if (position === 'default') {
	            this.resetStyle();
	            return;
	        }
	        var style;
	        if (position === 'bottom') {
	            style = {
	                bottom: size.height,
	            };
	        }
	        else if (position === 'top') {
	            style = {
	                top: size.height,
	            };
	        }
	        else if (position === 'left') {
	            style = {
	                left: size.width,
	            };
	        }
	        else if (position === 'right') {
	            style = {
	                right: size.width,
	            };
	        }
	        this.setState({
	            style: style,
	        });
	    };
	    Panes.prototype.resetStyle = function () {
	        this.setState({
	            style: {
	                bottom: 0,
	                left: 0,
	                right: 0,
	                top: 0,
	            },
	        });
	    };
	    Panes.prototype.componentDidMount = function () {
	        var _this = this;
	        dockPane.onDockShow(function (dock) {
	            var position = dock.getCurrentPosition();
	            _this.setStyle(position, _this.getDockSize(dock));
	        });
	        dockPane.onDockHide(function (dock) {
	            _this.resetStyle();
	        });
	        index_1.default.Bus.on('ve.dockpane.resize', function (dock, size) {
	            if (_this.resizeTimer) {
	                window.clearTimeout(_this.resizeTimer);
	            }
	            _this.resizeTimer = window.setTimeout(function () {
	                var position = dock.getCurrentPosition();
	                _this.setStyle(position, size);
	            }, 100);
	        });
	        index_1.default.Viewport.onPreview(function () {
	            var isPreview = index_1.default.Viewport.isPreview();
	            if (isPreview) {
	                _this.styleCache = __assign({}, _this.state.style);
	                _this.resetStyle();
	            }
	            else {
	                _this.setState({
	                    style: _this.styleCache,
	                });
	            }
	        });
	    };
	    Panes.prototype.render = function () {
	        var style = this.state.style;
	        return (React.createElement("div", { className: 'engine-panes', style: style },
	            React.createElement(dockpane_1.default, null),
	            React.createElement(actionpane_1.default, null),
	            React.createElement(workspacepane_1.default, null),
	            React.createElement(tabpane_1.default, null)));
	    };
	    return Panes;
	}(React.Component));
	exports.default = Panes;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var panes_1 = __webpack_require__(51);
	var actionPane = panes_1.default.actionPane;
	__webpack_require__(233);
	var Action = /** @class */ (function (_super) {
	    __extends(Action, _super);
	    function Action() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Action.prototype.render = function () {
	        var action = this.props.action;
	        return React.createElement("div", { className: 'engine-actionitem' }, action.getContent());
	    };
	    return Action;
	}(React.Component));
	var ActionPane = /** @class */ (function (_super) {
	    __extends(ActionPane, _super);
	    function ActionPane() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ActionPane.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = actionPane.onActionsChange(function () { return _this.forceUpdate(); });
	    };
	    ActionPane.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    ActionPane.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    ActionPane.prototype.render = function () {
	        var leftActions = [];
	        var centerActions = [];
	        var rightActions = [];
	        actionPane.getActions().forEach(function (action, i) {
	            if (action.isHidden()) {
	                return;
	            }
	            if (action.getPlace() === 'right') {
	                rightActions.unshift(React.createElement(Action, { key: "rightaction-" + i, action: action }));
	            }
	            else if (action.getPlace() === 'center') {
	                centerActions.push(React.createElement(Action, { key: "centeraction-" + i, action: action }));
	            }
	            else {
	                leftActions.push(React.createElement(Action, { key: "leftaction-" + i, action: action }));
	            }
	        });
	        return (React.createElement("div", { className: 'engine-pane engine-actionpane' },
	            React.createElement("div", { className: 'engine-actions-group engine-group-left' }, leftActions),
	            React.createElement("div", { className: 'engine-actions-group engine-group-center' }, centerActions),
	            React.createElement("div", { className: 'engine-actions-group engine-group-right' }, rightActions)));
	    };
	    return ActionPane;
	}(React.Component));
	exports.default = ActionPane;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(234);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./actionpane.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./actionpane.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-actionpane{top:0;left:0;right:0;height:48px;background:var(--color-pane-background,#fff);font:12px/1 PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;font-size:14px!important;color:var(--color-text,rgba(0,0,0,.6));z-index:4;display:flex;border:1px solid var(--color-line-normal,rgba(31,56,88,.1));transition:transform .2s,right .2s}.engine-actionpane .engine-actions-group{flex:1;display:flex;align-items:center}.engine-actionpane .engine-actions-group .engine-actionitem{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-width:8px;height:48px;color:var(--color-text,rgba(0,0,0,.6));font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif}.engine-actionpane .engine-actions-group.engine-group-left{justify-content:flex-start}.engine-actionpane .engine-actions-group.engine-group-center{justify-content:center}.engine-actionpane .engine-actions-group.engine-group-right{justify-content:flex-end}", ""]);
	
	// exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var classnames = __webpack_require__(134);
	var React = __webpack_require__(5);
	var index_1 = __webpack_require__(13);
	var panes_1 = __webpack_require__(51);
	__webpack_require__(236);
	var _a = __webpack_require__(133), Button = _a.Button, Tip = _a.Tip;
	var DraggableLine = __webpack_require__(238);
	var dockPane = panes_1.default.dockPane;
	function getCachedSize(dockPaneName) {
	    var sizeStr = window.localStorage && window.localStorage.getItem("__ve.dockpane." + dockPaneName + ".size__");
	    if (!sizeStr) {
	        return null;
	    }
	    try {
	        return JSON.parse(sizeStr);
	    }
	    catch (e) {
	        return null;
	    }
	}
	exports.getCachedSize = getCachedSize;
	function setSizeCache(dockPaneName, size) {
	    if (window.localStorage) {
	        window.localStorage.setItem("__ve.dockpane." + dockPaneName + ".size__", JSON.stringify(size));
	    }
	}
	var Slate = /** @class */ (function (_super) {
	    __extends(Slate, _super);
	    function Slate(props) {
	        var _this = _super.call(this, props) || this;
	        var dock = props.dock;
	        _this.cachedSize = getCachedSize(dock.getName()) || {
	            height: dock.getHeight(),
	            width: dock.getWidth(),
	        };
	        _this.state = {
	            height: _this.cachedSize.height,
	            width: _this.cachedSize.width,
	        };
	        return _this;
	    }
	    Slate.prototype.componentWillMount = function () {
	        var _this = this;
	        var dock = this.props.dock;
	        this.willDetach = [
	            this.props.dock.onContentsChange(function () { return _this.forceUpdate(); }),
	            this.props.dock.onPositonChange(function () {
	                var _a = _this.state, width = _a.width, height = _a.height;
	                index_1.default.Bus.emit('ve.dockpane.resize', dock, {
	                    height: height, width: width,
	                });
	                _this.forceUpdate();
	            }),
	        ];
	    };
	    Slate.prototype.componentWillUnmount = function () {
	        if (this.willDetach.length > 0) {
	            this.willDetach.forEach(function (item) { return item(); });
	        }
	    };
	    Slate.prototype.onDrag = function (value) {
	        var dock = this.props.dock;
	        var position = dock.getCurrentPosition();
	        var _a = this.state, width = _a.width, height = _a.height;
	        if (position === 'bottom' || position === 'top') {
	            height = this.cachedSize.height + value;
	        }
	        else {
	            width = this.cachedSize.width + value;
	        }
	        this.setState({
	            height: height,
	            width: width,
	        });
	        setSizeCache(dock.getName(), {
	            height: height,
	            width: width,
	        });
	        index_1.default.Bus.emit('ve.dockpane.resize', dock, {
	            height: height,
	            width: width,
	        });
	    };
	    Slate.prototype.renderHelpTip = function (index) {
	        var dock = this.props.dock;
	        var tip = dock.getTip();
	        if (!tip && dock.getContents) {
	            tip = dock.getContents()[index].tip;
	        }
	        if (tip === null || typeof tip !== 'object') {
	            return '';
	        }
	        return (React.createElement("div", { className: 'engine-slate-title-help-tip' },
	            React.createElement(Tip, { className: 'doubt', size: 'small', url: tip.url, position: 'top' },
	                React.createElement("span", null, tip.content))));
	    };
	    Slate.prototype.render = function () {
	        var _this = this;
	        var dock = this.props.dock;
	        if (!dock.isActive() && !dock.isInitialize()) {
	            return null;
	        }
	        var position = dock.getCurrentPosition();
	        var titles = dock.getTitles();
	        var _a = this.state, width = _a.width, height = _a.height;
	        var style = {
	            height: position === 'bottom' || position === 'top' ? height : '',
	            width: position === 'bottom' || position === 'top' ? '100%' : width,
	        };
	        var positionClass = position === 'left' || position === 'default' ? 'show' : '';
	        return (React.createElement("div", { className: classnames('engine-slate', "engine-slate-" + position), style: style },
	            dock.showTitleBar() && React.createElement("div", { className: 'engine-slate-header' },
	                React.createElement("div", { className: "engine-slate-tabs" + (titles.length > 1 ? ' engine-multi-tabs' : '') }, titles.map(function (title, index) { return React.createElement("div", { key: index, className: "engine-slate-title" + (index === dock.getCurrentIndex() ? ' engine-active' : ''), onClick: function () { return dock.activeIndex(index); } },
	                    React.createElement("div", { className: 'engine-slate-title-wrap' },
	                        React.createElement("div", null, title),
	                        _this.renderHelpTip(index))); })),
	                React.createElement(Button, { className: 'engine-slate-close', size: '12px', name: 'close', onClick: function () { return dockPane.activeDock(null); } })),
	            React.createElement("div", { className: 'engine-slate-content' }, dock.getContent()),
	            React.createElement(DraggableLine, { position: 'top', className: classnames('engine-slate-draggable-line-top', position === 'bottom' ? 'show' : ''), onDrag: this.onDrag.bind(this), maxIncrement: dock.getMaxHeight() - this.cachedSize.height, maxDecrement: this.cachedSize.height - dock.getHeight() }),
	            React.createElement(DraggableLine, { position: 'bottom', className: classnames('engine-slate-draggable-line-bottom', position === 'top' ? 'show' : ''), onDrag: this.onDrag.bind(this), maxIncrement: dock.getMaxHeight() - this.cachedSize.height, maxDecrement: this.cachedSize.height - dock.getHeight() }),
	            React.createElement(DraggableLine, { position: 'left', className: classnames('engine-slate-draggable-line-left', position === 'right' ? 'show' : ''), onDrag: this.onDrag.bind(this), maxIncrement: dock.getMaxWidth() - this.cachedSize.width, maxDecrement: this.cachedSize.width - dock.getWidth() }),
	            React.createElement(DraggableLine, { position: 'right', className: classnames('engine-slate-draggable-line-right', positionClass), onDrag: this.onDrag.bind(this), maxIncrement: dock.getMaxWidth() - this.cachedSize.width, maxDecrement: this.cachedSize.width - dock.getWidth() })));
	    };
	    return Slate;
	}(React.Component));
	var Dock = /** @class */ (function (_super) {
	    __extends(Dock, _super);
	    function Dock() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Dock.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = this.props.dock.onActiveChange(function () {
	            _this.forceUpdate();
	        });
	    };
	    Dock.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Dock.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    Dock.prototype.render = function () {
	        var dock = this.props.dock;
	        return (React.createElement("div", { className: 'engine-dock' },
	            React.createElement("div", { className: "engine-docktray" + (dock.isActive() ? ' engine-active' : '') },
	                React.createElement("div", { className: 'engine-dock-menu', "data-tip": dock.getDescription(), "data-dir": 'right', onClick: function () {
	                        // 如果只是动作，直接 return 掉。
	                        if (dock.isAction()) {
	                            return;
	                        }
	                        if (dock.isActive()) {
	                            dockPane.activeDock(null);
	                        }
	                        else {
	                            dockPane.activeDock(dock);
	                        }
	                    } }, dock.getMenu()),
	                React.createElement(Slate, { dock: dock }))));
	    };
	    return Dock;
	}(React.Component));
	var Docks = /** @class */ (function (_super) {
	    __extends(Docks, _super);
	    function Docks() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Docks.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = dockPane.onDocksChange(function () {
	            _this.forceUpdate();
	        });
	    };
	    Docks.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Docks.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    Docks.prototype.render = function () {
	        var topPanes = [];
	        var bottomPanes = [];
	        var docks = dockPane.getDocks().forEach(function (dock) {
	            if (dock.getPlace() === 'top') {
	                topPanes.push(React.createElement(Dock, { key: "dock-" + dock.getName(), dock: dock }));
	            }
	            else if (dock.getPlace() === 'bottom') {
	                bottomPanes.push(React.createElement(Dock, { key: "dock-" + dock.getName(), dock: dock }));
	            }
	        });
	        return React.createElement("div", { className: 'engine-dockpane-docks' },
	            React.createElement("div", { className: 'engine-dockpane-docks-top' }, topPanes),
	            React.createElement("div", { className: 'engine-dockpane-docks-bottom' }, bottomPanes));
	    };
	    return Docks;
	}(React.Component));
	var DockPane = /** @class */ (function (_super) {
	    __extends(DockPane, _super);
	    function DockPane() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DockPane.prototype.render = function () {
	        return (React.createElement("div", { className: 'engine-pane engine-dockpane' },
	            React.createElement(Docks, null)));
	    };
	    return DockPane;
	}(React.Component));
	exports.default = DockPane;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(237);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./dockpane.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./dockpane.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-dockpane{font-size:14px!important;left:0;bottom:0;top:48px;width:48px;padding-top:15px;font:12px/1 PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(--color-text,rgba(0,0,0,.6));border-right:1px solid var(--color-line-normal,rgba(31,56,88,.1));z-index:4;background:var(--color-pane-background,#fff);transition:transform .2s}.engine-dockpane .engine-dockpane-docks{height:100%;position:relative;overflow:visible;display:flex;flex-direction:column;justify-content:space-between}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray{outline:none;height:48px;width:48px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-dock-menu{height:48px;width:48px;background:transparent;color:var(--color-text,rgba(0,0,0,.6));display:flex;align-items:center;justify-content:center;cursor:pointer;box-sizing:border-box;padding:14px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-dock-menu svg{fill:var(--color-icon-normal,rgba(31,56,88,.4));transition:fill .3s cubic-bezier(.23,1,.32,1)}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-dock-menu svg:hover{fill:var(--color-icon-hover,rgba(31,56,88,.6));transition:fill .3s cubic-bezier(.23,1,.32,1)}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate{position:fixed;left:48px;top:48px;bottom:0;box-sizing:border-box;width:200px;background:var(--color-pane-background,#fff);z-index:3;display:none;border-right:1px solid var(--color-line-normal,rgba(31,56,88,.1))}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate.engine-slate-bottom{left:0;right:0;bottom:0;top:auto}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate.engine-slate-top{left:0;right:0;bottom:auto;top:0}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate.engine-slate-left{left:0;right:auto;bottom:0;top:0}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate.engine-slate-right{left:auto;right:0;bottom:0;top:0}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header{box-sizing:border-box;height:39px;position:relative;background:var(--color-block-background-light,rgba(31,56,88,.04))}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-close{position:absolute;right:5px;top:50%;transform:translateY(-50%)}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs{display:flex;height:39px;align-items:stretch}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs .engine-slate-title-wrap{display:flex;align-items:center;padding-left:12px;justify-content:center;color:var(--color-title,rgba(0,0,0,.8))}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs .engine-slate-title-help-tip{display:flex;margin-left:4px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs .engine-slate-title-help-tip a:visited{color:var(--color-line-darken,rgba(18,32,50,.1))}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs .engine-slate-title{flex:1;font-size:14px;line-height:39px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;font-weight:400;color:var(--color-text,rgba(0,0,0,.6));text-align:center;border-bottom:1px solid var(--color-line-normal,rgba(31,56,88,.1))}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs.engine-multi-tabs{margin-right:30px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs.engine-multi-tabs .engine-slate-title{line-height:39px;border-bottom:2px solid transparent}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs.engine-multi-tabs .engine-slate-title:hover{border-bottom-color:var(--color-line-darken,rgba(4,8,13,.1));transition:border-bottom-color .2s;cursor:pointer}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header .engine-slate-tabs.engine-multi-tabs .engine-slate-title.engine-active{transition:border-bottom-color .2s;cursor:default;border-bottom-color:var(--color-brand,#006cff)}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-content{position:absolute;top:0;bottom:0;left:0;right:0}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-header+.engine-slate-content{top:39px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate [class*=engine-slate-draggable-line-]{display:none}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate [class*=engine-slate-draggable-line-].show{display:block}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-draggable-line-top{top:-2px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-draggable-line-bottom{bottom:-2px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-draggable-line-left{left:-2px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray .engine-slate .engine-slate-draggable-line-right{right:-2px}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray.engine-active .engine-slate{display:block}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray.engine-active .engine-dock-menu{opacity:1}.engine-dockpane .engine-dockpane-docks .engine-dock .engine-docktray.engine-active .engine-dock-menu svg{fill:var(--color-brand,#006cff);opacity:1}html.engine-drag-mode .engine-dockpane .engine-slate,html.engine-hide-slate .engine-dockpane .engine-slate,html.engine-preview-mode .engine-dockpane{display:none}", ""]);
	
	// exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(134);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	__webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var DraggableLine = (_temp = _class = function (_Component) {
	  _inherits(DraggableLine, _Component);
	
	  function DraggableLine(props) {
	    _classCallCheck(this, DraggableLine);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.startDrag = false;
	    _this.canDrag = false;
	    _this.offset = 0;
	    _this.currentOffset = 0;
	    return _this;
	  }
	
	  DraggableLine.prototype.componentDidMount = function componentDidMount() {
	    this.offEvent = this.initEvent();
	  };
	
	  DraggableLine.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.offEvent) {
	      this.offEvent();
	    }
	  };
	
	  DraggableLine.prototype.onSelectStart = function onSelectStart(e) {
	    if (this.startDrag) {
	      e.preventDefault();
	    }
	  };
	
	  DraggableLine.prototype.onStartMove = function onStartMove(e) {
	    this.startDrag = true;
	    this.canDrag = true;
	    this.currentOffset = 0;
	    this.offDragEvent = this.initDragEvent();
	    this.startOffset = this.getClientPosition(e);
	  };
	
	  DraggableLine.prototype.onEndMove = function onEndMove() {
	    if (this.startDrag) {
	      if (this.offDragEvent) {
	        this.offDragEvent();
	      }
	      this.startDrag = false;
	      this.offset = this.currentOffset;
	    }
	  };
	
	  DraggableLine.prototype.onDrag = function onDrag(e) {
	    var _props = this.props,
	        position = _props.position,
	        onDrag = _props.onDrag,
	        maxIncrement = _props.maxIncrement,
	        maxDecrement = _props.maxDecrement;
	
	    if (this.startDrag) {
	      if (position === 'left' || position === 'top') {
	        this.currentOffset = this.offset + this.startOffset - this.getClientPosition(e);
	      } else {
	        this.currentOffset = this.offset + this.getClientPosition(e) - this.startOffset;
	      }
	
	      if (this.currentOffset < -maxDecrement) {
	        this.currentOffset = -maxDecrement;
	      } else if (this.currentOffset > maxIncrement) {
	        this.currentOffset = maxIncrement;
	      }
	
	      onDrag(this.currentOffset, e);
	    }
	  };
	
	  DraggableLine.prototype.getClientPosition = function getClientPosition(e) {
	    var position = this.props.position;
	
	    return position === 'left' || position === 'right' ? e.clientX : e.clientY;
	  };
	
	  DraggableLine.prototype.initEvent = function initEvent() {
	    var selectStart = this.onSelectStart.bind(this);
	    document.addEventListener('selectstart', selectStart);
	    return function () {
	      return document.removeEventListener('selectstart', selectStart);
	    };
	  };
	
	  DraggableLine.prototype.initDragEvent = function initDragEvent() {
	    var onDrag = this.onDrag.bind(this);
	    var onEndMove = this.onEndMove.bind(this);
	    document.addEventListener('mousemove', onDrag);
	    document.addEventListener('mouseup', onEndMove);
	    return function () {
	      document.removeEventListener('mousemove', onDrag);
	      document.removeEventListener('mouseup', onEndMove);
	    };
	  };
	
	  DraggableLine.prototype.render = function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        position = _props2.position;
	
	    return _react2.default.createElement('div', {
	      className: (0, _classnames3.default)(position === 'left' || position === 'right' ? 've-draggable-line-horizontal' : 've-draggable-line-vertical', _defineProperty({}, className, !!className)),
	      onMouseDown: this.onStartMove.bind(this)
	    });
	  };
	
	  return DraggableLine;
	}(_react.Component), _class.displayName = 'DraggableLine', _class.propTypes = {
	  onDrag: _react2.default.PropTypes.func,
	  position: _react2.default.PropTypes.string,
	  className: _react2.default.PropTypes.string,
	  maxIncrement: _react2.default.PropTypes.number,
	  maxDecrement: _react2.default.PropTypes.number
	}, _class.defaultProps = {
	  onDrag: function onDrag() {},
	
	  position: 'right',
	  className: '',
	  maxIncrement: 9999,
	  maxDecrement: 9999
	}, _temp);
	exports.default = DraggableLine;
	module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(240);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../_css-loader@0.23.1@css-loader/index.js!../../../_less-loader@2.2.3@less-loader/index.js!./style.less", function() {
				var newContent = require("!!../../../_css-loader@0.23.1@css-loader/index.js!../../../_less-loader@2.2.3@less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".ve-draggable-line-horizontal{position:absolute;width:4px;height:100%;background-color:transparent;cursor:col-resize}.ve-draggable-line-vertical{position:absolute;width:100%;height:4px;background-color:transparent;cursor:row-resize}", ""]);
	
	// exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var panes_1 = __webpack_require__(51);
	__webpack_require__(242);
	var tabPane = panes_1.default.tabPane;
	var Tab = /** @class */ (function (_super) {
	    __extends(Tab, _super);
	    function Tab() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Tab.prototype.componentWillMount = function () {
	        var _this = this;
	        this.tab = this.props.tab;
	        this.willDetach = this.tab.onActiveChange(function () {
	            _this.forceUpdate();
	        });
	    };
	    Tab.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Tab.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    Tab.prototype.render = function () {
	        var tab = this.tab;
	        return (React.createElement("div", { className: "engine-tab" + (tab.isActive() ? ' engine-active' : ''), onClick: function () { return tabPane.activeTab(tab); } }, tab.getTitle()));
	    };
	    return Tab;
	}(React.Component));
	var TabContent = /** @class */ (function (_super) {
	    __extends(TabContent, _super);
	    function TabContent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TabContent.prototype.componentWillMount = function () {
	        var _this = this;
	        this.tab = this.props.tab;
	        this.isInited = this.tab.isActive();
	        this.willDetach = this.tab.onActiveChange(function (flag) {
	            if (flag) {
	                _this.isInited = true;
	            }
	            _this.forceUpdate();
	        });
	    };
	    TabContent.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    TabContent.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    TabContent.prototype.render = function () {
	        if (!this.isInited)
	            return null;
	        var tab = this.tab;
	        var className = "engine-tab-content engine-tabcontent-" + tab.getName();
	        if (tab.isActive()) {
	            className += ' engine-visible';
	        }
	        return (React.createElement("div", { className: className }, tab.getContent()));
	    };
	    return TabContent;
	}(React.Component));
	var TabPane = /** @class */ (function (_super) {
	    __extends(TabPane, _super);
	    function TabPane() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TabPane.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = tabPane.onTabsChange(function () {
	            _this.forceUpdate();
	        });
	    };
	    TabPane.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    TabPane.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    TabPane.prototype.render = function () {
	        var tabs = [];
	        var tabsContent = [];
	        tabPane.getTabs().forEach(function (tab) {
	            tabs.push(React.createElement(Tab, { key: "tab-" + tab.getName(), tab: tab }));
	            tabsContent.push(React.createElement(TabContent, { key: "tabcontent-" + tab.getName(), tab: tab }));
	        });
	        var className = 'engine-pane engine-tabpane';
	        if (tabs.length < 2) {
	            className += ' engine-single';
	        }
	        return (React.createElement("div", { className: className },
	            React.createElement("div", { className: "engine-tabs" }, tabs),
	            React.createElement("div", { className: "engine-tab-contents" }, tabsContent)));
	    };
	    return TabPane;
	}(React.Component));
	exports.default = TabPane;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(243);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./tabpane.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./tabpane.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-tabpane{font:12px/1 PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;font-size:12px!important;color:var(--color-text,rgba(0,0,0,.6));width:280px;bottom:0;right:0;top:48px;background:var(--color-pane-background,#fff);z-index:3;transition:transform .2s}.engine-tabpane .engine-tabs{display:flex;height:39px;box-sizing:border-box;z-index:1;background:var(--color-block-background-shallow,rgba(31,56,88,.06))}.engine-tabpane .engine-tabs .engine-tab{flex:1;color:var(--color-text,rgba(0,0,0,.6));font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;font-size:14px;cursor:pointer;line-height:39px;text-align:center;border-bottom:2px solid transparent}.engine-tabpane .engine-tabs .engine-tab:hover{border-bottom-color:var(--color-line-darken,rgba(4,8,13,.1));transition:border-bottom-color .2s}.engine-tabpane .engine-tabs .engine-tab.engine-active{transition:border-bottom-color .2s;cursor:default;border-bottom-color:var(--color-brand,#006cff)}.engine-tabpane .engine-tab-contents{position:absolute;top:39px;left:0;right:0;bottom:0}.engine-tabpane .engine-tab-contents .engine-tab-content{position:absolute;top:0;bottom:0;left:0;right:0;display:none;color:var(--color-text,rgba(0,0,0,.6));font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;font-size:12px}.engine-tabpane .engine-tab-contents .engine-tab-content.engine-visible{display:block}.engine-tabpane.engine-single .engine-tabs{display:none}.engine-tabpane.engine-single .engine-tab-contents{top:0}html.engine-preview-mode .engine-tabpane{transform:translateX(100%)}", ""]);
	
	// exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var simulator_1 = __webpack_require__(245);
	var widgets_1 = __webpack_require__(262);
	__webpack_require__(265);
	var WorkspacePane = /** @class */ (function (_super) {
	    __extends(WorkspacePane, _super);
	    function WorkspacePane() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    WorkspacePane.prototype.render = function () {
	        return (React.createElement("div", { className: 'engine-pane engine-workspacepane' },
	            React.createElement(simulator_1.default, null),
	            React.createElement(widgets_1.default, null)));
	    };
	    return WorkspacePane;
	}(React.Component));
	exports.default = WorkspacePane;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var ve_copy_paster_1 = __webpack_require__(246);
	var ve_utils_1 = __webpack_require__(4);
	var dragengine_1 = __webpack_require__(21);
	var viewport_1 = __webpack_require__(41);
	var exchange_1 = __webpack_require__(20);
	var pageWrapper_1 = __webpack_require__(247);
	var overlay_1 = __webpack_require__(253);
	var pages_1 = __webpack_require__(61);
	__webpack_require__(260);
	var Simulator = /** @class */ (function (_super) {
	    __extends(Simulator, _super);
	    function Simulator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Simulator.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = [pages_1.default.onPagesChange(function () {
	                _this.destroyPage = true;
	                _this.forceUpdate(function () {
	                    _this.destroyPage = false;
	                });
	            })];
	    };
	    Simulator.prototype.componentDidMount = function () {
	        var _this = this;
	        var shell = this.shell;
	        viewport_1.default.setFocusTarget(shell);
	        var focusin = function () {
	            viewport_1.default.setFocus(true);
	        };
	        var focusout = function (e) {
	            if (e.target
	                && shell
	                && shell.contains
	                && !shell.contains(e.target)) {
	                viewport_1.default.setFocus(false);
	            }
	        };
	        shell.addEventListener('click', focusin);
	        document.addEventListener('click', focusout);
	        this.willDetach.push(function () {
	            shell.removeEventListener('click', focusin);
	            document.removeEventListener('click', focusout);
	        });
	        this.willDetach.push(dragengine_1.default.from(shell, function (e) {
	            _this.downEvent = e;
	            var page = pages_1.default.getCurrentPage();
	            if (viewport_1.default.isPreview() || dragengine_1.default.isUseHandler() || !page)
	                return false;
	            var node = page.getNodeFromPoint(e);
	            while (node && !node.canDragging()) {
	                node = node.getParent();
	            }
	            if (!node || node.canDragging() === 'handler' || node.isInPlaceEditing() || node.isLocking()) {
	                return false;
	            }
	            return node;
	        }));
	    };
	    Simulator.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Simulator.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	        viewport_1.default.setFocusTarget(null);
	    };
	    Simulator.prototype.renderPages = function () {
	        var _this = this;
	        var pages = pages_1.default.getPages() || [];
	        return pages.map(function (page) { return (React.createElement(pageWrapper_1.default, { key: _this.destroyPage ? ve_utils_1.uniqueId(null, 'page') : page.getId(), page: page, onPageClick: function (e) {
	                if (viewport_1.default.isPreview() || (_this.downEvent && _this.downEvent.shaked)) {
	                    return;
	                }
	                var node = page.getNodeFromPoint(e);
	                exchange_1.default.select(node);
	            } })); });
	    };
	    Simulator.prototype.render = function () {
	        var _this = this;
	        var pages = this.renderPages();
	        var copyPaster = React.createElement(ve_copy_paster_1.default, null);
	        return (React.createElement("div", { ref: function (ref) { _this.shell = ref; }, className: "engine-simulator" },
	            React.createElement(overlay_1.default, null),
	            React.createElement("div", { className: "engine-simulator-screen" },
	                React.createElement("div", { className: "engine-pages" }, pages),
	                copyPaster)));
	    };
	    return Simulator;
	}(React.Component));
	exports.default = Simulator;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clipboard = __webpack_require__(2);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	__webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var CopyPaster = function (_Component) {
	  _inherits(CopyPaster, _Component);
	
	  function CopyPaster() {
	    _classCallCheck(this, CopyPaster);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CopyPaster.setClipboardData = function setClipboardData(data, cb) {
	    _clipboard2.default.setData(data);
	    if (cb) {
	      cb();
	    }
	  };
	
	  CopyPaster.getClipboardData = function getClipboardData(cb) {
	    _clipboard2.default.waitPasteData(cb);
	  };
	
	  CopyPaster.isCopyPasteEvent = function isCopyPasteEvent(e) {
	    _clipboard2.default.isCopyPaster(e.target);
	  };
	
	  CopyPaster.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  CopyPaster.prototype.componentDidMount = function componentDidMount() {
	    this.willDetach = _clipboard2.default.setCopyPaster(this.shell);
	  };
	
	  CopyPaster.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.willDetach) {
	      this.willDetach();
	    }
	  };
	
	  CopyPaster.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement('textarea', { ref: function ref(_ref) {
	        _this2.shell = _ref;
	      }, className: 've-copy-paster' });
	  };
	
	  return CopyPaster;
	}(_react.Component);
	
	CopyPaster.displayName = 'CopyPaster';
	exports.default = CopyPaster;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(5);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var getUniqueKey = function getUniqueKey() {
	  return Math.random().toString(36).slice(2, 10);
	};
	
	function getDataFromPasteEvent(event) {
	  var html = event.clipboardData.getData('text/html');
	  if (html !== '') {
	    return {
	      componentName: 'RichText',
	      id: 'node_' + getUniqueKey(),
	      props: {
	        content: html,
	        event: {
	          onClick: 'function onClick(ctx) {}'
	        },
	        fieldId: 'richText_' + getUniqueKey(),
	        style: {}
	      }
	    };
	  }
	  try {
	    return JSON.parse(event.clipboardData.getData('text/plain'));
	  } catch (error) {
	    console.warn(error);
	    return event.clipboardData.getData('text/plain');
	  }
	}
	
	var Clipboard = function () {
	  function Clipboard() {
	    _classCallCheck(this, Clipboard);
	  }
	
	  Clipboard.prototype.isCopyPaster = function isCopyPaster(el) {
	    return this.copyPaster === el;
	  };
	
	  Clipboard.prototype.setCopyPaster = function setCopyPaster(el) {
	    var _this = this;
	
	    this.copyPaster = el;
	    var onPaste = function onPaste(e) {
	      if (_this.waitFn) {
	        _this.waitFn(getDataFromPasteEvent(e), e);
	        _this.waitFn = null;
	      }
	      _this.copyPaster.blur();
	    };
	    el.addEventListener('paste', onPaste, false);
	    return function () {
	      el.removeEventListener('paste', onPaste, false);
	      if (_this.copyPaster === el) {
	        _this.copyPaster = null;
	      }
	    };
	  };
	
	  Clipboard.prototype.setData = function setData(data) {
	    this.copyPaster.value = typeof data === 'string' ? data : JSON.stringify(data);
	    this.copyPaster.select();
	    document.execCommand('copy');
	    this.copyPaster.blur();
	  };
	
	  Clipboard.prototype.waitPasteData = function waitPasteData(cb) {
	    this.copyPaster.select();
	    this.waitFn = cb;
	  };
	
	  return Clipboard;
	}();
	
	exports.default = new Clipboard();
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(4);
	if(typeof content === 'string') content = [[module.i, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../Vision/visualengine-devtools/node_modules/css-loader/index.js!./../../../Vision/visualengine-devtools/node_modules/less-loader/index.js!./style.less", function() {
				var newContent = require("!!./../../../Vision/visualengine-devtools/node_modules/css-loader/index.js!./../../../Vision/visualengine-devtools/node_modules/less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.i, ".ve-copy-paster {\n  position: relative;\n  left: -999999px;\n}\n", ""]);
	
	// exports
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}
	
	
	/***/ })
	/******/ ]);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var dragengine_1 = __webpack_require__(21);
	var exchange_1 = __webpack_require__(20);
	var overlay_1 = __webpack_require__(16);
	var InPlaceEditing_1 = __webpack_require__(248);
	var viewport_1 = __webpack_require__(41);
	__webpack_require__(251);
	var PageWrapper = /** @class */ (function (_super) {
	    __extends(PageWrapper, _super);
	    function PageWrapper() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PageWrapper.prototype.componentWillMount = function () {
	        this.page = this.props.page;
	    };
	    PageWrapper.prototype.componentDidMount = function () {
	        var _this = this;
	        var shell = this.shell;
	        var doc = shell.firstElementChild;
	        var page = this.page;
	        var scroll = function () {
	            if (viewport_1.default.isPreview()) {
	                return;
	            }
	            page.scroll();
	        };
	        var hover = function (e) {
	            if (viewport_1.default.isPreview()) {
	                return;
	            }
	            var node = page.getNodeFromPoint(e);
	            exchange_1.default.hover(node);
	        };
	        var over = function (e) {
	            if (viewport_1.default.isPreview()) {
	                return;
	            }
	            if (page.inScrolling() || dragengine_1.default.inDragging()) {
	                return;
	            }
	            hover(e);
	        };
	        var leave = function (e) {
	            if (viewport_1.default.isPreview() || dragengine_1.default.inDragging()) {
	                return;
	            }
	            if (overlay_1.default.getHoveringCapture().capture(e, hover)) {
	                return;
	            }
	            exchange_1.default.hover(null);
	        };
	        var click = function (e) {
	            _this.props.onPageClick(e);
	        };
	        doc.addEventListener('click', click, true);
	        doc.addEventListener('scroll', scroll, true);
	        doc.addEventListener('mouseover', over, true);
	        doc.addEventListener('mouseleave', leave, false);
	        doc.addEventListener('mouseup', hover, true);
	        var inPlaceEditing = new InPlaceEditing_1.default();
	        inPlaceEditing.start(doc, page);
	        this.willDetach = [
	            page.onVisibleChange(function (visible) {
	                if (!shell) {
	                    return;
	                }
	                if (visible) {
	                    shell.classList.add('engine-visible');
	                }
	                else {
	                    shell.classList.remove('engine-visible');
	                }
	            }),
	            function () {
	                doc.removeEventListener('click', click, true);
	                doc.removeEventListener('scroll', scroll, true);
	                doc.removeEventListener('mouseover', over, true);
	                doc.removeEventListener('mouseleave', leave, false);
	                doc.removeEventListener('mouseup', hover, true);
	            },
	            function () {
	                inPlaceEditing.stop();
	            },
	        ];
	        page.mount(doc);
	    };
	    PageWrapper.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    PageWrapper.prototype.componentWillUnmount = function () {
	        this.page.unmount();
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    PageWrapper.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", { ref: function (ref) { _this.shell = ref; }, className: "engine-page" + (this.page.isVisible() ? ' engine-visible' : '') },
	            React.createElement("div", { className: 'engine-document', id: this.page.getId() })));
	    };
	    return PageWrapper;
	}(React.Component));
	exports.default = PageWrapper;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var env_1 = __webpack_require__(10);
	__webpack_require__(249);
	var I18nUtil = __webpack_require__(47);
	var EDITOR_KEY = 'data-setter-prop';
	var TIME_DELAY = 300;
	function getPropName(ele, root) {
	    var propName = ele.getAttribute(EDITOR_KEY);
	    var parent = ele.parentElement;
	    while (parent && parent !== root) {
	        if (!propName) {
	            propName = parent.getAttribute(EDITOR_KEY);
	        }
	        parent = parent.parentElement;
	    }
	    return propName;
	}
	var isI18nRecord = function (value) { return value && value.type === 'i18n' && value.key; };
	var isI18nSingleValue = function (value) { return value && value.type === 'i18n' && value.use; };
	var InPlaceEditing = /** @class */ (function () {
	    function InPlaceEditing() {
	        this.willStop = [];
	    }
	    InPlaceEditing.prototype.start = function (root, page) {
	        var _this = this;
	        if (this.boosted) {
	            return;
	        }
	        var onMouseDown = function (e) {
	            var currentTime = new Date().getTime();
	            var ele = e.target;
	            var propName = getPropName(ele, root);
	            if (propName) {
	                var node = page.getNodeFromPoint(e);
	                if (currentTime - _this.clickTime < TIME_DELAY
	                    && _this.preId === node.id
	                    && node.canOperating()) {
	                    if (node) {
	                        node.setInPlaceEdit(true);
	                    }
	                    ele.setAttribute('contenteditable', 'true');
	                }
	                _this.preId = node.id;
	            }
	            _this.clickTime = currentTime;
	        };
	        var onFocusOut = function (e) {
	            var ele = e.target;
	            var propName = getPropName(ele, root);
	            if (propName) {
	                var node = page.getNodeFromPoint(e);
	                if (node && node.canOperating()) {
	                    ele.removeAttribute('contenteditable');
	                    var innerText = ele.innerText;
	                    node.setInPlaceEdit(false);
	                    try {
	                        var setterName = node.getProp(propName).getSetter().type.displayName;
	                        if (setterName === 'I18nSetter') {
	                            _this.changeI18nValue(node, propName, innerText);
	                        }
	                        else {
	                            node.getProp(propName).setHotValue(innerText);
	                        }
	                        return;
	                    }
	                    catch (e) {
	                        throw new Error(e.message);
	                    }
	                }
	            }
	            _this.clickTime = 0;
	        };
	        root.addEventListener('mousedown', onMouseDown);
	        root.addEventListener('focusout', onFocusOut);
	        this.willStop = [
	            function () {
	                root.removeEventListener('mousedown', onMouseDown);
	                root.removeEventListener('focusout', onFocusOut);
	            },
	        ];
	    };
	    InPlaceEditing.prototype.stop = function () {
	        this.willStop.forEach(function (func) { return func(); });
	    };
	    /**
	     * i18n setting change
	     */
	    InPlaceEditing.prototype.changeI18nValue = function (node, propName, val) {
	        var _a, _b;
	        var locale = env_1.default.getLocale();
	        var advancedMode = env_1.default && env_1.default.supports && env_1.default.supports('i18nPane');
	        var hotValue = node.getProp(propName).getHotValue();
	        if (isI18nRecord(hotValue) && advancedMode) {
	            I18nUtil.update(hotValue.key, val, locale);
	        }
	        else if (isI18nSingleValue(hotValue)) {
	            node.getProp(propName).setHotValue(__assign(__assign({}, hotValue), (_a = {}, _a[hotValue.use] = val, _a)));
	        }
	        else {
	            node.getProp(propName).setHotValue(__assign(__assign({}, hotValue), (_b = {}, _b[locale] = val, _b)));
	        }
	    };
	    return InPlaceEditing;
	}());
	exports.default = InPlaceEditing;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(250);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./InPlaceEditing.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./InPlaceEditing.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-simulator-screen [data-setter-prop]{line-height:1.5}", ""]);
	
	// exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(252);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./page.less", function() {
				var newContent = require("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./page.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-page{left:0;top:0;right:0;bottom:0;position:absolute;overflow:hidden;transform:translateX(-100%)}.engine-page>.engine-document{width:100%;height:100%;box-sizing:border-box;overflow:auto}.engine-page>.engine-document:after,.engine-page>.engine-document:before{content:\"\";display:table}.engine-page>.engine-document:after{clear:both}.engine-page.engine-visible{transform:translateX(0)}html.engine-design-mode .engine-page>.engine-document{padding-bottom:30px;background:transparent}", ""]);
	
	// exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var flags_1 = __webpack_require__(23);
	var pages_1 = __webpack_require__(61);
	var insertion_1 = __webpack_require__(254);
	var droppingOutline_1 = __webpack_require__(255);
	var hoveringOutline_1 = __webpack_require__(256);
	var selectedOutline_1 = __webpack_require__(257);
	__webpack_require__(258);
	var Overlay = /** @class */ (function (_super) {
	    __extends(Overlay, _super);
	    function Overlay() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Overlay.prototype.componentWillMount = function () {
	        var _this = this;
	        var pageWillDetach = [];
	        var detachPage = function () {
	            pageWillDetach.forEach(function (off) { return off(); });
	            pageWillDetach = [];
	            _this.page = null;
	        };
	        var attachPage = function (page) {
	            if (page) {
	                pageWillDetach = [
	                    page.onReady(function () { return _this.forceUpdate(); }),
	                    page.onScroll(function () { return _this.forceUpdate(); }),
	                ];
	            }
	            _this.page = page;
	        };
	        attachPage(pages_1.default.getCurrentPage());
	        this.willDetach = [
	            detachPage,
	            pages_1.default.onCurrentPageChange(function (page) {
	                _this.page = page;
	                detachPage();
	                attachPage(page);
	                _this.forceUpdate();
	            }),
	            flags_1.default.onFlagsChange(function () { return _this.forceUpdate(); }),
	        ];
	    };
	    Overlay.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Overlay.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    Overlay.prototype.render = function () {
	        if (!this.page || !this.page.isReady()) {
	            return React.createElement("div", { className: 'engine-simulator-overlay' });
	        }
	        var st = this.page.getScrollTop();
	        return (React.createElement("div", { className: 'engine-simulator-overlay', style: { transform: "translateY(" + -st + "px)" } },
	            React.createElement(hoveringOutline_1.default, null),
	            React.createElement(selectedOutline_1.default, null),
	            React.createElement(droppingOutline_1.default, null),
	            React.createElement(insertion_1.default, null)));
	    };
	    return Overlay;
	}(React.Component));
	exports.default = Overlay;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var overlay_1 = __webpack_require__(16);
	var Insertion = /** @class */ (function (_super) {
	    __extends(Insertion, _super);
	    function Insertion() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Insertion.prototype.componentWillMount = function () {
	        var _this = this;
	        this.droppingLine = overlay_1.default.getDroppingLine();
	        this.insertionGhost = overlay_1.default.getInsertionGhost();
	        this.willDetach = [
	            this.droppingLine.onSync(function () { return _this.forceUpdate(); }),
	            this.insertionGhost.onSync(function () { return _this.forceUpdate(); }),
	        ];
	    };
	    Insertion.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Insertion.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    Insertion.prototype.render = function () {
	        if (!this.droppingLine.hasOutline()) {
	            return null;
	        }
	        var node = this.droppingLine.getCurrentNode();
	        var page = node.getPage();
	        var st = page.getScrollTop();
	        var bounds = page.getBounds();
	        var rect;
	        var style;
	        var className = 'engine-insertion';
	        var ghost = this.insertionGhost.getGhost();
	        var insertion = node.getStatus('dropping');
	        if (ghost) {
	            rect = ghost.getBoundingClientRect();
	            style = {
	                transform: "translate(" + (rect.left - bounds.left) + "px, " + (st + rect.top - bounds.top) + "px)",
	                width: rect.width,
	            };
	        }
	        else if (insertion && insertion.getIndex() !== null) {
	            var isAfter = insertion.isNearAfter();
	            rect = insertion.getNearRect() || node.getRect();
	            if (!!rect && !!bounds && insertion.isVertical()) {
	                style = {
	                    height: rect.height,
	                    transform: "translate(" + ((isAfter ? rect.right : rect.left) - bounds.left) + "px,           " + (st + rect.top - bounds.top) + "px)",
	                };
	                className += ' engine-vertical';
	            }
	            else if (rect && bounds) {
	                style = {
	                    transform: "translate(" + (rect.left - bounds.left) + "px,           " + (st + (isAfter ? rect.bottom : rect.top) - bounds.top) + "px)",
	                    width: rect.width,
	                };
	            }
	        }
	        return React.createElement("div", { className: className, style: style });
	    };
	    return Insertion;
	}(React.Component));
	exports.default = Insertion;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var overlay_1 = __webpack_require__(16);
	var DroppingOutline = /** @class */ (function (_super) {
	    __extends(DroppingOutline, _super);
	    function DroppingOutline() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DroppingOutline.prototype.componentWillMount = function () {
	        var _this = this;
	        this.droppingLine = overlay_1.default.getDroppingLine();
	        this.willDetach = this.droppingLine.onSync(function () { return _this.forceUpdate(); });
	    };
	    DroppingOutline.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    DroppingOutline.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    DroppingOutline.prototype.render = function () {
	        if (!this.droppingLine.hasOutline()) {
	            return null;
	        }
	        var node = this.droppingLine.getCurrentNode();
	        var rect = node.getRect();
	        var page = node.getPage();
	        var bounds = page.getBounds();
	        var st = page.getScrollTop();
	        if (!rect || !bounds) {
	            return null;
	        }
	        return (React.createElement("div", { className: 'engine-outline engine-dropping-outline', style: {
	                height: rect.height,
	                transform: "translate(" + (rect.left - bounds.left) + "px, " + (rect.top + st - bounds.top) + "px)",
	                width: rect.width,
	            } }));
	    };
	    return DroppingOutline;
	}(React.Component));
	exports.default = DroppingOutline;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var context_1 = __webpack_require__(9);
	var const_1 = __webpack_require__(12);
	var bus_1 = __webpack_require__(36);
	var dragengine_1 = __webpack_require__(21);
	var exchange_1 = __webpack_require__(20);
	var overlay_1 = __webpack_require__(16);
	var context = new context_1.default();
	var Icons = __webpack_require__(133);
	function getComputedActionSpace(rect, bounds, isSpaceEnough) {
	    var h = 'top';
	    var v = 'right';
	    if (rect.left - bounds.left < 60 && rect.width < 200) {
	        v = 'left';
	    }
	    if (rect.top < 70) {
	        h = 'bottom';
	    }
	    return h + "-" + v;
	}
	exports.getComputedActionSpace = getComputedActionSpace;
	function removeNode(node, from, bus) {
	    var removeHelper = context.getPlugin(const_1.VE_HOOKS.VE_NODE_REMOVE_HELPER);
	    if (removeHelper) {
	        removeHelper(node).then(function (isOK) {
	            if (isOK === void 0) { isOK = true; }
	            if (isOK) {
	                node.remove();
	                bus.emit(const_1.VE_EVENTS.VE_OVERLAY_ACTION_REMOVE_NODE, { from: from });
	            }
	        });
	    }
	    else {
	        node.remove();
	        bus.emit(const_1.VE_EVENTS.VE_OVERLAY_ACTION_REMOVE_NODE, { from: from });
	    }
	}
	exports.removeNode = removeNode;
	var HoveringOutline = /** @class */ (function (_super) {
	    __extends(HoveringOutline, _super);
	    function HoveringOutline() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    HoveringOutline.prototype.componentWillMount = function () {
	        var _this = this;
	        this.hoveringLine = overlay_1.default.getHoveringLine();
	        this.hoveringCapture = overlay_1.default.getHoveringCapture();
	        this.willDetach = this.hoveringLine.onSync(function () { return _this.forceUpdate(); });
	        this.bus = new bus_1.default();
	    };
	    HoveringOutline.prototype.componentDidMount = function () {
	        this.hoveringCapture.setBoundary(this.outline);
	        this.willBind();
	    };
	    HoveringOutline.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    HoveringOutline.prototype.componentDidUpdate = function () {
	        this.hoveringCapture.setBoundary(this.outline);
	        this.willBind();
	    };
	    HoveringOutline.prototype.componentWillUnmount = function () {
	        this.hoveringCapture.setBoundary(null);
	        if (this.willDetach) {
	            this.willDetach();
	        }
	        if (this.willUnbind) {
	            this.willUnbind();
	        }
	    };
	    HoveringOutline.prototype.willBind = function () {
	        var _this = this;
	        if (this.willUnbind) {
	            this.willUnbind();
	        }
	        var handler = this.handler;
	        if (!handler) {
	            return;
	        }
	        var node = this.hoveringLine.getCurrentNode();
	        var downEvent;
	        var dragOff = dragengine_1.default.from(handler, function (e) {
	            downEvent = e;
	            return node;
	        });
	        var select = function () {
	            if (downEvent && downEvent.shaked) {
	                return;
	            }
	            exchange_1.default.select(node);
	        };
	        handler.addEventListener('click', select, false);
	        this.willUnbind = function () {
	            handler.removeEventListener('click', select, false);
	            dragOff();
	            _this.willUnbind = null;
	        };
	    };
	    HoveringOutline.prototype.render = function () {
	        var _this = this;
	        if (!this.hoveringLine.hasOutline()) {
	            return null;
	        }
	        var node = this.hoveringLine.getCurrentNode();
	        var page = node.getPage();
	        var bounds = page.getBounds();
	        var st = page.getScrollTop();
	        var rect = node.getRect();
	        var canDragging = node.canDragging();
	        if (!rect || !bounds) {
	            return null;
	        }
	        var isSpaceEnough = rect.height > 30 && rect.width > 60;
	        var showHandler = isSpaceEnough && canDragging
	            && (canDragging === 'handler' || dragengine_1.default.isUseHandler());
	        var showActions = node.canOperating();
	        var actionSpace = getComputedActionSpace(rect, bounds, isSpaceEnough);
	        return (React.createElement("div", { ref: function (ref) { _this.outline = ref; }, className: 'engine-outline engine-hovering-outline', style: {
	                height: rect.height,
	                transform: "translate(" + (rect.left - bounds.left) + "px, " + (rect.top + st - bounds.top) + "px)",
	                width: rect.width,
	            } }, showHandler &&
	            React.createElement("div", { ref: function (ref) { _this.handler = ref; }, className: 'engine-draghandler' },
	                React.createElement(Icons, { name: 'drag-handler' }))));
	    };
	    return HoveringOutline;
	}(React.Component));
	exports.default = HoveringOutline;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var const_1 = __webpack_require__(12);
	var bus_1 = __webpack_require__(36);
	var dragengine_1 = __webpack_require__(21);
	var exchange_1 = __webpack_require__(20);
	var overlay_1 = __webpack_require__(16);
	var viewport_1 = __webpack_require__(41);
	var hoveringOutline_1 = __webpack_require__(256);
	var Icons = __webpack_require__(133);
	// 获取节点的父级节点（最多获取5层）
	var getParentNodes = function (node) {
	    var parentNodes = [];
	    var currentNode = node;
	    while (currentNode && parentNodes.length < 5) {
	        currentNode = currentNode.getParent();
	        if (currentNode && (currentNode.canSelecting() || currentNode.isRoot())) {
	            parentNodes.push(currentNode);
	        }
	    }
	    return parentNodes;
	};
	var getNodeSelectorSpace = function (rect, bounds, parentNodeLength) {
	    if (rect.top - bounds.top < (parentNodeLength + 1) * 22) {
	        return 'bottom';
	    }
	    return 'top';
	};
	var SelectedOutline = /** @class */ (function (_super) {
	    __extends(SelectedOutline, _super);
	    function SelectedOutline(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            parentNodes: [],
	            popupVisible: false,
	        };
	        return _this;
	    }
	    SelectedOutline.prototype.componentWillMount = function () {
	        var _this = this;
	        this.bus = new bus_1.default();
	        this.selectedLine = overlay_1.default.getSelectedLine();
	        this.inPlaceEditingPoint = overlay_1.default.getInPlaceEditingPoint();
	        this.willDetach = [
	            this.selectedLine.onSync(function () {
	                var node = _this.selectedLine.getCurrentNode();
	                var parentNodes = getParentNodes(node);
	                _this.setState({
	                    parentNodes: parentNodes,
	                });
	                _this.forceUpdate();
	            }),
	            this.inPlaceEditingPoint.onSync(function () {
	                _this.forceUpdate();
	            }),
	        ];
	    };
	    SelectedOutline.prototype.componentDidMount = function () {
	        this.willDrag();
	    };
	    SelectedOutline.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    SelectedOutline.prototype.componentDidUpdate = function () {
	        this.willDrag();
	    };
	    SelectedOutline.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (func) {
	                func();
	            });
	        }
	        if (this.willNotDrag) {
	            this.willNotDrag();
	        }
	    };
	    SelectedOutline.prototype.willDrag = function () {
	        var _this = this;
	        if (this.willNotDrag) {
	            this.willNotDrag();
	        }
	        var handler = this.handler;
	        if (!handler) {
	            return;
	        }
	        var dragOff = dragengine_1.default.from(handler, function () { return _this.selectedLine.getCurrentNode(); });
	        this.willNotDrag = function () {
	            dragOff();
	            _this.willNotDrag = null;
	        };
	    };
	    SelectedOutline.prototype.switchNode = function (node) {
	        exchange_1.default.select(node);
	        setTimeout(function () {
	            viewport_1.default.setFocus(true);
	        });
	    };
	    SelectedOutline.prototype.render = function () {
	        var _this = this;
	        if (!this.selectedLine.hasOutline()) {
	            return null;
	        }
	        var parentNodes = this.state.parentNodes;
	        var node = this.selectedLine.getCurrentNode();
	        var page = node.getPage();
	        var bounds = page.getBounds();
	        var st = page.getScrollTop();
	        var rect = node.getRect();
	        var canDragging = node.canDragging();
	        if (!rect || !bounds) {
	            return null;
	        }
	        var isSpaceEnough = rect.height > 30 && rect.width > 60;
	        var isInPlaceEditing = node.isInPlaceEditing();
	        var showHandler = !isInPlaceEditing && !node.isLocking() && isSpaceEnough && canDragging
	            && (canDragging === 'handler' || dragengine_1.default.isUseHandler());
	        var showActions = !isInPlaceEditing && !node.isLocking() && node.canOperating();
	        var actionSpace = hoveringOutline_1.getComputedActionSpace(rect, bounds, isSpaceEnough);
	        var nodeSelectorSpace = getNodeSelectorSpace(rect, bounds, parentNodes.length);
	        var showNodeSelector = node.getComponentName() !== 'Root';
	        if (nodeSelectorSpace === 'top') {
	            parentNodes = parentNodes.reverse();
	        }
	        return (React.createElement("div", { className: "engine-outline engine-selected-outline" + (isInPlaceEditing ? ' in-place-editing' : ''), style: {
	                height: rect.height,
	                transform: "translate(" + (rect.left - bounds.left) + "px, " + (rect.top + st - bounds.top) + "px)",
	                width: rect.width,
	            } },
	            showHandler &&
	                React.createElement("div", { ref: function (ref) { _this.handler = ref; }, className: 'engine-draghandler' },
	                    React.createElement(Icons, { name: 'drag-handler' })),
	            React.createElement("div", { className: "engine-selected-outline-actions-wrapper engine-space-" + actionSpace },
	                showNodeSelector && (React.createElement("div", { className: 'engine-outline-node-selector' },
	                    React.createElement("div", { className: 'engine-outline-node-selector-current' },
	                        React.createElement(Icons, { className: 'node-icon', name: node.getIcon() || 'unknow' }),
	                        React.createElement("span", { className: 'node-text' }, node.getPrototype() && node.getPrototype().getTitle() || node.getComponentName()),
	                        React.createElement(Icons, { className: 'arrow', name: 'arrow' })),
	                    React.createElement("div", { className: "engine-outline-node-selector-popup engine-outline-node-selector-popup-" + nodeSelectorSpace }, parentNodes.map(function (item) { return (React.createElement("div", { key: item.id, className: 'engine-outline-node-selector-popup-item' },
	                        React.createElement("div", { className: 'engine-outline-node-selector-popup-item-inner', onMouseEnter: function () { exchange_1.default.hover(item); }, onClick: _this.switchNode.bind(_this, item) },
	                            React.createElement(Icons, { className: 'node-icon', name: item.getIcon() || 'unknow' }),
	                            React.createElement("span", { className: 'node-text' }, item.getPrototype() && item.getPrototype().getTitle() || item.getComponentName())))); })))),
	                showActions && React.createElement("div", { className: 'engine-outline-actions' },
	                    node.getExtraActions(),
	                    React.createElement(Icons.Button, { "data-tip": '\u590D\u5236', className: 'engine-action-clone', name: 'clone', onClick: function () {
	                            node.clone();
	                            _this.bus.emit(const_1.VE_EVENTS.VE_OVERLAY_ACTION_CLONE_NODE, { from: 'selecting', node: exchange_1.default.getSelected() });
	                        } }),
	                    node.getPrototype() && node.getPrototype().isModal() ? (React.createElement(Icons.Button, { "data-tip": '\u9690\u85CF', className: 'engine-action-hidden', name: 'hidden', onClick: function () {
	                            node.setStatus('visibility', false);
	                        } })) : null,
	                    React.createElement(Icons.Button, { "data-tip": '\u5220\u9664', className: 'engine-action-remove', name: 'remove', onClick: function () {
	                            hoveringOutline_1.removeNode(node, 'selecting', _this.bus);
	                        } })))));
	    };
	    return SelectedOutline;
	}(React.Component));
	exports.default = SelectedOutline;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(259);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./overlay.less", function() {
				var newContent = require("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./overlay.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-simulator-overlay{pointer-events:none;position:absolute;z-index:3;top:0;left:0;font:12px/1 PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(-color-text,rgba(0,0,0,.6));overflow:visible}.engine-simulator-overlay .engine-outline{box-sizing:border-box;pointer-events:none;position:absolute}.engine-simulator-overlay .engine-outline .engine-draghandler{position:absolute;pointer-events:auto;top:-1px;left:50%;transform:translateX(-50%);height:16px;width:60px;text-align:center;background:var(--color-block-background-dark,rgba(31,56,88,.1));border-radius:0 0 3px 3px;cursor:grab}.engine-simulator-overlay .engine-outline .engine-draghandler .ve-svgicon{max-height:100%}.engine-simulator-overlay .engine-outline .engine-draghandler .ve-svgicon path{fill:var(--color-icon-normal,rgba(31,56,88,.4))}.engine-simulator-overlay .engine-outline .engine-draghandler:hover{background:var(--color-brand,#006cff)}.engine-simulator-overlay .engine-outline .engine-space-top-left{left:0;top:-22px}.engine-simulator-overlay .engine-outline .engine-space-top-right{right:0;top:-22px}.engine-simulator-overlay .engine-outline .engine-space-bottom-left{bottom:-22px;left:0}.engine-simulator-overlay .engine-outline .engine-space-bottom-right{bottom:-22px;right:0}.engine-simulator-overlay .engine-outline .engine-selected-outline-actions-wrapper{position:absolute;display:flex}.engine-simulator-overlay .engine-outline .engine-outline-actions{pointer-events:auto;display:flex;background:var(--color-brand,#006cff);border-radius:3px;box-shadow:0 1px 4px 0 rgba(31,56,88,.15)}.engine-simulator-overlay .engine-outline .engine-outline-actions>div{background:var(--color-brand,#006cff);opacity:1}.engine-simulator-overlay .engine-outline .engine-outline-actions>div>svg *{fill:#fff}.engine-simulator-overlay .engine-outline .engine-outline-actions>div:hover{background:var(--color-brand-light,#006cff);color:var(--color-text-reverse,hsla(0,0%,100%,.8));border-radius:0}.engine-simulator-overlay .engine-outline .engine-outline-actions>div:hover>svg *{fill:var(--color-text-reverse,hsla(0,0%,100%,.8))}.engine-simulator-overlay .engine-outline .engine-outline-actions .engine-action-clone,.engine-simulator-overlay .engine-outline .engine-outline-actions .engine-action-hidden,.engine-simulator-overlay .engine-outline .engine-outline-actions .engine-action-remove,.engine-simulator-overlay .engine-outline .engine-outline-actions .ve-action-save{box-sizing:border-box;cursor:pointer;height:20px;width:20px}.engine-simulator-overlay .engine-outline .engine-outline-node-selector{position:relative;color:#fff;background:var(--color-brand,#006cff);border-radius:3px;margin-right:2px;pointer-events:auto;flex-grow:0;flex-shrink:0}.engine-simulator-overlay .engine-outline .engine-outline-node-selector svg *{fill:#fff}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-current{padding:0 6px;display:flex;align-items:center;height:20px;cursor:pointer}.engine-simulator-overlay .engine-outline .engine-outline-node-selector:hover .engine-outline-node-selector-current{color:var(--color-text-reverse,hsla(0,0%,100%,.8))}.engine-simulator-overlay .engine-outline .engine-outline-node-selector:hover .engine-outline-node-selector-current svg *{fill:var(--color-text-reverse,hsla(0,0%,100%,.8))}.engine-simulator-overlay .engine-outline .engine-outline-node-selector:hover .engine-outline-node-selector-popup{visibility:visible;opacity:1;transition:all .2s ease-in}.engine-simulator-overlay .engine-outline .engine-outline-node-selector:hover .arrow{transform:rotate(180deg)}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .node-icon{width:16px;height:16px;margin-right:5px;flex-grow:0;flex-shrink:0;max-width:inherit}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .node-text{margin-right:8px;flex-grow:0;flex-shrink:0}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .arrow{width:12px;height:12px;max-width:inherit;transition:all .3s ease}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup{position:absolute;left:0;right:0;opacity:0;visibility:hidden}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup.engine-outline-node-selector-popup-top{bottom:20px}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup.engine-outline-node-selector-popup-bottom{top:20px}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup .engine-outline-node-selector-popup-item{margin:2px 0}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup .engine-outline-node-selector-popup-item .engine-outline-node-selector-popup-item-inner{background:#78869a;display:inline-flex;border-radius:3px;padding-left:6px;align-items:center;height:20px;color:#fff;cursor:pointer;overflow:visible}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup .engine-outline-node-selector-popup-item .engine-outline-node-selector-popup-item-inner:hover{opacity:.8}.engine-simulator-overlay .engine-outline .engine-outline-node-selector .engine-outline-node-selector-popup .engine-outline-node-selector-popup-item .node-text{margin-right:0;line-height:20px;background:#78869a;border-radius:3px;padding-right:6px}.engine-simulator-overlay .engine-outline.engine-hovering-outline{outline:1px dashed var(--color-brand-light,#197aff);z-index:1;outline-offset:-1px;background:rgba(0,121,242,.04)}.engine-simulator-overlay .engine-outline.engine-selected-outline{outline:2px dotted var(--color-brand-light,#197aff);z-index:1;outline-offset:-2px}.engine-simulator-overlay .engine-outline.engine-dropping-outline{outline:1px solid var(--color-brand-dark,rgba(0,108,255,.6));z-index:1;outline-offset:-1px}html.engine-view-focused .engine-simulator-overlay .engine-selected-outline{outline-style:solid}html.engine-view-focused .engine-simulator-overlay .engine-selected-outline.in-place-editing{outline-color:var(--color-success,#66bc5c)}html.engine-view-focused .engine-simulator-overlay .engine-selected-outline .engine-draghandler{background:var(--color-brand-dark,rgba(0,108,255,.6))}html.engine-view-focused .engine-simulator-overlay .engine-selected-outline .engine-draghandler:hover{background:var(--color-brand-light,#197aff)}html.engine-preview-mode .engine-simulator-overlay{display:none}.engine-insertion{position:absolute;display:block;z-index:12;pointer-events:none!important;height:2px;background-color:var(--color-brand-light,#197aff);line-height:0;font-size:0;will-change:transform}.engine-insertion:after,.engine-insertion:before{position:absolute;content:\"\";left:0;top:-2px;width:0;height:0;border-style:solid;border-width:3px 0 3px 5px;border-color:transparent transparent transparent var(--color-brand-light,#197aff)}.engine-insertion:after{left:auto;right:0;border-width:3px 5px 3px 0;border-color:transparent var(--color-brand-light,#197aff) transparent transparent}.engine-insertion.engine-vertical{width:2px;height:auto}.engine-insertion.engine-vertical:after,.engine-insertion.engine-vertical:before{top:0;left:-2px;right:auto}.engine-insertion.engine-vertical:before{border-width:5px 3px 0;border-color:var(--color-brand-light,#197aff) transparent transparent}.engine-insertion.engine-vertical:after{top:auto;bottom:0;border-width:0 3px 5px;border-color:transparent transparent var(--color-brand-light,#197aff)}", ""]);
	
	// exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(261);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./simulator.less", function() {
				var newContent = require("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./simulator.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-simulator{width:100%;position:absolute;top:0;left:50%;bottom:0;box-shadow:0 2px 10px 0 rgba(31,56,88,.15);transform:translate(-50%);outline:none}.engine-simulator .engine-simulator-screen{position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.engine-simulator .engine-simulator-screen .engine-pages{position:absolute;top:0;left:0;right:0;bottom:0;background:var(--color-pane-background,#fff)}html.engine-simulator-mobile .engine-simulator{width:378px}html.engine-simulator-mobile.engine-with-iphone6shell .engine-simulator{top:8px;background:url(https://img.alicdn.com/tps/TB12GetLpXXXXXhXFXXXXXXXXXX-756-1544.png) no-repeat top;background-size:378px 772px;box-shadow:none}html.engine-simulator-mobile.engine-with-iphone6shell .engine-simulator .engine-simulator-screen{top:114px;left:25px;right:25px;max-height:561px;border-radius:0 0 2px 2px}html.engine-simulator-mobile{font-size:37.8px!important}html.engine-simulator-mobile.engine-with-iphone6shell{font-size:32.8px!important}", ""]);
	
	// exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var panes_1 = __webpack_require__(51);
	__webpack_require__(263);
	var widgets = panes_1.default.widgets;
	var Widgets = /** @class */ (function (_super) {
	    __extends(Widgets, _super);
	    function Widgets() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Widgets.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = widgets.onWidgetsChange(function () { return _this.forceUpdate(); });
	    };
	    Widgets.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Widgets.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    Widgets.prototype.render = function () {
	        var widgetsList = widgets.getWidgets();
	        if (!widgetsList || widgetsList.length < 1)
	            return null;
	        return (React.createElement("div", { className: "engine-widgets" }, widgetsList.map(function (widget) {
	            return (React.createElement("div", { className: "engine-widget engine-widget-" + widget.getName(), key: widget.getName() }, widget.getContent()));
	        })));
	    };
	    return Widgets;
	}(React.Component));
	exports.default = Widgets;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(264);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./widgets.less", function() {
				var newContent = require("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./widgets.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-widgets{z-index:20}.engine-widgets,.engine-widgets .engine-widget{overflow:visible;width:0;height:0}", ""]);
	
	// exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(266);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-workspacepane{top:48px;left:48px;right:280px;bottom:0;z-index:1;background:var(--color-pane-background,#fff);margin:16px}html.engine-preview-mode .engine-workspacepane{left:0;right:0}", ""]);
	
	// exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(268);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-panes{position:absolute;right:0;top:0;bottom:0;left:0;z-index:1;transition:top .2s;background:var(--color-block-background-shallow,rgba(31,56,88,.06))}.engine-panes>.engine-pane{position:absolute;box-sizing:border-box}", ""]);
	
	// exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(270));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	var React = __webpack_require__(5);
	var variableSetter_1 = __webpack_require__(271);
	var context_1 = __webpack_require__(9);
	var const_1 = __webpack_require__(12);
	var fields_1 = __webpack_require__(274);
	__export(__webpack_require__(274));
	var VEUtils = __webpack_require__(4);
	var testType = VEUtils.testType;
	var Component = React.Component;
	var VE_SETTING_FIELD_VARIABLE_SETTER = const_1.VE_HOOKS.VE_SETTING_FIELD_VARIABLE_SETTER;
	var FIELD_TYPE_MAP = {
	    accordion: fields_1.AccordionField,
	    block: fields_1.BlockField,
	    caption: fields_1.CaptionField,
	    entry: fields_1.EntryField,
	    inline: fields_1.InlineField,
	    plain: fields_1.PlainField,
	    popup: fields_1.PopupField,
	    tab: fields_1.AccordionField,
	};
	var SettingField = /** @class */ (function (_super) {
	    __extends(SettingField, _super);
	    function SettingField(props) {
	        var _this = _super.call(this, props) || this;
	        var ctx = new context_1.default();
	        if (ctx.getPlugin(VE_SETTING_FIELD_VARIABLE_SETTER)) {
	            _this.variableSetter = ctx.getPlugin(VE_SETTING_FIELD_VARIABLE_SETTER);
	        }
	        else {
	            _this.variableSetter = variableSetter_1.default;
	        }
	        return _this;
	    }
	    SettingField.prototype.render = function () {
	        var _a = this.props, prop = _a.prop, selected = _a.selected;
	        var display = this.props.forceDisplay || prop.getDisplay();
	        if (display === 'none') {
	            return null;
	        }
	        // 标准的属性，即每一个 Field 在 VE 下都拥有的属性
	        var standardProps = {
	            className: this.props.className,
	            compact: this.props.compact,
	            isSupportMultiSetter: this.supportMultiSetter(),
	            isSupportVariable: prop.isSupportVariable(),
	            isUseVariable: prop.isUseVariable(),
	            prop: prop,
	            setUseVariable: function () { return prop.setUseVariable(!prop.isUseVariable()); },
	            tip: prop.getTip(),
	            title: prop.getTitle(),
	        };
	        // 部分 Field 所需要的额外 fieldProps
	        var extraProps = {};
	        var ctx = new context_1.default();
	        var plugin = ctx.getPlugin(const_1.VE_HOOKS.VE_SETTING_FIELD_PROVIDER);
	        var Field;
	        if (typeof plugin === 'function') {
	            Field = plugin(display, FIELD_TYPE_MAP, prop);
	        }
	        if (!Field) {
	            Field = FIELD_TYPE_MAP[display] || fields_1.PlainField;
	        }
	        this._prepareProps(display, extraProps);
	        if (display === 'entry') {
	            return React.createElement(Field, __assign({}, __assign(__assign({}, standardProps), extraProps)));
	        }
	        var setter;
	        var props = { prop: prop, selected: selected };
	        var fieldProps = __assign({}, __assign(__assign({}, standardProps), extraProps));
	        if (prop.isUseVariable() && !this.variableSetter.isPopup) {
	            props.placeholder = '请输入表达式: ${var}';
	            props.key = prop.getId() + "-variable";
	            setter = React.createElement(this.variableSetter, props);
	            return React.createElement(Field, __assign({}, fieldProps), setter);
	        }
	        // for composited prop
	        if (prop.getVisibleItems) {
	            setter = prop.getVisibleItems()
	                .map(function (item) { return (React.createElement(SettingField, __assign({}, { key: item.getId(), prop: item, selected: selected }))); });
	            return React.createElement(Field, __assign({}, fieldProps), setter);
	        }
	        setter = prop.getSetter();
	        var type = testType(setter);
	        if (type !== 'ReactElement') {
	            setter = React.createElement(type === 'ReactClass' ? setter : variableSetter_1.default, props);
	        }
	        else {
	            setter = React.cloneElement(setter, props);
	        }
	        return React.createElement(Field, __assign({}, fieldProps), setter);
	    };
	    SettingField.prototype.supportMultiSetter = function () {
	        var prop = this.props.prop;
	        var setter = prop && prop.getConfig && prop.getConfig('setter');
	        return prop.isSupportVariable() || Array.isArray(setter);
	    };
	    SettingField.prototype._prepareProps = function (displayType, extraProps) {
	        var _this = this;
	        var prop = this.props.prop;
	        extraProps.propName = prop.isGroup() ? '组合属性，无属性名称' : prop.getName();
	        switch (displayType) {
	            case 'title':
	                break;
	            case 'block':
	                lodash_1.assign(extraProps, { isGroup: prop.isGroup() });
	                break;
	            case 'accordion':
	                lodash_1.assign(extraProps, {
	                    headDIY: true,
	                    isExpand: prop.isExpand(),
	                    isGroup: prop.isGroup(),
	                    onExpandChange: function () { return prop.onExpandChange(function () { return _this.forceUpdate(); }); },
	                    toggleExpand: function () { prop.toggleExpand(); },
	                });
	                break;
	            case 'entry':
	                lodash_1.assign(extraProps, { stageName: prop.getName() });
	                break;
	            default:
	                break;
	        }
	    };
	    return SettingField;
	}(Component));
	exports.SettingField = SettingField;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	__webpack_require__(272);
	var Component = React.Component;
	var Input = /** @class */ (function (_super) {
	    __extends(Input, _super);
	    function Input(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            focused: false,
	        };
	        return _this;
	    }
	    Input.prototype.componentDidMount = function () {
	        this.adjustTextAreaHeight();
	    };
	    Input.prototype.adjustTextAreaHeight = function () {
	        this.domRef.style.height = '1px';
	        var calculatedHeight = this.domRef.scrollHeight;
	        this.domRef.style.height = calculatedHeight >= 200 ? '200px' : calculatedHeight + 'px';
	    };
	    Input.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange;
	        return (React.createElement("div", { className: "engine-variable-setter-input engine-input-control" + (this.state.focused ? ' engine-focused' : '') },
	            React.createElement("textarea", { ref: function (r) { _this.domRef = r; }, className: 'engine-input', value: value || '', placeholder: placeholder || '', onChange: function (e) { onChange((e.target.value || '')); }, onBlur: function () { return _this.setState({ focused: false }); }, onFocus: function () { return _this.setState({ focused: true }); }, onKeyUp: this.adjustTextAreaHeight.bind(this) })));
	    };
	    return Input;
	}(Component));
	var VariableSetter = /** @class */ (function (_super) {
	    __extends(VariableSetter, _super);
	    function VariableSetter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VariableSetter.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = this.props.prop.onValueChange(function () { return _this.forceUpdate(); });
	    };
	    VariableSetter.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    VariableSetter.prototype.render = function () {
	        var prop = this.props.prop;
	        return (React.createElement(Input, { value: prop.getVariableValue(), placeholder: this.props.placeholder, onChange: function (val) { return prop.setVariableValue(val); } }));
	    };
	    return VariableSetter;
	}(Component));
	exports.default = VariableSetter;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(273);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./variableSetter.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./variableSetter.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-input-control{box-sizing:border-box;font-size:12px;font-family:Consolas,Courier New,Courier,FreeMono,monospace;color:var(--color-text,rgba(0,0,0,.6));background:var(--color-field-background,#fff);border:1px solid var(--color-field-border,rgba(31,56,88,.3));flex:1;border-radius:3px;max-height:200px}.engine-input-control:hover{border-color:var(--color-field-border-hover,rgba(31,56,88,.4))}.engine-input-control.engine-focused{border-color:var(--color-field-border-active,rgba(31,56,88,.6))}.engine-input-control textarea{resize:none}.engine-input-control>.engine-input{box-sizing:border-box;padding:6px;display:block;font-size:12px;line-height:16px;color:var(--color-text,rgba(0,0,0,.6));width:100%;border:0;margin:0;background:transparent;outline:none}.engine-input-control>.engine-input::-webkit-input-placeholder{color:var(--color-field-placeholder,rgba(31,56,88,.3))}", ""]);
	
	// exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var Icons = __webpack_require__(133);
	var classNames = __webpack_require__(134);
	var React = __webpack_require__(5);
	var react_1 = __webpack_require__(5);
	var VEUtils = __webpack_require__(4);
	var field_1 = __webpack_require__(275);
	var settingField_1 = __webpack_require__(270);
	var variableSwitcher_1 = __webpack_require__(277);
	__export(__webpack_require__(270));
	__webpack_require__(280);
	var popups = __webpack_require__(282);
	var testType = VEUtils.testType;
	function renderTip(tip, prop) {
	    var propName = prop && prop.propName;
	    if (!tip) {
	        return (React.createElement(Icons.Tip, { position: 'top', key: 'icon', className: 'engine-field-tip-icon' },
	            React.createElement("div", null,
	                React.createElement("div", null, propName))));
	    }
	    if (testType(tip) === 'object') {
	        return (React.createElement(Icons.Tip, { position: 'top', url: tip.url, key: 'icon-tip', className: 'engine-field-tip-icon' },
	            React.createElement("div", null,
	                React.createElement("div", null,
	                    "\u5C5E\u6027\uFF1A",
	                    propName),
	                React.createElement("div", null,
	                    "\u8BF4\u660E\uFF1A",
	                    tip.content))));
	    }
	    return (React.createElement(Icons.Tip, { position: 'top', key: 'icon', className: 'engine-field-tip-icon' },
	        React.createElement("div", null,
	            React.createElement("div", null,
	                "\u5C5E\u6027\uFF1A",
	                propName),
	            React.createElement("div", null,
	                "\u8BF4\u660E\uFF1A",
	                tip))));
	}
	var PlainField = /** @class */ (function (_super) {
	    __extends(PlainField, _super);
	    function PlainField() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PlainField.prototype.renderHead = function () {
	        return null;
	    };
	    PlainField.defaultProps = {
	        headDIY: true,
	    };
	    PlainField.displayName = 'PlainField';
	    return PlainField;
	}(field_1.default));
	exports.PlainField = PlainField;
	var InlineField = /** @class */ (function (_super) {
	    __extends(InlineField, _super);
	    function InlineField(props) {
	        var _this = _super.call(this, props) || this;
	        _this.classNames = ['engine-setting-field', 'engine-inline-field'];
	        return _this;
	    }
	    InlineField.prototype.renderFoot = function () {
	        return (React.createElement("div", { className: 'engine-field-variable-wrapper' },
	            React.createElement(variableSwitcher_1.default, __assign({}, this.props))));
	    };
	    InlineField.displayName = 'InlineField';
	    return InlineField;
	}(field_1.default));
	exports.InlineField = InlineField;
	var BlockField = /** @class */ (function (_super) {
	    __extends(BlockField, _super);
	    function BlockField(props) {
	        var _this = _super.call(this, props) || this;
	        _this.classNames = ['engine-setting-field', 'engine-block-field', props.isGroup ? 'engine-group-field' : ''];
	        return _this;
	    }
	    BlockField.prototype.renderHead = function () {
	        var _a = this.props, title = _a.title, tip = _a.tip, propName = _a.propName;
	        return [
	            React.createElement("span", { className: 'engine-field-title', key: title }, title),
	            renderTip(tip, { propName: propName }),
	            React.createElement(variableSwitcher_1.default, __assign({}, this.props)),
	        ];
	    };
	    BlockField.displayName = 'BlockField';
	    return BlockField;
	}(field_1.default));
	exports.BlockField = BlockField;
	var AccordionField = /** @class */ (function (_super) {
	    __extends(AccordionField, _super);
	    function AccordionField(props) {
	        var _this = _super.call(this, props) || this;
	        _this._generateClassNames(props);
	        return _this;
	    }
	    AccordionField.prototype.componentWillReceiveProps = function (nextProps) {
	        this.classNames = this._generateClassNames(nextProps);
	    };
	    AccordionField.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = this.props.onExpandChange(function () { return _this.forceUpdate(); });
	    };
	    AccordionField.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    AccordionField.prototype.renderHead = function () {
	        var _a = this.props, title = _a.title, tip = _a.tip, toggleExpand = _a.toggleExpand, propName = _a.propName;
	        return (React.createElement("div", { className: 'engine-field-head', onClick: function () { return toggleExpand(); } },
	            React.createElement(Icons, { name: 'arrow', className: 'engine-field-arrow', size: '12px' }),
	            React.createElement("span", { className: 'engine-field-title' }, title),
	            renderTip(tip, { propName: propName }),
	            React.createElement(variableSwitcher_1.default, __assign({}, this.props))));
	    };
	    AccordionField.prototype._generateClassNames = function (props) {
	        this.classNames = ['engine-setting-field', 'engine-accordion-field',
	            props.isGroup ? 'engine-group-field' : '',
	            !props.isExpand ? 'engine-collapsed' : '', ,
	        ];
	        return this.classNames;
	    };
	    return AccordionField;
	}(field_1.default));
	exports.AccordionField = AccordionField;
	var EntryField = /** @class */ (function (_super) {
	    __extends(EntryField, _super);
	    function EntryField(props) {
	        var _this = _super.call(this, props) || this;
	        _this.classNames = ['engine-setting-field', 'engine-entry-field'];
	        return _this;
	    }
	    EntryField.prototype.render = function () {
	        var _a = this.props, propName = _a.propName, stageName = _a.stageName, tip = _a.tip, title = _a.title;
	        var classNameList = classNames.apply(void 0, __spreadArrays(this.classNames, [this.props.className]));
	        var fieldProps = {};
	        if (stageName) {
	            // 为 stage 切换奠定基础
	            fieldProps['data-stage-target'] = this.props.stageName;
	        }
	        var innerElements = [
	            React.createElement("span", { className: 'engine-field-title', key: 'field-title' }, title),
	            renderTip(tip, { propName: propName }),
	            React.createElement(Icons, { name: 'arrow', className: 'engine-field-arrow', size: '12px', key: 'engine-field-arrow-icon' }),
	        ];
	        return (React.createElement("div", __assign({ className: classNameList }, fieldProps), innerElements));
	    };
	    return EntryField;
	}(field_1.default));
	exports.EntryField = EntryField;
	var PopupField = /** @class */ (function (_super) {
	    __extends(PopupField, _super);
	    function PopupField(props) {
	        var _this = _super.call(this, props) || this;
	        _this.classNames = ['engine-setting-field', 'engine-popup-field'];
	        return _this;
	    }
	    PopupField.prototype.renderBody = function () {
	        return '';
	    };
	    PopupField.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, propName = _a.propName, stageName = _a.stageName, tip = _a.tip, title = _a.title;
	        var classNameList = classNames.apply(void 0, __spreadArrays(this.classNames, [this.props.className]));
	        var fieldProps = {};
	        if (stageName) {
	            // 为 stage 切换奠定基础
	            fieldProps['data-stage-target'] = this.props.stageName;
	        }
	        return (React.createElement("div", { className: classNameList, onClick: function (e) { return popups.popup({
	                cancelOnBlur: true,
	                content: _this.props.children,
	                position: 'left bottom',
	                showClose: true,
	                sizeFixed: true,
	                target: e.currentTarget,
	            }); } },
	            React.createElement("span", { className: 'engine-field-title' }, title),
	            renderTip(tip, { propName: propName }),
	            React.createElement(variableSwitcher_1.default, __assign({}, this.props)),
	            React.createElement(Icons, { name: 'popup', className: 'engine-field-icon', size: 'medium' })));
	    };
	    return PopupField;
	}(field_1.default));
	exports.PopupField = PopupField;
	var CaptionField = /** @class */ (function (_super) {
	    __extends(CaptionField, _super);
	    function CaptionField(props) {
	        var _this = _super.call(this, props) || this;
	        _this.classNames = ['engine-setting-field', 'engine-caption-field'];
	        return _this;
	    }
	    CaptionField.prototype.renderHead = function () {
	        var _a = this.props, title = _a.title, tip = _a.tip, propName = _a.propName;
	        return (React.createElement("div", null,
	            React.createElement("span", { className: 'engine-field-title' }, title),
	            renderTip(tip, { propName: propName })));
	    };
	    return CaptionField;
	}(field_1.default));
	exports.CaptionField = CaptionField;
	var Stage = /** @class */ (function (_super) {
	    __extends(Stage, _super);
	    function Stage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Stage.prototype.componentWillMount = function () {
	        var _this = this;
	        this.stage = this.props.stage;
	        if (this.stage.onCurrentTabChange) {
	            this.willDetach = this.stage.onCurrentTabChange(function () { return _this.forceUpdate(); });
	        }
	    };
	    Stage.prototype.componentDidMount = function () {
	        this.doSkate();
	    };
	    Stage.prototype.componentWillReceiveProps = function (props) {
	        var _this = this;
	        if (props.stage !== this.stage) {
	            this.stage = props.stage;
	            if (this.willDetach) {
	                this.willDetach();
	            }
	            if (this.stage.onCurrentTabChange) {
	                this.willDetach = this.stage.onCurrentTabChange(function () { return _this.forceUpdate(); });
	            }
	        }
	    };
	    Stage.prototype.componentDidUpdate = function () {
	        this.doSkate();
	    };
	    Stage.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach();
	        }
	    };
	    Stage.prototype.doSkate = function () {
	        var _this = this;
	        if (this.additionClassName) {
	            setTimeout(function () {
	                var elem = _this.shell;
	                if (elem && elem.classList) {
	                    if (_this.props.current) {
	                        elem.classList.remove(_this.additionClassName);
	                    }
	                    else {
	                        elem.classList.add(_this.additionClassName);
	                    }
	                    _this.additionClassName = null;
	                }
	            }, 10);
	        }
	    };
	    Stage.prototype.render = function () {
	        var _this = this;
	        var stage = this.stage;
	        var content = null;
	        var tabs = null;
	        var className = 'engine-settings-stage';
	        if (stage.getTabs) {
	            var selected_1 = stage.getNode();
	            // stat for cache
	            stage.stat();
	            var currentTab_1 = stage.getCurrentTab();
	            if (stage.hasTabs()) {
	                className += ' engine-has-tabs';
	                tabs = (React.createElement("div", { className: 'engine-settings-tabs' }, stage.getTabs().map(function (tab) {
	                    return React.createElement("div", { key: tab.getId(), className: "engine-settings-tab" + (tab === currentTab_1 ? ' engine-active' : ''), onClick: function () { return stage.setCurrentTab(tab); } },
	                        tab.getTitle(),
	                        renderTip(tab.getTip()));
	                })));
	            }
	            if (currentTab_1) {
	                if (currentTab_1.getVisibleItems) {
	                    content = currentTab_1.getVisibleItems().map(function (item) { return React.createElement(settingField_1.SettingField, { key: item.getId(), selected: selected_1, prop: item }); });
	                }
	                else if (currentTab_1.getSetter) {
	                    content = (React.createElement(settingField_1.SettingField, { key: currentTab_1.getId(), selected: selected_1, prop: currentTab_1, forceDisplay: 'plain' }));
	                }
	            }
	        }
	        else {
	            content = stage.getContent();
	        }
	        if (this.props.current) {
	            if (this.props.direction) {
	                this.additionClassName = "engine-stagein-" + this.props.direction;
	                className += " " + this.additionClassName;
	            }
	        }
	        else if (this.props.direction) {
	            this.additionClassName = "engine-stageout-" + this.props.direction;
	        }
	        var stageBacker = null;
	        if (stage.hasBack()) {
	            className += ' engine-has-backer';
	            stageBacker = (React.createElement("div", { className: 'engine-settings-stagebacker', "data-stage-target": 'stageback' },
	                React.createElement(Icons, { name: 'arrow', className: 'engine-field-arrow', size: '12px' }),
	                React.createElement("span", { className: 'engine-field-title' }, stage.getTitle()),
	                renderTip(stage.getTip())));
	        }
	        return (React.createElement("div", { ref: function (ref) { _this.shell = ref; }, className: className },
	            stageBacker,
	            tabs,
	            React.createElement("div", { className: 'engine-stage-content' }, content)));
	    };
	    return Stage;
	}(react_1.Component));
	exports.Stage = Stage;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var classnames = __webpack_require__(134);
	var lodash_1 = __webpack_require__(7);
	var React = __webpack_require__(5);
	var react_1 = __webpack_require__(5);
	var inlinetip_1 = __webpack_require__(276);
	function splitWord(title) {
	    return (title || '').split('').map(function (w, i) { return React.createElement("b", { key: "word" + i, className: 'engine-word' }, w); });
	}
	function getFieldTitle(title, tip, compact, propName) {
	    var className = classnames('engine-field-title', { 've-compact': compact });
	    var titleContent = null;
	    if (!compact && typeof title === 'string') {
	        titleContent = splitWord(title);
	    }
	    var tipUrl = null;
	    var tipContent = null;
	    tipContent = (React.createElement("div", null,
	        React.createElement("div", null,
	            "\u5C5E\u6027\uFF1A",
	            propName)));
	    if (lodash_1.isObject(tip)) {
	        tipUrl = tip.url;
	        tipContent = (React.createElement("div", null,
	            React.createElement("div", null,
	                "\u5C5E\u6027\uFF1A",
	                propName),
	            React.createElement("div", null,
	                "\u8BF4\u660E\uFF1A",
	                tip.content)));
	    }
	    else if (tip) {
	        tipContent = (React.createElement("div", null,
	            React.createElement("div", null,
	                "\u5C5E\u6027\uFF1A",
	                propName),
	            React.createElement("div", null,
	                "\u8BF4\u660E\uFF1A",
	                tip)));
	    }
	    return (React.createElement("a", { className: className, target: '_blank', rel: 'noopener noreferrer', href: tipUrl },
	        titleContent || (typeof title === 'object' ? '' : title),
	        React.createElement(inlinetip_1.default, { position: 'top' }, tipContent)));
	}
	var VEField = /** @class */ (function (_super) {
	    __extends(VEField, _super);
	    function VEField() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.classNames = [];
	        _this.state = {
	            hasError: false,
	        };
	        return _this;
	    }
	    VEField.prototype.componentDidCatch = function (error, info) {
	        console.error(error);
	        console.warn(info.componentStack);
	    };
	    VEField.prototype.renderHead = function () {
	        var _a = this.props, title = _a.title, tip = _a.tip, compact = _a.compact, propName = _a.propName;
	        return getFieldTitle(title, tip, compact, propName);
	    };
	    VEField.prototype.renderBody = function () {
	        return this.props.children;
	    };
	    VEField.prototype.renderFoot = function () {
	        return null;
	    };
	    VEField.prototype.render = function () {
	        var _a = this.props, stageName = _a.stageName, headDIY = _a.headDIY;
	        var classNameList = classnames.apply(void 0, __spreadArrays(this.classNames, [this.props.className]));
	        var fieldProps = {};
	        if (stageName) {
	            // 为 stage 切换奠定基础
	            fieldProps['data-stage-target'] = this.props.stageName;
	        }
	        if (this.state.hasError) {
	            return (React.createElement("div", null, "Field render error, please open console to find out."));
	        }
	        var headContent = headDIY ? this.renderHead()
	            : React.createElement("div", { className: 'engine-field-head' }, this.renderHead());
	        return (React.createElement("div", __assign({ className: classNameList }, fieldProps),
	            headContent,
	            React.createElement("div", { className: 'engine-field-body' }, this.renderBody()),
	            React.createElement("div", { className: 'engine-field-foot' }, this.renderFoot())));
	    };
	    VEField.displayName = 'VEField';
	    return VEField;
	}(react_1.Component));
	exports.default = VEField;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var InlineTip = /** @class */ (function (_super) {
	    __extends(InlineTip, _super);
	    function InlineTip() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineTip.prototype.render = function () {
	        var _a = this.props, position = _a.position, theme = _a.theme, children = _a.children;
	        return (React.createElement("div", { style: { display: 'none' }, "data-role": 'tip', "data-position": position, "data-theme": theme }, children));
	    };
	    InlineTip.displayName = 'InlineTip';
	    InlineTip.defaultProps = {
	        position: 'auto',
	        theme: 'black',
	    };
	    return InlineTip;
	}(React.Component));
	exports.default = InlineTip;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var variableSetter_1 = __webpack_require__(271);
	var context_1 = __webpack_require__(9);
	var const_1 = __webpack_require__(12);
	var Icons = __webpack_require__(133);
	__webpack_require__(278);
	var VE_SETTING_FIELD_VARIABLE_SETTER = const_1.VE_HOOKS.VE_SETTING_FIELD_VARIABLE_SETTER;
	var VariableSwitcher = /** @class */ (function (_super) {
	    __extends(VariableSwitcher, _super);
	    function VariableSwitcher(props) {
	        var _this = _super.call(this, props) || this;
	        _this.ref = null;
	        var ctx = new context_1.default();
	        if (ctx.getPlugin(VE_SETTING_FIELD_VARIABLE_SETTER)) {
	            _this.VariableSetter = ctx.getPlugin(VE_SETTING_FIELD_VARIABLE_SETTER);
	        }
	        else {
	            _this.VariableSetter = variableSetter_1.default;
	        }
	        _this.state = {
	            visible: false,
	        };
	        return _this;
	    }
	    VariableSwitcher.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, isUseVariable = _a.isUseVariable, prop = _a.prop;
	        var visible = this.state.visible;
	        var isSupportVariable = prop.isSupportVariable();
	        var tip = !isUseVariable ? '绑定变量' : prop.getVariableValue();
	        if (!isSupportVariable) {
	            return null;
	        }
	        return (React.createElement("div", null,
	            React.createElement(Icons.Tip, { name: 'var', size: '24px', position: 'bottom center', className: "engine-field-variable-switcher " + (isUseVariable ? 'engine-active' : ''), "data-tip": tip, onClick: function (e) {
	                    e.stopPropagation();
	                    if (_this.VariableSetter.isPopup) {
	                        _this.VariableSetter.show({
	                            prop: prop,
	                        });
	                    }
	                    else {
	                        prop.setUseVariable(!isUseVariable);
	                    }
	                } }, "\u7ED1\u5B9A\u53D8\u91CF")));
	    };
	    return VariableSwitcher;
	}(React.Component));
	exports.default = VariableSwitcher;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(279);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./variableSwitcher.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./variableSwitcher.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-field-variable-switcher{cursor:pointer;opacity:.6;margin-left:2px}.engine-field-variable-switcher.engine-active{opacity:1;background:var(--color-brand,#006cff);color:#fff!important;border-radius:3px;margin-left:4px}.engine-field-variable-switcher.engine-active svg{height:22px!important;width:22px!important}", ""]);
	
	// exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(281);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./fields.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./fields.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-accordion-field .engine-input-control,.engine-block-field .engine-input-control,.engine-entry-field .engine-input-control{margin:10px}.engine-field-tip-icon{margin-left:2px}", ""]);
	
	// exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _domready = __webpack_require__(24);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _manager = __webpack_require__(283);
	
	var _manager2 = _interopRequireDefault(_manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var origPopups = window && window.popups;
	var popups = origPopups || new _manager2.default();
	
	if (!origPopups) {
	  (0, _domready2.default)(function () {
	    return popups.init();
	  });
	  if (window) {
	    window.popups = popups;
	  }
	}
	
	exports.default = popups;
	module.exports = exports['default'];

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(8);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(11);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _overlay = __webpack_require__(284);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _handler = __webpack_require__(292);
	
	var _handler2 = _interopRequireDefault(_handler);
	
	var _util = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function fixConfig(config) {
	  if (!config) return;
	  if ('model' in config && !('modal' in config)) {
	    config.modal = config.model;
	  }
	}
	
	var Manager = function () {
	  function Manager() {
	    _classCallCheck(this, Manager);
	
	    this.items = [];
	    this.maps = {};
	    this.emitter = new _events2.default();
	  }
	
	  Manager.prototype.init = function init() {
	    if (!document.body) {
	      throw new Error('Must init in body');
	    }
	
	    if (this.inited) return;
	    this.inited = true;
	
	    if (this.tipHandler) {
	      this.initEvent();
	    }
	
	    var div = document.createElement('div');
	    div.className = 've-popups';
	    document.body.appendChild(div);
	
	    _reactDom2.default.render(_react2.default.createElement(_overlay2.default, { manager: this }), div);
	  };
	
	  Manager.prototype.initEvent = function initEvent() {
	    var _this = this;
	
	    document.addEventListener('mouseover', function (e) {
	      return _this.tipHandler.setTarget(e.target);
	    }, false);
	    document.addEventListener('mousedown', function () {
	      return _this.tipHandler.hideImmediately();
	    }, true);
	  };
	
	  Manager.prototype.enableTip = function enableTip() {
	    if (this.tipHandler) return;
	    this.tipHandler = new _handler.TipHandler(this);
	    if (this.inited) {
	      this.initEvent();
	    }
	    this.emitter.emit('itemschange');
	  };
	
	  Manager.prototype.message = function message(config) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
	
	    if (typeof config === 'string') {
	      config = {
	        content: config
	      };
	    }
	    fixConfig(config);
	    var item = new _handler.MessageHandler(this, _extends({
	      id: 1300,
	      type: type
	    }, config));
	    this.addItem(item);
	    return item;
	  };
	
	  Manager.prototype.success = function success(config) {
	    return this.message(config, 'success');
	  };
	
	  Manager.prototype.error = function error(config) {
	    return this.message(config, 'error');
	  };
	
	  Manager.prototype.warn = function warn(config) {
	    return this.message(config, 'warn');
	  };
	
	  Manager.prototype.info = function info(config) {
	    return this.message(config, 'info');
	  };
	
	  Manager.prototype.loading = function loading(config) {
	    if (typeof config === 'string') {
	      config = {
	        content: config
	      };
	    }
	    fixConfig(config);
	
	    return this.popup(_extends({
	      id: 1500,
	      type: 'loading',
	      modal: true,
	      position: 'center center'
	    }, config));
	  };
	
	  Manager.prototype.closeLoading = function closeLoading() {
	    this.removeItem('1500');
	  };
	
	  Manager.prototype.clear = function clear() {
	    this.items = [];
	    this.maps = {};
	    this.emitter.emit('itemschange');
	  };
	
	  Manager.prototype.confirm = function confirm(config) {
	    if (typeof config === 'string') {
	      config = {
	        content: config
	      };
	    }
	
	    var i = (0, _util.defer)();
	
	    this.popup(_extends({
	      id: 1200,
	      type: 'confirm',
	      modal: true,
	      cancelOnBlur: !!config.target,
	      actions: [{
	        name: 'ok',
	        title: config.confirmTitle || '好的',
	        func: function func() {
	          i.resolve();
	          this.close();
	        }
	      }, {
	        name: 'cancel',
	        title: config.cancelTitle || '取消',
	        func: function func() {
	          i.reject();
	          this.close();
	        }
	      }]
	    }, config));
	
	    return i.promise();
	  };
	
	  Manager.prototype.alert = function alert(config) {
	    if (typeof config === 'string') {
	      config = {
	        content: config
	      };
	    }
	
	    var i = (0, _util.defer)();
	
	    this.popup(_extends({
	      id: 1200,
	      type: 'alert',
	      actions: [{
	        name: 'ok',
	        title: config.confirmTitle || '好的',
	        func: function func() {
	          i.resolve();
	          this.close();
	        }
	      }]
	    }, config));
	
	    return i.promise();
	  };
	
	  Manager.prototype.modal = function modal(config) {
	    return this.popup(_extends({}, config, {
	      modal: true
	    }));
	  };
	
	  // 屎前巨坑
	
	
	  Manager.prototype.model = function model(config) {
	    this.modal(config);
	  };
	
	  Manager.prototype.removeItem = function removeItem(id) {
	    var item = this.maps[id];
	    if (item) {
	      this.maps[id] = null;
	      var i = this.items.indexOf(item);
	      if (i > -1) {
	        this.items.splice(i, 1);
	        this.emitter.emit('itemschange');
	      }
	    }
	  };
	
	  Manager.prototype.addItem = function addItem(item) {
	    var id = item.getId();
	
	    this.removeItem(id);
	
	    this.items.push(item);
	    this.maps[item.getId()] = item;
	
	    this.emitter.emit('itemschange');
	  };
	
	  Manager.prototype.popup = function popup(config) {
	    fixConfig(config);
	    var item = new _handler2.default(this, _extends({
	      id: 1100,
	      type: 'popup',
	      position: config.target ? 'top' : 'center center'
	    }, config));
	
	    this.addItem(item);
	
	    return item;
	  };
	
	  Manager.prototype.isShowMask = function isShowMask() {
	    return this.items.some(function (item) {
	      return item.isModal();
	    });
	  };
	
	  Manager.prototype.getItems = function getItems() {
	    if (this.tipHandler) {
	      return [].concat(_toConsumableArray(this.items), [this.tipHandler]);
	    }
	    return this.items;
	  };
	
	  Manager.prototype.onItemsChange = function onItemsChange(func) {
	    var _this2 = this;
	
	    this.emitter.on('itemschange', func);
	    return function () {
	      _this2.emitter.removeListener('itemschange', func);
	    };
	  };
	
	  return Manager;
	}();
	
	exports.default = Manager;
	module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _popup = __webpack_require__(285);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _loading = __webpack_require__(287);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _message = __webpack_require__(288);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _tip = __webpack_require__(289);
	
	var _tip2 = _interopRequireDefault(_tip);
	
	__webpack_require__(290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Overlay = (_temp = _class = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.manager = this.props.manager;
	    this.manager.onItemsChange(function () {
	      return _this2.forceUpdate();
	    });
	  };
	
	  Overlay.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  Overlay.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.mask) {
	      document.documentElement.classList.add('engine-blur');
	    } else {
	      document.documentElement.classList.remove('engine-blur');
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _this3 = this;
	
	    var items = this.manager.getItems().map(function (item) {
	      var props = item.getConfig();
	      var type = item.getType();
	      switch (type) {
	        case 'alert':case 'confirm':case 'modal':case 'popup':
	          return _react2.default.createElement(_popup2.default, _extends({}, props, { key: item.getId(), handle: item }));
	        case 'loading':
	          return _react2.default.createElement(_loading2.default, _extends({}, props, { key: item.getId(), handle: item }));
	        case 'info':case 'success':case 'error':case 'warn':
	          return _react2.default.createElement(_message2.default, _extends({}, props, { key: item.getId(), handle: item }));
	        case 'tip':
	          return _react2.default.createElement(_tip2.default, { key: item.getId(), handle: item });
	        default:
	          return null;
	      }
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.manager.isShowMask() && _react2.default.createElement('div', { ref: function ref(_ref) {
	          _this3.mask = _ref;
	        }, className: 've-mask' }),
	      items
	    );
	  };
	
	  return Overlay;
	}(_react.Component), _class.propTypes = {
	  manager: _react.PropTypes.object
	}, _temp);
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(134);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _veIcons = __webpack_require__(133);
	
	var _veIcons2 = _interopRequireDefault(_veIcons);
	
	var _util = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function Action(props) {
	  var action = props.action,
	      handle = props.handle; // eslint-disable-line
	
	  var className = (0, _classnames2.default)('ve-popup-action', 've-popup-action-' + (action.theme ? action.theme : 'default'));
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      onClick: function onClick() {
	        if (typeof action.func === 'function') {
	          action.func.call(handle, action);
	        }
	      }
	    },
	    action.title
	  );
	}
	
	function isPointInRect(event, rect) {
	  return event.clientY >= rect.top && event.clientY <= rect.bottom && event.clientX >= rect.left && event.clientX <= rect.right;
	}
	var Popup = (_temp = _class = function (_Component) {
	  _inherits(Popup, _Component);
	
	  function Popup() {
	    _classCallCheck(this, Popup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Popup.prototype.componentWillMount = function componentWillMount() {
	    this.handle = this.props.handle;
	  };
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var popup = this.shell;
	    var popupRect = popup.getBoundingClientRect();
	    var bounds = {
	      left: 0,
	      top: 0,
	      right: document.documentElement.clientWidth,
	      bottom: document.documentElement.clientHeight
	    };
	    var _props = this.props,
	        target = _props.target,
	        position = _props.position,
	        cancelOnBlur = _props.cancelOnBlur,
	        sizeFixed = _props.sizeFixed;
	
	    var targetRect = void 0;
	    if (target) {
	      if (target.getBoundingClientRect) {
	        targetRect = target.getBoundingClientRect();
	      } else if ('clientLeft' in target) {
	        targetRect = {
	          width: 0,
	          height: 0,
	          left: target.clientLeft,
	          top: target.clientTop,
	          right: target.clientLeft,
	          bottom: target.clientTop
	        };
	      }
	    }
	
	    if (targetRect) {
	      var arrow = popup.querySelector('.ve-arrow');
	      var arrowRect = arrow.getBoundingClientRect();
	
	      var _resolvePosition = (0, _util.resolvePosition)(popupRect, targetRect, arrowRect, bounds, position),
	          dir = _resolvePosition.dir,
	          left = _resolvePosition.left,
	          top = _resolvePosition.top,
	          arrowLeft = _resolvePosition.arrowLeft,
	          arrowTop = _resolvePosition.arrowTop;
	
	      popup.classList.add('ve-align-' + dir);
	      popup.style.top = top + 'px';
	      popup.style.left = left + 'px';
	      if (dir === 'top' || dir === 'bottom') {
	        arrow.style.left = arrowLeft + 'px';
	      } else {
	        arrow.style.top = arrowTop + 'px';
	      }
	      popup.classList.add('ve-visible-normal');
	      popup.style.transform = 'none';
	    } else {
	      var _resolveRelativePosit = (0, _util.resolveRelativePosition)(position, popupRect, bounds),
	          _left = _resolveRelativePosit.left,
	          _top = _resolveRelativePosit.top;
	
	      popup.style.top = +_top.split('px')[0] - popupRect.height / 2 + 'px';
	      popup.style.left = +_left.split('px')[0] - popupRect.width / 2 + 'px';
	      popup.style.transform = 'initial';
	      popup.classList.add('ve-visible-normal');
	    }
	
	    if (this.props.style) {
	      ['top', 'bottom', 'left', 'right'].forEach(function (e) {
	        if (_this2.props.style.hasOwnProperty(e)) {
	          popup.style[e] = _this2.props.style[e];
	        }
	      });
	    }
	
	    if (sizeFixed) {
	      popup.style.width = popupRect.width + 'px';
	      popup.style.height = popupRect.height + 'px';
	    }
	
	    if (cancelOnBlur) {
	      var down = function down(e) {
	        var rect = popup.getBoundingClientRect();
	        if (e.target && !popup.contains(e.target)) {
	          if (_this2.props.checkInRect) {
	            if (isPointInRect(e, rect)) {
	              return;
	            }
	          }
	          /**
	           * 对于已经 unMount 的 DOM Node 我们不作考虑
	           */
	          if (e.target.isConnected === false) {
	            return;
	          }
	          _this2.handle.close();
	        }
	      };
	      document.addEventListener('mousedown', down);
	      this.willDetach = function () {
	        document.removeEventListener('mousedown', down);
	      };
	    }
	  };
	
	  Popup.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  Popup.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.willDetach) {
	      this.willDetach();
	    }
	    this.clearTimer();
	  };
	
	  Popup.prototype.clearTimer = function clearTimer() {
	    if (this.timer) {
	      clearTimeout(this.timer);
	      this.timer = null;
	    }
	  };
	
	  Popup.prototype.render = function render() {
	    var _this3 = this;
	
	    var className = (0, _classnames2.default)('ve-popup', this.props.className);
	    var actions = this.props.actions;
	    var actionsTheme = (0, _classnames2.default)('ve-popup-actions-' + this.props.actionsTheme);
	    var contentWrapperClassName = (0, _classnames2.default)('ve-popup-content', {
	      've-popup-content-no-padding': !this.props.contentPadding
	    });
	    return _react2.default.createElement(
	      'div',
	      { className: className, ref: function ref(_ref) {
	          _this3.shell = _ref;
	        }, style: this.props.style },
	      this.props.target && _react2.default.createElement(
	        'svg',
	        { viewBox: '0 0 198 122', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', width: '19', height: '12', className: 've-arrow' },
	        _react2.default.createElement(
	          'g',
	          { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
	          _react2.default.createElement(
	            'g',
	            { id: 'Group', transform: 'translate(1.000000, 1.000000)' },
	            _react2.default.createElement('polygon', { fill: '#FFFFFF', points: '98 119 0 1 196 1' }),
	            _react2.default.createElement('polyline', { strokeWidth: '2', points: '0.135078433 0.243023088 97.9777525 119.044718 195.997442 0.243023088' })
	          )
	        )
	      ),
	      this.props.showClose && _react2.default.createElement(_veIcons2.default.Button, {
	        className: 've-popup-close',
	        name: 'close',
	        size: '12px',
	        onClick: function onClick() {
	          return _this3.handle.close();
	        }
	      }),
	      this.props.title && _react2.default.createElement(
	        'div',
	        { className: 've-popup-title' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: contentWrapperClassName },
	        this.props.children || this.props.content
	      ),
	      actions && actions.length > 0 ? _react2.default.createElement(
	        'div',
	        { className: actionsTheme },
	        actions.map(function (action, index) {
	          return _react2.default.createElement(Action, {
	            key: index,
	            action: action,
	            handle: _this3.handle
	          });
	        })
	      ) : null
	    );
	  };
	
	  return Popup;
	}(_react.Component), _class.propTypes = {
	  title: _react.PropTypes.any,
	  target: _react.PropTypes.any,
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  cancelOnBlur: _react.PropTypes.bool,
	  position: _react.PropTypes.string,
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
	  showClose: _react.PropTypes.bool,
	  sizeFixed: _react.PropTypes.bool,
	  actions: _react.PropTypes.array,
	  actionsTheme: _react.PropTypes.string,
	  children: _react.PropTypes.node,
	  content: _react.PropTypes.node,
	  handle: _react.PropTypes.object.isRequired,
	  contentPadding: _react.PropTypes.bool,
	  checkInRect: _react.PropTypes.bool
	}, _class.defaultProps = {
	  title: null,
	  actions: [],
	  actionsTheme: 'default',
	  showClose: false,
	  target: null,
	  animation: 'appear',
	  position: 'top center',
	  cancelOnBlur: false,
	  sizeFixed: false,
	  style: null,
	  className: null,
	  contentPadding: true,
	  checkInRect: false
	}, _class.displayName = 'Popup', _temp);
	exports.default = Popup;
	module.exports = exports['default'];

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.resolvePosition = resolvePosition;
	exports.resolveRelativePosition = resolveRelativePosition;
	exports.defer = defer;
	function resolveEdge(popup, target, arrow, bounds) {
	  var sx = arrow.width > target.width ? (arrow.width - target.width) / 2 : 0;
	  var sy = arrow.width > target.height ? (arrow.width - target.height) / 2 : 0;
	
	  var top = Math.max(target.top - popup.height + arrow.width - sy, bounds.top);
	  var right = Math.min(target.right + popup.width - arrow.width + sx, bounds.right);
	  var bottom = Math.min(target.bottom + popup.height - arrow.width + sy, bounds.bottom);
	  var left = Math.max(target.left - popup.width + arrow.width - sx, bounds.left);
	
	  return { top: top, right: right, bottom: bottom, left: left };
	}
	
	function resolveDirection(popup, target, edge, bounds, prefers) {
	  if (prefers.forceDirection) {
	    return prefers.dir;
	  }
	  var extendWidth = popup.width + popup.extraOffset;
	  var extendHeight = popup.height + popup.extraOffset;
	  var SY = popup.width * extendHeight;
	  var SX = popup.height * extendWidth;
	  var mw = Math.min(edge.right - edge.left, popup.width);
	  var mh = Math.min(edge.bottom - edge.top, popup.height);
	
	  var mat = {
	    top: function top() {
	      var s = mw * Math.min(target.top - bounds.top, extendHeight);
	      return { s: s, enough: s >= SY };
	    },
	    bottom: function bottom() {
	      var s = mw * Math.min(bounds.bottom - target.bottom, extendHeight);
	      return { s: s, enough: s >= SY };
	    },
	    left: function left() {
	      var s = mh * Math.min(target.left - bounds.left, extendWidth);
	      return { s: s, enough: s >= SX };
	    },
	    right: function right() {
	      var s = mh * Math.min(bounds.right - target.right, extendWidth);
	      return { s: s, enough: s >= SX };
	    }
	  };
	
	  var orders = ['top', 'right', 'bottom', 'left'];
	  if (prefers.dir) {
	    var i = orders.indexOf(prefers.dir);
	    if (i > -1) {
	      orders.splice(i, 1);
	      orders.unshift(prefers.dir);
	    }
	  }
	  var ms = 0;
	  var prefer = orders[0];
	  for (var _i = 0, l = orders.length; _i < l; _i++) {
	    var dir = orders[_i];
	
	    var _mat$dir = mat[dir](),
	        s = _mat$dir.s,
	        enough = _mat$dir.enough;
	
	    if (enough) {
	      return dir;
	    }
	    if (s > ms) {
	      ms = s;
	      prefer = dir;
	    }
	  }
	  return prefer;
	}
	
	function resolvePrefer(prefer) {
	  if (!prefer) {
	    return {};
	  }
	  var force = prefer[0] === '!';
	  if (force) {
	    prefer = prefer.substr(1);
	  }
	
	  var _prefer$split = prefer.split(/\s+/),
	      _prefer$split2 = _slicedToArray(_prefer$split, 2),
	      dir = _prefer$split2[0],
	      offset = _prefer$split2[1];
	
	  var forceDirection = false;
	  var forceOffset = false;
	  if (dir === 'center') {
	    dir = 'auto';
	    if (!offset) {
	      offset = 'center';
	    }
	  }
	
	  if (force) {
	    if (dir && dir !== 'auto') {
	      forceDirection = true;
	    }
	    if (offset && offset !== 'auto') {
	      forceOffset = true;
	    }
	  }
	
	  return { dir: dir, offset: offset, forceDirection: forceDirection, forceOffset: forceOffset };
	}
	
	function resolvePosition(popup, target, arrow, bounds, prefer) {
	  popup = {
	    extraOffset: arrow.height,
	    top: popup.top,
	    right: popup.right,
	    left: popup.left,
	    bottom: popup.bottom,
	    height: popup.height,
	    width: popup.width
	  };
	
	  var prefers = resolvePrefer(prefer);
	
	  var edge = resolveEdge(popup, target, arrow, bounds);
	
	  // 选择方向
	  var dir = resolveDirection(popup, target, edge, bounds, prefers);
	
	  var top = void 0;
	  var left = void 0;
	  var arrowTop = void 0;
	  var arrowLeft = void 0;
	
	  // 或得该方位上横向 或 纵向的 偏移
	  if (dir === 'top' || dir === 'bottom') {
	    if (dir === 'top') {
	      top = target.top - popup.extraOffset - popup.height;
	    } else {
	      top = target.bottom + popup.extraOffset;
	    }
	
	    // 解决横向偏移
	    var offset = arrow.width > target.width ? (arrow.width - target.width) / 2 : 0;
	    var minLeft = target.left + arrow.width - offset - popup.width;
	    var maxLeft = target.right - arrow.width + offset;
	    var centerLeft = target.left - (popup.width - target.width) / 2;
	
	    if (prefers.offset === 'left') {
	      left = minLeft;
	    } else if (prefers.offset === 'right') {
	      left = maxLeft;
	    } else {
	      left = centerLeft;
	    }
	
	    if (!prefers.forceOffset) {
	      left = Math.max(Math.min(edge.right - popup.width, left), minLeft);
	      left = Math.min(Math.max(edge.left, left), maxLeft);
	    }
	
	    arrowLeft = Math.min(popup.width - arrow.width, Math.max(target.left - (arrow.width - target.width) / 2 - left, 0));
	  } else {
	    if (dir === 'left') {
	      left = target.left - popup.extraOffset - popup.width;
	    } else {
	      left = target.right + popup.extraOffset;
	    }
	
	    // 解决纵向偏移
	    var _offset = arrow.width > target.height ? (arrow.width - target.height) / 2 : 0;
	    var minTop = target.top + arrow.width - _offset - popup.height;
	    var maxTop = target.bottom - arrow.width + _offset;
	    var centerTop = target.top - (popup.height - target.height) / 2;
	
	    if (prefers.offset === 'top') {
	      top = minTop;
	    } else if (prefers.offset === 'bottom') {
	      top = maxTop;
	    } else {
	      top = centerTop;
	    }
	
	    if (!prefers.forceOffset) {
	      top = Math.max(Math.min(edge.bottom - popup.height, top), minTop);
	      top = Math.min(Math.max(edge.top, top), maxTop);
	    }
	
	    arrowTop = Math.min(popup.height - arrow.height, Math.max(target.top - (arrow.width - target.height) / 2 - top, 0));
	  }
	
	  return { dir: dir, left: left, top: top, arrowLeft: arrowLeft, arrowTop: arrowTop };
	}
	
	var PercentPresets = {
	  right: 1,
	  left: 0,
	  top: 0,
	  bottom: 1,
	  center: 0.5
	};
	
	function isPercent(val) {
	  return (/^[\d.]+%$/.test(val)
	  );
	}
	
	function resolveRelativeValue(val, offset, total) {
	  if (!val) {
	    val = 0;
	  } else if (isPercent(val)) {
	    val = parseFloat(val) / 100 * total;
	  } else if (PercentPresets.hasOwnProperty(val)) {
	    val = PercentPresets[val] * total;
	  } else {
	    val = parseFloat(val);
	    if (isNaN(val)) {
	      val = 0;
	    }
	  }
	
	  return val + offset + 'px';
	}
	
	function resolveRelativePosition(align, popup, bounds) {
	  if (!align) {
	    // return default position
	    return {
	      top: '38.2%',
	      left: 'calc(50% - 110px)'
	    };
	  }
	
	  var _align$trim$split = align.trim().split(/\s+/),
	      _align$trim$split2 = _slicedToArray(_align$trim$split, 2),
	      xAlign = _align$trim$split2[0],
	      yAlign = _align$trim$split2[1];
	
	  if (xAlign === 'top' || xAlign === 'bottom' || yAlign === 'left' || yAlign === 'right') {
	    var tmp = xAlign;
	    xAlign = yAlign;
	    yAlign = tmp;
	  }
	
	  if (xAlign === 'center' && !yAlign) {
	    yAlign = 'center';
	  }
	
	  return {
	    left: resolveRelativeValue(xAlign, popup.width / 2, bounds.right - bounds.left - popup.width),
	    top: resolveRelativeValue(yAlign, popup.height / 2, bounds.bottom - bounds.top - popup.height)
	  };
	}
	
	function defer() {
	  var r = {};
	  var promise = new Promise(function (resolve, reject) {
	    r.resolve = resolve;
	    r.reject = reject;
	  });
	
	  r.promise = function () {
	    return promise;
	  };
	
	  return r;
	}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _veIcons = __webpack_require__(133);
	
	var _veIcons2 = _interopRequireDefault(_veIcons);
	
	var _popup = __webpack_require__(285);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Loading = (_temp = _class = function (_Component) {
	  _inherits(Loading, _Component);
	
	  function Loading() {
	    _classCallCheck(this, Loading);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Loading.prototype.render = function render() {
	    var _props = this.props,
	        content = _props.content,
	        props = _objectWithoutProperties(_props, ['content']);
	
	    return _react2.default.createElement(
	      _popup2.default,
	      _extends({}, props, { className: 've-loading' }),
	      _react2.default.createElement(_veIcons2.default, { name: 'loading', className: 've-loading-icon', size: 'large' }),
	      _react2.default.createElement(
	        'div',
	        { className: 've-loading-content' },
	        content
	      )
	    );
	  };
	
	  return Loading;
	}(_react.Component), _class.propTypes = {
	  content: _react.PropTypes.node,
	  handle: _react.PropTypes.object.isRequired
	}, _class.displayName = 'Loading', _temp);
	exports.default = Loading;
	module.exports = exports['default'];

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(134);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _veIcons = __webpack_require__(133);
	
	var _veIcons2 = _interopRequireDefault(_veIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Message = (_temp = _class = function (_Component) {
	  _inherits(Message, _Component);
	
	  function Message() {
	    _classCallCheck(this, Message);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Message.prototype.componentWillMount = function componentWillMount() {
	    this.handle = this.props.handle;
	  };
	
	  Message.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var popup = this.shell;
	
	    var _props = this.props,
	        type = _props.type,
	        duration = _props.duration;
	    var animation = this.props.animation;
	
	
	    if (animation) {
	      // prepare
	      if (type === 'error' && animation === true) {
	        animation = 'shake';
	      }
	
	      if (animation === 'appear') {
	        popup.classList.add('ve-ani-appear');
	      } else if (animation === 'shake') {
	        popup.classList.add('ve-ani-shake');
	      } else {
	        // appear
	        popup.classList.add('ve-ani-scale');
	      }
	
	      // animate
	      this.timer = setTimeout(function () {
	        if (animation === 'shake') {
	          popup.classList.add('ve-visible-shake');
	        } else {
	          popup.classList.add('ve-visible');
	        }
	      }, 10);
	    } else {
	      popup.classList.add('ve-visible');
	    }
	
	    if (duration) {
	      var timer = setTimeout(function () {
	        _this2.handle.close();
	      }, duration);
	      this.willDetach = function () {
	        clearTimeout(timer);
	      };
	    }
	  };
	
	  Message.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  Message.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.willDetach) {
	      this.willDetach();
	    }
	    this.clearTimer();
	  };
	
	  Message.prototype.clearTimer = function clearTimer() {
	    if (this.timer) {
	      clearTimeout(this.timer);
	      this.timer = null;
	    }
	  };
	
	  Message.prototype.render = function render() {
	    var _this3 = this;
	
	    var className = (0, _classnames2.default)('ve-message', this.props.className);
	    var type = this.props.type;
	
	    return _react2.default.createElement(
	      'div',
	      { className: className, ref: function ref(_ref) {
	          _this3.shell = _ref;
	        }, style: this.props.style },
	      _react2.default.createElement(
	        'a',
	        { className: 've-message-close', onClick: function onClick() {
	            return _this3.handle.close();
	          } },
	        _react2.default.createElement(_veIcons2.default, { name: 'close', size: '14px' })
	      ),
	      _react2.default.createElement(_veIcons2.default, { name: type, size: 'large', className: 've-message-icon-' + type }),
	      _react2.default.createElement(
	        'div',
	        { className: 've-message-content' },
	        this.props.content
	      )
	    );
	  };
	
	  return Message;
	}(_react.Component), _class.propTypes = {
	  className: _react.PropTypes.string,
	  type: _react.PropTypes.oneOf(['info', 'error', 'success', 'warn']),
	  style: _react.PropTypes.object,
	  animation: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['appear', 'scale', 'shake']), _react.PropTypes.bool]),
	  content: _react.PropTypes.node,
	  duration: _react.PropTypes.number,
	  handle: _react.PropTypes.object.isRequired
	}, _class.defaultProps = {
	  animation: true,
	  type: 'info',
	  style: null,
	  className: null,
	  duration: 3000
	}, _class.displayName = 'Message', _temp);
	exports.default = Message;
	module.exports = exports['default'];

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(134);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _util = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Tip = (_temp = _class = function (_Component) {
	  _inherits(Tip, _Component);
	
	  function Tip() {
	    _classCallCheck(this, Tip);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Tip.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    this.handle = this.props.handle;
	    this.willDetach = this.handle.onTipChange(function () {
	      return _this2.forceUpdate();
	    });
	  };
	
	  Tip.prototype.componentDidMount = function componentDidMount() {
	    this.updateTip();
	  };
	
	  Tip.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    return false;
	  };
	
	  Tip.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateTip();
	  };
	
	  Tip.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.willDetach) {
	      this.willDetach();
	    }
	    this.clearTimer();
	  };
	
	  Tip.prototype.clearTimer = function clearTimer() {
	    if (this.timer) {
	      clearTimeout(this.timer);
	      this.timer = null;
	    }
	  };
	
	  Tip.prototype.updateTip = function updateTip() {
	    var popup = this.shell;
	    var arrow = popup.querySelector('.ve-arrow');
	
	    // reset
	    popup.className = this.originClassName;
	    popup.style.cssText = '';
	    arrow.style.cssText = '';
	    this.clearTimer();
	
	    var tip = this.handle.getTip();
	    if (!tip) {
	      return;
	    }
	
	    var target = tip.target,
	        position = tip.position;
	
	    var targetRect = target.getBoundingClientRect();
	
	    if (targetRect.width === 0 || targetRect.height === 0) {
	      return;
	    }
	
	    var popupRect = popup.getBoundingClientRect();
	    var bounds = {
	      left: 1,
	      top: 1,
	      right: document.documentElement.clientWidth - 1,
	      bottom: document.documentElement.clientHeight - 1
	    };
	
	    var arrowRect = arrow.getBoundingClientRect();
	
	    var _resolvePosition = (0, _util.resolvePosition)(popupRect, targetRect, arrowRect, bounds, position),
	        dir = _resolvePosition.dir,
	        left = _resolvePosition.left,
	        top = _resolvePosition.top,
	        arrowLeft = _resolvePosition.arrowLeft,
	        arrowTop = _resolvePosition.arrowTop;
	
	    popup.classList.add('ve-align-' + dir);
	    popup.style.top = top + 'px';
	    popup.style.left = left + 'px';
	    popup.style.width = popupRect.width + 'px';
	    popup.style.height = popupRect.height + 'px';
	
	    if (dir === 'top' || dir === 'bottom') {
	      popup.style.transform = 'translateY(' + (dir === 'top' ? 5 : -5) + 'px)';
	      arrow.style.left = arrowLeft + 'px';
	    } else {
	      popup.style.transform = 'translateX(' + (dir === 'left' ? 5 : -5) + 'px)';
	      arrow.style.top = arrowTop + 'px';
	    }
	    this.timer = setTimeout(function () {
	      popup.classList.add('ve-visible-animate');
	      popup.style.transform = 'none';
	    }, 10);
	  };
	
	  Tip.prototype.render = function render() {
	    var _this3 = this;
	
	    var tip = this.handle.getTip();
	    var className = (0, _classnames2.default)('ve-tip', tip && tip.theme ? 've-theme-' + tip.theme : null);
	    var content = tip ? tip.content : null;
	    var innerHTML = null;
	
	    if (typeof content === 'string') {
	      innerHTML = { __html: content };
	      content = null;
	    }
	
	    this.originClassName = className;
	
	    return _react2.default.createElement(
	      'div',
	      { className: className, ref: function ref(_ref) {
	          _this3.shell = _ref;
	        } },
	      _react2.default.createElement('i', { className: 've-arrow' }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 've-tip-content',
	          dangerouslySetInnerHTML: innerHTML
	        },
	        content
	      )
	    );
	  };
	
	  return Tip;
	}(_react.Component), _class.propTypes = {
	  handle: _react.PropTypes.object.isRequired
	}, _temp);
	exports.default = Tip;
	module.exports = exports['default'];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(291);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../_css-loader@0.23.1@css-loader/index.js!../../../_less-loader@2.2.3@less-loader/index.js!./style.less", function() {
				var newContent = require("!!../../../_css-loader@0.23.1@css-loader/index.js!../../../_less-loader@2.2.3@less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes shake{0%,to{margin:0}20%,60%{margin:0 10px 0 -10px}40%,80%{margin:0 -10px 0 10px}}@keyframes spining{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes pulse{0%,to{transform:scale(1);opacity:.7}50%{transform:scale(1.02);opacity:1}}.ve-popups{position:fixed;z-index:65535;top:0;left:0;height:0;width:0;font-size:12px!important}.ve-popups .ve-mask{position:fixed;top:0;right:0;left:0;bottom:0;z-index:1;background:var(--color-layer-mask-background,rgba(0,0,0,.1))}.ve-popups .ve-arrow{position:absolute;width:36px;height:10px;box-sizing:border-box;overflow:hidden;transform-origin:0 0}.ve-popups .ve-arrow:after{content:\"\";display:block;width:0;height:0;margin:0 auto;border:8px solid transparent;border-top-color:var(--color-pane-background,#fff)}.ve-popups .ve-align-top>.ve-arrow{bottom:0;left:0;transform:translateY(100%)}.ve-popups .ve-align-right>.ve-arrow{left:0;top:0;transform:rotate(90deg)}.ve-popups .ve-align-left>.ve-arrow{right:0;top:0;transform-origin:right top;transform:rotate(-90deg)}.ve-popups .ve-align-bottom>.ve-arrow{top:0;left:0;transform:scaleY(-1)}.ve-popups .ve-popup{z-index:2;position:fixed;background:var(--color-pane-background,#fff);max-height:calc(100vh - 50px);color:var(--color-text,rgba(0,0,0,.6));left:0;top:0;transform:translate(-100%,-100%);visibility:hidden;border:1px solid var(--color-line-normal,rgba(31,56,88,.1));border-radius:3px;min-width:100px;box-shadow:0 1px 4px 0 rgba(31,56,88,.15);overflow:visible}.ve-popups .ve-popup .ve-popup-title{font-size:14px;color:var(--color-title,rgba(0,0,0,.8));height:30px;line-height:30px;padding-left:20px;background:var(--color-block-background-hover,rgba(31,56,88,.04));border-radius:3px 3px 0 0}.ve-popups .ve-popup .ve-popup-close{position:absolute;right:1px;top:1px;padding:2px}.ve-popups .ve-popup .ve-popup-content{padding:10px;min-height:20px;font-size:12px}.ve-popups .ve-popup div.ve-popup-content-no-padding{padding:0}.ve-popups .ve-popup .ve-popup-close+.ve-popup-content{padding-top:17px}.ve-popups .ve-popup .ve-popup-actions-default{display:flex;height:36px;align-items:stretch;border-top:1px solid var(--color-line-normal,rgba(31,56,88,.1));font-size:12px}.ve-popups .ve-popup .ve-popup-actions-default .ve-popup-action{line-height:36px;flex:1;text-align:center;cursor:pointer}.ve-popups .ve-popup .ve-popup-actions-default .ve-popup-action:not(:first-child){border-left:1px solid var(--color-line-normal,rgba(31,56,88,.1))}.ve-popups .ve-popup .ve-popup-actions-loose{display:flex;height:64px;align-items:center;justify-content:center;font-size:12px}.ve-popups .ve-popup .ve-popup-actions-loose .ve-popup-action{display:flex;align-items:center;padding:5px 22px;height:32px;text-align:center;font-size:14px;border-radius:3px;cursor:pointer}.ve-popups .ve-popup .ve-popup-actions-loose .ve-popup-action:not(:first-child){margin-left:8px}.ve-popups .ve-popup .ve-popup-action-default{opacity:.6}.ve-popups .ve-popup .ve-popup-action-default:hover{opacity:1}.ve-popups .ve-popup .ve-popup-action-primary{background:var(--color-brand,#006cff)}.ve-popups .ve-popup .ve-popup-action-primary:hover{background:var(--color-brand-light,#197aff)}.ve-popups .ve-popup .ve-popup-action-disabled{background:var(--color-block-background-disabled,rgba(31,56,88,.2))}.ve-popups .ve-popup .ve-popup-action-secondary{pointer-events:none;background:var(--color-block-background-normal,#fff);color:var(--color-text,rgba(0,0,0,.6))}.ve-popups .ve-popup .ve-popup-action-secondary:hover{background:var(--color-block-background-hover,rgba(31,56,88,.04))}.ve-popups .ve-popup .ve-popup-action-danger{background:var(--color-function-warning,#fabd0e);color:var(--color-text-reverse,hsla(0,0%,100%,.8))}.ve-popups .ve-popup .ve-popup-action-danger:hover{background:var(--color-function-warning-dark,#fabd0e)}.ve-popups .ve-popup.ve-visible{visibility:visible;transition:transform .15s ease-out}.ve-popups .ve-popup.ve-visible-normal{visibility:visible}.ve-popups .ve-popup.ve-visible-shake{visibility:visible;animation:shake .2s}.ve-popups .ve-popup.ve-loading .ve-popup-content{display:flex;justify-content:center;align-items:center;padding:15px}.ve-popups .ve-popup.ve-loading .ve-popup-content .ve-loading-icon{animation:spining .9s infinite linear}.ve-popups .ve-popup.ve-loading .ve-popup-content .ve-loading-content{flex:1;margin-left:8px;max-width:300px;word-break:break-all;animation:pulse 1s infinite linear}.ve-popups .ve-popup.ve-loading .ve-popup-content .ve-loading-content:empty{display:none}.ve-popups .ve-message{z-index:3;position:fixed;background:var(--color-block-background-normal,#fff);max-height:300px;color:var(--color-text,rgba(0,0,0,.6));right:270px;top:58px;box-shadow:0 2px 10px 0 rgba(31,56,88,.15);transform:translate(0);border-radius:3px;display:flex;padding:10px 25px 10px 10px;min-width:60px}.ve-popups .ve-message .ve-message-close{display:inline-block;height:16px;width:16px;position:absolute;right:2px;top:3px;opacity:.8;cursor:pointer}.ve-popups .ve-message .ve-message-close:hover{opacity:1}.ve-popups .ve-message .ve-message-icon-success>path{fill:var(--color-function-success,#66bc5c)}.ve-popups .ve-message .ve-message-icon-error>path{fill:var(--color-function-error,#f04631)}.ve-popups .ve-message .ve-message-icon-warn>path{fill:var(--color-function-warning,#fabd0e)}.ve-popups .ve-message .ve-message-icon-info>path{fill:var(--color-function-information,#2e76a6)}.ve-popups .ve-message .ve-message-content{display:flex;align-items:center;flex:1;margin-left:5px;max-width:300px;word-break:break-all;line-height:22px}.ve-popups .ve-message.ve-ani-scale{transform:translate(0) scale(.8)}.ve-popups .ve-message.ve-ani-appear{transform:translateY(-200%)}.ve-popups .ve-message.ve-ani-shake{transform:translate(0)}.ve-popups .ve-message.ve-visible{transition:transform .15s ease-out;transform:translate(0)}.ve-popups .ve-message.ve-visible-shake{transform:translate(0);animation:shake .2s}.ve-popups .ve-tip{z-index:2;position:fixed;box-sizing:border-box;background:var(--color-layer-tooltip-background,rgba(0,0,0,.8));max-height:400px;color:var(--color-text-reverse,hsla(0,0%,100%,.8));left:0;top:0;transform:translate(-100%,-100%);visibility:hidden;border-radius:3px;padding:6px 8px;text-shadow:0 -1px rgba(0,0,0,.3);font-size:12px;line-height:14px;max-width:200px;pointer-events:none}.ve-popups .ve-tip .ve-arrow{width:24px;height:8px}.ve-popups .ve-tip .ve-arrow:after{border:6px solid transparent;border-top-color:var(--color-layer-tooltip-background,rgba(0,0,0,.8))}.ve-popups .ve-tip.ve-theme-black{background:rgba(0,0,0,.7)}.ve-popups .ve-tip.ve-theme-black .ve-arrow:after{border-top-color:rgba(0,0,0,.7)}.ve-popups .ve-tip.ve-theme-green{background:#57a672}.ve-popups .ve-tip.ve-theme-green .ve-arrow:after{border-top-color:#57a672}.ve-popups .ve-tip.ve-visible{visibility:visible}.ve-popups .ve-tip.ve-visible-animate{visibility:visible;transition:transform .15s ease-out}", ""]);
	
	// exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TipHandler = exports.MessageHandler = exports.default = undefined;
	
	var _events = __webpack_require__(11);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Handler = function () {
	  function Handler(manager, config) {
	    _classCallCheck(this, Handler);
	
	    this.manager = manager;
	    this.config = config;
	    this.id = config.id;
	  }
	
	  Handler.prototype.getConfig = function getConfig() {
	    return this.config;
	  };
	
	  Handler.prototype.getType = function getType() {
	    return this.config.type;
	  };
	
	  // @deprecated
	
	
	  Handler.prototype.isModel = function isModel() {
	    return this.isModal();
	  };
	
	  Handler.prototype.isModal = function isModal() {
	    return this.config.modal;
	  };
	
	  Handler.prototype.getId = function getId() {
	    return this.config.id;
	  };
	
	  Handler.prototype.close = function close() {
	    this.manager.removeItem(this.getId());
	  };
	
	  return Handler;
	}();
	
	exports.default = Handler;
	
	
	function findTip(target) {
	  if (!target) return null;
	  // optimize deep finding on mouseover
	  var deepLimit = 10;
	  while (target && deepLimit-- > 0) {
	    // get tip from target node
	    if (target.dataset && target.dataset.tip) {
	      return {
	        content: target.dataset.tip,
	        position: target.dataset.position || target.dataset.direction || target.dataset.dir,
	        theme: target.dataset.theme,
	        target: target
	      };
	    }
	
	    // or get tip from child nodes
	    var children = target.childNodes;
	    var l = children.length;
	    var child = void 0;
	
	    while (l-- > 0) {
	      child = children[l];
	      if (child.dataset && child.dataset.role === 'tip') {
	        var html = child.innerHTML;
	        if (!html) {
	          return null;
	        }
	        return {
	          content: html,
	          position: child.dataset.position,
	          theme: child.dataset.theme,
	          target: target
	        };
	      }
	    }
	
	    target = target.parentNode;
	  }
	
	  return null;
	}
	
	var MessageHandler = exports.MessageHandler = function (_Handler) {
	  _inherits(MessageHandler, _Handler);
	
	  function MessageHandler() {
	    _classCallCheck(this, MessageHandler);
	
	    return _possibleConstructorReturn(this, _Handler.apply(this, arguments));
	  }
	
	  MessageHandler.prototype.isModal = function isModal() {
	    return false;
	  };
	
	  return MessageHandler;
	}(Handler);
	
	var TipHandler = exports.TipHandler = function (_Handler2) {
	  _inherits(TipHandler, _Handler2);
	
	  function TipHandler(manager) {
	    _classCallCheck(this, TipHandler);
	
	    var _this2 = _possibleConstructorReturn(this, _Handler2.call(this, manager, {
	      id: 1400,
	      type: 'tip'
	    }));
	
	    _this2.tip = null;
	    _this2.emitter = new _events2.default();
	    return _this2;
	  }
	
	  TipHandler.prototype.getTip = function getTip() {
	    return this.tip;
	  };
	
	  TipHandler.prototype.isModal = function isModal() {
	    return false;
	  };
	
	  TipHandler.prototype.setTarget = function setTarget(target) {
	    var _this3 = this;
	
	    var tip = findTip(target);
	    if (tip) {
	      if (this.tip) {
	        // the some target should return
	        if (this.tip.target === tip.target) {
	          this.tip = tip;
	          return;
	        }
	        // not show already, reset show delay
	        if (this.showDelay) {
	          clearTimeout(this.showDelay);
	          this.showDelay = null;
	          this.tip = null;
	        } else {
	          if (this.hideDelay) {
	            clearTimeout(this.hideDelay);
	            this.hideDelay = null;
	          }
	          this.tip = tip;
	          this.emitter.emit('tipchange');
	          return;
	        }
	      }
	
	      this.tip = tip;
	      if (this.hideDelay) {
	        clearTimeout(this.hideDelay);
	        this.hideDelay = null;
	        this.emitter.emit('tipchange');
	      } else {
	        this.showDelay = setTimeout(function () {
	          _this3.showDelay = null;
	          _this3.emitter.emit('tipchange');
	        }, 350);
	      }
	    } else {
	      if (this.showDelay) {
	        clearTimeout(this.showDelay);
	        this.showDelay = null;
	      } else {
	        this.hideDelay = setTimeout(function () {
	          _this3.hideDelay = null;
	        }, 100);
	      }
	      this.tip = null;
	
	      this.emitter.emit('tipchange');
	    }
	  };
	
	  TipHandler.prototype.hideImmediately = function hideImmediately() {
	    if (this.hideDelay) {
	      clearTimeout(this.hideDelay);
	      this.hideDelay = null;
	    }
	    if (this.showDelay) {
	      clearTimeout(this.showDelay);
	      this.showDelay = null;
	    }
	    this.tip = null;
	    this.emitter.emit('tipchange');
	  };
	
	  TipHandler.prototype.close = function close() {
	    return;
	  };
	
	  TipHandler.prototype.onTipChange = function onTipChange(func) {
	    var _this4 = this;
	
	    this.emitter.on('tipchange', func);
	    return function () {
	      _this4.emitter.removeListener('tipchange', func);
	    };
	  };
	
	  return TipHandler;
	}(Handler);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var pages_1 = __webpack_require__(61);
	var panes_1 = __webpack_require__(51);
	__webpack_require__(294);
	__webpack_require__(295);
	var settings_1 = __webpack_require__(296);
	var rootNodeVisitor_1 = __webpack_require__(303);
	__webpack_require__(304);
	var React = __webpack_require__(5);
	var popups = __webpack_require__(282);
	var StyleSheet = __webpack_require__(84);
	/**
	 * Build-in logo
	 */
	panes_1.default.add({
	    content: (React.createElement("a", { href: 'https://go.alibaba-inc.com/home/', target: '_blank', rel: 'noopener noreferrer' },
	        React.createElement("img", { alt: '', className: 'engine-logo', src: 'https://img.alicdn.com/tfs/TB1DsrsXkyWBuNjy0FpXXassXXa-60-60.png' }))),
	    name: 'logo',
	    place: 'left',
	    type: 'action',
	});
	/**
	 * Build-in prop value setting pane
	 */
	panes_1.default.add(settings_1.default);
	/**
	 * Enable global tips
	 */
	popups.enableTip();
	/**
	 * Add page nodes-visitor
	 */
	pages_1.default.onCurrentPageChange(function (page) {
	    if (!page) {
	        return;
	    }
	    page.acceptRootNodeVisitor('NodeCache', function (rootNode) {
	        var visitor = page.getRootNodeVisitor('NodeCache');
	        if (visitor) {
	            visitor.destroy();
	        }
	        return new rootNodeVisitor_1.default(page, rootNode);
	    });
	});
	StyleSheet.setDesignMode(true);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _veCopyPaster = __webpack_require__(246);
	
	var _veCopyPaster2 = _interopRequireDefault(_veCopyPaster);
	
	var _exchange = __webpack_require__(20);
	
	var _exchange2 = _interopRequireDefault(_exchange);
	
	var _viewport = __webpack_require__(41);
	
	var _viewport2 = _interopRequireDefault(_viewport);
	
	var _index = __webpack_require__(61);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKey = __webpack_require__(123);
	
	function isFormEvent(e) {
	  var t = e.target;
	  if (!t) return false;
	
	  if (t.form || /^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName)) {
	    return true;
	  }
	  if (/write/.test(window.getComputedStyle(t).getPropertyValue('-webkit-user-modify'))) {
	    return true;
	  }
	  return false;
	}
	
	function isValidNodeData(data) {
	  if (data && data.componentName) {
	    return true;
	  }
	  return false;
	}
	
	function getNextForSelect(next, head, parent) {
	  if (next) {
	    if (!head && next.canSelecting()) {
	      return next;
	    }
	
	    var ret = void 0;
	
	    if (next.isContainer()) {
	      ret = getNextForSelect(next.getChild(0));
	      if (ret) {
	        return ret;
	      }
	    }
	
	    ret = getNextForSelect(next.nextSibling());
	    if (ret) {
	      return ret;
	    }
	  }
	
	  if (parent) {
	    return getNextForSelect(parent.nextSibling(), false, parent.getParent());
	  }
	
	  return null;
	}
	
	function getPrevForSelect(prev, head, parent) {
	  if (prev) {
	    var ret = void 0;
	    if (!head && prev.isContainer()) {
	      ret = getPrevForSelect(prev.lastChild());
	      if (ret) {
	        return ret;
	      }
	    }
	
	    if (!head && prev.canSelecting()) {
	      return prev;
	    }
	
	    ret = getPrevForSelect(prev.prevSibling());
	    if (ret) {
	      return ret;
	    }
	  }
	
	  if (parent) {
	    if (parent.canSelecting()) {
	      return parent;
	    }
	    return getPrevForSelect(parent.lastChild(), false, parent.getParent());
	  }
	
	  return null;
	}
	
	var engineTreePane = null;
	function isInEditingArea(e) {
	  if (!engineTreePane) {
	    engineTreePane = document.querySelector('.engine-tree');
	  }
	  return _viewport2.default.isFocus() || e.target.contains(engineTreePane);
	}
	
	// remove select node
	HotKey.bind('backspace', function (e) {
	  if (isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	  e.preventDefault();
	  if (_viewport2.default.isPreview()) {
	    return;
	  }
	  var selected = _exchange2.default.getSelected();
	  if (!selected || !selected.canOperating()) return;
	  selected.remove();
	});
	
	// cancel select | cancel edit
	HotKey.bind('escape', function (e) {
	  if (_viewport2.default.isPreview() || isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	
	  e.preventDefault();
	  var selected = _exchange2.default.getSelected();
	  if (!selected) return;
	
	  if (selected.isLocking()) {
	    _exchange2.default.lock(null);
	  } else {
	    _exchange2.default.select(null);
	  }
	});
	
	// command + c copy  command + x cut
	HotKey.bind(['command+c', 'ctrl+c', 'command+x', 'ctrl+x'], function (e, action) {
	  if (_viewport2.default.isPreview() || isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	  e.preventDefault();
	
	  var selected = _exchange2.default.getSelected();
	  if (!selected || !selected.canOperating()) return;
	  _veCopyPaster2.default.setClipboardData(selected.toData(), function () {
	    return _viewport2.default.returnFocus();
	  });
	  var cutMode = action.indexOf('x') > 0;
	  if (cutMode) {
	    var parentNode = selected.getParent();
	    parentNode.select();
	    selected.remove();
	  }
	});
	
	// command + v paste
	HotKey.bind(['command+v', 'ctrl+v'], function (e) {
	  if (_viewport2.default.isPreview() || isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	  _veCopyPaster2.default.getClipboardData(function (data) {
	    _viewport2.default.returnFocus();
	    if (isValidNodeData(data)) {
	      var selected = _exchange2.default.getSelected();
	      if (!selected) return;
	      if (!selected.isRoot() && !selected.canOperating()) return;
	      var page = selected.getPage();
	      var clipboardNode = page.createNode(data);
	      if (!clipboardNode) return;
	      var place = selected.getSuitablePlace(clipboardNode);
	      if (!place) return;
	      if (selected.isRoot()) {
	        place.container.insert(clipboardNode, place.ref);
	      } else {
	        place.container.insertAfter(clipboardNode, place.ref);
	      }
	      if (clipboardNode) {
	        _exchange2.default.select(clipboardNode);
	      }
	    }
	  });
	});
	
	// command + z undo
	HotKey.bind(['command+z', 'ctrl+z'], function (e) {
	  if (_viewport2.default.isPreview() || isFormEvent(e)) {
	    return;
	  }
	  e.preventDefault();
	  var currentPage = _index2.default.getCurrentPage();
	  if (!currentPage) {
	    return;
	  }
	  currentPage.getHistory().back();
	});
	
	// command + shift + z redo
	HotKey.bind(['command+y', 'ctrl+y', 'command+shift+z'], function (e) {
	  if (_viewport2.default.isPreview() || isFormEvent(e)) {
	    return;
	  }
	  e.preventDefault();
	  var currentPage = _index2.default.getCurrentPage();
	  if (!currentPage) {
	    return;
	  }
	  currentPage.getHistory().forward();
	});
	
	// sibling selection
	HotKey.bind(['left', 'right'], function (e, action) {
	  if (_viewport2.default.isPreview() || isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	  e.preventDefault();
	  var selected = _exchange2.default.getSelected();
	  if (!selected) return;
	  var silbing = action === 'left' ? selected.prevSibling() : selected.nextSibling();
	  if (silbing) {
	    _exchange2.default.select(silbing);
	  }
	});
	
	HotKey.bind(['up', 'down'], function (e, action) {
	  if (_viewport2.default.isPreview() || isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	
	  e.preventDefault();
	  var selected = _exchange2.default.getSelected();
	  if (!selected) return;
	  if (action === 'down') {
	    var next = getNextForSelect(selected, true, selected.getParent());
	    if (next) {
	      _exchange2.default.select(next);
	    }
	    return;
	  }
	  if (action === 'up') {
	    var prev = getPrevForSelect(selected, true, selected.getParent());
	    if (prev) {
	      _exchange2.default.select(prev);
	    }
	  }
	});
	
	HotKey.bind(['option+up', 'option+down', 'option+left', 'option+right'], function (e, action) {
	  if (_viewport2.default.isPreview() || isFormEvent(e) || !isInEditingArea(e)) {
	    return;
	  }
	
	  e.preventDefault();
	  var selected = _exchange2.default.getSelected();
	  if (!selected || !selected.canOperating()) return;
	
	  var parent = selected.getParent();
	  if (!parent) return;
	
	  var isPrev = /(up|left)$/.test(action);
	  var isTravel = /(up|down)$/.test(action);
	
	  var silbing = isPrev ? selected.prevSibling() : selected.nextSibling();
	  if (silbing) {
	    if (isTravel && silbing.isContainer()) {
	      var place = silbing.getSuitablePlace(selected, null, true);
	      if (isPrev) {
	        place.container.insertAfter(selected, place.ref);
	      } else {
	        place.container.insertBefore(selected, place.ref);
	      }
	    } else if (isPrev) {
	      parent.insertBefore(selected, silbing);
	    } else {
	      parent.insertAfter(selected, silbing);
	    }
	    _exchange2.default.select(selected);
	    return;
	  }
	  if (isTravel) {
	    var _place = parent.getSuitablePlace(selected); // upwards
	    if (_place) {
	      if (isPrev) {
	        _place.container.insertBefore(selected, _place.ref);
	      } else {
	        _place.container.insertAfter(selected, _place.ref);
	      }
	      _exchange2.default.select(selected);
	    }
	  }
	});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var bundle_1 = __webpack_require__(14);
	var env_1 = __webpack_require__(10);
	var I18nUtil = __webpack_require__(47);
	function i18nReducer(obj) {
	    if (!obj) {
	        return obj;
	    }
	    if (Array.isArray(obj)) {
	        return obj.map(function (item) { return i18nReducer(item); });
	    }
	    if (typeof obj === 'object') {
	        if (obj.type === 'i18n') {
	            var locale = env_1.default.getLocale();
	            if (obj.key) {
	                return I18nUtil.get(obj.key, locale);
	            }
	            if (locale !== 'zh_CN' && locale !== 'zh_TW' && !obj[locale]) {
	                locale = 'en_US';
	            }
	            return obj[obj.use || locale] || obj.zh_CN;
	        }
	        var out_1 = {};
	        Object.keys(obj).forEach(function (key) {
	            out_1[key] = i18nReducer(obj[key]);
	        });
	        return out_1;
	    }
	    return obj;
	}
	/**
	 * Build-in i18n value handler
	 */
	bundle_1.default.addGlobalPropsReducer(i18nReducer);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(5);
	var settings_1 = __webpack_require__(297);
	__webpack_require__(301);
	/**
	 * The SettingPane on the right-side
	 * of the whole engine UI
	 */
	exports.default = {
	    content: React.createElement(settings_1.default, null),
	    name: 'settings',
	    title: '设置',
	    type: 'tab',
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Icons = __webpack_require__(133);
	var React = __webpack_require__(5);
	var const_1 = __webpack_require__(12);
	var bus_1 = __webpack_require__(36);
	var env_1 = __webpack_require__(10);
	var exchange_1 = __webpack_require__(20);
	var navigator_1 = __webpack_require__(298);
	var fields_1 = __webpack_require__(269);
	;
	var Settings = /** @class */ (function (_super) {
	    __extends(Settings, _super);
	    function Settings() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            hasError: false,
	        };
	        return _this;
	    }
	    Settings.getDerivedStateFromError = function (error) {
	        return { hasError: error, error: error };
	    };
	    Settings.prototype.componentWillMount = function () {
	        var _this = this;
	        var detachListeners;
	        this.bus = new bus_1.default();
	        var detach = function () {
	            if (detachListeners) {
	                detachListeners.forEach(function (off) { return off(); });
	                detachListeners = [];
	            }
	        };
	        var attach = function () {
	            detach();
	            _this.selected = exchange_1.default.getSelected();
	            if (_this.selected) {
	                detachListeners = [_this.selected.onStatusChange(function (status, field) {
	                        if (field === 'pseudo') {
	                            _this.forceUpdate();
	                        }
	                    })];
	                var props = _this.selected.getProps();
	                if (props) {
	                    detachListeners.push(props.onPropsChange(function () { return _this.forceUpdate(); }));
	                    detachListeners.push(props.onStageChange(function () { return _this.forceUpdate(); }));
	                }
	            }
	        };
	        attach();
	        this.willDetach = [
	            detach,
	            exchange_1.default.onSelectedChange(function () {
	                attach();
	                _this.forceUpdate();
	            }),
	            env_1.default.onEnvChange(function (envs, name) {
	                if (name === 'locale') {
	                    _this.forceUpdate();
	                }
	            }),
	            this.bus.on(const_1.VE_EVENTS.VE_NODE_PROPS_REPLACE, function () {
	                _this.forceUpdate();
	            }),
	            this.bus.on(const_1.VE_EVENTS.VE_NODE_CREATED, function () {
	                _this.forceUpdate();
	            }),
	            this.bus.on(const_1.VE_EVENTS.VE_NODE_DESTROY, function () {
	                _this.forceUpdate();
	            }),
	        ];
	    };
	    Settings.prototype.componentDidMount = function () {
	        var _this = this;
	        var pane = this.shell;
	        function getTarget(node) {
	            if (!pane.contains(node) || (node.nodeName === 'A' && node.getAttribute('href'))) {
	                return null;
	            }
	            var target = node.dataset ? node.dataset.stageTarget : null;
	            if (target) {
	                return target;
	            }
	            return getTarget(node.parentNode);
	        }
	        if (pane && pane.contains) {
	            var click_1 = function (e) {
	                var target = getTarget(e.target);
	                if (!target || !_this.selected) {
	                    return;
	                }
	                var props = _this.selected.getProps();
	                if (props) {
	                    if (target === 'stageback') {
	                        props.stageBack();
	                    }
	                    else {
	                        props.stagePush(target);
	                    }
	                }
	            };
	            pane.addEventListener('click', click_1, false);
	            this.willDetach.push(function () { return pane.removeEventListener('click', click_1, false); });
	        }
	    };
	    Settings.prototype.shouldComponentUpdate = function () {
	        return false;
	    };
	    Settings.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    Settings.prototype.componentDidCatch = function (error, info) {
	        console.error(error);
	        console.warn(info, info.componentStack);
	    };
	    Settings.prototype.render = function () {
	        var _this = this;
	        var selected = this.selected;
	        var content = null;
	        var contentRefer = null;
	        if (this.state.hasError) {
	            return (React.createElement("div", null, "Setting Pane rendering error, open console to check."));
	        }
	        if (selected) {
	            var props = selected.getProps();
	            if (props) {
	                var stage = props.getCurrentStage();
	                var refer = stage.getRefer();
	                if (refer) {
	                    content = React.createElement(fields_1.Stage, { key: stage.getId(), stage: stage, direction: refer.direction, current: true });
	                    contentRefer = (React.createElement(fields_1.Stage, { key: refer.stage.getId(), stage: refer.stage, direction: refer.direction }));
	                }
	                else {
	                    content = (React.createElement(fields_1.Stage, { key: stage.getId(), stage: stage, current: true }));
	                }
	            }
	        }
	        else {
	            content = (React.createElement("div", { className: 'engine-nonselected-notice' },
	                Icons.getIcon('selection'),
	                React.createElement("p", null, "\u8BF7\u5728\u5DE6\u4FA7\u753B\u5E03\u9009\u4E2D\u8282\u70B9")));
	        }
	        return (React.createElement("div", { ref: function (ref) { _this.shell = ref; }, className: 'engine-settings' },
	            React.createElement(navigator_1.default, null),
	            React.createElement("div", { className: 'engine-settings-content' },
	                content,
	                contentRefer)));
	    };
	    return Settings;
	}(React.Component));
	exports.default = Settings;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var Icons = __webpack_require__(133);
	var React = __webpack_require__(5);
	var context_1 = __webpack_require__(9);
	var exchange_1 = __webpack_require__(20);
	var viewport_1 = __webpack_require__(41);
	__webpack_require__(299);
	function getSegments(selected) {
	    var segments = [selected];
	    var limit = 2;
	    var segment = selected.getParent();
	    while (limit-- > 0 && segment) {
	        segments.unshift(segment);
	        segment = segment.getParent();
	    }
	    return segments;
	}
	var Segment = /** @class */ (function (_super) {
	    __extends(Segment, _super);
	    function Segment() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Segment.prototype.render = function () {
	        var node = this.props.node;
	        var title = node.getTitle() || 'unknow';
	        var tipContent = title;
	        var proto = node.getPrototype();
	        var packageName = proto && proto.getPackageName();
	        if (packageName) {
	            tipContent = title + " | " + packageName;
	        }
	        return (React.createElement("div", { className: 'engine-navigator-segment', onMouseOver: function () { return exchange_1.default.hover(node); }, onMouseOut: function () { return exchange_1.default.hover(null); }, onClick: function () { return exchange_1.default.select(node); }, "data-tip": tipContent, "data-dir": 'top' },
	            React.createElement("a", { className: 'engine-segment-title' }, title)));
	    };
	    return Segment;
	}(React.Component));
	var Navigator = /** @class */ (function (_super) {
	    __extends(Navigator, _super);
	    function Navigator(props) {
	        var _this = _super.call(this, props) || this;
	        _this.ctx = new context_1.default();
	        return _this;
	    }
	    Navigator.prototype.componentWillMount = function () {
	        var _this = this;
	        this.willDetach = [exchange_1.default.onSelectedChange(function () { return _this.forceUpdate(); })];
	    };
	    Navigator.prototype.componentDidMount = function () {
	        var outline = this.outline;
	        var focusin = function () {
	            viewport_1.default.setFocus(true);
	        };
	        var focusout = function (e) {
	            if (!outline || !outline.contains) {
	                return;
	            }
	            if (e.relatedTarget && outline.contains(e.relatedTarget)) {
	                viewport_1.default.setFocus(true);
	            }
	            else {
	                viewport_1.default.setFocus(false);
	            }
	        };
	        outline.addEventListener('focusin', focusin);
	        outline.addEventListener('focusout', focusout);
	        this.willDetach.push(function () {
	            outline.removeEventListener('focusin', focusin);
	            outline.removeEventListener('focusout', focusout);
	        });
	    };
	    Navigator.prototype.componentWillUnmount = function () {
	        if (this.willDetach) {
	            this.willDetach.forEach(function (off) { return off(); });
	        }
	    };
	    Navigator.prototype.render = function () {
	        var _this = this;
	        var selected = exchange_1.default.getSelected();
	        var TreePane = this.ctx.getModule('TreePane');
	        var TreeCore = this.ctx.getModule('TreeCore');
	        // Icons' declaration file use React v16.0 which is not compatible
	        var IconButton = Icons.Button;
	        var IconSingle = Icons;
	        var icon;
	        var path;
	        var treePaneHeader = null;
	        var treePane = null;
	        if (selected) {
	            icon = selected.getIcon() || 'unknow';
	            path = getSegments(selected).map(function (segment) {
	                return React.createElement(Segment, { key: segment.getId(), node: segment });
	            });
	        }
	        else {
	            icon = 'nonselected';
	            path = React.createElement("span", { className: 'engine-navigator-nonselected' }, "\u672A\u9009\u4E2D");
	        }
	        if (TreeCore && TreePane) {
	            treePaneHeader = (React.createElement(IconButton, { name: 'outline', className: 'engine-toggle-tree', size: 'medium', "data-tip": '\u5927\u7EB2\u6811', onClick: function () { return TreeCore.toggle(); } }, "\u5927\u7EB2\u6811"));
	            treePane = React.createElement(TreePane, null);
	        }
	        return (React.createElement("div", { className: 'engine-navigator' },
	            React.createElement("div", { className: 'engine-navigator-path' },
	                treePaneHeader,
	                React.createElement(IconSingle, { name: icon, className: 'engine-navigator-icon', size: 'medium' }),
	                path),
	            React.createElement("div", { ref: function (ref) { _this.outline = ref; }, className: 'engine-navigator-outline', tabIndex: -1 }, treePane)));
	    };
	    return Navigator;
	}(React.Component));
	exports.default = Navigator;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(300);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./navigator.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./navigator.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-navigator{position:absolute;top:0;left:0;right:0;height:36px;overflow:hidden;z-index:4;box-sizing:border-box}.engine-navigator .engine-navigator-path{display:flex;align-items:center;height:36px;background:var(---color-block-background-normal,#fff);border-bottom:1px solid var(--color-line-normal,rgba(31,56,88,.1));position:relative}.engine-navigator .engine-navigator-path .engine-navigator-icon{margin:0 2px 0 5px;width:16px;height:16px;opacity:.6}.engine-navigator .engine-navigator-path .engine-navigator-icon *{fill:var(--color-icon-normal,rgba(31,56,88,.4))}.engine-navigator .engine-navigator-path .engine-navigator-nonselected{font-size:12px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(--color-text,rgba(0,0,0,.6));pointer-events:none}.engine-navigator .engine-navigator-path .engine-navigator-segment{display:inline-flex;align-items:center;cursor:pointer;padding:6px 4px;border-radius:2px}.engine-navigator .engine-navigator-path .engine-navigator-segment>.engine-segment-title{font-size:12px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(--color-text,rgba(0,0,0,.6));max-width:48px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-decoration:none}.engine-navigator .engine-navigator-path .engine-navigator-segment:not(:last-of-type):after{display:inline-block;content:\">\";width:8px;height:10px;font-family:sans-serif;margin-left:4px;margin-right:-5px;opacity:.4}.engine-navigator .engine-navigator-path .engine-navigator-segment:last-of-type{cursor:default}.engine-navigator .engine-navigator-path .engine-navigator-segment:last-of-type>.engine-segment-title{max-width:72px}.engine-navigator .engine-navigator-path .engine-toggle-tree{position:absolute;right:3px;top:50%;transform:translateY(-50%);cursor:pointer}.engine-navigator .engine-navigator-outline{position:absolute;top:36px;right:0;left:0;bottom:0;overflow-x:hidden;overflow-y:auto;display:none;outline:none}html.engine-drag-mode .engine-navigator,html.engine-show-tree .engine-navigator{height:auto;bottom:0}html.engine-drag-mode .engine-navigator .engine-toggle-tree .ve-svgicon,html.engine-show-tree .engine-navigator .engine-toggle-tree .ve-svgicon{opacity:1}html.engine-drag-mode .engine-navigator .engine-toggle-tree .ve-svgicon path,html.engine-show-tree .engine-navigator .engine-toggle-tree .ve-svgicon path{fill:#5a99cc}html.engine-drag-mode .engine-navigator .engine-navigator-outline,html.engine-show-tree .engine-navigator .engine-navigator-outline{display:block}", ""]);
	
	// exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../../../node_modules/_less-loader@2.2.3@less-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, ".engine-settings{position:absolute;top:0;bottom:0;left:0;right:0;border-left:1px solid var(--color-line-normal,rgba(31,56,88,.1));overflow-x:hidden;overflow-y:auto}.engine-settings-content{position:absolute;top:35px;bottom:0;left:0;right:0}.engine-nonselected-notice{text-align:center;font-size:12px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(--color-text,rgba(0,0,0,.6));margin:50px 15px 0;overflow:hidden;padding:15px 0}.engine-nonselected-notice>svg{color:var(--color-icon-normal,rgba(31,56,88,.4))}.engine-nonselected-notice>p{padding:0;margin-top:20px;font-size:12px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(--color-text,rgba(0,0,0,.6))}.engine-settings-stage{position:absolute;top:0;bottom:0;left:0;right:0;opacity:1;transition:transform .2s}.engine-settings-stage .engine-settings-tabs{margin:5px 0;display:none;align-items:center;justify-content:center}.engine-settings-stage .engine-settings-tabs .engine-settings-tab{background:var(--color-brand,#006cff);color:var(--color-text-reverse,hsla(0,0%,100%,.8));box-sizing:border-box;display:flex;align-items:center;font-size:12px;height:30px;padding:0 8px;text-transform:uppercase;cursor:pointer}.engine-settings-stage .engine-settings-tabs .engine-settings-tab:first-child{border-radius:5px 0 0 5px}.engine-settings-stage .engine-settings-tabs .engine-settings-tab:last-child{border-radius:0 5px 5px 0}.engine-settings-stage .engine-settings-tabs .engine-settings-tab .engine-icontip{margin-left:2px}.engine-settings-stage .engine-settings-tabs .engine-settings-tab.engine-active{cursor:default;pointer-events:none;background:var(--color-block-background-dark,rgba(31,56,88,.1));color:var(--color-text,rgba(0,0,0,.6))}.engine-settings-stage .engine-stage-content{position:absolute;top:0;bottom:0;left:0;right:0;z-index:2;overflow-x:hidden;overflow-y:auto;box-sizing:border-box}.engine-settings-stage.engine-stagein-right,.engine-settings-stage.engine-stageout-left{transform:translateX(-100%)}.engine-settings-stage.engine-stagein-left,.engine-settings-stage.engine-stageout-right{transform:translateX(100%)}.engine-settings-stage .engine-settings-stagebacker{cursor:pointer;font-weight:500;height:30px;display:flex;align-items:center;background:var(--color-block-background-light,rgba(31,56,88,.04));justify-content:center;position:relative}.engine-settings-stage .engine-settings-stagebacker .engine-field-title{letter-spacing:1px;font-size:12px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;line-height:1em;user-select:none;color:var(--color-text,rgba(0,0,0,.6));width:fit-content;white-space:normal;word-break:break-word}.engine-settings-stage .engine-settings-stagebacker .engine-field-title:first-letter{text-transform:capitalize}.engine-settings-stage .engine-settings-stagebacker .engine-field-arrow{position:absolute;left:3px;top:50%;transform:translateY(-50%) rotate(90deg);opacity:.6}.engine-settings-stage .engine-settings-stagebacker .engine-icontip{margin-left:2px}.engine-settings-stage .engine-settings-stagebacker:hover{background:var(--color-block-background-shallow,rgba(31,56,88,.06))}.engine-settings-stage .engine-settings-stagebacker:hover .engine-field-arrow{opacity:1}.engine-settings-stage.engine-has-tabs .engine-settings-tabs{display:flex}.engine-settings-stage.engine-has-tabs .engine-stage-content{top:40px}.engine-settings-stage.engine-has-backer .engine-stage-content{top:36px}.engine-settings-stage.engine-has-backer .engine-block-field .engine-field-body{margin:6px}.engine-settings-stage.engine-has-tabs.engine-has-backer .engine-stage-content{top:70px}.engine-setting-field{white-space:nowrap;position:relative}.engine-setting-field:after,.engine-setting-field:before{content:\" \";display:table}.engine-setting-field:after{clear:both}.engine-setting-field .engine-field-title{font-size:12px;font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;line-height:1em;user-select:none;color:var(--color-text,rgba(0,0,0,.6));width:fit-content;white-space:normal;word-break:break-word}.engine-setting-field .engine-field-title:first-letter{text-transform:capitalize}.engine-setting-field .engine-field-title .engine-word{flex:1;text-align:center;font-weight:400;overflow:hidden}.engine-setting-field .engine-field-title .engine-word:first-child{text-align:left}.engine-setting-field .engine-field-title .engine-word:last-of-type{text-align:right}.engine-setting-field .engine-field-title .engine-word:only-of-type{text-align:center}.engine-setting-field a.engine-field-title{border-bottom:1px dashed var(--color-line-normal,rgba(31,56,88,.1));text-decoration:none;padding-bottom:2px}.engine-setting-field a.engine-field-title:hover{cursor:help}.engine-setting-field .engine-field-variable-wrapper{margin-left:5px}.engine-setting-field .engine-field-variable{cursor:pointer;opacity:.6}.engine-setting-field .engine-field-variable.engine-active{opacity:1;color:var(--color-brand,#006cff)}.engine-setting-field .engine-field-head{padding-left:10px;height:32px;background:var(--color-block-background-shallow,rgba(31,56,88,.06));display:flex;align-items:center;font-weight:500;border-top:1px solid var(--color-line-normal,rgba(31,56,88,.1));border-bottom:1px solid var(--color-line-normal,rgba(31,56,88,.1));color:var(--color-title,rgba(0,0,0,.8))}.engine-setting-field .engine-field-head>.engine-icontip{margin-left:2px}.engine-setting-field .engine-field-body{min-height:20px;margin:6px 0}.engine-setting-field .engine-field-body:after,.engine-setting-field .engine-field-body:before{content:\" \";display:table}.engine-setting-field .engine-field-body:after{clear:both}.engine-setting-field .engine-field-body .engine-field-head{height:28px;border:none;font-weight:400}.engine-setting-field.engine-plain-field>.engine-field-variable{position:absolute;right:5px;top:8px}.engine-setting-field.engine-plain-field:hover>.engine-field-variable{opacity:1}.engine-setting-field.engine-entry-field{cursor:pointer;display:flex;align-items:center;height:32px;padding-left:10px;font-weight:500;border-top:1px solid var(--color-line-normal,rgba(31,56,88,.1));border-bottom:1px solid var(--color-line-normal,rgba(31,56,88,.1));background:var(--color-block-background-shallow,rgba(31,56,88,.06));margin-bottom:6px}.engine-setting-field.engine-entry-field>.engine-field-title{letter-spacing:1px}.engine-setting-field.engine-entry-field>.engine-icontip{margin-left:2px}.engine-setting-field.engine-entry-field>.engine-field-arrow{position:absolute;right:5px;top:50%;transform:translateY(-50%) rotate(-90deg);opacity:.4}.engine-setting-field.engine-entry-field:hover>.engine-field-arrow{opacity:1}.engine-setting-field.engine-popup-field{cursor:pointer;display:flex;align-items:center;height:32px;padding-left:10px;background:var(--color-block-background-shallow,rgba(31,56,88,.06));margin-bottom:1px}.engine-setting-field.engine-popup-field>.engine-field-title{letter-spacing:1px}.engine-setting-field.engine-popup-field>.engine-icontip{margin-left:2px}.engine-setting-field.engine-popup-field>.engine-field-icon{position:absolute;right:5px;top:50%;transform:translateY(-50%);opacity:.6}.engine-setting-field.engine-popup-field:hover>.engine-field-icon{opacity:1}.engine-setting-field.engine-block-field>.engine-field-head>.engine-field-title{letter-spacing:1px}.engine-setting-field.engine-block-field>.engine-field-head>.engine-field-variable{margin-left:2px}.engine-setting-field.engine-block-field>.engine-field-body{margin:6px}.engine-setting-field.engine-inline-field{display:flex;align-items:center;margin:10px}.engine-setting-field.engine-inline-field>.engine-field-head{display:inline-flex;background:none;padding:0;border:none}.engine-setting-field.engine-inline-field>.engine-field-head>.engine-field-title{display:inline-flex;width:50px;margin-right:5px}.engine-setting-field.engine-inline-field>.engine-field-body{width:100%;display:inline-flex;align-items:flex-start;padding:0;margin:0;flex:1;position:relative}.engine-setting-field.engine-inline-field>.engine-field-variable{margin-left:2px}.engine-setting-field.engine-inline-field:hover>.engine-field-variable{opacity:1}.engine-setting-field.engine-accordion-field>.engine-field-head{position:relative;cursor:pointer}.engine-setting-field.engine-accordion-field>.engine-field-head>.engine-field-title{letter-spacing:1px}.engine-setting-field.engine-accordion-field>.engine-field-head>.engine-field-arrow{transform:rotate(180deg);position:absolute;right:7px;top:7px;transition:transform .1s ease;opacity:.6}.engine-setting-field.engine-accordion-field>.engine-field-head>.engine-field-variable{margin-left:2px}.engine-setting-field.engine-accordion-field.engine-collapsed>.engine-field-head{margin-bottom:6px}.engine-setting-field.engine-accordion-field.engine-collapsed>.engine-field-head>.engine-field-arrow{transform:rotate(0)}.engine-setting-field.engine-accordion-field.engine-collapsed>.engine-field-body{display:none}.engine-setting-field.engine-accordion-field>.engine-field-body{margin:6px}html.engine-drag-mode .engine-settings .engine-settings-content,html.engine-show-tree .engine-settings .engine-settings-content{visibility:hidden}", ""]);
	
	// exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(7);
	/**
	 * RootNodeVisitor for VisualEngine Page
	 *
	 * - store / cache node
	 * - quickly find / search or do operations on Node
	 */
	var RootNodeVisitor = /** @class */ (function () {
	    function RootNodeVisitor(page, rootNode) {
	        this.nodeIdMap = {};
	        this.nodeFieldIdMap = {};
	        this.nodeList = [];
	        this.cancelers = [];
	        this.page = page;
	        this.root = rootNode;
	        this._findNode(this.root);
	        this._init();
	    }
	    RootNodeVisitor.prototype.getNodeList = function () {
	        return this.nodeList;
	    };
	    RootNodeVisitor.prototype.getNodeIdMap = function () {
	        return this.nodeIdMap;
	    };
	    RootNodeVisitor.prototype.getNodeFieldIdMap = function () {
	        return this.nodeFieldIdMap;
	    };
	    RootNodeVisitor.prototype.getNodeById = function (id) {
	        if (!id) {
	            return this.nodeIdMap;
	        }
	        return this.nodeIdMap[id];
	    };
	    RootNodeVisitor.prototype.getNodeByFieldId = function (fieldId) {
	        if (!fieldId) {
	            return this.nodeFieldIdMap;
	        }
	        return this.nodeFieldIdMap[fieldId];
	    };
	    RootNodeVisitor.prototype.destroy = function () {
	        this.cancelers.forEach(function (canceler) { return canceler(); });
	    };
	    RootNodeVisitor.prototype._init = function () {
	        var _this = this;
	        this.cancelers.push(this.page.onNodeCreate(function (node) {
	            _this.nodeList.push(node);
	            _this.nodeIdMap[node.id] = node;
	            if (node.getPropValue('fieldId')) {
	                _this.nodeFieldIdMap[node.getPropValue('fieldId')] = node;
	            }
	        }));
	        this.cancelers.push(this.page.onNodeDestroy(function (node) {
	            var idx = lodash_1.findIndex(_this.nodeList, function (n) { return node.id === n.id; });
	            _this.nodeList.splice(idx, 1);
	            delete _this.nodeIdMap[node.id];
	            if (node.getPropValue('fieldId')) {
	                delete _this.nodeFieldIdMap[node.getPropValue('fieldId')];
	            }
	        }));
	    };
	    RootNodeVisitor.prototype._findNode = function (node) {
	        var _this = this;
	        var props = node.getProps();
	        var fieldId = props && props.getPropValue('fieldId');
	        this.nodeIdMap[node.getId()] = node;
	        this.nodeList.push(node);
	        if (fieldId) {
	            this.nodeFieldIdMap[fieldId] = node;
	        }
	        var children = node.getChildren();
	        if (children) {
	            children.forEach(function (child) { return _this._findNode(child); });
	        }
	    };
	    return RootNodeVisitor;
	}());
	exports.default = RootNodeVisitor;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var vu_logger_1 = __webpack_require__(6);
	vu_logger_1.default.setLogMap({
	    ERROR_PROP_VALUE: {
	        doc: 'https://lark.alipay.com/vision/log/error_set_hot_value',
	        en_US: 'Component property setting error',
	        title: 'ERROR',
	        type: 'error',
	        zh_CN: '组件属性设置 / 初始化错误',
	    },
	    ERROR_PAGE_RENDER: {
	        doc: 'https://lark.alipay.com/vision/log/error_page_render',
	        en_US: 'Visual page render error',
	        title: 'ERROR',
	        type: 'error',
	        zh_CN: '可视化编辑区域页面渲染出错，对应的解决方法请',
	    },
	    ERROR_COMPONENT_RENDER: {
	        doc: 'https://lark.alipay.com/vision/log/error_component_render',
	        en_US: 'Component rendering error',
	        title: 'ERROR',
	        type: 'error',
	        zh_CN: '组件在设计器中渲染出错'
	    },
	    ERROR_NO_PROTOTYPE_VIEW: {
	        doc: 'https://yuque.antfin-inc.com/vision/log/aa4mnl',
	        zh_CN: '组件视图无 displayName',
	        en_US: 'componentView should have displayName',
	        title: 'ERROR',
	        type: 'error',
	    },
	    ERROR_NO_COMPONENT_VIEW: {
	        doc: 'https://yuque.antfin-inc.com/vision/log/aa4mnl',
	        zh_CN: '组件无视图',
	        en_US: 'componentView is lost',
	        title: 'ERROR',
	        type: 'error'
	    }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(306);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(30)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./global.less", function() {
				var newContent = require("!!../../node_modules/_css-loader@0.23.1@css-loader/index.js!../../node_modules/_less-loader@2.2.3@less-loader/index.js!./global.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(29)();
	// imports
	
	
	// module
	exports.push([module.id, "html.engine-cursor-move,html.engine-cursor-move *{cursor:grabbing!important}html.engine-cursor-copy,html.engine-cursor-copy *{cursor:copy!important}#engine,body{position:absolute;left:0;right:0;bottom:0;top:0;box-sizing:border-box;padding:0;margin:0;overflow:hidden;background:#fff;text-rendering:optimizeLegibility;-webkit-user-select:none;-webkit-user-drag:none;-webkit-text-size-adjust:none;-webkit-touch-callout:none;-webkit-font-smoothing:antialiased}html{min-width:1024px}.engine-logo{height:48px;padding:8px;box-sizing:border-box;width:48px;cursor:pointer}::-webkit-scrollbar{width:5px;height:5px}::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.3);border-radius:5px}html.engine-blur #engine{-webkit-filter:blur(4px)}.engine-main{width:100%;height:100%;position:relative}.engine-main .ve-icon-tip,.engine-main .ve-icon-tip:visited{color:var(--color-icon-normal,rgba(31,56,88,.4))}.engine-main .ve-icon-button>.ve-icon-contents{font-family:PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica,Arial,sans-serif;color:var(--color-text,rgba(0,0,0,.6))}.engine-main .ve-icon-button.active>.ve-icon-contents,.engine-main .ve-icon-button:hover>.ve-icon-contents{color:var(--color-text-light,rgba(51,51,51,.6))}.engine-main .engine-empty{background:#f2f3f5;color:#a7b1bd;outline:1px dashed rgba(31,56,88,.4);outline-offset:-1px!important;height:66px;max-height:100%;min-width:140px;text-align:center;overflow:hidden;display:flex;align-items:center}.engine-main .engine-empty:before{content:\"\\62D6\\62FD\\7EC4\\4EF6\\6216\\6A21\\677F\\5230\\8FD9\\91CC\";font-size:14px;z-index:1;width:100%;white-space:nowrap}", ""]);
	
	// exports


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// engine.js